/* Options:
Date: 2026-05-21 13:55:10
Version: 8.40
Tip: To override a DTO option, remove "//" prefix before updating
BaseUrl: https://localhost:5002

//GlobalNamespace: 
//MakePropertiesOptional: False
//AddServiceStackTypes: True
//AddResponseStatus: False
//AddImplicitVersion: 
//AddDescriptionAsComments: True
//IncludeTypes: 
ExcludeTypes: GetInstitutionPersonnelEmailAddresses,InstitutionPersonnelEmailAddressesResponse,GetUserPersonnelEmailAddress,UserPersonnelEmailAddressResponse,SendRegistrationEmail,SendRandomisationEmail
//DefaultImports: 
*/

//@ts-nocheck
import { immerable } from "immer";

export interface IReturn<T>
{
    createResponse(): T;
}

export interface IReturnVoid
{
    createResponse(): void;
}

export interface IGet
{
}

export interface IDelete
{
}

export interface IHasSessionId
{
    sessionId?: string;
}

export interface IHasBearerToken
{
    bearerToken?: string;
}

export interface IPost
{
}

export enum ConsentTypeEnum
{
    Remote = 1,
    FaceToFace = 2,
    Standard = 3,
}

export enum StatusTypeEnum
{
    Waiting = 1,
    Responded = 2,
    NotInterested = 3,
    PatientSigning = 4,
    InvestigatorSigning = 5,
    VerifyingDocument = 6,
    Completed = 7,
    Refused = 8,
}

export class ConsentEvent implements IConsentEvent
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public eventDefinitionId?: number;
    public consentTypeId?: ConsentTypeEnum;
    public statusId?: StatusTypeEnum;
    public guid: string;
    public investigator: string;
    public investigatorSpecify: string;
    public dateStarted?: string;
    public dateNotificationSent?: string;
    public datePatientCompleted?: string;
    public dateInvestigatorCompleted?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ConsentEvent>) { (Object as any).assign(this, init); }
}

export interface IEConsentRequest
{
    guid: string;
}

export class MultipleRandomisationEmailData
{
    [immerable]? = true;

    public institutionName: string;
    public randomisationDate: string;
    public participantNumber: string;

    public constructor(init?: Partial<MultipleRandomisationEmailData>) { (Object as any).assign(this, init); }
}

export class EmailAddress
{
    [immerable]? = true;

    public displayName: string;
    public address: string;

    public constructor(init?: Partial<EmailAddress>) { (Object as any).assign(this, init); }
}

export class Translation
{
    [immerable]? = true;

    public id?: number;
    public localeId?: number;
    public namespaceId?: number;
    public key?: string;
    public value?: string;
    public version?: number;

    public constructor(init?: Partial<Translation>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FileUploadTemporary implements IFileUploadTemporary
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public guid: string;

    // @DataMember(Order=2)
    public name: string;

    // @DataMember(Order=3)
    public extension: string;

    // @DataMember(Order=4)
    public fileSize?: number;

    // @DataMember(Order=5)
    public contentType: string;

    // @DataMember(Order=6)
    public image: boolean;

    public constructor(init?: Partial<FileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class File
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;
    public propertyName: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    // @Ignore()
    public upload: FileUploadTemporary;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<File>) { (Object as any).assign(this, init); }
}

export class ImageDocument implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public name: string;
    public fileTypeId?: number;
    public isDeIdentified?: boolean;
    public deIdentifiedFailed?: boolean;
    public isVerified?: boolean;
    public isUploadedToSharePoint?: boolean;
    public uploadToSharePointFailed?: boolean;
    // @Ignore()
    public isCorrectInitials?: boolean;

    public participantInitials?: string;
    public file?: File;
    public accessionNumber?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ImageDocument>) { (Object as any).assign(this, init); }
}

export class MriImageUpload implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public imageDocument?: ImageDocument;
    public cemDocument?: ImageDocument;
    // @Ignore()
    public participantNumber?: string;

    // @Ignore()
    public initials?: string;

    // @Ignore()
    public mammogramPerformed?: boolean;

    // @Ignore()
    public institutionName?: string;

    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MriImageUpload>) { (Object as any).assign(this, init); }
}

export enum PatientStateType
{
    Screening = 1,
    ConsentPending = 2,
    Consent = 3,
    Registration = 4,
    RadiologistReview = 5,
    Allocation = 6,
    BctReview = 7,
    CorrectionRequired = 8,
    Allocated = 9,
    PostAllocated = 10,
    ThreeMonthsPostSurgery = 11,
    SixMonthsPostSurgery = 12,
    TwelveMonthsPostSurgery = 13,
    TwentyFourMonthsPostSurgery = 14,
    FiveYearsPostSurgery = 15,
    ScreenFail = 16,
    Ineligible = 17,
    Waivered = 18,
    Removed = 19,
}

export enum LookupIndigenousStatusType
{
    AboriginalAndOrTorresStraitIslander = 1,
    NeitherAboriginalAndOrTorresStraitIslander = 2,
    Unknown = 3,
}

export enum LookupUntypedType
{
    NoType = 1,
}

export enum LookupYesNoType
{
    No = 0,
    Yes = 1,
}

export enum LookupLeftRightType
{
    Left = 1,
    Right = 2,
}

export enum LookupHistopathologyType
{
    InvasiveDuctalCarcinoma = 1,
    InvasiveLobularCarcinoma = 2,
    Other = 3,
    DCIS = 4,
}

export enum LookupUltrasoundLesionType
{
    Mass = 1,
    MultipleMasses = 2,
    TexturalChange = 3,
    Calcifications = 4,
    NoAbnormality = 5,
    Other = 6,
}

export enum LookupMammographyLesionType
{
    Mass = 1,
    MultipleMasses = 2,
    AsymmetricalDensity = 3,
    Calcifications = 4,
    ArchitecturalDistortion = 5,
    NoAbnormality = 6,
}

export enum LookupLesionClassificationType
{
    PrimaryLesion = 1,
    HaematomaOnly = 2,
    Contralateral = 3,
    ContiguousWithIndex = 4,
    DiscontiguousWithIndex = 5,
    MinimumDistanceFromIndex = 6,
}

export enum LookupAddPatientType
{
    Standard = 1,
    EConsent = 2,
}

export enum LookupLikelihoodType
{
    NotLikely = 1,
    VeryUnlikely = 2,
    AsLikelyAsNot = 3,
    Likely = 4,
    VeryLikely = 5,
}

export enum LookupPatientHealthQuestionnaireType
{
    NotAtAll = 1,
    SeveralDays = 2,
    MoreThanHalfTheDays = 3,
    NearlyEveryDay = 4,
}

export enum LookupAgreeType
{
    NotAtAll = 1,
    Little = 2,
    SomeWhat = 3,
    QuiteABit = 4,
    VeryMuch = 5,
}

export enum LookupEndocrineTherapyDiscontinuationType
{
    ConcernsAboutToxicity = 1,
    ExperiencedToxicity = 2,
    CostsTooMuch = 3,
    NoBenefit = 4,
    LackOfAccessToProvider = 5,
    Other = 6,
}

export enum LookupPathologyType
{
    BenignOrFibrocystic = 1,
    ADH = 2,
    ALH = 3,
    LCIS = 4,
    DCIS = 5,
    Malignant = 6,
    Other = 7,
}

export enum LookupLesionIdentityType
{
    R2 = 1,
    R3 = 2,
    R4 = 3,
    R5 = 4,
    R6 = 5,
    Other = 6,
}

export enum LookupImageReportDocumentType
{
    Mammogram2D = 1,
    MammogramTomosynthesis = 2,
    MammogramCEM = 3,
    Ultrasound = 4,
    MRI = 5,
}

export enum FormDefinitionType
{
    ScreeningForm = 1,
    MainConsent = 2,
    TissueBankingConsent = 3,
    ServicesAustraliaConsent = 4,
    SourceDocument = 5,
    GeneralAndConsent = 6,
    RegistrationEligibilityChecklist = 7,
    DiagnosticImaging = 8,
    MedicalHistory = 9,
    PROMs = 10,
    RadiologyReport = 11,
    MammographyReportLesion = 12,
    UltrasoundReportLesion = 13,
    MRIReportLesion = 14,
    CEMReportLesion = 15,
    RiskAppraisal = 16,
    PatientHealthQuestionnaire = 17,
    InternationalPersonalityItemPool = 18,
    GeneralizedAnxietyDisorder2 = 19,
    FearOfCancerRecurrence = 20,
    EndocrineTherapyAdherence = 21,
    ExperienceAndImpactOfTreatment = 22,
    EQ5D5L = 23,
    EORTCIL353 = 24,
    DecisionRegretScale = 25,
    BriefIllnessPerceptionQuestionnaire = 26,
    BreastCancerTreatmentOutcomesScale = 27,
    BreastMri = 28,
    BreastMriAdverseEvent = 29,
    BreastMriAdditionalLesion = 30,
    ContrastEnhanceMammogram = 31,
    TranslationalBloodCollection = 32,
    Surgery = 33,
    Histopatholgy = 34,
    AdditionalCancer = 35,
    AdditionalCancerDetail = 36,
    TreatmentDecisions = 37,
    TissueCollection = 38,
    ImageReportUpload = 39,
    ImageReportDocument = 40,
    Procomida = 41,
    ProcomidaIncomplete = 42,
    ProcomidaAssistance = 43,
    SystemErrorForm = 44,
    SystemErrorInfo = 45,
    SystemErrorDetails = 46,
    SystemErrorSourceDocument = 47,
    WithdrawalOfConsent = 48,
    MriUploads = 100,
    MriUploadsDocument = 101,
}

export enum LookupPositiveNegativeType
{
    Negative = 1,
    Positive = 2,
    NA = 3,
}

export enum LookupLessGreaterThanType
{
    LessThan = 1,
    LessThanOrEqual = 2,
    Equal = 3,
    NotEqual = 4,
    GreaterThan = 5,
    GreaterThanOrEqual = 6,
}

export enum LookupScreenFailReasonType
{
    ParticipantIneligible = 1,
    ClinicianDeemedUnsuitable = 2,
    ParticipantPrefersStandardCare = 3,
    ParticipantDeclinedNoReason = 4,
}

export enum LookupIneligibleReasonType
{
    ParticipantPreferStandardCare = 0,
    ParticipantDeclinedNoReason = 1,
    TreatingClinicianRecommendedRt = 2,
    IneligibleBreastCancerSubType = 3,
    IneligibleFor10YearFollowUp = 4,
    PreviousBreastCancer = 5,
    PlannedMastectomy = 6,
    KnownBcGenenMutation = 7,
    ContraIndicationToBreastMri = 8,
    AdditionalLesionsIdentified = 9,
    HasModerateOrMarkedBpe = 10,
    SurgeryMoreThan8Weeks = 11,
    UnableToAllocateParticipant = 12,
    OtherSpecify = 13,
}

export enum LookupIneligibleBreastCancerSubType
{
    ErAndHer2Negative = 0,
    LymphovascularInvasion = 1,
    MultifocalBreastCancer = 2,
    BilateralBreastCancer = 3,
    DistantMetastasis = 4,
}

export enum LookupImageDocumentType
{
    MRI = 1,
    CEM = 2,
}

export enum LookupDCISType
{
    NotPresent = 1,
    PresentNotEIC = 2,
    PresentEIC = 3,
}

export enum LookupEventErrorsByPassedType
{
    Screening = 1,
    Consent = 2,
    Registration = 3,
    RadiologistReview = 4,
    Allocation = 5,
}

export enum LookupSystemErrorApprovedByType
{
    Other = 0,
    DataManagement = 1,
    TrialDepartmentManager = 2,
}

export enum LookupContinuationType
{
    Stopped = 0,
    Continued = 1,
}

export enum WithdrawalStateType
{
    FullyWithdrawn = 1,
    WithdrawnFollowUp = 2,
    WithdrawnProms = 3,
}

export class AddParticipant implements IDataModel
{
    [immerable]? = true;

    public id?: number;
    public institutionId?: number;
    public patientId?: number;
    public patientInitials?: string;
    // @Ignore()
    public patientStudyNumber?: string;

    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<AddParticipant>) { (Object as any).assign(this, init); }
}

export interface IReportRequest
{
    token: string;
}

export enum RejectedAsType
{
    SaeIsInvalid = 1,
    InformationIsIncorrect = 2,
}

export enum FormType
{
    Crf = 1,
    Pro = 2,
    Staff = 3,
}

export enum ValidationErrorType
{
    Warning = 1,
    Ineligible = 2,
    Normal = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class FormDefinitionPropertyErrorMessage implements IFormDefinitionPropertyErrorMessage
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinitionProperty)")
    public formDefinitionPropertyId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormDefinitionPropertyErrorMessage>) { (Object as any).assign(this, init); }
}

export class FormDefinitionProperty
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public propertyName: string;
    public label: string;
    public detailedLabel: string;
    public errorMessages: FormDefinitionPropertyErrorMessage[];

    public constructor(init?: Partial<FormDefinitionProperty>) { (Object as any).assign(this, init); }
}

export class FormDefinition
{
    [immerable]? = true;

    public id?: number;
    public testProperty?: number;
    public code: string;
    public type?: FormType;
    public name: string;
    public instructions?: string;
    public patientInstructions?: string;
    public properties: FormDefinitionProperty[];
    // @Ignore()
    public subformProperties: { [index: string]: FormDefinitionProperty[]; };

    public constructor(init?: Partial<FormDefinition>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsent implements IEConsentForm, IOpenClinicaForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public patientId?: number;

    // @DataMember(Order=4)
    public eventId?: number;

    // @DataMember(Order=5)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=6)
    public parentFormId?: number;

    // @DataMember(Order=7)
    public exportedToOpenClinica?: string;

    // @DataMember(Order=8)
    // @Ignore()
    public consentEvent: ConsentEvent;

    // @DataMember(Order=9)
    public picfId?: number;

    // @DataMember(Order=10)
    public picfVersion?: string;

    // @DataMember(Order=11)
    public picfVersionSpecify?: string;

    // @DataMember(Order=12)
    public patientSignedConsent?: number;

    // @DataMember(Order=13)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=14)
    public participantAgreedToProvideBloodSample?: number;

    // @DataMember(Order=15)
    public participantAgreedToCompleteQuestionnaires?: number;

    // @DataMember(Order=16)
    public investigatorSignedConsent?: number;

    // @DataMember(Order=17)
    public dateInvestigatorSignedConsent?: string;

    // @DataMember(Order=18)
    public investigator: string;

    // @DataMember(Order=19)
    public investigatorSpecify: string;

    // @DataMember(Order=20)
    // @Ignore()
    public formDefinition?: FormDefinition;

    // @DataMember(Order=25)
    // @Ignore()
    public patientName: string;

    // @DataMember(Order=26)
    // @Ignore()
    public patientSigning: boolean;

    // @DataMember(Order=27)
    // @Ignore()
    public investigatorSigning: boolean;

    // @DataMember(Order=28)
    public consentTypeId?: ConsentTypeEnum;

    // @DataMember(Order=21)
    public enteredDate?: string;

    // @DataMember(Order=22)
    public enteredBy: string;

    // @DataMember(Order=23)
    public modifiedDate?: string;

    // @DataMember(Order=24)
    public modifiedBy: string;

    public constructor(init?: Partial<MainConsent>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsent implements IEConsentForm, IOpenClinicaForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public patientId?: number;

    // @DataMember(Order=4)
    public eventId?: number;

    // @DataMember(Order=5)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=6)
    public parentFormId?: number;

    // @DataMember(Order=7)
    public exportedToOpenClinica?: string;

    // @DataMember(Order=8)
    // @Ignore()
    public consentEvent: ConsentEvent;

    // @DataMember(Order=9)
    public picfId?: number;

    // @DataMember(Order=10)
    public picfVersion?: string;

    // @DataMember(Order=11)
    public picfVersionSpecify?: string;

    // @DataMember(Order=12)
    public patientSignedConsent?: number;

    // @DataMember(Order=13)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=14)
    public particpantAgreedToSampleStorageAndUse?: number;

    // @DataMember(Order=15)
    public particpantAgreedToImageStorageAndUse?: number;

    // @DataMember(Order=16)
    public investigatorSignedConsent?: number;

    // @DataMember(Order=17)
    public dateInvestigatorSignedConsent?: string;

    // @DataMember(Order=18)
    public investigator: string;

    // @DataMember(Order=19)
    public investigatorSpecify: string;

    // @DataMember(Order=20)
    // @Ignore()
    public formDefinition?: FormDefinition;

    // @DataMember(Order=25)
    // @Ignore()
    public patientName: string;

    // @DataMember(Order=26)
    // @Ignore()
    public patientSigning: boolean;

    // @DataMember(Order=27)
    // @Ignore()
    public investigatorSigning: boolean;

    // @DataMember(Order=28)
    public consentTypeId?: ConsentTypeEnum;

    // @DataMember(Order=21)
    public enteredDate?: string;

    // @DataMember(Order=22)
    public enteredBy: string;

    // @DataMember(Order=23)
    public modifiedDate?: string;

    // @DataMember(Order=24)
    public modifiedBy: string;

    public constructor(init?: Partial<TissueBankingConsent>) { (Object as any).assign(this, init); }
}

export class Drug
{
    [immerable]? = true;

    public id?: number;
    public drugName: string;
    public unitsPerShippingContainer: number;
    public containerName: string;
    public unitConcentration: number;
    public unitVolume: number;
    public enableDrugShipmentGeneration: boolean;
    public drugTypeId?: number;

    public constructor(init?: Partial<Drug>) { (Object as any).assign(this, init); }
}

export class Batch
{
    [immerable]? = true;

    public id?: number;
    public drugId?: number;
    public batchNo: string;
    public dateExpiration?: string;
    public allocationCutOffDate?: string;
    public available: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<Batch>) { (Object as any).assign(this, init); }
}

export class DepotBatch
{
    [immerable]? = true;

    public id?: number;
    public depotId: number;
    public batchId: number;
    public depotBatchNo?: number;
    public drugUnitsTotal: number;
    public drugUnitsAllocated: number;
    public drugUnitsDestroyed: number;
    public available: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public batch: Batch;

    public constructor(init?: Partial<DepotBatch>) { (Object as any).assign(this, init); }
}

export class OrderForm
{
    [immerable]? = true;

    public id?: number;
    public orderFormName: string;

    public constructor(init?: Partial<OrderForm>) { (Object as any).assign(this, init); }
}

export class Depot
{
    [immerable]? = true;

    public id?: number;
    public depotName: string;
    public address: string;
    public email: string;
    public contactName: string;
    public phoneNo: string;
    public orderFormId: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public orderForm: OrderForm;

    public constructor(init?: Partial<Depot>) { (Object as any).assign(this, init); }
}

export enum PharmacyStatus
{
    Inactive = 1,
    Open = 2,
    Closed = 3,
}

export class PharmacyDrug
{
    [immerable]? = true;

    public id?: number;
    public pharmacyId: number;
    public drugId: number;
    public capacity: number;
    public minThreshold: number;
    public enabled: boolean;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<PharmacyDrug>) { (Object as any).assign(this, init); }
}

export class Pharmacy
{
    [immerable]? = true;

    public id?: number;
    public depotId: number;
    public institutionCode: string;
    public pharmacyName: string;
    public phoneNumber: string;
    public address: string;
    public email: string;
    public ccOnEmails: boolean;
    public pharmacyStatus?: PharmacyStatus;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public notes: string;
    public pharmacistPersonId?: number;
    public pharmacyDrugs: PharmacyDrug[];

    public constructor(init?: Partial<Pharmacy>) { (Object as any).assign(this, init); }
}

export class Timepoint
{
    [immerable]? = true;

    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<Timepoint>) { (Object as any).assign(this, init); }
}

export class DrugDispensation implements IDrugManagementForm
{
    [immerable]? = true;

    public id?: number;
    public pharmacyId?: number;
    public patientId?: number;
    public depotBatchId?: number;
    public timepointId?: number;
    public dateDispensation?: string;
    public drugUnits?: number;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public pharmacy: Pharmacy;
    public depotBatch: DepotBatch;
    public timepoint: Timepoint;

    public constructor(init?: Partial<DrugDispensation>) { (Object as any).assign(this, init); }
}

export enum ShipmentStatus
{
    New = 1,
    Ordered = 2,
    InTransit = 3,
    Available = 4,
    Lost = 5,
    QuarantinedFromTransit = 6,
    Destroyed = 7,
    QuarantinedAtSite = 8,
}

export class DrugShipmentDepotBatch implements IDrugManagementForm
{
    [immerable]? = true;

    public id?: number;
    public drugShipmentId?: number;
    public depotBatchId?: number;
    public drugUnits?: number;
    public drugUnitsUsed?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;
    public notes: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipment: DrugShipment;
    public depotBatch: DepotBatch;
    public drugAllocated?: number;
    public drugRemaining?: number;

    public constructor(init?: Partial<DrugShipmentDepotBatch>) { (Object as any).assign(this, init); }
}

export class DrugShipmentStatusHistory implements IDrugManagementForm
{
    [immerable]? = true;

    public id?: number;
    public drugShipmentId?: number;
    public shipmentStatus: ShipmentStatus;
    public statusDate: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<DrugShipmentStatusHistory>) { (Object as any).assign(this, init); }
}

export class DrugManagementFileUploadTemporary implements IFileUploadTemporary
{
    [immerable]? = true;

    public guid: string;
    public name: string;
    public extension: string;
    public fileSize?: number;
    public contentType: string;
    public image: boolean;

    public constructor(init?: Partial<DrugManagementFileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class DrugManagementFile
{
    [immerable]? = true;

    // @Ignore()
    public upload: DrugManagementFileUploadTemporary;

    // @Ignore()
    public extension: string;

    // @Ignore()
    public fileSize?: number;

    // @Ignore()
    public contentType: string;

    // @Ignore()
    public exists: boolean;

    // @Ignore()
    public image: boolean;

    public constructor(init?: Partial<DrugManagementFile>) { (Object as any).assign(this, init); }
}

export class DrugShipmentDocument
{
    [immerable]? = true;

    public id?: number;
    public drugShipmentId?: number;
    public name: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public file: DrugManagementFile;

    public constructor(init?: Partial<DrugShipmentDocument>) { (Object as any).assign(this, init); }
}

export class DrugShipmentPharmacist
{
    [immerable]? = true;

    public id?: number;
    public pharmacyId?: number;
    public pharmacistId?: number;
    public drugShipmentId?: number;

    public constructor(init?: Partial<DrugShipmentPharmacist>) { (Object as any).assign(this, init); }
}

export class DrugShipment implements IDrugManagementForm
{
    [immerable]? = true;

    public id?: number;
    public institutionCode: string;
    public pharmacyId?: number;
    public pharmacyShipmentNo?: number;
    public shipmentStatus?: ShipmentStatus;
    public consignmentNo: string;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public notes: string;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];
    public drugShipmentStatusHistory: DrugShipmentStatusHistory[];
    public drugShipmentDocuments: DrugShipmentDocument[];
    public drugShipmentPharmacists: DrugShipmentPharmacist[];

    public constructor(init?: Partial<DrugShipment>) { (Object as any).assign(this, init); }
}

export class DrugAmount
{
    [immerable]? = true;

    public drugId?: number;
    public drugUnits?: number;

    public constructor(init?: Partial<DrugAmount>) { (Object as any).assign(this, init); }
}

export class DrugShipmentDepotBatchVerify
{
    [immerable]? = true;

    public id?: number;
    public drugShipmentId?: number;
    public depotBatchId?: number;
    public drugUnits?: number;
    public drugUnitsReceived?: number;
    public drugUnitsDamaged?: number;
    public drugUnitsDestroyed?: number;
    public drugUnitsLost?: number;
    public drugUnitsQuarantined?: number;

    public constructor(init?: Partial<DrugShipmentDepotBatchVerify>) { (Object as any).assign(this, init); }
}

export class DrugShipmentVerify
{
    [immerable]? = true;

    public id?: number;
    public consignmentNo: string;
    public received?: string;
    public notes: string;
    public drugShipmentDepotBatches: DrugShipmentDepotBatchVerify[];
    public drugShipmentDocuments: DrugShipmentDocument[];

    public constructor(init?: Partial<DrugShipmentVerify>) { (Object as any).assign(this, init); }
}

export enum PatientTreatmentStatus
{
    OnTreatment = 1,
    OffTreatment = 2,
}

export class PatientDrug
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public drugId?: number;
    public patientTreatmentStatus?: PatientTreatmentStatus;
    public enteredDate?: string;
    public enteredByUserId: string;
    public modifiedDate?: string;
    public modifiedByUserId: string;
    public drug: Drug;

    public constructor(init?: Partial<PatientDrug>) { (Object as any).assign(this, init); }
}

export enum QuarantinedStockAction
{
    Quarantined = 1,
    ReturnStockToSiteSupply = 2,
    DestroyStock = 3,
}

export interface IConsentPendingGetSingleById extends IGet
{
    id?: number;
}

export interface IConsentPendingGetCollection extends IGet
{
}

export interface IConsentPendingGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
}

export class ConsentPending implements IConsentPending
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public institutionCode: string;
    public emailAddress: string;
    public dateSent?: string;
    public investigator: string;
    public firstName: string;
    public lastName: string;
    public confirmed?: boolean;
    public dateSubmitted?: string;
    public statusId?: StatusTypeEnum;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ConsentPending>) { (Object as any).assign(this, init); }
}

export interface IConsentPendingDelete extends IDelete
{
    id?: number;
}

export interface IPatientConsentGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientConsentGetSingleByGuid extends IGet
{
    guid: string;
}

export interface IPatientConsentGetCollection extends IGet
{
}

export interface IPatientConsentGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
}

export class ConsentPicf
{
    [immerable]? = true;

    public id?: number;
    public consentId?: number;
    public picfTypeId?: number;
    public picfId?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ConsentPicf>) { (Object as any).assign(this, init); }
}

export class ConsentFileUploadTemporary implements IFileUploadTemporary
{
    [immerable]? = true;

    public guid: string;
    public name: string;
    public extension: string;
    public fileSize?: number;
    public contentType: string;
    public image: boolean;

    public constructor(init?: Partial<ConsentFileUploadTemporary>) { (Object as any).assign(this, init); }
}

export class ConsentFileUpload
{
    [immerable]? = true;

    public extension: string;
    public fileSize?: number;
    public contentType: string;
    public exists: boolean;
    public image: boolean;
    public upload: ConsentFileUploadTemporary;

    public constructor(init?: Partial<ConsentFileUpload>) { (Object as any).assign(this, init); }
}

export class ConsentType
{
    [immerable]? = true;

    public id: ConsentTypeEnum;
    public value: string;

    public constructor(init?: Partial<ConsentType>) { (Object as any).assign(this, init); }
}

export class StatusType
{
    [immerable]? = true;

    public id: StatusTypeEnum;
    public value: string;

    public constructor(init?: Partial<StatusType>) { (Object as any).assign(this, init); }
}

export class Eoi
{
    [immerable]? = true;

    public id?: number;
    public invitationId?: number;
    public firstName: string;
    public lastName: string;
    public confirmed?: boolean;
    public dateSubmitted?: string;
    public statusId?: StatusTypeEnum;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Eoi>) { (Object as any).assign(this, init); }
}

export class PatientConsent
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(Prospective.ServiceLogic.Models.Dos.EConsent.ConsentPending)")
    public consentPendingId?: number;

    public patientId?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.EConsent.Models.Dos.ConsentType)")
    public typeId?: ConsentTypeEnum;

    // @References("typeof(NewtonGreen.ServiceStack.Opms.EConsent.Models.Dos.StatusType)")
    public statusId?: StatusTypeEnum;

    public guid: string;
    public dateStarted?: string;
    public mobileNumber: string;
    public patientSigned?: boolean;
    public datePatientSigned?: string;
    public investigatorSigned?: boolean;
    public dateInvestigatorSigned?: string;
    public documentVerified?: boolean;
    public documentVerifiedBy: string;
    public dateDocumentVerified?: string;
    public dateNotificationSent?: string;
    public storageOfTissueSamples?: boolean;
    // @Ignore()
    public picfs: ConsentPicf[];

    // @Ignore()
    public documentUpload: ConsentFileUpload;

    public type: ConsentType;
    public status: StatusType;
    public eoi: Eoi;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<PatientConsent>) { (Object as any).assign(this, init); }
}

export interface IPatientConsentDelete extends IDelete
{
    id?: number;
}

export enum SaeStatus
{
    Added = 0,
    New = 1,
    AwaitingForReview = 2,
    Approved = 3,
    Rejected = 4,
    Invalid = 5,
}

export enum SaeRelatedness
{
    Unrelated = 1,
    Possible = 3,
    Probable = 4,
    Definite = 5,
}

export enum SaeExpectedness
{
    Expected = 1,
    Unexpected = 2,
}

export class MedicalReviewItem
{
    [immerable]? = true;

    public id?: number;
    public medicalReviewId?: number;
    public saeTreatmentCategoryId?: number;
    public typeId?: number;
    public dataEntered?: boolean;
    public latestRelatednessId?: number;
    public relatednessId?: SaeRelatedness;
    public expected?: SaeExpectedness;
    public comments: string;
    public notApplicable?: boolean;

    public constructor(init?: Partial<MedicalReviewItem>) { (Object as any).assign(this, init); }
}

export class MedicalReview
{
    [immerable]? = true;

    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public saeFollowUpNumber?: number;
    public date?: string;
    public saeStatus?: SaeStatus;
    public narrativeSummary: string;
    public items: MedicalReviewItem[];

    public constructor(init?: Partial<MedicalReview>) { (Object as any).assign(this, init); }
}

export enum QueryStatus
{
    Issued = 1,
    Responded = 2,
    Closed = 3,
    Cancelled = 4,
}

export class Query implements IDataModel
{
    [immerable]? = true;

    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public parentQueryId?: number;
    public queryNumber?: number;
    public repeat?: number;
    public question: string;
    public response: string;
    public recipientId?: number;
    public status?: QueryStatus;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Query>) { (Object as any).assign(this, init); }
}

export interface ISaeGetCollection extends IGet
{
}

export interface ISaeGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
}

export interface ISaeGetSingleByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
    saeNumber?: number;
}

export enum SaeWebActionTypeEnum
{
    MarkAsInvalid = 0,
    NotifiedSiteInvestigators = 1,
    Approved = 2,
    Rejected = 3,
    NotifiedSiteTc = 4,
    Reset = 5,
    NotifiedMedicalReviewers = 6,
    SubmittedMedicalReview = 7,
    NotifiedTeam = 8,
    NotifiedStudyChair = 9,
    NotifiedStudySponsor = 10,
}

export class SaeWebActionType
{
    [immerable]? = true;

    public id?: number;
    public value: string;

    public constructor(init?: Partial<SaeWebActionType>) { (Object as any).assign(this, init); }
}

export class WebAction
{
    [immerable]? = true;

    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public saeFollowUpNumber?: number;
    public actionType?: SaeWebActionTypeEnum;
    public actionDate?: string;
    public userName: string;
    public notes: string;
    public reasonForRejection: string;
    public rejectedAs: number;
    public recipients: string;
    public saeWebActionType: SaeWebActionType;

    public constructor(init?: Partial<WebAction>) { (Object as any).assign(this, init); }
}

export class SaeStudyDrugReviewForm
{
    [immerable]? = true;

    public studyDrug: string;
    public investigatorAssessment: string;
    public assessment: string;
    public comments: string;

    public constructor(init?: Partial<SaeStudyDrugReviewForm>) { (Object as any).assign(this, init); }
}

export class SaeExpectednessForm
{
    [immerable]? = true;

    public assessment: string;
    public comments: string;

    public constructor(init?: Partial<SaeExpectednessForm>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewForm
{
    [immerable]? = true;

    public studyDrugReviews: SaeStudyDrugReviewForm[];
    public expectedness: SaeExpectednessForm[];
    public isEventStatusDeath: boolean;

    public constructor(init?: Partial<SaeMedicalReviewForm>) { (Object as any).assign(this, init); }
}

export class SaeDocumentForm
{
    [immerable]? = true;

    public name: string;
    public file: File;

    public constructor(init?: Partial<SaeDocumentForm>) { (Object as any).assign(this, init); }
}

export enum SaeNotificationType
{
    NotifyInvestigator = 1,
    NotifyMedicalReviewer = 2,
}

export class SaeNotificationForm
{
    [immerable]? = true;

    public recipients: number[];
    public ccRecipients: number[];
    public notes: string;
    public notifyStudyChair?: boolean;
    public notifySponsor?: boolean;
    public attachments: SaeDocumentForm[];
    public notificationType: SaeNotificationType;
    public additionalData: { [index: string]: string; };

    public constructor(init?: Partial<SaeNotificationForm>) { (Object as any).assign(this, init); }
}

export enum InvalidSaeReason
{
    CriteriaNotMet = 1,
    Other = 2,
}

export class SaeFileUpload
{
    [immerable]? = true;

    public id?: number;
    public extension: string;
    public fileSize?: number;
    public contentType: string;
    public image: boolean;
    public exists: boolean;
    public upload: FileUploadTemporary;

    public constructor(init?: Partial<SaeFileUpload>) { (Object as any).assign(this, init); }
}

export class InvalidSaeFile implements IDataModel
{
    [immerable]? = true;

    public id?: number;
    public invalidSaeFormId?: number;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    // @Ignore()
    public fileUpload: SaeFileUpload;

    public constructor(init?: Partial<InvalidSaeFile>) { (Object as any).assign(this, init); }
}

export class InvalidSaeForm implements IDataModel
{
    [immerable]? = true;

    public id?: number;
    public patientStudyNumber: string;
    public saeNumber?: number;
    public comments: string;
    public date?: string;
    public appliedToOpenClinica?: boolean;
    public dateDeterminedInvalid?: string;
    public reason?: InvalidSaeReason;
    public reasonSpecify: string;
    public decidedById?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public files: InvalidSaeFile[];

    public constructor(init?: Partial<InvalidSaeForm>) { (Object as any).assign(this, init); }
}

export interface ILookupGetCollectionByFormDefinitionId extends IGet
{
    formDefinitionId?: number;
}

export interface IEventDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IEventDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IEventDefinitionGetCollection extends IGet
{
}

export interface IFormDefinitionGetSingleById extends IGet
{
    id?: number;
}

export interface IFormDefinitionGetSingleByCode extends IGet
{
    code: string;
}

export interface IFormDefinitionGetCollection extends IGet
{
}

export interface IPatientStateGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientStateGetCollection extends IGet
{
}

export interface ITreatmentGetSingleById extends IGet
{
    id?: number;
}

export interface ITreatmentGetCollection extends IGet
{
}

export interface IMasterGroupGetSingleById extends IGet
{
    id?: number;
}

export interface IMasterGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface IMasterGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetSingleById extends IGet
{
    id?: number;
}

export interface ICollaboratingGroupGetSingleByCode extends IGet
{
    code: string;
}

export interface ICollaboratingGroupGetCollection extends IGet
{
}

export interface ICollaboratingGroupGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICollaboratingGroupGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetSingleById extends IGet
{
    id?: number;
}

export interface ICountryGetSingleByCode extends IGet
{
    code: string;
}

export interface ICountryGetCollection extends IGet
{
}

export interface ICountryGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
}

export interface ICountryGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
}

export interface ICountryGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
}

export interface ICountryGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
}

export interface IInstitutionGetSingleById extends IGet
{
    id?: number;
}

export interface IInstitutionGetSingleByCode extends IGet
{
    code: string;
}

export interface IInstitutionGetCollection extends IGet
{
}

export interface IInstitutionGetCollectionByCountryId extends IGet
{
    countryId?: number;
}

export interface IInstitutionGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
}

export interface IInstitutionGetCollectionByCountryCode extends IGet
{
    countryCode: string;
}

export interface IInstitutionGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
}

export interface IInstitutionGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
}

export interface IPatientGetSingleById extends IGet
{
    id?: number;
}

export interface IPatientGetSingleByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetValidationById extends IGet
{
    id?: number;
    patientOnly?: boolean;
}

export interface IPatientGetValidationByStudyNumber extends IGet
{
    studyNumber: string;
    patientOnly?: boolean;
}

export interface IPatientGetCollection extends IGet
{
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupId extends IGet
{
    masterGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupId extends IGet
{
    collaboratingGroupId?: number;
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryId extends IGet
{
    countryId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionId extends IGet
{
    institutionId?: number;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByMasterGroupCode extends IGet
{
    masterGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCollaboratingGroupCode extends IGet
{
    collaboratingGroupCode: string;
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByCountryCode extends IGet
{
    countryCode: string;
    patientStateIds: number[];
}

export interface IPatientGetCollectionByInstitutionCode extends IGet
{
    institutionCode: string;
    patientStateIds: number[];
}

export class PatientStatusLog
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public patientStateId?: number;
    public notes?: string;
    public enteredDate?: string;
    public enteredBy?: string;

    public constructor(init?: Partial<PatientStatusLog>) { (Object as any).assign(this, init); }
}

export enum SaConsentStatus
{
    Pending = 1,
    PendingReview = 2,
    Complete = 3,
    Processed = 4,
}

// @DataContract
export class Patient implements IRegistrationPatient, IOpenClinicaPatient, IConsentPatient, IConsentServiceAustraliaPatient, IConsentTissueBankingPatient
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public studyNumber: string;

    // @DataMember(Order=3)
    public temporaryNumber: string;

    // @DataMember(Order=4)
    public registrationNumber: string;

    // @DataMember(Order=5)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.Treatment)")
    public treatmentId?: number;

    // @DataMember(Order=6)
    public institutionId?: number;

    // @DataMember(Order=7)
    public institutionCode: string;

    // @DataMember(Order=8)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.PatientState)")
    public patientStateId?: number;

    // @DataMember(Order=9)
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.PatientState)")
    public previousPatientStateId?: number;

    // @DataMember(Order=10)
    public patientStateChangeDate?: string;

    // @DataMember(Order=11)
    public initials: string;

    // @DataMember(Order=12)
    public screeningDate?: string;

    // @DataMember(Order=13)
    public consentDate?: string;

    // @DataMember(Order=14)
    public registrationDate?: string;

    // @DataMember(Order=15)
    public reviewDate?: string;

    // @DataMember(Order=16)
    public treatmentAllocationDate?: string;

    // @DataMember(Order=17)
    public exportedToOpenClinica?: string;

    // @DataMember(Order=18)
    public enteredDate?: string;

    // @DataMember(Order=19)
    public enteredBy: string;

    // @DataMember(Order=20)
    public modifiedDate?: string;

    // @DataMember(Order=21)
    public modifiedBy: string;

    // @DataMember(Order=22)
    public email?: string;

    // @DataMember(Order=23)
    public account?: boolean;

    // @DataMember(Order=24)
    public firstName?: string;

    // @DataMember(Order=25)
    public lastName?: string;

    // @DataMember(Order=26)
    public consentEvents: ConsentEvent[];

    // @DataMember(Order=27)
    public patientStatusLogs: PatientStatusLog[];

    // @DataMember(Order=28)
    // @Ignore()
    public ineligibleReason: string;

    // @DataMember(Order=29)
    // @Ignore()
    public servicesAustraliaConsentStatus?: SaConsentStatus;

    // @DataMember(Order=30)
    public preferredLocaleId?: number;

    // @DataMember(Order=31)
    public withdrawalStateId?: number;

    public constructor(init?: Partial<Patient>) { (Object as any).assign(this, init); }
}

export interface IEventGetValidationByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    eventOnly?: boolean;
}

export interface IEventGetSingleById extends IGet
{
    id?: number;
}

export interface IEventGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
}

export interface IEventGetCollection extends IGet
{
}

export interface IEventGetCollectionByPatientId extends IGet
{
    patientId?: number;
}

export interface IEventGetCollectionByPatientStudyNumber extends IGet
{
    patientStudyNumber: string;
}

export class Event implements IEvent
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventDefinitionId?: number;
    public repeat?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Event>) { (Object as any).assign(this, init); }
}

export interface IFormGetSingleById extends IGet
{
    id?: number;
}

export interface IFormGetSingleByIds extends IGet
{
    institutionId?: number;
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetSingleByCodes extends IGet
{
    institutionCode: string;
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
    formRepeat?: number;
    createPatient?: boolean;
    createEvent?: boolean;
    createForm?: boolean;
}

export interface IFormGetCollection extends IGet
{
}

export interface IFormGetCollectionByIds extends IGet
{
    patientId?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export interface IFormGetCollectionByCodes extends IGet
{
    patientStudyNumber: string;
    eventDefinitionCode: string;
    eventRepeat?: number;
}

export class ImageReportDocument implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public fileTypeId?: number;
    public fileDate?: string;
    public file?: File;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ImageReportDocument>) { (Object as any).assign(this, init); }
}

export class SourceDocument implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public repeat?: number;
    public name: string;
    public fileTypeId?: number;
    public file?: File;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SourceDocument>) { (Object as any).assign(this, init); }
}

export class SystemErrorDetails implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public eventErrorsByPassed?: number;
    public formName: string;
    public fieldName: string;
    public details: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SystemErrorDetails>) { (Object as any).assign(this, init); }
}

export class SystemErrorInfo implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public eventErrorsByPassed?: number;
    public approvedBy?: number;
    public approvedByOther: string;
    public dateSystemErrorByPassed?: string;
    public reason: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SystemErrorInfo>) { (Object as any).assign(this, init); }
}

export class SystemErrorSourceDocument implements IForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public eventErrorsByPassed?: number;
    public name: string;
    public fileTypeId?: number;
    public file: File;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SystemErrorSourceDocument>) { (Object as any).assign(this, init); }
}

export class SystemErrorForm implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public exportedToOpenClinica?: string;
    public systemErrorInfo: SystemErrorInfo[];
    public systemErrorDetails: SystemErrorDetails[];
    public systemErrorSourceDocuments: SystemErrorSourceDocument[];
    // @Ignore()
    public registrationRadiologist?: number;

    // @Ignore()
    public newPatientStatus?: number;

    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<SystemErrorForm>) { (Object as any).assign(this, init); }
}

export class BreastCancerTreatmentOutcomesScale implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public breastSizeScore?: number;
    public breastTextureScore?: number;
    public armHeavinessScore?: number;
    public nippleAppearanceScore?: number;
    public shoulderMovementScore?: number;
    public armMovementScore?: number;
    public breastPainScore?: number;
    public abilityToLiftObjectsScore?: number;
    public fitOfShirtSleeveScore?: number;
    public breastTendernessScore?: number;
    public shoulderStiffnessScore?: number;
    public breastShapeScore?: number;
    public breastElevationScore?: number;
    public scarTissueScore?: number;
    public shoulderPainScore?: number;
    public armPainScore?: number;
    public armSwellingScore?: number;
    public breastSwellingScore?: number;
    public armStiffnessScore?: number;
    public fitOfBraScore?: number;
    public breastSensitivityScore?: number;
    public fitOfClothingScore?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScale>) { (Object as any).assign(this, init); }
}

export class BriefIllnessPerceptionQuestionnaire implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public affectOnLifeScore?: number;
    public thoughtsOnCancerDurationScore?: number;
    public controlOverCancerScore?: number;
    public benefitOfTreatmentScore?: number;
    public symptomsExperiencedFrequencyScore?: number;
    public levelOfConcernScore?: number;
    public confidenceInUnderstandingCancerScore?: number;
    public emotionalEffectScore?: number;
    public believedCancerFactor1?: string;
    public believedCancerFactor2?: string;
    public believedCancerFactor3?: string;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaire>) { (Object as any).assign(this, init); }
}

export class DecisionRegretScale implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public rightDecision?: number;
    public regretTheDecision?: number;
    public makeSameDecisionAgain?: number;
    public decisionDidMeHarm?: number;
    public wiseDecision?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<DecisionRegretScale>) { (Object as any).assign(this, init); }
}

export class EndocrineTherapyAdherence implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public prescribedEndocrineTherapy?: number;
    public endocrineTherapyContinuation?: number;
    public endocrineTherapyDiscontinuationReason?: number;
    public endocrineTherapyDiscontinuationReasonSpecify?: string;
    public iHaveHotFlashes?: number;
    public iHaveColdSweats?: number;
    public iHaveNightSweats?: number;
    public iHaveVaginalDischarge?: number;
    public iHaveVaginalIrritation?: number;
    public iHaveVaginalBleeding?: number;
    public iHaveVaginalDryness?: number;
    public iHavePainWithIntercourse?: number;
    public iHaveLostInterestInSex?: number;
    public iHaveGainedWeight?: number;
    public iFeelDizzy?: number;
    public iHaveBeenVommiting?: number;
    public iHaveDiarrhea?: number;
    public iGetHeadaches?: number;
    public iFeelBloated?: number;
    public iHaveBreastSensitivity?: number;
    public iHaveMoodSwings?: number;
    public iAmIrritable?: number;
    public iHaveJointPain?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<EndocrineTherapyAdherence>) { (Object as any).assign(this, init); }
}

export class EortcIL353 implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public restNeeded?: number;
    public feltWeak?: number;
    public feltTired?: number;
    public experiencedFinancialDifficulties?: number;
    public feltLessAttractive?: number;
    public feltLessFeminine?: number;
    public difficultyViewingNakedSelf?: number;
    public dissatisifiedWithBody?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<EortcIL353>) { (Object as any).assign(this, init); }
}

export class EQ5D5L implements IProFormNotComplete, IOpenClinicaForm, IProFormDateCompleted
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public mobilityScore?: number;
    public selfCareScore?: number;
    public usualActivitiesScore?: number;
    public discomfortScore?: number;
    public anxietyDepressionScore?: number;
    public healthScore?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<EQ5D5L>) { (Object as any).assign(this, init); }
}

export class ExperienceAndImpactOfTreatment implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public experienceAndImpactSpecify?: string;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatment>) { (Object as any).assign(this, init); }
}

export class FearOfCancerRecurrence implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public iAmWorriedAboutRecurrence?: number;
    public iAmAfraidOfRecurrence?: number;
    public iBelieveItIsNormal?: number;
    public iThinkOfUnpleasantThoughts?: number;
    public iBelieveImCured?: number;
    public cancerRecurrenceOpinion?: number;
    public frequencyOfCancerRecurrenceThoughts?: number;
    public frequencyOfCancerRecurrenceThoughtsPerDay?: number;
    public cancerRecurrencePeriodOfThought?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<FearOfCancerRecurrence>) { (Object as any).assign(this, init); }
}

export class GeneralizedAnxietyDisorder2 implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public nervousAnxious?: number;
    public worrying?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2>) { (Object as any).assign(this, init); }
}

export class InternationalPersonalityItemPool implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public iFeelBlue?: number;
    public iDislikeMyself?: number;
    public iFeelDown?: number;
    public iHaveMoodSwings?: number;
    public iPanicEasily?: number;
    public iIrritateRarely?: number;
    public iSeldomFeelBlue?: number;
    public iFeelComfortable?: number;
    public iNotEasilyBothered?: number;
    public iAmVeryPleased?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<InternationalPersonalityItemPool>) { (Object as any).assign(this, init); }
}

export class PatientHealthQuestionnaire2 implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public interestOrPleasureRating?: number;
    public depressedRating?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<PatientHealthQuestionnaire2>) { (Object as any).assign(this, init); }
}

export class RiskAppraisal implements IProFormNotComplete, IProFormDateCompleted, IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public patientId?: number;
    public parentFormId?: number;
    public parentFormDefinitionId?: number;
    public eventId?: number;
    public repeat?: number;
    public completed?: boolean;
    public ptDidNotComplete?: boolean;
    public dateCompleted?: string;
    public likelihoodOfReappearance?: number;
    public likelihoodOfReappearanceElsewhere?: number;
    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<RiskAppraisal>) { (Object as any).assign(this, init); }
}

export class ProcomidaIncomplete implements IForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formDefinitionId?: number;
    public patientRefusal?: boolean;
    public patientIll?: boolean;
    public other?: boolean;
    public otherSpecify: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ProcomidaIncomplete>) { (Object as any).assign(this, init); }
}

export class ProcomidaAssistance implements IForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public formDefinitionId?: number;
    public assistanceReadAllowed?: boolean;
    public assistanceClarificationRequired?: boolean;
    public assistanceIndependentlyCompleted?: boolean;
    public assistanceOther?: boolean;
    public assistanceOtherSpecify: string;
    public reasonCouldNotRead?: boolean;
    public reasonOther?: boolean;
    public reasonOtherSpecify: string;
    public assistedByStaff?: boolean;
    public assistedByFamily?: boolean;
    public assistedByFriend?: boolean;
    public assistedByOther?: boolean;
    public assistedByOtherSpecify: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ProcomidaAssistance>) { (Object as any).assign(this, init); }
}

export class Procomida implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public allProsCompleted?: number;
    public patientRequiredAssistance?: number;
    public incompleteForms?: ProcomidaIncomplete[];
    public assistedForms?: ProcomidaAssistance[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;
    public exportedToOpenClinica?: string;

    public constructor(init?: Partial<Procomida>) { (Object as any).assign(this, init); }
}

export enum LookupScreeningOutcomeType
{
    Proceed = 1,
    Fail = 2,
}

export class ScreeningForm implements IScreeningForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public initials?: string;
    public yearOfBirth?: number;
    public outcome?: LookupScreeningOutcomeType;
    public screenFailReason?: number;
    // @Ignore()
    public participantEmail?: string;

    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ScreeningForm>) { (Object as any).assign(this, init); }
}

export class WithdrawalOfConsent implements IForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public dateOfConsentWithdrawal?: string;
    public reasonForWithdrawal?: number;
    public reasonForWithdrawalSpecify?: string;
    public agreeToBeContactedByTelephone?: number;
    public agreeToCollectHealthInfo?: number;
    public agreeToUseOfImages?: number;
    public agreeToKeepProvidingSamples?: number;
    public agreeToKeepCompletingProms?: number;
    public agreeToUseServicesAustraliaInfo?: number;
    public agreeBiologicalSamples?: number;
    public agreeBiologicalSamplesSpecify?: number;
    public agreeDataLinkage?: number;
    public servicesAustraliaWithdrawalOfConsentCompleted?: number;
    public indicatedToDestroyOrRetainHealthInfo?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<WithdrawalOfConsent>) { (Object as any).assign(this, init); }
}

export class DiagnosticImaging implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public primaryTumourSide?: number;
    public primaryTumourDetection?: number;
    public mmg?: number;
    public mmg2D?: boolean;
    public mmg2DDate?: string;
    public mmgTomo?: boolean;
    public mmgTomoDate?: string;
    public mmgCEM?: boolean;
    public mmgCEMDate?: string;
    public usPerformed?: number;
    public usPerformedDate?: string;
    public mriPerformed?: number;
    public mriShowedParenchymalEnhancement?: number;
    public coreBiopsyDate?: string;
    public lymphovascularInvasionReported?: number;
    public erSymbol?: number;
    public erStainedValue?: number;
    public erIntensity?: number;
    public erCat?: number;
    public prSymbol?: number;
    public prStainedValue?: number;
    public prIntensity?: number;
    public prCat?: number;
    public her2Ihc?: number;
    public her2Ish?: number;
    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<DiagnosticImaging>) { (Object as any).assign(this, init); }
}

export class GeneralAndConsent implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public isFemale?: number;
    public ageAtEntry?: number;
    public initials?: string;
    public hasPerformedClinicalReview?: number;
    public performedClinicalReviewDate?: string;
    public ecogStatus?: number;
    public postcode?: string;
    public ethnicityId?: number;
    public ethnicityNotStatedUnknown?: boolean;
    public countryId?: number;
    public countryOther?: boolean;
    public countryOtherSpecify?: string;
    public languageSpokenAsChildId?: number;
    public languageSpokenAsChildOther?: boolean;
    public languageSpokenAsChildOtherSpecify?: string;
    public languagePrinciple?: number;
    public languagePrincipleOther?: boolean;
    public languagePrincipleOtherSpecify?: string;
    public treatment?: number;
    public registrationDate?: string;
    public allocationDate?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<GeneralAndConsent>) { (Object as any).assign(this, init); }
}

export class ImageReportUpload implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public dateMriPerformed?: string;
    public mriReportUpload?: File;
    public imageReportDocuments?: ImageReportDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ImageReportUpload>) { (Object as any).assign(this, init); }
}

export class MedicalHistory implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public previousRT?: number;
    public takingHRT?: number;
    public etUseBaseline?: number;
    public hormonalContraception?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MedicalHistory>) { (Object as any).assign(this, init); }
}

export class Proms implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public speaksEnglish?: number;
    public highestEducationLevel?: number;
    public relationshipStatus?: number;
    public carerResponsibilities?: number;
    public dependentChildren?: boolean;
    public dependentAdults?: boolean;
    public parity?: number;
    public ageOfYoungestChildLength?: number;
    public ageOfYoungestChild?: number;
    public treatedForAnxietyOrDepression?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Proms>) { (Object as any).assign(this, init); }
}

export class RegistrationEligibilityChecklist implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public breastCancerEligibility?: number;
    public tenYearsFollowUp?: number;
    public performedBreastImaging?: number;
    public willingToHaveSurgery?: number;
    public tripleNegativeBreastCancer?: number;
    public previousDCIS?: number;
    public planToHaveMastectomy?: number;
    public lviReported?: number;
    public multifocalBreastCancer?: number;
    public distantMetastasis?: number;
    public bilateralBreastCancer?: number;
    public geneMutation?: number;
    public contraindicationToMRI?: number;
    public concurrentIllness?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<RegistrationEligibilityChecklist>) { (Object as any).assign(this, init); }
}

export class CEMReportLesion implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public lesionNumber?: number;
    public lesionType?: number;
    public lesionSide?: number;
    public lesionLocation?: number;
    public lesionSize?: number;
    public primaryLesionBirads?: number;
    public secondaryLesionBirads?: number;
    public lesionCorrespondance?: number;
    public lesionCorrespondanceLesion?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CEMReportLesion>) { (Object as any).assign(this, init); }
}

export class MammographyReportLesion implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public lesionNumber?: number;
    public primaryLesionType?: number;
    public secondaryLesionType?: number;
    public lesionSide?: number;
    public lesionLocation?: number;
    public lesionSize?: number;
    public primaryLesionBirads?: number;
    public secondaryLesionBirads?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MammographyReportLesion>) { (Object as any).assign(this, init); }
}

export class MRIReportLesion implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public lesionNumber?: number;
    public lesionType?: number;
    public lesionSide?: number;
    public lesionLocation?: number;
    public lesionSize?: number;
    public primaryLesionBirads?: number;
    public secondaryLesionBirads?: number;
    public primaryLesionClassification?: number;
    public secondaryLesionClassification?: number;
    public secondaryLesionClassificationMinimumDistance?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MRIReportLesion>) { (Object as any).assign(this, init); }
}

export class UltrasoundReportLesion implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public lesionNumber?: number;
    public primaryLesionType?: number;
    public secondaryLesionType?: number;
    public lesionTypeSpecify?: string;
    public lesionSide?: number;
    public lesionLocation?: number;
    public lesionSize?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<UltrasoundReportLesion>) { (Object as any).assign(this, init); }
}

export class RadiologyReport implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public mammographyPerformed?: boolean;
    public mammographyBreastDensityAssignment?: number;
    public mammographyBiradsBreastDensityScore?: number;
    public mammographyLesions?: MammographyReportLesion[];
    public ultrasoundPerformed?: boolean;
    public ultrasoundLesions?: UltrasoundReportLesion[];
    public parenchymalEnhancementScoreRight?: number;
    public parenchymalEnhancementScoreLeft?: number;
    public mriLesions?: MRIReportLesion[];
    public cemPerformed?: boolean;
    public cemParenchymalEnhancementScoreRight?: number;
    public cemParenchymalEnhancementScoreLeft?: number;
    public cemBreastDensityScore?: number;
    public cemBiradsBreastDensityScore?: number;
    public cemLesions?: CEMReportLesion[];
    public radiologist?: number;
    public completedBy: string;
    // @Ignore()
    public complete: boolean;

    public sourceDocuments?: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<RadiologyReport>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsent implements IConsentForm, IOpenClinicaForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public patientId?: number;

    // @DataMember(Order=4)
    public eventId?: number;

    // @DataMember(Order=5)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=6)
    public parentFormId?: number;

    // @DataMember(Order=7)
    public exportedToOpenClinica?: string;

    // @DataMember(Order=8)
    // @Ignore()
    public consentEvent: ConsentEvent;

    // @DataMember(Order=9)
    public picfId?: number;

    // @DataMember(Order=10)
    public picfVersion?: string;

    // @DataMember(Order=11)
    public picfVersionSpecify?: string;

    // @DataMember(Order=12)
    public patientSignedConsent?: number;

    // @DataMember(Order=13)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=14)
    public participantAgreedToDisclosureOfInformation?: number;

    // @DataMember(Order=19)
    public sourceDocuments: SourceDocument[];

    // @DataMember(Order=20)
    // @Ignore()
    public formDefinition?: FormDefinition;

    // @DataMember(Order=25)
    // @Ignore()
    public patientName: string;

    // @DataMember(Order=26)
    // @Ignore()
    public patientSigning: boolean;

    // @DataMember(Order=28)
    public consentTypeId?: ConsentTypeEnum;

    // @DataMember(Order=29)
    public saConsentStatus?: SaConsentStatus;

    // @DataMember(Order=30)
    public consentFormVersion?: string;

    // @DataMember(Order=31)
    public consentFormDate?: string;

    // @DataMember(Order=32)
    public currentTmdConsentFormVersion?: number;

    // @DataMember(Order=33)
    public participantSignedCorrectVersion?: number;

    // @DataMember(Order=34)
    public consentFullyCompleted?: number;

    // @DataMember(Order=35)
    public correctionsSigned?: number;

    // @DataMember(Order=36)
    public witnessIdentityConfirmed?: number;

    // @DataMember(Order=37)
    public additionalComments?: string;

    // @DataMember(Order=38)
    public isHistoryEntry?: boolean;

    // @DataMember(Order=39)
    public reviewedBy?: string;

    // @DataMember(Order=40)
    public reviewedDate?: string;

    // @DataMember(Order=21)
    public enteredDate?: string;

    // @DataMember(Order=22)
    public enteredBy: string;

    // @DataMember(Order=23)
    public modifiedDate?: string;

    // @DataMember(Order=24)
    public modifiedBy: string;

    public constructor(init?: Partial<ServicesAustraliaConsent>) { (Object as any).assign(this, init); }
}

export class AdditionalCancerDetail implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public additionalTumourSide?: number;
    public additionalTumourSize?: number;
    public histopathologicType?: number;
    public histopathologicTypeSpecify?: string;
    public histologicGrade?: number;
    public multifocality?: number;
    public lymphovascularInvasionPresent?: number;
    public additionalDCISUnrelated?: number;
    public estrogenReceptor?: number;
    public progesteroneReceptor?: number;
    public her2Ihc?: number;
    public her2Ish?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<AdditionalCancerDetail>) { (Object as any).assign(this, init); }
}

export class AdditionalCancer implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public undetectedCancersRemoved?: number;
    public additionalCancerDetails?: AdditionalCancerDetail[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<AdditionalCancer>) { (Object as any).assign(this, init); }
}

export class AdverseEvent implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public ctcaeTermId?: number;
    public ctcaeGradeId?: number;
    public ctcaeSpecification?: string;
    public onsetDate?: string;
    public resolutionDate?: string;
    public resolutionOngoing?: boolean;
    public consequence?: number;
    public treatmentGiven?: number;
    public treatmentGivenSpecify?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<AdverseEvent>) { (Object as any).assign(this, init); }
}

export class BreastMriAdditionalLesion implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public lesionNumber?: number;
    public lesionType?: number;
    public lesionSide?: number;
    public lesionLocation?: number;
    public lesionSize?: number;
    public birads?: number;
    public biopsyMethod?: number;
    public pathology?: number;
    public pathologySpecify?: string;
    public grade?: number;
    public estrogenReceptor?: number;
    public progesteroneReceptor?: number;
    public her2Ihc?: number;
    public her2Ish?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<BreastMriAdditionalLesion>) { (Object as any).assign(this, init); }
}

export class BreastMri implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public mriDatePerformed?: string;
    public primaryLesionSide?: number;
    public parenchymalEnhancementLeftBreast?: number;
    public parenchymalEnhancementRightBreast?: number;
    public additionalLesionsPresent?: number;
    public additionalLesionsPresentTotal?: number;
    public experiencedAdverseEventToMri?: number;
    public breastMriAdditionalLesions?: BreastMriAdditionalLesion[];
    public adverseEvents?: AdverseEvent[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<BreastMri>) { (Object as any).assign(this, init); }
}

export class ContrastEnhancedMammogram implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public cemPerformed?: number;
    public cemPerformedDate?: string;
    public cemLesionsNotFoundInMri?: number;
    public mriLesionsNotFoundInCem?: number;
    public mriR2NotFoundInCem?: boolean;
    public mriR3NotFoundInCem?: boolean;
    public mriR4NotFoundInCem?: boolean;
    public mriR5NotFoundInCem?: boolean;
    public mriR6NotFoundInCem?: boolean;
    public mriOtherNotFoundInCem?: boolean;
    public mriLesionsNotFoundInCemIdentifiedSpecify?: string;
    public additionalLesions?: BreastMriAdditionalLesion[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<ContrastEnhancedMammogram>) { (Object as any).assign(this, init); }
}

export class Histopathology implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public indexTumourSize?: number;
    public invasiveSize?: number;
    public dcisSize?: number;
    public tumourHistopathologyType?: number;
    public tumourHistopathologyTypeSpecify?: string;
    public histologicGradeOfTumour?: number;
    public dcis?: number;
    public lymphovascularInvasionPresent?: number;
    public multifocality?: number;
    public radialMarginPostSurgeryGT2?: number;
    public closestRadialMarginOperator?: number;
    public closestRadialMarginValue?: number;
    public closestSuperficialMarginOperator?: number;
    public closestSuperficialMarginValue?: number;
    public breastTissueRespectivelyRemoved?: number;
    public ki67AssessmentResult?: number;
    public ki67NotDone?: boolean;
    public hormoneReceptorTested?: number;
    public sxEROperator?: number;
    public sxERValue?: number;
    public sxERIntensity?: number;
    public sxERCat?: number;
    public sxPROperator?: number;
    public sxPRValue?: number;
    public sxPRIntensity?: number;
    public sxPRCat?: number;
    public sxIHC?: number;
    public sxISH?: number;
    public sourceDocuments: SourceDocument[];
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Histopathology>) { (Object as any).assign(this, init); }
}

export class Surgery implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public indexLesionBreastConvervingSurgeryDate?: string;
    public indexLesionBreastConvervingSurgeryNotDone?: boolean;
    public indexLesionBcsMarginReExcision1Date?: string;
    public indexLesionBcsMarginReExcision1NotDone?: boolean;
    public indexLesionBcsMarginReExcision2Date?: string;
    public indexLesionBcsMarginReExcision2NotDone?: boolean;
    public indexLesionUnilateralMastectomyDate?: string;
    public indexLesionUnilateralMastectomyNotDone?: boolean;
    public indexLesionBilateralMastectomyDate?: string;
    public indexLesionBilateralMastectomyNotDone?: boolean;
    public malignantLesionSurgeryPerformed?: number;
    public malignantLesionBreastConvervingSurgerySameExcisionDate?: string;
    public malignantLesionBreastConvervingSurgerySameExcisionNotDone?: boolean;
    public malignantLesionBreastConvervingSurgerySeparateExcisionDate?: string;
    public malignantLesionBreastConvervingSurgerySeparateExcisionNotDone?: boolean;
    public malignantLesionBreastConvervingSurgeryContralateralDate?: string;
    public malignantLesionBreastConvervingSurgeryContralateralNotDone?: boolean;
    public malignantLesionBcsMarginReExcision1Date?: string;
    public malignantLesionBcsMarginReExcision1NotDone?: boolean;
    public malignantLesionBcsMarginReExcision2Date?: string;
    public malignantLesionBcsMarginReExcision2NotDone?: boolean;
    public malignantLesionBcsMarginReExcision1ContralateralDate?: string;
    public malignantLesionBcsMarginReExcision1ContralateralNotDone?: boolean;
    public malignantLesionBcsMarginReExcision2ContralateralDate?: string;
    public malignantLesionBcsMarginReExcision2ContralateralNotDone?: boolean;
    public malignantLesionUnilateralMastectomyDate?: string;
    public malignantLesionUnilateralMastectomyNotDone?: boolean;
    public malignantLesionBilateralMastectomyDate?: string;
    public malignantLesionBilateralMastectomyNotDone?: boolean;
    public sentinelLymphNodeBiopsyDate?: string;
    public sentinelLymphNodeBiopsyNotDone?: boolean;
    public numberSentinelNodesRemoved?: number;
    public numberSentinelNodesPositive?: number;
    public numberSentinelNodesPositiveItcs?: number;
    public numberSentinelNodesPositiveMicrometastases?: number;
    public numberSentinelNodesPositiveMetastases?: number;
    public numberSentinelNodesNegative?: number;
    public lymphNodePathology?: number;
    public axillaryDissectionDate?: string;
    public axillaryDissectionNotDone?: boolean;
    public numberAuxillaryNodesRemoved?: number;
    public numberAuxillaryNodesPositive?: number;
    public numberAuxillaryNodesPositiveItcs?: number;
    public numberAuxillaryNodesPositiveMicrometastases?: number;
    public numberAuxillaryNodesPositiveMetastases?: number;
    public numberAuxillaryNodesNegative?: number;
    public auxillaryNodesPathology?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Surgery>) { (Object as any).assign(this, init); }
}

export class TissueCollection implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public tissueSampleSubmitted?: number;
    public tissueSampleSubmittedSpecify?: string;
    public tissueCollectionTimepoint?: number;
    public dateOfCollection?: string;
    public blockNumbersForFFPE?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TissueCollection>) { (Object as any).assign(this, init); }
}

export class TranslationalBloodCollection implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public preSurgeryBloodSample?: number;
    public preSurgeryBloodSampleDate?: string;
    public preSurgeryBloodSampleTime?: string;
    public numberStreckTubes?: number;
    public streckTubeExpiry?: string;
    public strekStockType?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TranslationalBloodCollection>) { (Object as any).assign(this, init); }
}

export class TreatmentDecisions implements IOpenClinicaForm
{
    [immerable]? = true;

    public id?: number;
    public repeat?: number;
    public patientId?: number;
    public eventId?: number;
    public parentFormDefinitionId?: number;
    public parentFormId?: number;
    public exportedToOpenClinica?: string;
    public radiationTherapyRecommended?: number;
    public radiationTherapyChosen?: number;
    public systemicTreatmentCompliance?: number;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<TreatmentDecisions>) { (Object as any).assign(this, init); }
}

export interface IPatientGetEventStatesById extends IGet
{
    id?: number;
}

export interface IPatientGetEventStatesByStudyNumber extends IGet
{
    studyNumber: string;
}

export interface IPatientGetFormStatesByIds extends IGet
{
    id?: number;
    eventDefinitionId?: number;
    eventRepeat?: number;
}

export enum Permission
{
    OpmsAccess = 1,
    OpmsInstitutionView = 2,
    OpmsAdminister = 3,
    OpmsPatientView = 4,
    SystemAdminister = 5,
    OpmsPatientUpdate = 6,
    OpmsMasterGroupAdminister = 7,
    OpmsCoordinatingGroupAdminister = 8,
    PathologyTestAdminister = 9,
    BlockShipmentDetailsView = 10,
    OpmsPatientRegister = 11,
    OpmsPatientRandomise = 12,
    SaeView = 13,
    SaeReview = 14,
    ScreeningLogView = 15,
    ScreeningLogUpdate = 16,
    TeleformView = 17,
    TeleformManage = 18,
    EcrfView = 19,
    SaeAdminister = 20,
    MedicalReviewAccess = 21,
    MedicalReviewPerform = 22,
    MedicalReviewAdminister = 23,
    HistopathologyAccess = 24,
    DrugManagementView = 25,
    DrugManagementAdminister = 26,
    DrugManagementDispenseDrug = 27,
    OpmsProView = 28,
    OpmsProUpdate = 29,
    OpmsProAdminister = 30,
    OpmsPatientImpersonate = 31,
    OpmsPatientAccountManagement = 32,
    OpmsCrfView = 33,
    OpmsCrfUpdate = 34,
    OpmsEventView = 35,
    OpmsEventUpdate = 36,
    OpmsConsentAdminister = 37,
    OpmsCoordinatingGroupContactView = 38,
    OpmsSaeInvestigatorNotify = 39,
    EConsentView = 40,
    EConsentAdminister = 41,
    EConsentManage = 42,
    PISignOffView = 43,
    PISignOffPerform = 44,
    PISignOffAdminister = 45,
    OpmsDataManage = 46,
    RedactVerificationAccess = 47,
    ReconsentAdminister = 48,
    TrialManagementAccess = 49,
    SourceDataVerificationAccess = 50,
    TrialParticipantAccess = 51,
    StaffTrainingAccess = 52,
    TrainingAccess = 53,
    ReportAccess = 54,
    WebsiteImporterAccess = 55,
    ConstituentManagerAccess = 56,
    OpmsBypassErrors = 57,
    RadiologyReviewAccess = 58,
    ApproveInvoice = 59,
    PrescreeningAccess = 60,
    PrescreeningAdminister = 61,
    InvoiceExportView = 62,
    InvoiceExportUpdate = 63,
    InvoiceRequisitionView = 64,
    InvoiceRequisitionUpdate = 65,
    CanCentralReview = 66,
    InvoiceView = 67,
    InvoiceUpdate = 68,
    IsSiteUser = 69,
}

export class EventDefinitionFormDefinitionState implements IEventDefinitionFormDefinitionState
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinitionFormDefinition)")
    public eventDefinitionFormDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<EventDefinitionFormDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionFormDefinition
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.FormDefinition)")
    public formDefinitionId?: number;

    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public states: EventDefinitionFormDefinitionState[];

    public constructor(init?: Partial<EventDefinitionFormDefinition>) { (Object as any).assign(this, init); }
}

export class EventDefinitionState implements IEventDefinitionState
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public patientStateId?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;

    public constructor(init?: Partial<EventDefinitionState>) { (Object as any).assign(this, init); }
}

export class EventDefinitionErrorMessage implements IEventDefinitionErrorMessage
{
    [immerable]? = true;

    public id?: number;
    // @References("typeof(NewtonGreen.ServiceStack.Opms.Models.Configuration.EventDefinition)")
    public eventDefinitionId?: number;

    public errorCode: string;
    public message: string;
    public detailedMessage: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventDefinitionErrorMessage>) { (Object as any).assign(this, init); }
}

export class EventDefinition
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public code: string;
    public repeating?: boolean;
    public minimumRepeat?: number;
    public maximumRepeat?: number;
    public order?: number;
    public formDefinitions: EventDefinitionFormDefinition[];
    public states: EventDefinitionState[];
    public errorMessages: EventDefinitionErrorMessage[];

    public constructor(init?: Partial<EventDefinition>) { (Object as any).assign(this, init); }
}

export class PatientState implements IPatientState
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public order?: number;

    public constructor(init?: Partial<PatientState>) { (Object as any).assign(this, init); }
}

export class Treatment implements ITreatment
{
    [immerable]? = true;

    public id?: number;
    public name: string;

    public constructor(init?: Partial<Treatment>) { (Object as any).assign(this, init); }
}

export class SentrySettings
{
    [immerable]? = true;

    public dsn?: string;
    public environment?: string;
    public customer?: string;
    public sendDefaultPii?: boolean;
    public enableMetrics?: boolean;
    public attachStacktrace?: boolean;
    public debug?: boolean;
    public enableLogs?: boolean;
    public enableReportABug?: boolean;
    public replaysOnErrorSampleRate?: number;
    public replaysSessionSampleRate?: number;
    public tracesSampleRate?: number;

    public constructor(init?: Partial<SentrySettings>) { (Object as any).assign(this, init); }
}

export class ClientAppSettings
{
    [immerable]? = true;

    public sentry?: SentrySettings;

    public constructor(init?: Partial<ClientAppSettings>) { (Object as any).assign(this, init); }
}

export class PicfType
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public label: string;
    public fileName: string;

    public constructor(init?: Partial<PicfType>) { (Object as any).assign(this, init); }
}

export class Picf
{
    [immerable]? = true;

    public type: PicfType;
    public picfId?: number;
    public name: string;
    public label: string;
    public version: string;
    public fileName: string;
    public file: string;

    public constructor(init?: Partial<Picf>) { (Object as any).assign(this, init); }
}

export interface IEConsentForm extends IConsentForm, IHasInvestigator
{
}

export class MasterGroup implements IMasterGroup
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<MasterGroup>) { (Object as any).assign(this, init); }
}

export class CollaboratingGroup implements ICollaboratingGroup
{
    [immerable]? = true;

    public id?: number;
    public masterGroupId?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<CollaboratingGroup>) { (Object as any).assign(this, init); }
}

export class Country implements ICountry
{
    [immerable]? = true;

    public id?: number;
    public code: string;
    public name: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Country>) { (Object as any).assign(this, init); }
}

export class Institution implements IInstitution
{
    [immerable]? = true;

    public id?: number;
    public countryId?: number;
    public masterGroupId?: number;
    public collaboratingGroupId?: number;
    public code: string;
    public name: string;
    public enabled?: boolean;
    public activatedDate?: string;
    public recruitmentDisabled?: boolean;
    public eConsentActivationDate?: string;
    public enteredDate?: string;
    public enteredBy: string;
    public modifiedDate?: string;
    public modifiedBy: string;

    public constructor(init?: Partial<Institution>) { (Object as any).assign(this, init); }
}

export interface IEvent extends IDataModel, IHasPatientId, IHasEventDefinitionId
{
    repeat?: number;
}

export class Locale
{
    [immerable]? = true;

    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<Locale>) { (Object as any).assign(this, init); }
}

export class Namespace
{
    [immerable]? = true;

    public id?: number;
    public code?: string;
    public name?: string;

    public constructor(init?: Partial<Namespace>) { (Object as any).assign(this, init); }
}

export class PerformanceTestResult
{
    [immerable]? = true;

    public test: string;
    public testCount?: number;
    public first?: string;
    public last?: string;
    public minimum?: string;
    public maximum?: string;
    public average?: string;
    public metadata: { [index: string]: Object; };

    public constructor(init?: Partial<PerformanceTestResult>) { (Object as any).assign(this, init); }
}

export class AllocationData
{
    [immerable]? = true;

    public form: string;
    public label: string;
    public value: string;
    public order?: number;

    public constructor(init?: Partial<AllocationData>) { (Object as any).assign(this, init); }
}

export class PatientAllocationFactors implements IPatientAllocationFactors
{
    [immerable]? = true;

    public studyNumber: string;
    public coreBiopsyEr?: number;
    public surgicalSampleIsh?: number;
    public coreBiopsyIsh?: number;
    public surgicalSampleIhc?: number;
    public coreBiopsyIhc?: number;
    public surgicalSampleGrade?: number;
    public er?: number;
    public her2?: number;
    public grade?: number;
    public bmriParenchymalEnhancementLeft?: number;
    public bmriParenchymalEnhancementRight?: number;
    public bmriAdditionalLesionDcisOrMalignantPathologyCount?: number;
    public cemAdditionalLesionDcisOrMalignantPathologyCount?: number;
    public surgeryIndexLesionUnilateralMastectomyDate?: string;
    public surgeryIndexLesionBilateralMastectomyDate?: string;
    public surgeryMalignantLesionUnilateralMastectomyDate?: string;
    public surgeryMalignantLesionBilateralMastectomyDate?: string;
    public surgerySentinelLymphNodePathology?: number;
    public surgeryAuxillaryNodesPathology?: number;
    public histopathologyIndexTumourSize?: number;
    public histopathologyInvasiveSize?: number;
    public histopathologyDcis?: number;
    public histopathologyDcisSize?: number;
    public histopathologyLymphovascularInvasionPresent?: number;
    public histopathologyMultifocality?: number;
    public histopathologyRadialMargin?: number;
    public histopathologyClosestSuperficialMarginOperator?: number;
    public histopathologyClosestSuperficialMarginValue?: number;
    public histopathologyBreastTissueRespectivelyRemoved?: number;
    public additionalCancerUndetectedCancersRemoved?: number;
    public treatmentDecisionsRadiationTherapyRecommended?: number;
    public treatmentDecisionsRadiationTherapyChosen?: number;
    public treatmentDecisionsPatientAgreedSystemicTreatment?: number;

    public constructor(init?: Partial<PatientAllocationFactors>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentHistory
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=2)
    public repeat?: number;

    // @DataMember(Order=3)
    public patientId?: number;

    // @DataMember(Order=4)
    public eventId?: number;

    // @DataMember(Order=5)
    public parentFormDefinitionId?: number;

    // @DataMember(Order=6)
    public parentFormId?: number;

    // @DataMember(Order=7)
    public exportedToOpenClinica?: string;

    // @DataMember(Order=8)
    // @Ignore()
    public consentEvent: ConsentEvent;

    // @DataMember(Order=9)
    public picfId?: number;

    // @DataMember(Order=10)
    public picfVersion?: string;

    // @DataMember(Order=11)
    public picfVersionSpecify?: string;

    // @DataMember(Order=12)
    public patientSignedConsent?: number;

    // @DataMember(Order=13)
    public datePatientSignedConsent?: string;

    // @DataMember(Order=14)
    public participantAgreedToDisclosureOfInformation?: number;

    // @DataMember(Order=25)
    // @Ignore()
    public patientName: string;

    // @DataMember(Order=26)
    // @Ignore()
    public patientSigning: boolean;

    // @DataMember(Order=28)
    public consentTypeId?: ConsentTypeEnum;

    // @DataMember(Order=29)
    public saConsentStatus?: SaConsentStatus;

    // @DataMember(Order=30)
    public consentFormVersion?: string;

    // @DataMember(Order=31)
    public consentFormDate?: string;

    // @DataMember(Order=32)
    public currentTmdConsentFormVersion?: number;

    // @DataMember(Order=33)
    public participantSignedCorrectVersion?: number;

    // @DataMember(Order=34)
    public consentFullyCompleted?: number;

    // @DataMember(Order=35)
    public correctionsSigned?: number;

    // @DataMember(Order=36)
    public witnessIdentityConfirmed?: number;

    // @DataMember(Order=37)
    public additionalComments?: string;

    // @DataMember(Order=38)
    public isHistoryEntry?: boolean;

    // @DataMember(Order=39)
    public reviewedBy?: string;

    // @DataMember(Order=40)
    public reviewedDate?: string;

    // @DataMember(Order=21)
    public enteredDate?: string;

    // @DataMember(Order=22)
    public enteredBy: string;

    // @DataMember(Order=23)
    public modifiedDate?: string;

    // @DataMember(Order=24)
    public modifiedBy: string;

    public constructor(init?: Partial<ServicesAustraliaConsentHistory>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportDocumentHyperlink
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public fileTypeId?: LookupImageReportDocumentType;

    // @DataMember(Order=2)
    public fileDate?: string;

    // @DataMember(Order=3)
    public fileViewUrl?: string;

    // @DataMember(Order=4)
    public fileDownloadUrl?: string;

    public constructor(init?: Partial<ImageReportDocumentHyperlink>) { (Object as any).assign(this, init); }
}

export class FormsDueEvent
{
    [immerable]? = true;

    public initials: string;
    public studyNumber: string;
    public institutionCode: string;
    public institutionName: string;
    public eventName: string;
    public eventRepeat?: number;
    public visitDate: string;
    public dueDate: string;
    public formsDue: string;

    public constructor(init?: Partial<FormsDueEvent>) { (Object as any).assign(this, init); }
}

export class FormsDueSchedule
{
    [immerable]? = true;

    public id?: number;
    public randno?: string;
    public lastSurgeryDate?: string;
    public institutionId?: number;
    public instCode?: string;
    public instname?: string;
    public initials?: string;
    public allocDate?: string;
    public allocation?: number;
    public month3Visit?: string;
    public month3DueDate?: string;
    public month6Visit?: string;
    public month6DueDate?: string;
    public month12Visit?: string;
    public month12DueDate?: string;
    public month24Visit?: string;
    public month24DueDate?: string;
    public month36Visit?: string;
    public month36DueDate?: string;
    public month48Visit?: string;
    public month48DueDate?: string;
    public year5Visit?: string;
    public year5DueDate?: string;
    public year6Visit?: string;
    public year6DueDate?: string;
    public year7Visit?: string;
    public year7DueDate?: string;
    public year8Visit?: string;
    public year8DueDate?: string;
    public year9Visit?: string;
    public year9DueDate?: string;
    public year10Visit?: string;
    public year10DueDate?: string;

    public constructor(init?: Partial<FormsDueSchedule>) { (Object as any).assign(this, init); }
}

export enum ValidationResultType
{
    Valid = 1,
    Ineligible = 2,
    Error = 3,
    StratificationFailure = 4,
    Critical = 5,
}

export class FormValidationError implements IFormValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<FormValidationError>) { (Object as any).assign(this, init); }
}

export class FormValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public formId?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public completed?: boolean;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public errors: FormValidationError[];

    public constructor(init?: Partial<FormValidationResult>) { (Object as any).assign(this, init); }
}

export class DrugManagementValidationError implements IDrugManagementValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<DrugManagementValidationError>) { (Object as any).assign(this, init); }
}

export class DrugManagementValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public errors: DrugManagementValidationError[];

    public constructor(init?: Partial<DrugManagementValidationResult>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseError
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public fieldName: string;

    // @DataMember(Order=3)
    public message: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseError>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ResponseStatus
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public errorCode: string;

    // @DataMember(Order=2)
    public message: string;

    // @DataMember(Order=3)
    public stackTrace: string;

    // @DataMember(Order=4)
    public errors: ResponseError[];

    // @DataMember(Order=5)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<ResponseStatus>) { (Object as any).assign(this, init); }
}

export class DrugManagementValidationResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public validationResult: DrugManagementValidationResult;

    public constructor(init?: Partial<DrugManagementValidationResponse>) { (Object as any).assign(this, init); }
}

export interface IPharmacist
{
    id?: number;
    title: string;
    firstName: string;
    lastName: string;
    deliveryAddress: string;
    deliveryStreet2: string;
    deliverySuburb: string;
    deliveryState: string;
    deliveryPostCode: string;
    deliveryCountry: string;
    email: string;
    phone: string;
    fax: string;
}

export class PharmacyBatchDrugRemaining
{
    [immerable]? = true;

    public pharmacy: Pharmacy;
    public batch: Batch;
    public drugRemaining?: number;

    public constructor(init?: Partial<PharmacyBatchDrugRemaining>) { (Object as any).assign(this, init); }
}

export interface IInstitution extends IDataModel, IHasMasterGroupId, IHasCollaboratingGroupId, IHasCountryId
{
    name: string;
    code: string;
    enabled?: boolean;
    activatedDate?: string;
    recruitmentDisabled?: boolean;
    eConsentActivationDate?: string;
}

export class SaeFormValidationError implements ISaeFormValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<SaeFormValidationError>) { (Object as any).assign(this, init); }
}

export class SaeFormValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public errors: SaeFormValidationError[];

    public constructor(init?: Partial<SaeFormValidationResult>) { (Object as any).assign(this, init); }
}

export class LookupItem implements ILookupItem
{
    [immerable]? = true;

    public id?: number;
    public value: string;
    public order?: number;
    public type?: number;

    public constructor(init?: Partial<LookupItem>) { (Object as any).assign(this, init); }
}

export class Lookup
{
    [immerable]? = true;

    public propertyName: string;
    public items: LookupItem[];

    public constructor(init?: Partial<Lookup>) { (Object as any).assign(this, init); }
}

export class QueryRecipient implements IModel
{
    [immerable]? = true;

    public id?: number;
    public name: string;

    public constructor(init?: Partial<QueryRecipient>) { (Object as any).assign(this, init); }
}

export enum SaeMedicalReviewStatus
{
    NotNotified = 0,
    Pending = 1,
    Reviewed = 3,
}

export class Sae<TSaeForm, TPatient>
{
    [immerable]? = true;

    public patient: TPatient;
    public saeNumber?: number;
    public status: SaeStatus;
    public form: TSaeForm;
    public ecrfs: TSaeForm[];
    public saeFormItems: { [index: string]: string; };
    public invalidForm: InvalidSaeForm;
    public medicalReview: MedicalReview;
    public medicalReviewStatus: SaeMedicalReviewStatus;
    public actionHistory: WebAction[];
    public lookups: Lookup[];

    public constructor(init?: Partial<Sae<TSaeForm, TPatient>>) { (Object as any).assign(this, init); }
}

export interface ISaeForm extends IModel
{
    patientId?: number;
    saeNumber?: number;
    followUpNumber?: number;
    eventStatus: string;
    dateCreated?: string;
    dateUpdated?: string;
    unassignedProperties: { [index: string]: Object; };
    inconvertableProperties: { [index: string]: string; };
}

// @DataContract
export class UserApiKey
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public key: string;

    // @DataMember(Order=2)
    public keyType: string;

    // @DataMember(Order=3)
    public expiryDate?: string;

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UserApiKey>) { (Object as any).assign(this, init); }
}

export interface IFormValidationError extends IValidationError
{
    property: string;
}

export interface IFormValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    formId?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    completed?: boolean;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    errors: IFormValidationError[];
}

export interface IFileUploadTemporary
{
    guid: string;
    name: string;
    extension: string;
    fileSize?: number;
    contentType: string;
    image: boolean;
}

export enum UserType
{
    TrialPersonnel = 1,
    Patient = 2,
}

export class FormMetadata
{
    [immerable]? = true;

    public formDefinitionId?: number;
    public formDefinitionCode: string;
    public name: string;
    public propertyName: string;
    public title: string;
    public instructions: string;

    public constructor(init?: Partial<FormMetadata>) { (Object as any).assign(this, init); }
}

export class PatientValidationError implements IPatientValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<PatientValidationError>) { (Object as any).assign(this, init); }
}

export class EventValidationError implements IEventValidationError
{
    [immerable]? = true;

    public property: string;
    public message: string;
    public detailedMessage: string;
    public code: string;
    public ruleSet: string;
    public type?: ValidationErrorType;

    public constructor(init?: Partial<EventValidationError>) { (Object as any).assign(this, init); }
}

export class EventValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public eventId?: number;
    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;
    public errors: EventValidationError[];
    public formResults: FormValidationResult[];

    public constructor(init?: Partial<EventValidationResult>) { (Object as any).assign(this, init); }
}

export class PatientValidationResult
{
    [immerable]? = true;

    public result: ValidationResultType;
    public answeredQuestions?: number;
    public totalQuestions?: number;
    public patientId?: number;
    public patientDefinitionId?: number;
    public patientRepeat?: number;
    public errors: PatientValidationError[];
    public eventResults: EventValidationResult[];

    public constructor(init?: Partial<PatientValidationResult>) { (Object as any).assign(this, init); }
}

export class EventState implements IEventState
{
    [immerable]? = true;

    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<EventState>) { (Object as any).assign(this, init); }
}

export class FormState implements IFormState
{
    [immerable]? = true;

    public eventDefinitionId?: number;
    public eventRepeat?: number;
    public formDefinitionId?: number;
    public formRepeat?: number;
    public visible?: boolean;
    public read?: boolean;
    public write?: boolean;
    public validate?: boolean;
    public redactable?: boolean;

    public constructor(init?: Partial<FormState>) { (Object as any).assign(this, init); }
}

export class BctUserPermissionContext
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public masterGroupId?: number;

    // @DataMember(Order=2)
    public masterGroupCode: string;

    // @DataMember(Order=3)
    public collaboratingGroupId?: number;

    // @DataMember(Order=4)
    public collaboratingGroupCode: string;

    // @DataMember(Order=5)
    public institutionId?: number;

    // @DataMember(Order=6)
    public institutionCode: string;

    // @DataMember(Order=7)
    public patientId?: number;

    // @DataMember(Order=8)
    public patientStudyNumber: string;

    // @DataMember(Order=9)
    public permissions: Permission[];

    public constructor(init?: Partial<BctUserPermissionContext>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnel
{
    [immerable]? = true;

    public id?: number;
    public name: string;
    public email: string;

    public constructor(init?: Partial<InstitutionPersonnel>) { (Object as any).assign(this, init); }
}

export interface IConsentEvent extends IDataModel
{
    patientId?: number;
    eventId?: number;
    consentTypeId?: ConsentTypeEnum;
    statusId?: StatusTypeEnum;
    guid: string;
    investigator: string;
    investigatorSpecify: string;
    dateStarted?: string;
    dateNotificationSent?: string;
    datePatientCompleted?: string;
    dateInvestigatorCompleted?: string;
}

export interface IDataModel extends IModel, IHasAudit
{
}

export interface IModel
{
    id?: number;
}

export interface IHasAudit
{
    enteredDate?: string;
    enteredBy: string;
    modifiedDate?: string;
    modifiedBy: string;
}

export interface IForm extends IDataModel, IHasPatientId, IHasEventId, IHasParentFormDefinitionId, IHasParentFormId
{
    repeat?: number;
}

export interface IHasPatientId
{
    patientId?: number;
}

export interface IHasEventId
{
    eventId?: number;
}

export interface IHasParentFormDefinitionId
{
    parentFormDefinitionId?: number;
}

export interface IHasParentFormId
{
    parentFormId?: number;
}

export interface IConsentForm extends IForm
{
    consentEvent?: ConsentEvent;
    consentTypeId?: ConsentTypeEnum;
    picfId?: number;
    picfVersion?: string;
    picfVersionSpecify?: string;
    patientName: string;
    patientSignedConsent?: number;
    datePatientSignedConsent?: string;
    formDefinition?: FormDefinition;
}

export interface IHasInvestigator
{
    investigatorSignedConsent?: number;
    dateInvestigatorSignedConsent?: string;
    investigator: string;
    investigatorSpecify: string;
}

export interface IOpenClinicaForm extends IForm
{
    exportedToOpenClinica?: string;
}

export interface IDrugManagementForm
{
}

export interface IConsentPending extends IDataModel
{
    patientId?: number;
    institutionCode: string;
    emailAddress: string;
    dateSent?: string;
    investigator: string;
    firstName: string;
    lastName: string;
    confirmed?: boolean;
    dateSubmitted?: string;
    statusId?: StatusTypeEnum;
}

export interface IPatientConsent extends IDataModel
{
    consentPendingId?: number;
    typeId?: ConsentTypeEnum;
    statusId?: StatusTypeEnum;
    patientId?: number;
    guid: string;
    dateStarted?: string;
    documentVerified?: boolean;
    documentVerifiedBy?: string;
    dateDocumentVerified?: string;
    mobileNumber: string;
    patientSigned?: boolean;
    datePatientSigned?: string;
    investigatorSigned?: boolean;
    dateInvestigatorSigned?: string;
    dateNotificationSent?: string;
    type: ConsentType;
    status: StatusType;
    consentPending: IConsentPending;
    picfs: ConsentPicf[];
}

export interface IPatient extends IDataModel, IHasInstitutionId, IHasPatientStateId, IHasTreatmentId
{
    studyNumber: string;
}

export interface IHasInstitutionId
{
    institutionId?: number;
}

export interface IHasPatientStateId
{
    patientStateId?: number;
}

export interface IHasTreatmentId
{
    treatmentId?: number;
}

export interface IRegistrationPatient
{
    registrationNumber: string;
    registrationDate?: string;
}

export interface IOpenClinicaPatient extends IPatient
{
    exportedToOpenClinica?: string;
}

export interface IConsentPatient extends IPatient
{
    email: string;
    firstName: string;
    lastName: string;
    consentEvents: ConsentEvent[];
}

export interface IConsentServiceAustraliaPatient
{
    servicesAustraliaConsentStatus?: SaConsentStatus;
}

export interface IConsentTissueBankingPatient
{
}

export interface IHasEventDefinitionId
{
    eventDefinitionId?: number;
}

export interface IProForm extends IForm
{
    completed?: boolean;
}

export interface IProFormNotComplete
{
    ptDidNotComplete?: boolean;
}

export interface IProFormDateCompleted extends IProForm
{
    dateCompleted?: string;
}

export interface IScreeningForm extends IForm
{
    initials?: string;
    yearOfBirth?: number;
    outcome?: LookupScreeningOutcomeType;
    screenFailReason?: number;
    participantEmail?: string;
}

export interface IFormDefinitionPropertyErrorMessage extends IConfigurationModel, IHasFormDefinitionPropertyId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IFormDefinitionProperty extends IConfigurationModel, IHasFormDefinitionId
{
    propertyName: string;
    label: string;
    detailedLabel: string;
    errorMessages: IFormDefinitionPropertyErrorMessage[];
}

export interface IFormDefinition extends IConfigurationModel
{
    type?: FormType;
    name: string;
    code: string;
    instructions?: string;
    patientInstructions?: string;
    properties: IFormDefinitionProperty[];
    subformProperties: { [index: string]: IFormDefinitionProperty[]; };
}

export interface IConfigurationModel extends IModel
{
}

export interface IEventDefinitionFormDefinitionState extends IConfigurationModel, IHasEventDefinitionFormDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
}

export interface IEventDefinitionFormDefinition extends IConfigurationModel, IHasEventDefinitionId, IHasFormDefinitionId
{
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    states: IEventDefinitionFormDefinitionState[];
}

export interface IEventDefinitionState extends IConfigurationModel, IHasEventDefinitionId, IHasPatientStateId
{
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
}

export interface IEventDefinitionErrorMessage extends IConfigurationModel, IHasEventDefinitionId
{
    errorCode: string;
    message: string;
    detailedMessage: string;
    type?: ValidationErrorType;
}

export interface IEventDefinition extends IConfigurationModel
{
    name: string;
    code: string;
    repeating?: boolean;
    minimumRepeat?: number;
    maximumRepeat?: number;
    order?: number;
    formDefinitions: IEventDefinitionFormDefinition[];
    states: IEventDefinitionState[];
    errorMessages: IEventDefinitionErrorMessage[];
}

export interface IPatientState extends IConfigurationModel
{
    name: string;
    order?: number;
}

export interface ITreatment extends IConfigurationModel
{
    name: string;
}

export interface ILookupItem
{
    id?: number;
    value: string;
    order?: number;
    type?: number;
}

export interface ILookup
{
    propertyName: string;
    items: ILookupItem[];
}

export interface IMasterGroup extends IDataModel
{
    name: string;
    code: string;
}

export interface ICollaboratingGroup extends IDataModel, IHasMasterGroupId
{
    name: string;
    code: string;
}

export interface IHasMasterGroupId
{
    masterGroupId?: number;
}

export interface ICountry extends IDataModel
{
    name: string;
    code: string;
}

export interface IHasCollaboratingGroupId
{
    collaboratingGroupId?: number;
}

export interface IHasCountryId
{
    countryId?: number;
}

export interface IPatientAllocationFactors
{
    studyNumber: string;
    coreBiopsyEr?: number;
    surgicalSampleIsh?: number;
    coreBiopsyIsh?: number;
    surgicalSampleIhc?: number;
    coreBiopsyIhc?: number;
    surgicalSampleGrade?: number;
    bmriParenchymalEnhancementLeft?: number;
    bmriParenchymalEnhancementRight?: number;
    bmriAdditionalLesionDcisOrMalignantPathologyCount?: number;
    cemAdditionalLesionDcisOrMalignantPathologyCount?: number;
    surgeryIndexLesionUnilateralMastectomyDate?: string;
    surgeryIndexLesionBilateralMastectomyDate?: string;
    surgeryMalignantLesionUnilateralMastectomyDate?: string;
    surgeryMalignantLesionBilateralMastectomyDate?: string;
    surgerySentinelLymphNodePathology?: number;
    surgeryAuxillaryNodesPathology?: number;
    histopathologyIndexTumourSize?: number;
    histopathologyInvasiveSize?: number;
    histopathologyDcis?: number;
    histopathologyLymphovascularInvasionPresent?: number;
    histopathologyMultifocality?: number;
    histopathologyRadialMargin?: number;
    histopathologyClosestSuperficialMarginOperator?: number;
    histopathologyClosestSuperficialMarginValue?: number;
    histopathologyBreastTissueRespectivelyRemoved?: number;
    additionalCancerUndetectedCancersRemoved?: number;
    treatmentDecisionsRadiationTherapyRecommended?: number;
    treatmentDecisionsRadiationTherapyChosen?: number;
    treatmentDecisionsPatientAgreedSystemicTreatment?: number;
}

export interface IValidationError
{
    message: string;
    detailedMessage: string;
    code: string;
    type?: ValidationErrorType;
}

export interface IValidationResult
{
    result: ValidationResultType;
    errors: IValidationError[];
}

export interface IDrugManagementValidationError extends IValidationError
{
    property: string;
}

export interface IDrugManagementValidationResult extends IValidationResult
{
    errors: IDrugManagementValidationError[];
}

export interface ISaeFormValidationError extends IValidationError
{
    property: string;
}

export interface ISaeFormValidationResult extends IValidationResult
{
    errors: ISaeFormValidationError[];
}

export class TreatmentOfEvent implements ISaeSubform
{
    [immerable]? = true;

    public ordinal: number;
    public treatmentName: string;
    public treatmentDose: string;
    public treatmentDateCommenced?: string;
    public treatmentOngoing?: boolean;
    public treatmentDateCeased?: string;

    public constructor(init?: Partial<TreatmentOfEvent>) { (Object as any).assign(this, init); }
}

export class SourceDocuments implements ISaeSubform, ISourceDocument
{
    [immerable]? = true;

    public ordinal: number;
    public type: string;
    public name: string;
    public document: string;

    public constructor(init?: Partial<SourceDocuments>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SaeForm implements ISaeForm
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public id?: number;

    // @DataMember(Order=36)
    public instCode?: string;

    // @DataMember(Order=2)
    public patientId?: number;

    // @DataMember(Order=3)
    public saeNumber?: number;

    // @DataMember(Order=4)
    public followUpNumber?: number;

    // @DataMember(Order=32)
    public randNo: string;

    // @DataMember(Order=34)
    public age?: number;

    // @DataMember(Order=35)
    public sex?: boolean;

    // @DataMember(Order=7)
    public saeNo?: number;

    // @DataMember(Order=8)
    public dateOfOnset?: string;

    // @DataMember(Order=9)
    public eventName: string;

    // @DataMember(Order=10)
    public eventGrade?: number;

    // @DataMember(Order=11)
    public descriptionOfEvent: string;

    // @DataMember(Order=12)
    public causalityOption: string;

    // @DataMember(Order=13)
    public reportingResultsInDeath?: boolean;

    // @DataMember(Order=14)
    public reportingLifeThreatening?: boolean;

    // @DataMember(Order=15)
    public requiresHospitalisation?: boolean;

    // @DataMember(Order=16)
    public reportingDisability?: boolean;

    // @DataMember(Order=17)
    public reportingIntervention?: boolean;

    // @DataMember(Order=18)
    public reportingAnomaly?: boolean;

    // @DataMember(Order=19)
    public reportingSignificant?: boolean;

    // @DataMember(Order=20)
    public eventStatus: string;

    // @DataMember(Order=21)
    public eventStatusDate?: string;

    // @DataMember(Order=22)
    public relevantTests: string;

    // @DataMember(Order=23)
    public additionalInfo: string;

    // @DataMember(Order=24)
    public investigatorName: string;

    // @DataMember(Order=25)
    public investigatorPhoneNo: string;

    // @DataMember(Order=26)
    public dateCreated?: string;

    // @DataMember(Order=27)
    public dateUpdated?: string;

    // @DataMember(Order=28)
    public treatments?: TreatmentOfEvent[];

    // @DataMember(Order=29)
    public sourceDocuments?: SourceDocuments[];

    // @DataMember(Order=30)
    public unassignedProperties: { [index: string]: Object; };

    // @DataMember(Order=31)
    public inconvertableProperties: { [index: string]: string; };

    public constructor(init?: Partial<SaeForm>) { (Object as any).assign(this, init); }
}

export interface IPatientValidationError extends IValidationError
{
}

export interface IEventValidationError extends IValidationError
{
}

export interface IEventValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    eventDefinitionId?: number;
    eventId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
    errors: IEventValidationError[];
    formResults: IFormValidationResult[];
}

export interface IPatientValidationResult extends IValidationResult
{
    answeredQuestions?: number;
    totalQuestions?: number;
    patientId?: number;
    errors: IPatientValidationError[];
    eventResults: IEventValidationResult[];
}

export interface IEventState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
}

export interface IFormState
{
    eventDefinitionId?: number;
    eventRepeat?: number;
    formDefinitionId?: number;
    formRepeat?: number;
    visible?: boolean;
    read?: boolean;
    write?: boolean;
    validate?: boolean;
    redactable?: boolean;
}

export interface IFileUpload
{
    extension: string;
    fileSize?: number;
    contentType: string;
    exists: boolean;
    image: boolean;
    upload: IFileUploadTemporary;
}

export interface IFile extends IDataModel, IHasPatientId, IHasFormDefinitionId, IHasFormId, IFileUpload
{
    propertyName: string;
}

export interface IHasFormDefinitionId
{
    formDefinitionId?: number;
}

export interface IHasFormId
{
    formId?: number;
}

export interface IHasFormDefinitionPropertyId
{
    formDefinitionPropertyId?: number;
}

export interface IHasEventDefinitionFormDefinitionId
{
    eventDefinitionFormDefinitionId?: number;
}

export interface ISaeSubform
{
    ordinal: number;
}

export interface ISourceDocument
{
    type: string;
    name: string;
    document: string;
}

// @DataContract
export class GetBreastMriLesionsByPatientIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public lesions?: BreastMriAdditionalLesion[];

    public constructor(init?: Partial<GetBreastMriLesionsByPatientIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetBreastMriAdverseEventsByPatientIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public adverseEvents?: AdverseEvent[];

    public constructor(init?: Partial<GetBreastMriAdverseEventsByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class CachedFormDefinitionCollectionResponse
{
    [immerable]? = true;

    public formDefinitions: FormDefinition[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedFormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedEventDefinitionCollectionResponse
{
    [immerable]? = true;

    public eventDefinitions: EventDefinition[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedEventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedPatientStateCollectionResponse
{
    [immerable]? = true;

    public patientStates: PatientState[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedPatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

export class CachedTreatmentCollectionResponse
{
    [immerable]? = true;

    public treatments: Treatment[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CachedTreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetClientAppSettingsResponse
{
    [immerable]? = true;

    public settings?: ClientAppSettings;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetClientAppSettingsResponse>) { (Object as any).assign(this, init); }
}

export class StartConsentResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StartConsentResponse>) { (Object as any).assign(this, init); }
}

export class GetConsentVersionsResponse
{
    [immerable]? = true;

    public consentPicfs?: Picf[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetConsentVersionsResponse>) { (Object as any).assign(this, init); }
}

export class SendConsentInformationResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendConsentInformationResponse>) { (Object as any).assign(this, init); }
}

export class GetConsentEventByGuidResponse
{
    [immerable]? = true;

    public consentEvent: ConsentEvent;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetConsentEventByGuidResponse>) { (Object as any).assign(this, init); }
}

export class GetConsentEventDataResponse
{
    [immerable]? = true;

    public consentEvent: ConsentEvent;
    public consentEventEConsentForms: IEConsentForm[];
    public lookups: { [index: number]: ILookup[]; };
    public masterGroup: MasterGroup;
    public collaboratingGroup: CollaboratingGroup;
    public country: Country;
    public institution: Institution;
    public event: IEvent;
    public patient: Patient;
    public investigators: { [index: string]: string; };
    public principalInvestigator: string;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetConsentEventDataResponse>) { (Object as any).assign(this, init); }
}

export class GetConsentInvestigatorsResponse
{
    [immerable]? = true;

    public investigators: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetConsentInvestigatorsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetCtcaeTermNameResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public ctcaeTermName?: string;

    public constructor(init?: Partial<GetCtcaeTermNameResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetEConsentSettingsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public eConsentActivated: boolean;

    // @DataMember(Order=2)
    public eConsentActivatedInstitutions?: number[];

    // @DataMember(Order=3)
    public trialInfoPageUrl?: string;

    // @DataMember(Order=4)
    public trialConsentPageUrl?: string;

    // @DataMember(Order=5)
    public trialConsentSignedPageUrl?: string;

    // @DataMember(Order=6)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetEConsentSettingsResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentPatientEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendEConsentPatientEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentPatientCompleteEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendEConsentPatientCompleteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentCompleteEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendEConsentCompleteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentCompleteTrialEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendEConsentCompleteTrialEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendEConsentRefusedEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendEConsentRefusedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendConsentInformationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendConsentInformationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendRadiologyReviewEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendRadiologyReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendRadiologyReviewCompleteSiteEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendRadiologyReviewCompleteSiteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendRadiologyReviewCompleteBctEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendRadiologyReviewCompleteBctEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSuccessfulAllocationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSuccessfulAllocationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendBctReviewEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendBctReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendBctReviewSiteEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendBctReviewSiteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendCorrectionRequiredEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendCorrectionRequiredEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendBctAllocationReviewReminderEmailResponse
{
    [immerable]? = true;

    public patientAllocationPendingCount?: number;
    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendBctAllocationReviewReminderEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSuccessfulRegistrationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSuccessfulRegistrationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendPatientWelcomeEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendPatientWelcomeEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendPatientReminderEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendPatientReminderEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendPatientReminderResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SendPatientReminderResponse>) { (Object as any).assign(this, init); }
}

export class SendNewInvestigatorEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendNewInvestigatorEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendNewPicfVersionEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendNewPicfVersionEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendMultipleRandomisationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendMultipleRandomisationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendWeeklyDicomEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendWeeklyDicomEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendDicomFailedEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendDicomFailedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaConsentUpdatesRequiredEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaConsentUpdatesRequiredEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSuccessfulPreregistrationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSuccessfulPreregistrationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendFormsDueSummaryEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendFormsDueSummaryEmailResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetImageReportDocumentsResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public imageReportDocuments?: ImageReportDocument[];

    public constructor(init?: Partial<GetImageReportDocumentsResponse>) { (Object as any).assign(this, init); }
}

export class GetMriImageUploadsResponse
{
    [immerable]? = true;

    public data: MriImageUpload[];
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetMriImageUploadsResponse>) { (Object as any).assign(this, init); }
}

export class GetMriImageUploadByIdResponse
{
    [immerable]? = true;

    public data: MriImageUpload;
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetMriImageUploadByIdResponse>) { (Object as any).assign(this, init); }
}

export class PostSubmitImageUploadResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostSubmitImageUploadResponse>) { (Object as any).assign(this, init); }
}

export class PostImageUploadVerifyResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostImageUploadVerifyResponse>) { (Object as any).assign(this, init); }
}

export class PostDeleteImageDocByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostDeleteImageDocByIdResponse>) { (Object as any).assign(this, init); }
}

export class PostDeIdentifyImageResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostDeIdentifyImageResponse>) { (Object as any).assign(this, init); }
}

export class PostDeIdentifyImageErrorResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PostDeIdentifyImageErrorResponse>) { (Object as any).assign(this, init); }
}

export class PerformanceTestResponse
{
    [immerable]? = true;

    public results: PerformanceTestResult[];

    public constructor(init?: Partial<PerformanceTestResponse>) { (Object as any).assign(this, init); }
}

export class ActiveDirectoryResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ActiveDirectoryResponse>) { (Object as any).assign(this, init); }
}

export class StartReviewResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<StartReviewResponse>) { (Object as any).assign(this, init); }
}

export class GetRadiologistPatientsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patients: Patient[];

    public constructor(init?: Partial<GetRadiologistPatientsResponse>) { (Object as any).assign(this, init); }
}

export class SetPatientStatusResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SetPatientStatusResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientAllocationSummaryDataResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patientAllocationData: AllocationData[];

    public constructor(init?: Partial<GetPatientAllocationSummaryDataResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientAllocationFactorsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patientAllocationFactors: PatientAllocationFactors;

    public constructor(init?: Partial<GetPatientAllocationFactorsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientTreatmentResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public treatmentId?: number;

    public constructor(init?: Partial<GetPatientTreatmentResponse>) { (Object as any).assign(this, init); }
}

export class QueuePatientOcTransferResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueuePatientOcTransferResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetEnumTypesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<GetEnumTypesResponse>) { (Object as any).assign(this, init); }
}

export class QueueMultipleRegistrationEmailsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QueueMultipleRegistrationEmailsResponse>) { (Object as any).assign(this, init); }
}

export class GetAccrualCountsResponse
{
    [immerable]? = true;

    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetAccrualCountsResponse>) { (Object as any).assign(this, init); }
}

export class GetServicesAustraliaConsentHistoryResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public consentHistory?: ServicesAustraliaConsentHistory[];

    public constructor(init?: Partial<GetServicesAustraliaConsentHistoryResponse>) { (Object as any).assign(this, init); }
}

export class CreateProcomidaMissingIncompleteFormResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CreateProcomidaMissingIncompleteFormResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueuePatientsOcTransferResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public hasMore?: boolean;

    public constructor(init?: Partial<QueuePatientsOcTransferResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PostSaveParticipantResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    // @DataMember(Order=2)
    public participant?: AddParticipant;

    public constructor(init?: Partial<PostSaveParticipantResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class QueueAutomaticPatientStatusUpdatesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus?: ResponseStatus;

    public constructor(init?: Partial<QueueAutomaticPatientStatusUpdatesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetImageReportUploadContentResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public imageReportDocuments?: ImageReportDocumentHyperlink[];

    public constructor(init?: Partial<GetImageReportUploadContentResponse>) { (Object as any).assign(this, init); }
}

export class GetFormsDueSummaryDataResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public formsDueSummary: FormsDueEvent[];

    public constructor(init?: Partial<GetFormsDueSummaryDataResponse>) { (Object as any).assign(this, init); }
}

export class GetFormsDueScheduleDataResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public formsDueSchedule?: FormsDueSchedule;

    public constructor(init?: Partial<GetFormsDueScheduleDataResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNewEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeInvestigatorReviewPendingEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeInvestigatorReviewPendingEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeMedicalReviewPendingEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeMedicalReviewPendingEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotNotifiedInvestigatorEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotNotifiedInvestigatorEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotNotifiedMedicalReviewerEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotNotifiedMedicalReviewerEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeUnresolvedEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeUnresolvedEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeIncompleteEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public incompleteSaesCount?: number;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeIncompleteEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifyInvestigatorEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifyInvestigatorEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifyStudyChairEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifyStudyChairEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifyStudySponsorEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifyStudySponsorEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeNotifyMedicalReviewerEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeNotifyMedicalReviewerEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeInvestigatorReviewEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeInvestigatorReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeTrialTeamRejectionEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeTrialTeamRejectionEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeMedicalReviewEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeMedicalReviewEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeBlueCardNotificationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeBlueCardNotificationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeDeathNotificationEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeDeathNotificationEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeInvalidEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeInvalidEmailResponse>) { (Object as any).assign(this, init); }
}

export class SendMonthlySaesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendMonthlySaesResponse>) { (Object as any).assign(this, init); }
}

export class SendSaeSusarEmailResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public result: string;
    public subject: string;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];
    public bccAddresses: EmailAddress[];
    public fromAddress: EmailAddress;

    public constructor(init?: Partial<SendSaeSusarEmailResponse>) { (Object as any).assign(this, init); }
}

export class ExportSaConsent implements IReturn<ExportSaConsent>
{
    [immerable]? = true;

    public failureStatisticsOnly?: boolean;

    public constructor(init?: Partial<ExportSaConsent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExportSaConsent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExportSaConsent(); }
}

export class GetTpParticipantsByInstitutionIdResponse
{
    [immerable]? = true;

    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpParticipantsByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

export class GetTpSaeByInstitutionIdResponse
{
    [immerable]? = true;

    public data: { [index: string]: string; };
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetTpSaeByInstitutionIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentEConsentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved main consent. */
    // @DataMember(Order=2)
    public form: MainConsent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MainConsentEConsentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentEConsentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<MainConsentEConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsentEConsentFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tissue banking consent. */
    // @DataMember(Order=2)
    public form: TissueBankingConsent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TissueBankingConsentEConsentFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsentEConsentFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<TissueBankingConsentEConsentFormValidationResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public batch: Batch;

    public constructor(init?: Partial<GetBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesByIdsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesByIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetBatchesExpiringAtSpecifiedDateResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public batches: Batch[];

    public constructor(init?: Partial<GetBatchesExpiringAtSpecifiedDateResponse>) { (Object as any).assign(this, init); }
}

export class SetBatchResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public batch: Batch;

    public constructor(init?: Partial<SetBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<GetDepotBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByDepotIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByDepotIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByPharmacyIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByPharmacyIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByDrugShipmentIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByDrugShipmentIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesByBatchIdsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesByBatchIdsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotBatchesWithLowStockByDepotIdsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatches: DepotBatch[];

    public constructor(init?: Partial<GetDepotBatchesWithLowStockByDepotIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDepotBatchResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<SetDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depots: Depot[];

    public constructor(init?: Partial<GetDepotsResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depot: Depot;

    public constructor(init?: Partial<GetDepotByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDepotsByDrugUnderThresholdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depotIds: number[];

    public constructor(init?: Partial<GetDepotsByDrugUnderThresholdResponse>) { (Object as any).assign(this, init); }
}

export class SetDepotResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public depot: Depot;

    public constructor(init?: Partial<SetDepotResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<GetDrugDispensationByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationByPatientIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientsWithLateDispensationsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patientIds: number[];

    public constructor(init?: Partial<GetPatientsWithLateDispensationsResponse>) { (Object as any).assign(this, init); }
}

export class GetLastDispensationForPatientIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<GetLastDispensationForPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugDispensationsByIdsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugDispensations: DrugDispensation[];

    public constructor(init?: Partial<GetDrugDispensationsByIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugDispensationResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<SetDrugDispensationResponse>) { (Object as any).assign(this, init); }
}

export class DeleteDrugDispensationResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteDrugDispensationResponse>) { (Object as any).assign(this, init); }
}

export class ValidateDrugDispensationResponse extends DrugManagementValidationResponse
{
    [immerable]? = true;


    public constructor(init?: Partial<ValidateDrugDispensationResponse>) { super(init); (Object as any).assign(this, init); }
}

export class GetDrugsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugs: Drug[];

    public constructor(init?: Partial<GetDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentDepotBatchesByPharmacyIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatches: DrugShipmentDepotBatch[];

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByPharmacyIdResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentDepotBatchResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<SetDrugShipmentDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class StartDrugShipmentGenerationResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public messages: string[];
    public createdDrugShipments: DrugShipment[];

    public constructor(init?: Partial<StartDrugShipmentGenerationResponse>) { (Object as any).assign(this, init); }
}

export class CreateDrugShipmentFromPatientResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<CreateDrugShipmentFromPatientResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsByInstitutionResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsByInstitutionResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<GetDrugShipmentByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsByIdsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsByIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentResponse>) { (Object as any).assign(this, init); }
}

export class ValidateDrugShipmentResponse extends DrugManagementValidationResponse
{
    [immerable]? = true;


    public constructor(init?: Partial<ValidateDrugShipmentResponse>) { super(init); (Object as any).assign(this, init); }
}

export class SetDrugShipmentStatusResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentStatusResponse>) { (Object as any).assign(this, init); }
}

export class DeleteDrugShipmentResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DeleteDrugShipmentResponse>) { (Object as any).assign(this, init); }
}

export class SetDrugShipmentVerifyResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipmentVerify: DrugShipmentVerify;

    public constructor(init?: Partial<SetDrugShipmentVerifyResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotShippedByExpectedDateResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotShippedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetDrugShipmentsNotReceivedByExpectedDateResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public drugShipments: DrugShipment[];

    public constructor(init?: Partial<GetDrugShipmentsNotReceivedByExpectedDateResponse>) { (Object as any).assign(this, init); }
}

export class GetOrderFormsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public orderForms: OrderForm[];

    public constructor(init?: Partial<GetOrderFormsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientDrugsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<GetPatientDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetPatientDrugsByPatientIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<GetPatientDrugsByPatientIdResponse>) { (Object as any).assign(this, init); }
}

export class SetPatientDrugsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<SetPatientDrugsResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacistsByInstCodeResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacists: IPharmacist[];

    public constructor(init?: Partial<GetPharmacistsByInstCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacistByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacist: IPharmacist;

    public constructor(init?: Partial<GetPharmacistByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmaciesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacies: Pharmacy[];

    public constructor(init?: Partial<GetPharmaciesResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<GetPharmacyByIdResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyByInstitutionCodeResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<GetPharmacyByInstitutionCodeResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyBatchesDrugRemainingByBatchIdsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacyBatchesDrugRemaining: PharmacyBatchDrugRemaining[];

    public constructor(init?: Partial<GetPharmacyBatchesDrugRemainingByBatchIdsResponse>) { (Object as any).assign(this, init); }
}

export class SetPharmacyResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<SetPharmacyResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyStockResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyStockResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyDepotBatchResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class ActionQuarantinedStockResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<ActionQuarantinedStockResponse>) { (Object as any).assign(this, init); }
}

export class QuarantineRemovePharmacyDepotBatchResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<QuarantineRemovePharmacyDepotBatchResponse>) { (Object as any).assign(this, init); }
}

export class GetPharmacyEmailsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public emailAddresses: MailAddress[];

    public constructor(init?: Partial<GetPharmacyEmailsResponse>) { (Object as any).assign(this, init); }
}

export class QuarantinePharmacyBatchesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<QuarantinePharmacyBatchesResponse>) { (Object as any).assign(this, init); }
}

export class ActionQuarantinedPharmacyBatchesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public success: boolean;

    public constructor(init?: Partial<ActionQuarantinedPharmacyBatchesResponse>) { (Object as any).assign(this, init); }
}

export class GetTimepointsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public timepoints: Timepoint[];

    public constructor(init?: Partial<GetTimepointsResponse>) { (Object as any).assign(this, init); }
}

export class GetInstitutionsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public institutions: IInstitution[];

    public constructor(init?: Partial<GetInstitutionsResponse>) { (Object as any).assign(this, init); }
}

export class GetInvestigatorsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public investigators: { [index: string]: string; };

    public constructor(init?: Partial<GetInvestigatorsResponse>) { (Object as any).assign(this, init); }
}

export class GetPicfsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public picfs: Picf[];

    public constructor(init?: Partial<GetPicfsResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConsentPendingSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved consentpending. */
    // @DataMember(Order=2)
    public consentPending: ConsentPending;

    public constructor(init?: Partial<ConsentPendingSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConsentPendingCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved consentpendings. */
    // @DataMember(Order=2)
    public consentPendings: ConsentPending[];

    public constructor(init?: Partial<ConsentPendingCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ConsentPendingDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ConsentPendingDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patientconsent. */
    // @DataMember(Order=2)
    public patientConsent: PatientConsent;

    public constructor(init?: Partial<PatientConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patientconsents. */
    // @DataMember(Order=2)
    public patientConsents: PatientConsent[];

    public constructor(init?: Partial<PatientConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PatientConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

export class PatientConsentSendVerificationCodeResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public verificationCode: number;

    public constructor(init?: Partial<PatientConsentSendVerificationCodeResponse>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewSingleByPatientStudyNumberResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public medicalReview: MedicalReview;

    public constructor(init?: Partial<SaeMedicalReviewSingleByPatientStudyNumberResponse>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewNarrativeSummaryPostSaveResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeMedicalReviewNarrativeSummaryPostSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewPostSaveResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public medicalReview: MedicalReview;

    public constructor(init?: Partial<SaeMedicalReviewPostSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeValidateMedicalReviewResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public validationResult: SaeFormValidationResult;

    public constructor(init?: Partial<SaeValidateMedicalReviewResponse>) { (Object as any).assign(this, init); }
}

export class SaeQueryCollectionByPatientSaeNumberResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public queries: Query[];
    public queryRecipientsLookup: Lookup;

    public constructor(init?: Partial<SaeQueryCollectionByPatientSaeNumberResponse>) { (Object as any).assign(this, init); }
}

export class SaeQueryPostSaveResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public queries: Query[];

    public constructor(init?: Partial<SaeQueryPostSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeQueryRecipientSingleByIdResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public queryRecipient: QueryRecipient;

    public constructor(init?: Partial<SaeQueryRecipientSingleByIdResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SaeCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved saes. */
    // @DataMember(Order=2)
    public saes: Sae<SaeForm,Patient>[];

    public constructor(init?: Partial<SaeCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SaeSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved sae. */
    // @DataMember(Order=2)
    public sae: Sae<SaeForm, Patient>;

    public constructor(init?: Partial<SaeSingleResponse>) { (Object as any).assign(this, init); }
}

export class SaeGetCollectionByStatusResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public saes: Sae<ISaeForm,IPatient>[];

    public constructor(init?: Partial<SaeGetCollectionByStatusResponse>) { (Object as any).assign(this, init); }
}

export class SaeGetIncompleteFormsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public incompleteSaeForms: ISaeForm[];

    public constructor(init?: Partial<SaeGetIncompleteFormsResponse>) { (Object as any).assign(this, init); }
}

export class SaeWebActionSaveResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeWebActionSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeMedicalReviewWebActionSaveResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeMedicalReviewWebActionSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeSendNotificationResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SaeSendNotificationResponse>) { (Object as any).assign(this, init); }
}

export class SaeValidateNotificationFormResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public validationResult: SaeFormValidationResult;

    public constructor(init?: Partial<SaeValidateNotificationFormResponse>) { (Object as any).assign(this, init); }
}

export class SaeValidateRejectionFormResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public validationResult: SaeFormValidationResult;

    public constructor(init?: Partial<SaeValidateRejectionFormResponse>) { (Object as any).assign(this, init); }
}

export class SaeInvalidFormPostSaveResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public invalidSaeForm: InvalidSaeForm;

    public constructor(init?: Partial<SaeInvalidFormPostSaveResponse>) { (Object as any).assign(this, init); }
}

export class SaeValidateInvalidFormResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public validationResult: SaeFormValidationResult;

    public constructor(init?: Partial<SaeValidateInvalidFormResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AuthenticateResponse implements IHasSessionId, IHasBearerToken
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userId: string;

    // @DataMember(Order=2)
    public sessionId: string;

    // @DataMember(Order=3)
    public userName: string;

    // @DataMember(Order=4)
    public displayName: string;

    // @DataMember(Order=5)
    public referrerUrl: string;

    // @DataMember(Order=6)
    public bearerToken: string;

    // @DataMember(Order=7)
    public refreshToken: string;

    // @DataMember(Order=8)
    public refreshTokenExpiry?: string;

    // @DataMember(Order=9)
    public profileUrl: string;

    // @DataMember(Order=10)
    public roles: string[];

    // @DataMember(Order=11)
    public permissions: string[];

    // @DataMember(Order=12)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=13)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AuthenticateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UnAssignRolesResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public allRoles: string[];

    // @DataMember(Order=2)
    public allPermissions: string[];

    // @DataMember(Order=3)
    public meta: { [index: string]: string; };

    // @DataMember(Order=4)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UnAssignRolesResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GetApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegenerateApiKeysResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public results: UserApiKey[];

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    // @DataMember(Order=3)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegenerateApiKeysResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormValidationByIdResponse
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    // @DataMember(Order=2)
    public result: IFormValidationResult;

    public constructor(init?: Partial<FormValidationByIdResponse>) { (Object as any).assign(this, init); }
}

export class UploadResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public upload: IFileUploadTemporary;

    public constructor(init?: Partial<UploadResponse>) { (Object as any).assign(this, init); }
}

export class GetUserResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public userId: string;
    public sessionId: string;
    public userName: string;
    public displayName: string;
    public type?: UserType;

    public constructor(init?: Partial<GetUserResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class LookupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved lookups. */
    // @DataMember(Order=2)
    public lookups: Lookup[];

    public constructor(init?: Partial<LookupCollectionResponse>) { (Object as any).assign(this, init); }
}

export class GetFormMetadataResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public formMetadata: FormMetadata[];

    public constructor(init?: Partial<GetFormMetadataResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event definition. */
    // @DataMember(Order=2)
    public eventDefinition: EventDefinition;

    public constructor(init?: Partial<EventDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventDefinitionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event definitions. */
    // @DataMember(Order=2)
    public eventDefinitions: EventDefinition[];

    public constructor(init?: Partial<EventDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definition. */
    // @DataMember(Order=2)
    public formDefinition: FormDefinition;

    public constructor(init?: Partial<FormDefinitionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormDefinitionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form definitions. */
    // @DataMember(Order=2)
    public formDefinitions: FormDefinition[];

    public constructor(init?: Partial<FormDefinitionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient state. */
    // @DataMember(Order=2)
    public patientState: PatientState;

    public constructor(init?: Partial<PatientStateSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientStateCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient states. */
    // @DataMember(Order=2)
    public patientStates: PatientState[];

    public constructor(init?: Partial<PatientStateCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatment. */
    // @DataMember(Order=2)
    public treatment: Treatment;

    public constructor(init?: Partial<TreatmentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatments. */
    // @DataMember(Order=2)
    public treatments: Treatment[];

    public constructor(init?: Partial<TreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved master group. */
    // @DataMember(Order=2)
    public masterGroup: MasterGroup;

    public constructor(init?: Partial<MasterGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MasterGroupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved master groups. */
    // @DataMember(Order=2)
    public masterGroups: MasterGroup[];

    public constructor(init?: Partial<MasterGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved collaborating group. */
    // @DataMember(Order=2)
    public collaboratingGroup: CollaboratingGroup;

    public constructor(init?: Partial<CollaboratingGroupSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CollaboratingGroupCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved collaborating groups. */
    // @DataMember(Order=2)
    public collaboratingGroups: CollaboratingGroup[];

    public constructor(init?: Partial<CollaboratingGroupCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountrySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved country. */
    // @DataMember(Order=2)
    public country: Country;

    public constructor(init?: Partial<CountrySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CountryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved countrys. */
    // @DataMember(Order=2)
    public countries: Country[];

    public constructor(init?: Partial<CountryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved institution. */
    // @DataMember(Order=2)
    public institution: Institution;

    public constructor(init?: Partial<InstitutionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InstitutionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved institutions. */
    // @DataMember(Order=2)
    public institutions: Institution[];

    public constructor(init?: Partial<InstitutionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient. */
    // @DataMember(Order=2)
    public patient: Patient;

    public constructor(init?: Partial<PatientSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: PatientValidationResult;

    public constructor(init?: Partial<PatientValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patients. */
    // @DataMember(Order=2)
    public patients: Patient[];

    public constructor(init?: Partial<PatientCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: EventValidationResult;

    public constructor(init?: Partial<EventValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event. */
    // @DataMember(Order=2)
    public event: Event;

    public constructor(init?: Partial<EventSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved events. */
    // @DataMember(Order=2)
    public events: Event[];

    public constructor(init?: Partial<EventCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageDocumentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved image document. */
    // @DataMember(Order=2)
    public form: ImageDocument;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ImageDocumentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageDocumentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved image documents. */
    // @DataMember(Order=2)
    public forms: ImageDocument[];

    public constructor(init?: Partial<ImageDocumentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageDocumentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ImageDocumentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageDocumentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ImageDocumentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriImageUploadSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved mri image upload. */
    // @DataMember(Order=2)
    public form: MriImageUpload;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MriImageUploadSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriImageUploadCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved mri image uploads. */
    // @DataMember(Order=2)
    public forms: MriImageUpload[];

    public constructor(init?: Partial<MriImageUploadCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriImageUploadDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MriImageUploadDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriImageUploadValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<MriImageUploadValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportDocumentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved image report document. */
    // @DataMember(Order=2)
    public form: ImageReportDocument;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ImageReportDocumentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportDocumentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved image report documents. */
    // @DataMember(Order=2)
    public forms: ImageReportDocument[];

    public constructor(init?: Partial<ImageReportDocumentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportDocumentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ImageReportDocumentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportDocumentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ImageReportDocumentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved source document. */
    // @DataMember(Order=2)
    public form: SourceDocument;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SourceDocumentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved source documents. */
    // @DataMember(Order=2)
    public forms: SourceDocument[];

    public constructor(init?: Partial<SourceDocumentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SourceDocumentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SourceDocumentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SourceDocumentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorDetailsSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error details. */
    // @DataMember(Order=2)
    public form: SystemErrorDetails;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SystemErrorDetailsSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorDetailsCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error detailss. */
    // @DataMember(Order=2)
    public forms: SystemErrorDetails[];

    public constructor(init?: Partial<SystemErrorDetailsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorDetailsDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SystemErrorDetailsDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorDetailsValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SystemErrorDetailsValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error form. */
    // @DataMember(Order=2)
    public form: SystemErrorForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SystemErrorFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error forms. */
    // @DataMember(Order=2)
    public forms: SystemErrorForm[];

    public constructor(init?: Partial<SystemErrorFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SystemErrorFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SystemErrorFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorInfoSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error info. */
    // @DataMember(Order=2)
    public form: SystemErrorInfo;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SystemErrorInfoSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorInfoCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error infos. */
    // @DataMember(Order=2)
    public forms: SystemErrorInfo[];

    public constructor(init?: Partial<SystemErrorInfoCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorInfoDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SystemErrorInfoDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorInfoValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SystemErrorInfoValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorSourceDocumentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error source document. */
    // @DataMember(Order=2)
    public form: SystemErrorSourceDocument;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SystemErrorSourceDocumentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorSourceDocumentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved system error source documents. */
    // @DataMember(Order=2)
    public forms: SystemErrorSourceDocument[];

    public constructor(init?: Partial<SystemErrorSourceDocumentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorSourceDocumentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SystemErrorSourceDocumentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SystemErrorSourceDocumentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SystemErrorSourceDocumentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastCancerTreatmentOutcomesScaleSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved breast cancer treatment outcomes scale. */
    // @DataMember(Order=2)
    public form: BreastCancerTreatmentOutcomesScale;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastCancerTreatmentOutcomesScaleCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved breast cancer treatment outcomes scales. */
    // @DataMember(Order=2)
    public forms: BreastCancerTreatmentOutcomesScale[];

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastCancerTreatmentOutcomesScaleDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastCancerTreatmentOutcomesScaleValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BriefIllnessPerceptionQuestionnaireSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved brief illness perception questionnaire. */
    // @DataMember(Order=2)
    public form: BriefIllnessPerceptionQuestionnaire;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BriefIllnessPerceptionQuestionnaireCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved brief illness perception questionnaires. */
    // @DataMember(Order=2)
    public forms: BriefIllnessPerceptionQuestionnaire[];

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BriefIllnessPerceptionQuestionnaireDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BriefIllnessPerceptionQuestionnaireValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DecisionRegretScaleSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved decision regret scale. */
    // @DataMember(Order=2)
    public form: DecisionRegretScale;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<DecisionRegretScaleSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DecisionRegretScaleCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved decision regret scales. */
    // @DataMember(Order=2)
    public forms: DecisionRegretScale[];

    public constructor(init?: Partial<DecisionRegretScaleCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DecisionRegretScaleDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DecisionRegretScaleDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DecisionRegretScaleValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<DecisionRegretScaleValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndocrineTherapyAdherenceSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved endocrine therapy adherence. */
    // @DataMember(Order=2)
    public form: EndocrineTherapyAdherence;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<EndocrineTherapyAdherenceSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndocrineTherapyAdherenceCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved endocrine therapy adherences. */
    // @DataMember(Order=2)
    public forms: EndocrineTherapyAdherence[];

    public constructor(init?: Partial<EndocrineTherapyAdherenceCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndocrineTherapyAdherenceDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<EndocrineTherapyAdherenceDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EndocrineTherapyAdherenceValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<EndocrineTherapyAdherenceValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EortcIL353SingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved eortc i l353. */
    // @DataMember(Order=2)
    public form: EortcIL353;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<EortcIL353SingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EortcIL353CollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved eortc i l353s. */
    // @DataMember(Order=2)
    public forms: EortcIL353[];

    public constructor(init?: Partial<EortcIL353CollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EortcIL353DeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<EortcIL353DeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EortcIL353ValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<EortcIL353ValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EQ5D5LSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved e q5 d5 l. */
    // @DataMember(Order=2)
    public form: EQ5D5L;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<EQ5D5LSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EQ5D5LCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved e q5 d5 ls. */
    // @DataMember(Order=2)
    public forms: EQ5D5L[];

    public constructor(init?: Partial<EQ5D5LCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EQ5D5LDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<EQ5D5LDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EQ5D5LValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<EQ5D5LValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExperienceAndImpactOfTreatmentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved experience and impact of treatment. */
    // @DataMember(Order=2)
    public form: ExperienceAndImpactOfTreatment;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExperienceAndImpactOfTreatmentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved experience and impact of treatments. */
    // @DataMember(Order=2)
    public forms: ExperienceAndImpactOfTreatment[];

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExperienceAndImpactOfTreatmentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ExperienceAndImpactOfTreatmentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FearOfCancerRecurrenceSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved fear of cancer recurrence. */
    // @DataMember(Order=2)
    public form: FearOfCancerRecurrence;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<FearOfCancerRecurrenceSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FearOfCancerRecurrenceCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved fear of cancer recurrences. */
    // @DataMember(Order=2)
    public forms: FearOfCancerRecurrence[];

    public constructor(init?: Partial<FearOfCancerRecurrenceCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FearOfCancerRecurrenceDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<FearOfCancerRecurrenceDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FearOfCancerRecurrenceValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<FearOfCancerRecurrenceValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralizedAnxietyDisorder2SingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved generalized anxiety disorder2. */
    // @DataMember(Order=2)
    public form: GeneralizedAnxietyDisorder2;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2SingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralizedAnxietyDisorder2CollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved generalized anxiety disorder2s. */
    // @DataMember(Order=2)
    public forms: GeneralizedAnxietyDisorder2[];

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2CollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralizedAnxietyDisorder2DeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2DeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralizedAnxietyDisorder2ValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2ValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InternationalPersonalityItemPoolSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved international personality item pool. */
    // @DataMember(Order=2)
    public form: InternationalPersonalityItemPool;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<InternationalPersonalityItemPoolSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InternationalPersonalityItemPoolCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved international personality item pools. */
    // @DataMember(Order=2)
    public forms: InternationalPersonalityItemPool[];

    public constructor(init?: Partial<InternationalPersonalityItemPoolCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InternationalPersonalityItemPoolDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<InternationalPersonalityItemPoolDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class InternationalPersonalityItemPoolValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<InternationalPersonalityItemPoolValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientHealthQuestionnaire2SingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient health questionnaire2. */
    // @DataMember(Order=2)
    public form: PatientHealthQuestionnaire2;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<PatientHealthQuestionnaire2SingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientHealthQuestionnaire2CollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved patient health questionnaire2s. */
    // @DataMember(Order=2)
    public forms: PatientHealthQuestionnaire2[];

    public constructor(init?: Partial<PatientHealthQuestionnaire2CollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientHealthQuestionnaire2DeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PatientHealthQuestionnaire2DeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PatientHealthQuestionnaire2ValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<PatientHealthQuestionnaire2ValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RiskAppraisalSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved risk appraisal. */
    // @DataMember(Order=2)
    public form: RiskAppraisal;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<RiskAppraisalSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RiskAppraisalCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved risk appraisals. */
    // @DataMember(Order=2)
    public forms: RiskAppraisal[];

    public constructor(init?: Partial<RiskAppraisalCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RiskAppraisalDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RiskAppraisalDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RiskAppraisalValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<RiskAppraisalValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved procomida. */
    // @DataMember(Order=2)
    public form: Procomida;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ProcomidaSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved procomidas. */
    // @DataMember(Order=2)
    public forms: Procomida[];

    public constructor(init?: Partial<ProcomidaCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcomidaDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ProcomidaValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaAssistanceSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved procomida assistance. */
    // @DataMember(Order=2)
    public form: ProcomidaAssistance;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ProcomidaAssistanceSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaAssistanceCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved procomida assistances. */
    // @DataMember(Order=2)
    public forms: ProcomidaAssistance[];

    public constructor(init?: Partial<ProcomidaAssistanceCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaAssistanceDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcomidaAssistanceDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaAssistanceValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ProcomidaAssistanceValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaIncompleteSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved procomida incomplete. */
    // @DataMember(Order=2)
    public form: ProcomidaIncomplete;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ProcomidaIncompleteSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaIncompleteCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved procomida incompletes. */
    // @DataMember(Order=2)
    public forms: ProcomidaIncomplete[];

    public constructor(init?: Partial<ProcomidaIncompleteCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaIncompleteDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ProcomidaIncompleteDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ProcomidaIncompleteValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ProcomidaIncompleteValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved screening form. */
    // @DataMember(Order=2)
    public form: ScreeningForm;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ScreeningFormSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved screening forms. */
    // @DataMember(Order=2)
    public forms: ScreeningForm[];

    public constructor(init?: Partial<ScreeningFormCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ScreeningFormDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ScreeningFormValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ScreeningFormValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalOfConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved withdrawal of consent. */
    // @DataMember(Order=2)
    public form: WithdrawalOfConsent;

    public constructor(init?: Partial<WithdrawalOfConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalOfConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved withdrawal of consents. */
    // @DataMember(Order=2)
    public forms: WithdrawalOfConsent[];

    public constructor(init?: Partial<WithdrawalOfConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalOfConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<WithdrawalOfConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class WithdrawalOfConsentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<WithdrawalOfConsentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DiagnosticImagingSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved diagnostic imaging. */
    // @DataMember(Order=2)
    public form: DiagnosticImaging;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<DiagnosticImagingSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DiagnosticImagingCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved diagnostic imagings. */
    // @DataMember(Order=2)
    public forms: DiagnosticImaging[];

    public constructor(init?: Partial<DiagnosticImagingCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DiagnosticImagingDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<DiagnosticImagingDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class DiagnosticImagingValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<DiagnosticImagingValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralAndConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved general and consent. */
    // @DataMember(Order=2)
    public form: GeneralAndConsent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<GeneralAndConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralAndConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved general and consents. */
    // @DataMember(Order=2)
    public forms: GeneralAndConsent[];

    public constructor(init?: Partial<GeneralAndConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralAndConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<GeneralAndConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GeneralAndConsentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<GeneralAndConsentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportUploadSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved image report upload. */
    // @DataMember(Order=2)
    public form: ImageReportUpload;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ImageReportUploadSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportUploadCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved image report uploads. */
    // @DataMember(Order=2)
    public forms: ImageReportUpload[];

    public constructor(init?: Partial<ImageReportUploadCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportUploadDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ImageReportUploadDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ImageReportUploadValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ImageReportUploadValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MedicalHistorySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved medical history. */
    // @DataMember(Order=2)
    public form: MedicalHistory;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MedicalHistorySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MedicalHistoryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved medical historys. */
    // @DataMember(Order=2)
    public forms: MedicalHistory[];

    public constructor(init?: Partial<MedicalHistoryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MedicalHistoryDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MedicalHistoryDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MedicalHistoryValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<MedicalHistoryValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PromsSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved proms. */
    // @DataMember(Order=2)
    public form: Proms;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<PromsSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PromsCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved promss. */
    // @DataMember(Order=2)
    public forms: Proms[];

    public constructor(init?: Partial<PromsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PromsDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<PromsDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class PromsValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<PromsValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationEligibilityChecklistSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved registration eligibility checklist. */
    // @DataMember(Order=2)
    public form: RegistrationEligibilityChecklist;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<RegistrationEligibilityChecklistSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationEligibilityChecklistCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved registration eligibility checklists. */
    // @DataMember(Order=2)
    public forms: RegistrationEligibilityChecklist[];

    public constructor(init?: Partial<RegistrationEligibilityChecklistCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationEligibilityChecklistDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RegistrationEligibilityChecklistDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RegistrationEligibilityChecklistValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<RegistrationEligibilityChecklistValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CemReportLesionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved cem report lesion. */
    // @DataMember(Order=2)
    public form: CEMReportLesion;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<CemReportLesionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CemReportLesionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved cem report lesions. */
    // @DataMember(Order=2)
    public forms: CEMReportLesion[];

    public constructor(init?: Partial<CemReportLesionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CemReportLesionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<CemReportLesionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class CemReportLesionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<CemReportLesionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MammographyReportLesionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved mammography report lesion. */
    // @DataMember(Order=2)
    public form: MammographyReportLesion;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MammographyReportLesionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MammographyReportLesionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved mammography report lesions. */
    // @DataMember(Order=2)
    public forms: MammographyReportLesion[];

    public constructor(init?: Partial<MammographyReportLesionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MammographyReportLesionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MammographyReportLesionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MammographyReportLesionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<MammographyReportLesionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriReportLesionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved mri report lesion. */
    // @DataMember(Order=2)
    public form: MRIReportLesion;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MriReportLesionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriReportLesionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved mri report lesions. */
    // @DataMember(Order=2)
    public forms: MRIReportLesion[];

    public constructor(init?: Partial<MriReportLesionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriReportLesionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MriReportLesionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MriReportLesionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<MriReportLesionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RadiologyReportSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved radiology report. */
    // @DataMember(Order=2)
    public form: RadiologyReport;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<RadiologyReportSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RadiologyReportCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved radiology reports. */
    // @DataMember(Order=2)
    public forms: RadiologyReport[];

    public constructor(init?: Partial<RadiologyReportCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RadiologyReportDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<RadiologyReportDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class RadiologyReportValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<RadiologyReportValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UltrasoundReportLesionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved ultrasound report lesion. */
    // @DataMember(Order=2)
    public form: UltrasoundReportLesion;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<UltrasoundReportLesionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UltrasoundReportLesionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved ultrasound report lesions. */
    // @DataMember(Order=2)
    public forms: UltrasoundReportLesion[];

    public constructor(init?: Partial<UltrasoundReportLesionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UltrasoundReportLesionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<UltrasoundReportLesionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class UltrasoundReportLesionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<UltrasoundReportLesionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved main consent. */
    // @DataMember(Order=2)
    public form: MainConsent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<MainConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved main consents. */
    // @DataMember(Order=2)
    public forms: MainConsent[];

    public constructor(init?: Partial<MainConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<MainConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class MainConsentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<MainConsentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved services australia consent. */
    // @DataMember(Order=2)
    public form: ServicesAustraliaConsent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved services australia consents. */
    // @DataMember(Order=2)
    public forms: ServicesAustraliaConsent[];

    public constructor(init?: Partial<ServicesAustraliaConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ServicesAustraliaConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ServicesAustraliaConsentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ServicesAustraliaConsentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsentSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tissue banking consent. */
    // @DataMember(Order=2)
    public form: TissueBankingConsent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TissueBankingConsentSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsentCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tissue banking consents. */
    // @DataMember(Order=2)
    public forms: TissueBankingConsent[];

    public constructor(init?: Partial<TissueBankingConsentCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsentDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TissueBankingConsentDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueBankingConsentValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<TissueBankingConsentValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved additional cancer. */
    // @DataMember(Order=2)
    public form: AdditionalCancer;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<AdditionalCancerSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved additional cancers. */
    // @DataMember(Order=2)
    public forms: AdditionalCancer[];

    public constructor(init?: Partial<AdditionalCancerCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdditionalCancerDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<AdditionalCancerValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerDetailSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved additional cancer detail. */
    // @DataMember(Order=2)
    public form: AdditionalCancerDetail;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<AdditionalCancerDetailSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerDetailCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved additional cancer details. */
    // @DataMember(Order=2)
    public forms: AdditionalCancerDetail[];

    public constructor(init?: Partial<AdditionalCancerDetailCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerDetailDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdditionalCancerDetailDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdditionalCancerDetailValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<AdditionalCancerDetailValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved adverse event. */
    // @DataMember(Order=2)
    public form: AdverseEvent;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<AdverseEventSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved adverse events. */
    // @DataMember(Order=2)
    public forms: AdverseEvent[];

    public constructor(init?: Partial<AdverseEventCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<AdverseEventDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class AdverseEventValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<AdverseEventValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved breast mri. */
    // @DataMember(Order=2)
    public form: BreastMri;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<BreastMriSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved breast mris. */
    // @DataMember(Order=2)
    public forms: BreastMri[];

    public constructor(init?: Partial<BreastMriCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BreastMriDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<BreastMriValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriAdditionalLesionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved breast mri additional lesion. */
    // @DataMember(Order=2)
    public form: BreastMriAdditionalLesion;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<BreastMriAdditionalLesionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriAdditionalLesionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved breast mri additional lesions. */
    // @DataMember(Order=2)
    public forms: BreastMriAdditionalLesion[];

    public constructor(init?: Partial<BreastMriAdditionalLesionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriAdditionalLesionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<BreastMriAdditionalLesionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class BreastMriAdditionalLesionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<BreastMriAdditionalLesionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContrastEnhancedMammogramSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved contrast enhanced mammogram. */
    // @DataMember(Order=2)
    public form: ContrastEnhancedMammogram;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<ContrastEnhancedMammogramSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContrastEnhancedMammogramCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved contrast enhanced mammograms. */
    // @DataMember(Order=2)
    public forms: ContrastEnhancedMammogram[];

    public constructor(init?: Partial<ContrastEnhancedMammogramCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContrastEnhancedMammogramDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<ContrastEnhancedMammogramDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class ContrastEnhancedMammogramValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<ContrastEnhancedMammogramValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class HistopathologySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved histopathology. */
    // @DataMember(Order=2)
    public form: Histopathology;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<HistopathologySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class HistopathologyCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved histopathologys. */
    // @DataMember(Order=2)
    public forms: Histopathology[];

    public constructor(init?: Partial<HistopathologyCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class HistopathologyDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<HistopathologyDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class HistopathologyValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<HistopathologyValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SurgerySingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved surgery. */
    // @DataMember(Order=2)
    public form: Surgery;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<SurgerySingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SurgeryCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved surgerys. */
    // @DataMember(Order=2)
    public forms: Surgery[];

    public constructor(init?: Partial<SurgeryCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SurgeryDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<SurgeryDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class SurgeryValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<SurgeryValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueCollectionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tissue collection. */
    // @DataMember(Order=2)
    public form: TissueCollection;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TissueCollectionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueCollectionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved tissue collections. */
    // @DataMember(Order=2)
    public forms: TissueCollection[];

    public constructor(init?: Partial<TissueCollectionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueCollectionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TissueCollectionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TissueCollectionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<TissueCollectionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TranslationalBloodCollectionSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved translational blood collection. */
    // @DataMember(Order=2)
    public form: TranslationalBloodCollection;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TranslationalBloodCollectionSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TranslationalBloodCollectionCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved translational blood collections. */
    // @DataMember(Order=2)
    public forms: TranslationalBloodCollection[];

    public constructor(init?: Partial<TranslationalBloodCollectionCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TranslationalBloodCollectionDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TranslationalBloodCollectionDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TranslationalBloodCollectionValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<TranslationalBloodCollectionValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentDecisionsSingleResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatment decisions. */
    // @DataMember(Order=2)
    public form: TreatmentDecisions;

    /** @description Whether the form should be visible in the patient summary list. */
    // @DataMember(Order=3)
    public visible: boolean;

    /** @description Whether the form should be validated. */
    // @DataMember(Order=4)
    public validate: boolean;

    /** @description Whether the form should be readable. */
    // @DataMember(Order=5)
    public read: boolean;

    /** @description Whether the form should be writable. */
    // @DataMember(Order=6)
    public write: boolean;

    public constructor(init?: Partial<TreatmentDecisionsSingleResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentDecisionsCollectionResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved treatment decisionss. */
    // @DataMember(Order=2)
    public forms: TreatmentDecisions[];

    public constructor(init?: Partial<TreatmentDecisionsCollectionResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentDecisionsDeleteResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    public constructor(init?: Partial<TreatmentDecisionsDeleteResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class TreatmentDecisionsValidationResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The validation result. */
    // @DataMember(Order=2)
    public validationResult: FormValidationResult;

    public constructor(init?: Partial<TreatmentDecisionsValidationResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class EventStateResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved event states for the patient. */
    // @DataMember(Order=2)
    public states: EventState[];

    public constructor(init?: Partial<EventStateResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class FormStateResponse
{
    [immerable]? = true;

    /** @description The information about any issues that may have occurred while attempting to process the request. */
    // @DataMember(Order=1)
    public responseStatus: ResponseStatus;

    /** @description The retrieved form states for the patient event. */
    // @DataMember(Order=2)
    public states: FormState[];

    public constructor(init?: Partial<FormStateResponse>) { (Object as any).assign(this, init); }
}

export class UserPermissionsResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public permissions: BctUserPermissionContext[];

    public constructor(init?: Partial<UserPermissionsResponse>) { (Object as any).assign(this, init); }
}

export class HasOpmsPermissionCollectionResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public hasPermission: { [index: number]: boolean; };

    public constructor(init?: Partial<HasOpmsPermissionCollectionResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public personnel: { [index: number]: InstitutionPersonnel; };

    public constructor(init?: Partial<InstitutionPersonnelResponse>) { (Object as any).assign(this, init); }
}

export class InstitutionPersonnelNamesResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public personnelNames: { [index: number]: string; };

    public constructor(init?: Partial<InstitutionPersonnelNamesResponse>) { (Object as any).assign(this, init); }
}

export class TrialPersonnelActiveRoleResponse
{
    [immerable]? = true;

    public responseStatus: ResponseStatus;
    public hasRole: { [index: number]: boolean; };

    public constructor(init?: Partial<TrialPersonnelActiveRoleResponse>) { (Object as any).assign(this, init); }
}

export class GetSiteProtocolResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public protocolName: string;
    public protocolVersion: string;
    public usingNewProtocol: boolean;

    public constructor(init?: Partial<GetSiteProtocolResponse>) { (Object as any).assign(this, init); }
}

export class CheckAnyOpmsInstitutionOnNewProtocolResponse
{
    [immerable]? = true;

    public responseStatus?: ResponseStatus;
    public usingNewProtocol: boolean;

    public constructor(init?: Partial<CheckAnyOpmsInstitutionOnNewProtocolResponse>) { (Object as any).assign(this, init); }
}

// @DataContract
export class GetBreastMriLesionsByPatientId implements IReturn<GetBreastMriLesionsByPatientIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    public constructor(init?: Partial<GetBreastMriLesionsByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBreastMriLesionsByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBreastMriLesionsByPatientIdResponse(); }
}

// @DataContract
export class GetBreastMriAdverseEventsByPatientId implements IReturn<GetBreastMriAdverseEventsByPatientIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    public constructor(init?: Partial<GetBreastMriAdverseEventsByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBreastMriAdverseEventsByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBreastMriAdverseEventsByPatientIdResponse(); }
}

export class GetCachedFormDefinitions implements IReturn<CachedFormDefinitionCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedFormDefinitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedFormDefinitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedFormDefinitionCollectionResponse(); }
}

export class GetCachedEventDefinitions implements IReturn<CachedEventDefinitionCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedEventDefinitions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedEventDefinitions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedEventDefinitionCollectionResponse(); }
}

export class GetCachedPatientStates implements IReturn<CachedPatientStateCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedPatientStates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedPatientStates'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedPatientStateCollectionResponse(); }
}

export class GetCachedTreatments implements IReturn<CachedTreatmentCollectionResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetCachedTreatments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCachedTreatments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CachedTreatmentCollectionResponse(); }
}

export class GetClientAppSettings implements IReturn<GetClientAppSettingsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetClientAppSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetClientAppSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetClientAppSettingsResponse(); }
}

export class StartConsent implements IReturn<StartConsentResponse>
{
    [immerable]? = true;

    public consentEvent: ConsentEvent;
    public eventDefinitionId?: number;
    public firstName: string;
    public lastName: string;

    public constructor(init?: Partial<StartConsent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartConsent'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StartConsentResponse(); }
}

export class GetConsentVersions implements IReturn<GetConsentVersionsResponse>
{
    [immerable]? = true;

    public institutionCode: string;
    public picfTypeName: string;

    public constructor(init?: Partial<GetConsentVersions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConsentVersions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConsentVersionsResponse(); }
}

export class SendConsentInformation implements IReturn<SendConsentInformationResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public eventDefinitionId?: number;

    public constructor(init?: Partial<SendConsentInformation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendConsentInformation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendConsentInformationResponse(); }
}

export class GetConsentEventByGuid implements IReturn<GetConsentEventByGuidResponse>, IEConsentRequest, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetConsentEventByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConsentEventByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConsentEventByGuidResponse(); }
}

export class GetConsentEventData implements IReturn<GetConsentEventDataResponse>, IEConsentRequest, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetConsentEventData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConsentEventData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConsentEventDataResponse(); }
}

export class GetConsentInvestigators implements IReturn<GetConsentInvestigatorsResponse>, IEConsentRequest, IGet
{
    [immerable]? = true;

    public guid: string;
    public institutionCode: string;

    public constructor(init?: Partial<GetConsentInvestigators>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetConsentInvestigators'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetConsentInvestigatorsResponse(); }
}

// @DataContract
export class GetCtcaeTermName implements IReturn<GetCtcaeTermNameResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public ctcaeTermId?: number;

    public constructor(init?: Partial<GetCtcaeTermName>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetCtcaeTermName'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetCtcaeTermNameResponse(); }
}

// @Route("/opms/econsent/settings/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class GetEConsentSettings implements IReturn<GetEConsentSettingsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetEConsentSettings>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEConsentSettings'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEConsentSettingsResponse(); }
}

export class SendEConsentPatientEmail implements IReturn<SendEConsentPatientEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public investigator?: string;
    public consentGuid?: string;

    public constructor(init?: Partial<SendEConsentPatientEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentPatientEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentPatientEmailResponse(); }
}

export class SendEConsentPatientCompleteEmail implements IReturn<SendEConsentPatientCompleteEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public consentGuid?: string;

    public constructor(init?: Partial<SendEConsentPatientCompleteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentPatientCompleteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentPatientCompleteEmailResponse(); }
}

export class SendEConsentCompleteEmail implements IReturn<SendEConsentCompleteEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public consentGuid?: string;

    public constructor(init?: Partial<SendEConsentCompleteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentCompleteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentCompleteEmailResponse(); }
}

export class SendEConsentCompleteTrialEmail implements IReturn<SendEConsentCompleteTrialEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public consentGuid?: string;

    public constructor(init?: Partial<SendEConsentCompleteTrialEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentCompleteTrialEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentCompleteTrialEmailResponse(); }
}

export class SendEConsentRefusedEmail implements IReturn<SendEConsentRefusedEmailResponse>
{
    [immerable]? = true;

    public patientConsentId: number;

    public constructor(init?: Partial<SendEConsentRefusedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendEConsentRefusedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendEConsentRefusedEmailResponse(); }
}

export class SendConsentInformationEmail implements IReturn<SendConsentInformationEmailResponse>
{
    [immerable]? = true;

    public participantEmail: string;
    public instCode: string;

    public constructor(init?: Partial<SendConsentInformationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendConsentInformationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendConsentInformationEmailResponse(); }
}

export class SendRadiologyReviewEmail implements IReturn<SendRadiologyReviewEmailResponse>
{
    [immerable]? = true;

    public radiologyReportId?: number;

    public constructor(init?: Partial<SendRadiologyReviewEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendRadiologyReviewEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendRadiologyReviewEmailResponse(); }
}

export class SendRadiologyReviewCompleteSiteEmail implements IReturn<SendRadiologyReviewCompleteSiteEmailResponse>
{
    [immerable]? = true;

    public radiologyReportId?: number;

    public constructor(init?: Partial<SendRadiologyReviewCompleteSiteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendRadiologyReviewCompleteSiteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendRadiologyReviewCompleteSiteEmailResponse(); }
}

export class SendRadiologyReviewCompleteBctEmail implements IReturn<SendRadiologyReviewCompleteBctEmailResponse>
{
    [immerable]? = true;

    public radiologyReportId?: number;

    public constructor(init?: Partial<SendRadiologyReviewCompleteBctEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendRadiologyReviewCompleteBctEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendRadiologyReviewCompleteBctEmailResponse(); }
}

export class SendSuccessfulAllocationEmail implements IReturn<SendSuccessfulAllocationEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<SendSuccessfulAllocationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSuccessfulAllocationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSuccessfulAllocationEmailResponse(); }
}

export class SendBctReviewEmail implements IReturn<SendBctReviewEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<SendBctReviewEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendBctReviewEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendBctReviewEmailResponse(); }
}

export class SendBctReviewSiteEmail implements IReturn<SendBctReviewSiteEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<SendBctReviewSiteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendBctReviewSiteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendBctReviewSiteEmailResponse(); }
}

export class SendCorrectionRequiredEmail implements IReturn<SendCorrectionRequiredEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public correctionReason: string;

    public constructor(init?: Partial<SendCorrectionRequiredEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendCorrectionRequiredEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendCorrectionRequiredEmailResponse(); }
}

export class SendBctAllocationReviewReminderEmail implements IReturn<SendBctAllocationReviewReminderEmailResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<SendBctAllocationReviewReminderEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendBctAllocationReviewReminderEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendBctAllocationReviewReminderEmailResponse(); }
}

export class SendSuccessfulRegistrationEmail implements IReturn<SendSuccessfulRegistrationEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<SendSuccessfulRegistrationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSuccessfulRegistrationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSuccessfulRegistrationEmailResponse(); }
}

export class SendPatientWelcomeEmail implements IReturn<SendPatientWelcomeEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<SendPatientWelcomeEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendPatientWelcomeEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendPatientWelcomeEmailResponse(); }
}

export class SendPatientReminderEmail implements IReturn<SendPatientReminderEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public resetPassword?: boolean;

    public constructor(init?: Partial<SendPatientReminderEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendPatientReminderEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendPatientReminderEmailResponse(); }
}

export class SendPatientReminder implements IReturn<SendPatientReminderResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<SendPatientReminder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendPatientReminder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendPatientReminderResponse(); }
}

export class SendNewInvestigatorEmail implements IReturn<SendNewInvestigatorEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public investigator: string;
    public consentForm: string;

    public constructor(init?: Partial<SendNewInvestigatorEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendNewInvestigatorEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendNewInvestigatorEmailResponse(); }
}

export class SendNewPicfVersionEmail implements IReturn<SendNewPicfVersionEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public picfVersion: string;
    public consentForm: string;

    public constructor(init?: Partial<SendNewPicfVersionEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendNewPicfVersionEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendNewPicfVersionEmailResponse(); }
}

export class SendMultipleRandomisationEmail implements IReturn<SendMultipleRandomisationEmailResponse>
{
    [immerable]? = true;

    public instName: string;
    public randomisationEmailData: MultipleRandomisationEmailData[];

    public constructor(init?: Partial<SendMultipleRandomisationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendMultipleRandomisationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendMultipleRandomisationEmailResponse(); }
}

export class SendWeeklyDicomEmail implements IReturn<SendWeeklyDicomEmailResponse>
{
    [immerable]? = true;

    public date?: string;

    public constructor(init?: Partial<SendWeeklyDicomEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendWeeklyDicomEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendWeeklyDicomEmailResponse(); }
}

export class SendDicomFailedEmail implements IReturn<SendDicomFailedEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public ccList: EmailAddress[];

    public constructor(init?: Partial<SendDicomFailedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendDicomFailedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendDicomFailedEmailResponse(); }
}

export class SendSaConsentUpdatesRequiredEmail implements IReturn<SendSaConsentUpdatesRequiredEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public comments?: string;

    public constructor(init?: Partial<SendSaConsentUpdatesRequiredEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaConsentUpdatesRequiredEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaConsentUpdatesRequiredEmailResponse(); }
}

export class SendSuccessfulPreregistrationEmail implements IReturn<SendSuccessfulPreregistrationEmailResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public age?: number;

    public constructor(init?: Partial<SendSuccessfulPreregistrationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSuccessfulPreregistrationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSuccessfulPreregistrationEmailResponse(); }
}

export class SendFormsDueSummaryEmail implements IReturn<SendFormsDueSummaryEmailResponse>
{
    [immerable]? = true;

    public instCode: string;
    public cutOffDate?: string;

    public constructor(init?: Partial<SendFormsDueSummaryEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendFormsDueSummaryEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendFormsDueSummaryEmailResponse(); }
}

// @DataContract
export class GetImageReportDocuments implements IReturn<GetImageReportDocumentsResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    public constructor(init?: Partial<GetImageReportDocuments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetImageReportDocuments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetImageReportDocumentsResponse(); }
}

export class PostPatientSetPreferredLanguage implements IReturnVoid, IPost
{
    [immerable]? = true;

    public patientId?: number;
    public localeId?: number;

    public constructor(init?: Partial<PostPatientSetPreferredLanguage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostPatientSetPreferredLanguage'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/locales/{LocaleCode}/{NamespaceCode}", "GET")
export class GetLocaleNamespace implements IReturn<Object>, IGet
{
    [immerable]? = true;

    public localeCode?: string;
    public namespaceCode?: string;

    public constructor(init?: Partial<GetLocaleNamespace>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocaleNamespace'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Object(); }
}

// @Route("/locales/{LocaleCode}/{NamespaceCode}/add", "POST")
export class AddLocaleNamespaceTranslation implements IReturn<Object>, IPost
{
    [immerable]? = true;

    public localeCode?: string;
    public namespaceCode?: string;
    public requestStream: string;

    public constructor(init?: Partial<AddLocaleNamespaceTranslation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AddLocaleNamespaceTranslation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new Object(); }
}

export class GetLocales implements IReturn<Locale[]>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetLocales>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLocales'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Locale>(); }
}

export class GetNamespaces implements IReturn<Namespace[]>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetNamespaces>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetNamespaces'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Namespace>(); }
}

export class GetTranslations implements IReturn<Translation[]>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetTranslations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTranslations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Array<Translation>(); }
}

export class SaveTranslation implements IReturn<boolean>
{
    [immerable]? = true;

    public translation?: Translation;

    public constructor(init?: Partial<SaveTranslation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaveTranslation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return false; }
}

export class GetMriImageUploads implements IReturn<GetMriImageUploadsResponse>
{
    [immerable]? = true;

    public institutionCode?: string;
    public selectedImagesNotUploaded?: boolean;
    public selectedImagesNotVerified?: boolean;
    public selectedImagesDeidentifiedFailed?: boolean;
    public noCache?: string;

    public constructor(init?: Partial<GetMriImageUploads>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMriImageUploads'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMriImageUploadsResponse(); }
}

export class GetMriImageUploadById implements IReturn<GetMriImageUploadByIdResponse>
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<GetMriImageUploadById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetMriImageUploadById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetMriImageUploadByIdResponse(); }
}

export class PostSubmitImageUpload implements IReturn<PostSubmitImageUploadResponse>
{
    [immerable]? = true;

    public mriImageUpload?: MriImageUpload;
    public imageDeIdentified?: boolean;
    public cemDeIdentified?: boolean;

    public constructor(init?: Partial<PostSubmitImageUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSubmitImageUpload'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSubmitImageUploadResponse(); }
}

export class PostImageUploadVerify implements IReturn<PostImageUploadVerifyResponse>
{
    [immerable]? = true;

    public documentId?: number;

    public constructor(init?: Partial<PostImageUploadVerify>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostImageUploadVerify'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostImageUploadVerifyResponse(); }
}

export class PostDeleteImageDocById implements IReturn<PostDeleteImageDocByIdResponse>
{
    [immerable]? = true;

    public documentId?: number;

    public constructor(init?: Partial<PostDeleteImageDocById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostDeleteImageDocById'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostDeleteImageDocByIdResponse(); }
}

export class PostDeIdentifyImage implements IReturn<PostDeIdentifyImageResponse>
{
    [immerable]? = true;

    public documentId?: number;

    public constructor(init?: Partial<PostDeIdentifyImage>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostDeIdentifyImage'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostDeIdentifyImageResponse(); }
}

export class PostDeIdentifyImageError implements IReturn<PostDeIdentifyImageErrorResponse>
{
    [immerable]? = true;

    public documentId?: number;

    public constructor(init?: Partial<PostDeIdentifyImageError>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostDeIdentifyImageError'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostDeIdentifyImageErrorResponse(); }
}

export class PerformanceTest implements IReturn<PerformanceTestResponse>
{
    [immerable]? = true;

    public iterations?: number;

    public constructor(init?: Partial<PerformanceTest>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PerformanceTest'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PerformanceTestResponse(); }
}

export class PatientAccountCreate implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public email: string;
    public password: string;

    public constructor(init?: Partial<PatientAccountCreate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountCreate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class PatientAccountResendWelcome implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<PatientAccountResendWelcome>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountResendWelcome'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class PatientAccountSetPassword implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public password: string;

    public constructor(init?: Partial<PatientAccountSetPassword>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountSetPassword'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class PatientAccountUpdateEmail implements IReturn<ActiveDirectoryResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public email: string;

    public constructor(init?: Partial<PatientAccountUpdateEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientAccountUpdateEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActiveDirectoryResponse(); }
}

export class StartReview implements IReturn<StartReviewResponse>
{
    [immerable]? = true;

    public patientId?: number;
    public radiologist?: number;

    public constructor(init?: Partial<StartReview>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartReview'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StartReviewResponse(); }
}

export class GetRadiologistPatients implements IReturn<GetRadiologistPatientsResponse>
{
    [immerable]? = true;

    public radiologistUserName: string;

    public constructor(init?: Partial<GetRadiologistPatients>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetRadiologistPatients'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetRadiologistPatientsResponse(); }
}

export class SetPatientStatus implements IReturn<SetPatientStatusResponse>, IPost
{
    [immerable]? = true;

    public patientId?: number;
    public patientStateId?: number;
    public notes: string;

    public constructor(init?: Partial<SetPatientStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPatientStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPatientStatusResponse(); }
}

export class GetPatientAllocationSummaryData implements IReturn<GetPatientAllocationSummaryDataResponse>, IGet
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<GetPatientAllocationSummaryData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientAllocationSummaryData'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientAllocationSummaryDataResponse(); }
}

export class GetPatientAllocationFactors implements IReturn<GetPatientAllocationFactorsResponse>, IGet
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<GetPatientAllocationFactors>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientAllocationFactors'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientAllocationFactorsResponse(); }
}

export class GetPatientTreatment implements IReturn<GetPatientTreatmentResponse>, IGet
{
    [immerable]? = true;

    public studyNumber: string;

    public constructor(init?: Partial<GetPatientTreatment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientTreatment'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientTreatmentResponse(); }
}

export class QueuePatientOcTransfer implements IReturn<QueuePatientOcTransferResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<QueuePatientOcTransfer>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueuePatientOcTransfer'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueuePatientOcTransferResponse(); }
}

// @DataContract
export class GetEnumTypes implements IReturn<GetEnumTypesResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientStateType?: PatientStateType;

    // @DataMember(Order=2)
    public lookupIndigenousStatusType?: LookupIndigenousStatusType;

    // @DataMember(Order=3)
    public lookupUntypedType?: LookupUntypedType;

    // @DataMember(Order=4)
    public lookupYesNoType?: LookupYesNoType;

    // @DataMember(Order=5)
    public lookupLeftRightType?: LookupLeftRightType;

    // @DataMember(Order=6)
    public lookupHistopathologyType?: LookupHistopathologyType;

    // @DataMember(Order=7)
    public lookupUltrasoundLesionType?: LookupUltrasoundLesionType;

    // @DataMember(Order=8)
    public lookupMammographyLesionType?: LookupMammographyLesionType;

    // @DataMember(Order=9)
    public lookupLesionClassificationType?: LookupLesionClassificationType;

    // @DataMember(Order=10)
    public lookupAddPatientType?: LookupAddPatientType;

    // @DataMember(Order=11)
    public lookupLikelihoodType?: LookupLikelihoodType;

    // @DataMember(Order=12)
    public lookupPatientHealthQuestionnaireType?: LookupPatientHealthQuestionnaireType;

    // @DataMember(Order=13)
    public lookupAgreeType?: LookupAgreeType;

    // @DataMember(Order=14)
    public lookupEndocrineTherapyDiscontinuationType?: LookupEndocrineTherapyDiscontinuationType;

    // @DataMember(Order=15)
    public lookupPathologyType?: LookupPathologyType;

    // @DataMember(Order=16)
    public lookupLesionIdentityType?: LookupLesionIdentityType;

    // @DataMember(Order=17)
    public lookupImageReportDocumentType?: LookupImageReportDocumentType;

    // @DataMember(Order=18)
    public formDefinitionType?: FormDefinitionType;

    // @DataMember(Order=19)
    public lookupPositiveNegativeType?: LookupPositiveNegativeType;

    // @DataMember(Order=20)
    public lookupLessGreaterThanType?: LookupLessGreaterThanType;

    // @DataMember(Order=21)
    public lookupScreenFailReasonType?: LookupScreenFailReasonType;

    // @DataMember(Order=22)
    public lookupIneligibleReasonType?: LookupIneligibleReasonType;

    // @DataMember(Order=23)
    public lookupIneligibleBreastCancerSubType?: LookupIneligibleBreastCancerSubType;

    // @DataMember(Order=24)
    public lookupImageDocumentType?: LookupImageDocumentType;

    // @DataMember(Order=25)
    public lookupDCISType?: LookupDCISType;

    // @DataMember(Order=26)
    public lookupEventErrorsByPassedType?: LookupEventErrorsByPassedType;

    // @DataMember(Order=27)
    public lookupSystemErrorApprovedByType?: LookupSystemErrorApprovedByType;

    // @DataMember(Order=28)
    public lookupContinuationType?: LookupContinuationType;

    // @DataMember(Order=29)
    public withdrawalStateType?: WithdrawalStateType;

    public constructor(init?: Partial<GetEnumTypes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetEnumTypes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetEnumTypesResponse(); }
}

export class QueueMultipleRegistrationEmails implements IReturn<QueueMultipleRegistrationEmailsResponse>
{
    [immerable]? = true;

    // @Validate(Validator="NotEmpty")
    public checkDate: string;

    public constructor(init?: Partial<QueueMultipleRegistrationEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueMultipleRegistrationEmails'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueMultipleRegistrationEmailsResponse(); }
}

// @Route("/get/accrual-counts/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetAccrualCounts implements IReturn<GetAccrualCountsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetAccrualCounts>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetAccrualCounts'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetAccrualCountsResponse(); }
}

export class GetServicesAustraliaConsentHistory implements IReturn<GetServicesAustraliaConsentHistoryResponse>
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<GetServicesAustraliaConsentHistory>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetServicesAustraliaConsentHistory'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetServicesAustraliaConsentHistoryResponse(); }
}

export class CreateProcomidaMissingIncompleteForm implements IReturn<CreateProcomidaMissingIncompleteFormResponse>
{
    [immerable]? = true;

    public patientStateId?: number;
    public eventDefinitionId?: number;
    public formDefinitionId?: number;

    public constructor(init?: Partial<CreateProcomidaMissingIncompleteForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateProcomidaMissingIncompleteForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateProcomidaMissingIncompleteFormResponse(); }
}

// @DataContract
export class QueuePatientsOcTransfer implements IReturn<QueuePatientsOcTransferResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public skip?: number;

    // @DataMember(Order=2)
    public take?: number;

    public constructor(init?: Partial<QueuePatientsOcTransfer>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueuePatientsOcTransfer'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueuePatientsOcTransferResponse(); }
}

// @DataContract
export class PostSaveParticipant implements IReturn<PostSaveParticipantResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public participant?: AddParticipant;

    public constructor(init?: Partial<PostSaveParticipant>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostSaveParticipant'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PostSaveParticipantResponse(); }
}

// @DataContract
export class QueueAutomaticPatientStatusUpdates implements IReturn<QueueAutomaticPatientStatusUpdatesResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<QueueAutomaticPatientStatusUpdates>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QueueAutomaticPatientStatusUpdates'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QueueAutomaticPatientStatusUpdatesResponse(); }
}

// @DataContract
export class GetImageReportUploadContent implements IReturn<GetImageReportUploadContentResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId: number;

    public constructor(init?: Partial<GetImageReportUploadContent>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetImageReportUploadContent'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetImageReportUploadContentResponse(); }
}

// @Route("/report/forms-due-summary", "GET,POST")
export class GetFormsDueSummaryData implements IReturn<GetFormsDueSummaryDataResponse>, IReportRequest
{
    [immerable]? = true;

    public token?: string;
    public institutionCode?: string;
    public studyNumber?: string;
    public cutOffDate?: string;

    public constructor(init?: Partial<GetFormsDueSummaryData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormsDueSummaryData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetFormsDueSummaryDataResponse(); }
}

// @Route("/report/forms-due-schedule", "GET,POST")
export class GetFormsDueScheduleData implements IReturn<GetFormsDueScheduleDataResponse>, IReportRequest
{
    [immerable]? = true;

    public token?: string;
    public randNo?: string;

    public constructor(init?: Partial<GetFormsDueScheduleData>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormsDueScheduleData'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GetFormsDueScheduleDataResponse(); }
}

export class SendSaeNewEmail implements IReturn<SendSaeNewEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendSaeNewEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNewEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNewEmailResponse(); }
}

export class SendSaeInvestigatorReviewPendingEmail implements IReturn<SendSaeInvestigatorReviewPendingEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber?: number;

    public constructor(init?: Partial<SendSaeInvestigatorReviewPendingEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeInvestigatorReviewPendingEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeInvestigatorReviewPendingEmailResponse(); }
}

export class SendSaeMedicalReviewPendingEmail implements IReturn<SendSaeMedicalReviewPendingEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber?: number;

    public constructor(init?: Partial<SendSaeMedicalReviewPendingEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeMedicalReviewPendingEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeMedicalReviewPendingEmailResponse(); }
}

export class SendSaeNotNotifiedInvestigatorEmail implements IReturn<SendSaeNotNotifiedInvestigatorEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber?: number;

    public constructor(init?: Partial<SendSaeNotNotifiedInvestigatorEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNotNotifiedInvestigatorEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNotNotifiedInvestigatorEmailResponse(); }
}

export class SendSaeNotNotifiedMedicalReviewerEmail implements IReturn<SendSaeNotNotifiedMedicalReviewerEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber?: number;

    public constructor(init?: Partial<SendSaeNotNotifiedMedicalReviewerEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNotNotifiedMedicalReviewerEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNotNotifiedMedicalReviewerEmailResponse(); }
}

export class SendSaeUnresolvedEmail implements IReturn<SendSaeUnresolvedEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendSaeUnresolvedEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeUnresolvedEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeUnresolvedEmailResponse(); }
}

export class SendSaeIncompleteEmail implements IReturn<SendSaeIncompleteEmailResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<SendSaeIncompleteEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeIncompleteEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeIncompleteEmailResponse(); }
}

export class SendSaeNotifyInvestigatorEmail implements IReturn<SendSaeNotifyInvestigatorEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public recipientIds: number[];
    public ccRecipientIds: number[];
    public attachmentNames: string[];
    public attachmentGuids: string[];
    public includedNotes: string;

    public constructor(init?: Partial<SendSaeNotifyInvestigatorEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNotifyInvestigatorEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNotifyInvestigatorEmailResponse(); }
}

export class SendSaeNotifyStudyChairEmail implements IReturn<SendSaeNotifyStudyChairEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendSaeNotifyStudyChairEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNotifyStudyChairEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNotifyStudyChairEmailResponse(); }
}

export class SendSaeNotifyStudySponsorEmail implements IReturn<SendSaeNotifyStudySponsorEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendSaeNotifyStudySponsorEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNotifyStudySponsorEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNotifyStudySponsorEmailResponse(); }
}

export class SendSaeNotifyMedicalReviewerEmail implements IReturn<SendSaeNotifyMedicalReviewerEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public recipientIds: number[];
    public ccRecipientIds: number[];
    public attachmentNames: string[];
    public attachmentGuids: string[];
    public includedNotes: string;
    public sendBctEmailsToSharedMailbox: boolean;

    public constructor(init?: Partial<SendSaeNotifyMedicalReviewerEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeNotifyMedicalReviewerEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeNotifyMedicalReviewerEmailResponse(); }
}

export class SendSaeInvestigatorReviewEmail implements IReturn<SendSaeInvestigatorReviewEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public approved: boolean;
    public rejectedAs: RejectedAsType;
    public reasonForRejection: string;

    public constructor(init?: Partial<SendSaeInvestigatorReviewEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeInvestigatorReviewEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeInvestigatorReviewEmailResponse(); }
}

export class SendSaeTrialTeamRejectionEmail implements IReturn<SendSaeTrialTeamRejectionEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public approved: boolean;
    public rejectedAs: RejectedAsType;
    public reasonForRejection: string;

    public constructor(init?: Partial<SendSaeTrialTeamRejectionEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeTrialTeamRejectionEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeTrialTeamRejectionEmailResponse(); }
}

export class SendSaeMedicalReviewEmail implements IReturn<SendSaeMedicalReviewEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public medicalReviewDetails: string;

    public constructor(init?: Partial<SendSaeMedicalReviewEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeMedicalReviewEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeMedicalReviewEmailResponse(); }
}

export class SendSaeBlueCardNotificationEmail implements IReturn<SendSaeBlueCardNotificationEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public medicalReviewDetails: string;

    public constructor(init?: Partial<SendSaeBlueCardNotificationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeBlueCardNotificationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeBlueCardNotificationEmailResponse(); }
}

export class SendSaeDeathNotificationEmail implements IReturn<SendSaeDeathNotificationEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public medicalReviewDetails: string;

    public constructor(init?: Partial<SendSaeDeathNotificationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeDeathNotificationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeDeathNotificationEmailResponse(); }
}

export class SendSaeInvalidEmail implements IReturn<SendSaeInvalidEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;
    public toAddresses: EmailAddress[];
    public ccAddresses: EmailAddress[];

    public constructor(init?: Partial<SendSaeInvalidEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeInvalidEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeInvalidEmailResponse(); }
}

// @Route("/report/send-monthly-saes-email")
export class SendMonthlySaes implements IReturn<SendMonthlySaesResponse>
{
    [immerable]? = true;

    public startDate?: string;
    public endDate?: string;

    public constructor(init?: Partial<SendMonthlySaes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendMonthlySaes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendMonthlySaesResponse(); }
}

export class SendSaeSusarEmail implements IReturn<SendSaeSusarEmailResponse>
{
    [immerable]? = true;

    public patientStudyNumber: string;
    public saeNumber: number;

    public constructor(init?: Partial<SendSaeSusarEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SendSaeSusarEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SendSaeSusarEmailResponse(); }
}

export class SaConsentSharepointMove implements IReturnVoid, IPost
{
    [immerable]? = true;

    public saConsentId: number;

    public constructor(init?: Partial<SaConsentSharepointMove>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaConsentSharepointMove'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/get/tp-participants/", "GET")
// @Route("/get/tp-participants/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpParticipantsByInstitutionId implements IReturn<GetTpParticipantsByInstitutionIdResponse>
{
    [immerable]? = true;

    public institutionId?: number;

    public constructor(init?: Partial<GetTpParticipantsByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpParticipantsByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpParticipantsByInstitutionIdResponse(); }
}

// @Route("/get/tp-sae/", "GET")
// @Route("/get/tp-sae/{InstitutionId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetTpSaeByInstitutionId implements IReturn<GetTpSaeByInstitutionIdResponse>
{
    [immerable]? = true;

    public institutionId?: number;

    public constructor(init?: Partial<GetTpSaeByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTpSaeByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTpSaeByInstitutionIdResponse(); }
}

// @Route("/opms/form/main-consent/save", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentEConsentFormPostSave implements IReturn<MainConsentEConsentFormSingleResponse>, IEConsentRequest
{
    [immerable]? = true;

    /** @description The guid of the consent form to save. */
    // @DataMember(Order=1)
    public guid: string;

    /** @description The main consent to save. */
    // @DataMember(Order=2)
    public form: MainConsent;

    public constructor(init?: Partial<MainConsentEConsentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentEConsentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentEConsentFormSingleResponse(); }
}

// @Route("/opms/form/main-consent/validate", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsentForm.EConsentForm.MainConsentEConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentEConsentFormPostValidate implements IReturn<MainConsentEConsentFormValidationResponse>, IEConsentRequest
{
    [immerable]? = true;

    /** @description The guid of the consent form to save. */
    // @DataMember(Order=1)
    public guid: string;

    /** @description The main consent to validate. */
    // @DataMember(Order=2)
    public form: MainConsent;

    public constructor(init?: Partial<MainConsentEConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentEConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentEConsentFormValidationResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/save", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentEConsentFormPostSave implements IReturn<TissueBankingConsentEConsentFormSingleResponse>, IEConsentRequest
{
    [immerable]? = true;

    /** @description The guid of the consent form to save. */
    // @DataMember(Order=1)
    public guid: string;

    /** @description The tissue banking consent to save. */
    // @DataMember(Order=2)
    public form: TissueBankingConsent;

    public constructor(init?: Partial<TissueBankingConsentEConsentFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentEConsentFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentEConsentFormSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/validate", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsentForm.EConsentForm.TissueBankingConsentEConsentFormValidationResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentEConsentFormPostValidate implements IReturn<TissueBankingConsentEConsentFormValidationResponse>, IEConsentRequest
{
    [immerable]? = true;

    /** @description The guid of the consent form to save. */
    // @DataMember(Order=1)
    public guid: string;

    /** @description The tissue banking consent to validate. */
    // @DataMember(Order=2)
    public form: TissueBankingConsent;

    public constructor(init?: Partial<TissueBankingConsentEConsentFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentEConsentFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentEConsentFormValidationResponse(); }
}

// @Route("/drug-management-api/batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatches implements IReturn<GetBatchesResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchesResponse(); }
}

// @Route("/drug-management-api/batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchById implements IReturn<GetBatchByIdResponse>
{
    [immerable]? = true;

    /** @description The id of the drug batch */
    // @ApiMember(DataType="int", Description="The id of the drug batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetBatchById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchByIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchesByIds implements IReturn<GetBatchesByIdsResponse>, IGet
{
    [immerable]? = true;

    public ids: number[];

    public constructor(init?: Partial<GetBatchesByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchesByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchesByIdsResponse(); }
}

// @Route("/drug-management-api/batches/expiring-at-specified-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetBatchesExpiringAtSpecifiedDate implements IReturn<GetBatchesExpiringAtSpecifiedDateResponse>, IGet
{
    [immerable]? = true;

    /** @description The date of expiry */
    // @ApiMember(DataType="DateTime", Description="The date of expiry", IsRequired=true, Name="ExpiryDate", ParameterType="query")
    public expiryDate: string;

    public constructor(init?: Partial<GetBatchesExpiringAtSpecifiedDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetBatchesExpiringAtSpecifiedDate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetBatchesExpiringAtSpecifiedDateResponse(); }
}

// @Route("/drug-management-api/batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetBatch implements IReturn<SetBatchResponse>
{
    [immerable]? = true;

    /** @description The drug batch form data to save */
    // @ApiMember(DataType="BatchForm", Description="The drug batch form data to save", IsRequired=true, Name="BatchForm", ParameterType="body")
    public batch: Batch;

    public constructor(init?: Partial<SetBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetBatchResponse(); }
}

// @Route("/drug-management-api/depot-batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatches implements IReturn<GetDepotBatchesResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetDepotBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesResponse(); }
}

// @Route("/drug-management-api/depot-batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchById implements IReturn<GetDepotBatchByIdResponse>
{
    [immerable]? = true;

    /** @description The id of the depot batch */
    // @ApiMember(DataType="int", Description="The id of the depot batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepotBatchById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchByIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/depotId/{DepotId}", "GET")
// @ApiResponse(Description="Depot Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByDepotId implements IReturn<GetDepotBatchesByDepotIdResponse>
{
    [immerable]? = true;

    /** @description The id of the depot */
    // @ApiMember(DataType="int", Description="The id of the depot", IsRequired=true, Name="DepotId", ParameterType="path")
    public depotId: number;

    public constructor(init?: Partial<GetDepotBatchesByDepotId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByDepotId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByDepotIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/pharmacyId/{PharmacyId}", "GET")
// @ApiResponse(Description="Pharmacy Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByPharmacyId implements IReturn<GetDepotBatchesByPharmacyIdResponse>
{
    [immerable]? = true;

    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="PharmacyId", ParameterType="path")
    public pharmacyId: number;

    public constructor(init?: Partial<GetDepotBatchesByPharmacyId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByPharmacyId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByPharmacyIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/drugShipmentId/{DrugShipmentId}", "GET")
// @ApiResponse(Description="Drug Shipment Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByDrugShipmentId implements IReturn<GetDepotBatchesByDrugShipmentIdResponse>
{
    [immerable]? = true;

    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="DrugShipmentId", ParameterType="path")
    public drugShipmentId: number;

    public constructor(init?: Partial<GetDepotBatchesByDrugShipmentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByDrugShipmentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByDrugShipmentIdResponse(); }
}

// @Route("/drug-management-api/depot-batches/institution/{InstCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByInstitutionCode implements IReturn<GetDepotBatchesByPharmacyIdResponse>
{
    [immerable]? = true;

    /** @description The institution code */
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetDepotBatchesByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByPharmacyIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesByBatchIds implements IReturn<GetDepotBatchesByBatchIdsResponse>, IGet
{
    [immerable]? = true;

    public batchIds: number[];

    public constructor(init?: Partial<GetDepotBatchesByBatchIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesByBatchIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesByBatchIdsResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotBatchesWithLowStockByDepotIds implements IReturn<GetDepotBatchesWithLowStockByDepotIdsResponse>, IGet
{
    [immerable]? = true;

    public depotIds: number[];
    public drugThreshold?: number;

    public constructor(init?: Partial<GetDepotBatchesWithLowStockByDepotIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotBatchesWithLowStockByDepotIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotBatchesWithLowStockByDepotIdsResponse(); }
}

// @Route("/drug-management-api/depot-batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepotBatch implements IReturn<SetDepotBatchResponse>
{
    [immerable]? = true;

    /** @description The depot batch form data to save */
    // @ApiMember(DataType="DepotBatch", Description="The depot batch form data to save", IsRequired=true, Name="DepotBatch", ParameterType="body")
    public depotBatch: DepotBatch;

    public constructor(init?: Partial<SetDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDepotBatchResponse(); }
}

// @Route("/drug-management-api/depots", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepots implements IReturn<GetDepotsResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetDepots>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepots'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotsResponse(); }
}

// @Route("/drug-management-api/depot/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotById implements IReturn<GetDepotByIdResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the drug depot */
    // @ApiMember(DataType="int", Description="The id of the drug depot", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDepotById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotByIdResponse(); }
}

// @Route("/drug-management-api/depots/by-drug-under-threshold", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDepotsByDrugUnderThreshold implements IReturn<GetDepotsByDrugUnderThresholdResponse>, IGet
{
    [immerable]? = true;

    /** @description The threshold to check */
    // @ApiMember(DataType="int", Description="The threshold to check", IsRequired=true, Name="DrugThreshold", ParameterType="query")
    public drugThreshold: number;

    public constructor(init?: Partial<GetDepotsByDrugUnderThreshold>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDepotsByDrugUnderThreshold'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDepotsByDrugUnderThresholdResponse(); }
}

// @Route("/drug-management-api/depot/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDepot implements IReturn<SetDepotResponse>
{
    [immerable]? = true;

    /** @description The drug depot form data to save */
    // @ApiMember(DataType="DepotForm", Description="The drug depot form data to save", IsRequired=true, Name="DepotForm", ParameterType="body")
    public depot: Depot;

    public constructor(init?: Partial<SetDepot>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDepot'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDepotResponse(); }
}

// @Route("/drug-management-api/drug-dispensations", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensations implements IReturn<GetDrugDispensationsResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetDrugDispensations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationsResponse(); }
}

// @Route("/drug-management-api/drug-dispensation/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationById implements IReturn<GetDrugDispensationByIdResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the drug dispensation */
    // @ApiMember(DataType="int", Description="The id of the drug dispensation", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugDispensationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationByIdResponse(); }
}

// @Route("/drug-management-api/drug-dispensations/patient-id/{PatientId}", "GET")
// @ApiResponse(Description="Patient id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationByPatientId implements IReturn<GetDrugDispensationByPatientIdResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the patient to retrieve drug dispensations for */
    // @ApiMember(DataType="int", Description="The id of the patient to retrieve drug dispensations for", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<GetDrugDispensationByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensationByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationByPatientIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientsWithLateDispensations implements IReturn<GetPatientsWithLateDispensationsResponse>, IGet
{
    [immerable]? = true;

    public expectedDate?: string;

    public constructor(init?: Partial<GetPatientsWithLateDispensations>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientsWithLateDispensations'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientsWithLateDispensationsResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetLastDispensationForPatientId implements IReturn<GetLastDispensationForPatientIdResponse>, IGet
{
    [immerable]? = true;

    public patientId?: number;

    public constructor(init?: Partial<GetLastDispensationForPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetLastDispensationForPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetLastDispensationForPatientIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugDispensationsByIds implements IReturn<GetDrugDispensationsByIdsResponse>, IGet
{
    [immerable]? = true;

    public ids: number[];

    public constructor(init?: Partial<GetDrugDispensationsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugDispensationsByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugDispensationsByIdsResponse(); }
}

// @Route("/drug-management-api/drug-dispensation/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugDispensation implements IReturn<SetDrugDispensationResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient dispensation form data to save */
    // @ApiMember(DataType="DrugDispensation", Description="The patient dispensation form data to save", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<SetDrugDispensation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugDispensation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugDispensationResponse(); }
}

export class DeleteDrugDispensation implements IReturn<DeleteDrugDispensationResponse>
{
    [immerable]? = true;

    /** @description The drug dispensation we want to delete */
    // @ApiMember(DataType="DrugDispensation", Description="The drug dispensation we want to delete", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<DeleteDrugDispensation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteDrugDispensation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteDrugDispensationResponse(); }
}

// @Route("/drug-management-api/drug-dispensation/validate", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateDrugDispensation implements IReturn<ValidateDrugDispensationResponse>, IPost
{
    [immerable]? = true;

    /** @description The drug dispensation form data to validate */
    // @ApiMember(DataType="model", Description="The drug dispensation form data to validate", IsRequired=true, Name="DrugDispensation", ParameterType="body")
    public drugDispensation: DrugDispensation;

    public constructor(init?: Partial<ValidateDrugDispensation>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDrugDispensation'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateDrugDispensationResponse(); }
}

// @Route("/drug-management-api/drugs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugs implements IReturn<GetDrugsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetDrugs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugsResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batches", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatches implements IReturn<GetDrugShipmentDepotBatchesResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetDrugShipmentDepotBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatches'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchesResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batch/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchById implements IReturn<GetDrugShipmentDepotBatchByIdResponse>
{
    [immerable]? = true;

    /** @description The id of the drug shipment depot batch */
    // @ApiMember(DataType="int", Description="The id of the drug shipment depot batch", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchByIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batches/pharmacyId/{PharmacyId}", "GET")
// @ApiResponse(Description="Pharmacy Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchesByPharmacyId implements IReturn<GetDrugShipmentDepotBatchesByPharmacyIdResponse>
{
    [immerable]? = true;

    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="PharmacyId", ParameterType="path")
    public pharmacyId: number;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByPharmacyId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchesByPharmacyId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchesByPharmacyIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batches/institution/{InstCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentDepotBatchesByInstitutionCode implements IReturn<GetDrugShipmentDepotBatchesByPharmacyIdResponse>
{
    [immerable]? = true;

    /** @description The institution code */
    // @ApiMember(DataType="string", Description="The institution code", IsRequired=true, Name="InstCode", ParameterType="path")
    public instCode: string;

    public constructor(init?: Partial<GetDrugShipmentDepotBatchesByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentDepotBatchesByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentDepotBatchesByPharmacyIdResponse(); }
}

// @Route("/drug-management-api/drug-shipment-depot-batch/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentDepotBatch implements IReturn<SetDrugShipmentDepotBatchResponse>
{
    [immerable]? = true;

    /** @description The drug shipment depot batch form data to save */
    // @ApiMember(DataType="DrugShipmentDepotBatch", Description="The drug shipment depot batch form data to save", IsRequired=true, Name="DrugShipmentDepotBatch", ParameterType="body")
    public drugShipmentDepotBatch: DrugShipmentDepotBatch;

    public constructor(init?: Partial<SetDrugShipmentDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipmentDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentDepotBatchResponse(); }
}

// @Route("/drug-management-api/drug-shipment-generation/queue", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class StartDrugShipmentGeneration implements IReturn<StartDrugShipmentGenerationResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<StartDrugShipmentGeneration>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'StartDrugShipmentGeneration'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new StartDrugShipmentGenerationResponse(); }
}

// @Route("/drug-management-api/drug-shipment-generation/create-from-patient", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class CreateDrugShipmentFromPatient implements IReturn<CreateDrugShipmentFromPatientResponse>, IPost
{
    [immerable]? = true;

    /** @description The id of the patient */
    // @ApiMember(DataType="int", Description="The id of the patient", IsRequired=true, Name="PatientId", ParameterType="body")
    public patientId: number;

    /** @description The drugs to order for the patient */
    // @ApiMember(DataType="model", Description="The drugs to order for the patient", IsRequired=true, Name="Drugs", ParameterType="body")
    public drugs: DrugAmount[];

    public constructor(init?: Partial<CreateDrugShipmentFromPatient>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CreateDrugShipmentFromPatient'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CreateDrugShipmentFromPatientResponse(); }
}

// @Route("/drug-management-api/drug-shipments", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipments implements IReturn<GetDrugShipmentsResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetDrugShipments>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipments'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsResponse(); }
}

// @Route("/drug-management-api/drug-shipments/institution/{InstitutionCode}", "GET")
// @ApiResponse(Description="Institution code invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsByInstitution implements IReturn<GetDrugShipmentsByInstitutionResponse>, IGet
{
    [immerable]? = true;

    /** @description The institution of the pharmacies */
    // @ApiMember(DataType="string", Description="The institution of the pharmacies", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetDrugShipmentsByInstitution>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsByInstitution'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsByInstitutionResponse(); }
}

// @Route("/drug-management-api/drug-shipment/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentById implements IReturn<GetDrugShipmentByIdResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentByIdResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsByIds implements IReturn<GetDrugShipmentsByIdsResponse>, IGet
{
    [immerable]? = true;

    public ids: number[];

    public constructor(init?: Partial<GetDrugShipmentsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsByIdsResponse(); }
}

// @Route("/drug-management-api/drug-shipment/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipment implements IReturn<SetDrugShipmentResponse>, IPost
{
    [immerable]? = true;

    /** @description The drug shipment form data to save */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to save", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentResponse(); }
}

// @Route("/drug-management-api/drug-shipment/validate", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ValidateDrugShipment implements IReturn<ValidateDrugShipmentResponse>, IPost
{
    [immerable]? = true;

    /** @description The drug shipment form data to validate */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to validate", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<ValidateDrugShipment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ValidateDrugShipment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ValidateDrugShipmentResponse(); }
}

// @Route("/drug-management-api/drug-shipment/set-status", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentStatus implements IReturn<SetDrugShipmentStatusResponse>, IPost
{
    [immerable]? = true;

    /** @description The drug shipment form data to save */
    // @ApiMember(DataType="DrugShipmentForm", Description="The drug shipment form data to save", IsRequired=true, Name="DrugShipmentForm", ParameterType="body")
    public drugShipment: DrugShipment;

    public constructor(init?: Partial<SetDrugShipmentStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipmentStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentStatusResponse(); }
}

// @Route("/drug-management-api/drug-shipment/delete", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class DeleteDrugShipment implements IReturn<DeleteDrugShipmentResponse>, IPost
{
    [immerable]? = true;

    /** @description The drug shipment id to delete */
    // @ApiMember(DataType="int", Description="The drug shipment id to delete", IsRequired=true, Name="DrugShipmentId", ParameterType="body")
    public drugShipmentId: number;

    public constructor(init?: Partial<DeleteDrugShipment>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteDrugShipment'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DeleteDrugShipmentResponse(); }
}

// @Route("/drug-management-api/drug-shipment/verify", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetDrugShipmentVerify implements IReturn<SetDrugShipmentVerifyResponse>, IPost
{
    [immerable]? = true;

    /** @description The drug shipment form data to verify */
    // @ApiMember(DataType="model", Description="The drug shipment form data to verify", IsRequired=true, Name="DrugShipmentVerify", ParameterType="body")
    public drugShipmentVerify: DrugShipmentVerify;

    public constructor(init?: Partial<SetDrugShipmentVerify>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetDrugShipmentVerify'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetDrugShipmentVerifyResponse(); }
}

// @Route("/drug-management-api/drug-shipments/not-shipped-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotShippedByExpectedDate implements IReturn<GetDrugShipmentsNotShippedByExpectedDateResponse>, IGet
{
    [immerable]? = true;

    /** @description The date to check from */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedShippingDate", ParameterType="query")
    public expectedShippingDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotShippedByExpectedDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsNotShippedByExpectedDate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsNotShippedByExpectedDateResponse(); }
}

// @Route("/drug-management-api/drug-shipments/not-received-by-expected-date", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentsNotReceivedByExpectedDate implements IReturn<GetDrugShipmentsNotReceivedByExpectedDateResponse>, IGet
{
    [immerable]? = true;

    /** @description The date to check from */
    // @ApiMember(DataType="DateTime", Description="The date to check from", IsRequired=true, Name="ExpectedReceptionDate", ParameterType="query")
    public expectedReceptionDate: string;

    public constructor(init?: Partial<GetDrugShipmentsNotReceivedByExpectedDate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentsNotReceivedByExpectedDate'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetDrugShipmentsNotReceivedByExpectedDateResponse(); }
}

// @Route("/drug-management-api/drug-shipment-order-form/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetDrugShipmentOrderFormById implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    /** @description The id of the drug shipment */
    // @ApiMember(DataType="int", Description="The id of the drug shipment", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetDrugShipmentOrderFormById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDrugShipmentOrderFormById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/drug-management-api/order-forms", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetOrderForms implements IReturn<GetOrderFormsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetOrderForms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetOrderForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetOrderFormsResponse(); }
}

// @Route("/drug-management-api/patient-drugs", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientDrugs implements IReturn<GetPatientDrugsResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetPatientDrugs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientDrugs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientDrugsResponse(); }
}

// @Route("/drug-management-api/patient-drugs/patient-id/{PatientId}", "GET")
// @ApiResponse(Description="Patient id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPatientDrugsByPatientId implements IReturn<GetPatientDrugsByPatientIdResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the patient to retrieve patient drugs for */
    // @ApiMember(DataType="int", Description="The id of the patient to retrieve patient drugs for", IsRequired=true, Name="PatientId", ParameterType="path")
    public patientId: number;

    public constructor(init?: Partial<GetPatientDrugsByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPatientDrugsByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPatientDrugsByPatientIdResponse(); }
}

// @Route("/drug-management-api/patient-drugs/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPatientDrugs implements IReturn<SetPatientDrugsResponse>, IPost
{
    [immerable]? = true;

    /** @description The patient drug form data to save */
    // @ApiMember(DataType="model", Description="The patient drug form data to save", IsRequired=true, Name="PatientDrugs", ParameterType="body")
    public patientDrugs: PatientDrug[];

    public constructor(init?: Partial<SetPatientDrugs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPatientDrugs'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPatientDrugsResponse(); }
}

export class GetPharmacistsByInstCode implements IReturn<GetPharmacistsByInstCodeResponse>, IGet
{
    [immerable]? = true;

    public instCode: string;

    public constructor(init?: Partial<GetPharmacistsByInstCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacistsByInstCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacistsByInstCodeResponse(); }
}

export class GetPharmacistById implements IReturn<GetPharmacistByIdResponse>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<GetPharmacistById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacistById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacistByIdResponse(); }
}

// @Route("/drug-management-api/pharmacies", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacies implements IReturn<GetPharmaciesResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetPharmacies>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacies'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmaciesResponse(); }
}

// @Route("/drug-management-api/pharmacy/id/{Id}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyById implements IReturn<GetPharmacyByIdResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    public constructor(init?: Partial<GetPharmacyById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyByIdResponse(); }
}

// @Route("/drug-management-api/pharmacy/institution/{InstitutionCode}", "GET")
// @ApiResponse(Description="Id invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyByInstitutionCode implements IReturn<GetPharmacyByInstitutionCodeResponse>, IGet
{
    [immerable]? = true;

    /** @description The institution code of the pharmacy */
    // @ApiMember(DataType="string", Description="The institution code of the pharmacy", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetPharmacyByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyByInstitutionCodeResponse(); }
}

// @ApiResponse(Description="Ids invalid", StatusCode=400)
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyBatchesDrugRemainingByBatchIds implements IReturn<GetPharmacyBatchesDrugRemainingByBatchIdsResponse>, IGet
{
    [immerable]? = true;

    public batchIds: number[];

    public constructor(init?: Partial<GetPharmacyBatchesDrugRemainingByBatchIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyBatchesDrugRemainingByBatchIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyBatchesDrugRemainingByBatchIdsResponse(); }
}

// @Route("/drug-management-api/pharmacy/save", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class SetPharmacy implements IReturn<SetPharmacyResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy form data to save */
    // @ApiMember(DataType="model", Description="The pharmacy form data to save", IsRequired=true, Name="PharmacyForm", ParameterType="body")
    public pharmacy: Pharmacy;

    public constructor(init?: Partial<SetPharmacy>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SetPharmacy'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SetPharmacyResponse(); }
}

// @Route("/drug-management-api/pharmacy/quarantine-stock", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyStock implements IReturn<QuarantinePharmacyStockResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy id to quarantine */
    // @ApiMember(DataType="integer", Description="The pharmacy id to quarantine", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    public constructor(init?: Partial<QuarantinePharmacyStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantinePharmacyStock'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantinePharmacyStockResponse(); }
}

// @Route("/drug-management-api/pharmacy/quarantine-depot-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyDepotBatch implements IReturn<QuarantinePharmacyDepotBatchResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy depot batch ids to quarantine */
    // @ApiMember(DataType="integer[]", Description="The pharmacy depot batch ids to quarantine", IsRequired=true, Name="Ids", ParameterType="body")
    public ids: number[];

    public constructor(init?: Partial<QuarantinePharmacyDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantinePharmacyDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantinePharmacyDepotBatchResponse(); }
}

// @Route("/drug-management-api/pharmacy/action-quarantined-stock", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ActionQuarantinedStock implements IReturn<ActionQuarantinedStockResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy id to quarantine */
    // @ApiMember(DataType="integer", Description="The pharmacy id to quarantine", IsRequired=true, Name="Id", ParameterType="body")
    public id: number;

    /** @description The action to take on the pharmacy's stock */
    // @ApiMember(DataType="integer", Description="The action to take on the pharmacy's stock", IsRequired=true, Name="QuarantinedStockAction", ParameterType="body")
    public quarantinedStockAction: QuarantinedStockAction;

    public constructor(init?: Partial<ActionQuarantinedStock>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ActionQuarantinedStock'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActionQuarantinedStockResponse(); }
}

// @Route("/drug-management-api/pharmacy/action-depot-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantineRemovePharmacyDepotBatch implements IReturn<QuarantineRemovePharmacyDepotBatchResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy id related to these depot batches */
    // @ApiMember(DataType="integer", Description="The pharmacy id related to these depot batches", IsRequired=true, Name="PharmacyId", ParameterType="body")
    public pharmacyId: number;

    /** @description A dictionary of the depot batch ids correlating to the new state of the unit count */
    // @ApiMember(DataType="dictionary", Description="A dictionary of the depot batch ids correlating to the new state of the unit count", IsRequired=true, Name="DepotBatchStates", ParameterType="body")
    public depotBatchStates: { [index: number]: QuarantinedStockAction; };

    public constructor(init?: Partial<QuarantineRemovePharmacyDepotBatch>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantineRemovePharmacyDepotBatch'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantineRemovePharmacyDepotBatchResponse(); }
}

// @Route("/drug-management-api/pharmacy/emails", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetPharmacyEmails implements IReturn<GetPharmacyEmailsResponse>, IGet
{
    [immerable]? = true;

    /** @description The id of the pharmacy */
    // @ApiMember(DataType="int", Description="The id of the pharmacy", IsRequired=true, Name="Id", ParameterType="path")
    public id: number;

    /** @description The institution code of the pharmacy */
    // @ApiMember(DataType="string", Description="The institution code of the pharmacy", IsRequired=true, Name="InstitutionCode", ParameterType="path")
    public institutionCode: string;

    public constructor(init?: Partial<GetPharmacyEmails>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPharmacyEmails'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPharmacyEmailsResponse(); }
}

// @Route("/drug-management-api/pharmacy/quarantine-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class QuarantinePharmacyBatches implements IReturn<QuarantinePharmacyBatchesResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy id related to these batches */
    // @ApiMember(DataType="integer", Description="The pharmacy id related to these batches", IsRequired=true, Name="PharmacyId", ParameterType="body")
    public pharmacyId: number;

    /** @description The batch ids to quarantine at the pharmacy */
    // @ApiMember(DataType="array", Description="The batch ids to quarantine at the pharmacy", IsRequired=true, Name="Ids", ParameterType="body")
    public ids: number[];

    public constructor(init?: Partial<QuarantinePharmacyBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'QuarantinePharmacyBatches'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new QuarantinePharmacyBatchesResponse(); }
}

// @Route("/drug-management-api/pharmacy/action-quarantined-batches", "POST")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class ActionQuarantinedPharmacyBatches implements IReturn<ActionQuarantinedPharmacyBatchesResponse>, IPost
{
    [immerable]? = true;

    /** @description The pharmacy id related to these batches */
    // @ApiMember(DataType="integer", Description="The pharmacy id related to these batches", IsRequired=true, Name="PharmacyId", ParameterType="body")
    public pharmacyId: number;

    /** @description A dictionary of the batch ids correlating to the new state of the unit count */
    // @ApiMember(DataType="model", Description="A dictionary of the batch ids correlating to the new state of the unit count", IsRequired=true, Name="BatchActions", ParameterType="body")
    public batchActions: { [index: number]: QuarantinedStockAction; };

    public constructor(init?: Partial<ActionQuarantinedPharmacyBatches>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ActionQuarantinedPharmacyBatches'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ActionQuarantinedPharmacyBatchesResponse(); }
}

// @Route("/drug-management-api/timepoints", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTimepoints implements IReturn<GetTimepointsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetTimepoints>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTimepoints'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTimepointsResponse(); }
}

// @Route("/drug-management-api/timepoints/treatment/{TreatmentId}", "GET")
// @ApiResponse(Description="Oops, something broke", StatusCode=500)
export class GetTimepointsByTreatmentId implements IReturn<GetTimepointsResponse>
{
    [immerable]? = true;

    /** @description The treatment id to get timepoints for */
    // @ApiMember(DataType="int", Description="The treatment id to get timepoints for", IsRequired=true, Name="TreatmentId", ParameterType="path")
    public treatmentId: number;

    public constructor(init?: Partial<GetTimepointsByTreatmentId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTimepointsByTreatmentId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetTimepointsResponse(); }
}

// @Route("/opms/invitation/institutions", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetInstitutions implements IReturn<GetInstitutionsResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetInstitutions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutions'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInstitutionsResponse(); }
}

// @Route("/opms/invitation/investigators", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetInvestigators implements IReturn<GetInvestigatorsResponse>, IGet
{
    [immerable]? = true;

    public institutionCode: string;

    public constructor(init?: Partial<GetInvestigators>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvestigators'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetInvestigatorsResponse(); }
}

// @Route("/opms/picf/{InstCode}/{PatientConsentId}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetPicfs implements IReturn<GetPicfsResponse>, IGet
{
    [immerable]? = true;

    public instCode: string;
    public patientConsentId?: number;

    public constructor(init?: Partial<GetPicfs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetPicfs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetPicfsResponse(); }
}

// @Route("/opms/picf/download/{InstCode}/{PicfIdOne}/{PicfTypeIdOne}/{PicfIdTwo}/{PicfTypeIdTwo}/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDownloadTwoPicfs implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public instCode: string;
    public picfIdOne?: number;
    public picfTypeIdOne?: number;
    public picfIdTwo?: number;
    public picfTypeIdTwo?: number;

    public constructor(init?: Partial<GetDownloadTwoPicfs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDownloadTwoPicfs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/picf/download/all/{InstCode}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDownloadPicfs implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public instCode: string;

    public constructor(init?: Partial<GetDownloadPicfs>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDownloadPicfs'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/picf/download/{InstCode}/{PicfId}/{PicfTypeId}/", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetDownloadPicf implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public instCode: string;
    public picfId?: number;
    public picfTypeId?: number;

    public constructor(init?: Partial<GetDownloadPicf>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetDownloadPicf'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/consentpending/single/id/{Id}", "GET")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingGetSingleById implements IReturn<ConsentPendingSingleResponse>, IConsentPendingGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the consentpending to retrieve. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<ConsentPendingGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ConsentPendingSingleResponse(); }
}

// @Route("/opms/consentpending/collection", "GET")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingGetCollection implements IReturn<ConsentPendingCollectionResponse>, IConsentPendingGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ConsentPendingGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ConsentPendingCollectionResponse(); }
}

// @Route("/opms/consentpending/collection/institution/{InstitutionCode}", "GET")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingCollectionResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingGetCollectionByInstitutionCode implements IReturn<ConsentPendingCollectionResponse>, IConsentPendingGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The institution code of the consentpending to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    public constructor(init?: Partial<ConsentPendingGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ConsentPendingCollectionResponse(); }
}

// @Route("/opms/consentpending/save", "POST")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingSingleResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingPostSave implements IReturn<ConsentPendingSingleResponse>
{
    [immerable]? = true;

    /** @description The consentpending to save. */
    // @DataMember(Order=1)
    public consentPending: ConsentPending;

    /** @description The consentpending to save. */
    // @DataMember(Order=2)
    public invitationGuid: string;

    public constructor(init?: Partial<ConsentPendingPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ConsentPendingSingleResponse(); }
}

// @Route("/opms/consentpending/delete/{Id}", "DELETE")
// @Api(Description="ConsentPending")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.ConsentPending.ConsentPendingDeleteResponse)", StatusCode=500)
// @DataContract
export class ConsentPendingDelete implements IReturn<ConsentPendingDeleteResponse>, IConsentPendingDelete
{
    [immerable]? = true;

    /** @description The consentpending ID to delete. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<ConsentPendingDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ConsentPendingDeleteResponse(); }
}

// @Route("/opms/consentpending/save-status", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class ConsentPendingSaveStatus implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;
    public statusId?: StatusTypeEnum;

    public constructor(init?: Partial<ConsentPendingSaveStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingSaveStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/consentpending/resend-email", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class ConsentPendingResendEmail implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<ConsentPendingResendEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ConsentPendingResendEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/patientconsent/single/id/{Id}", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetSingleById implements IReturn<PatientConsentSingleResponse>, IPatientConsentGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patientconsent to retrieve. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<PatientConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentSingleResponse(); }
}

// @Route("/opms/patientconsent/single/guid/{Guid}", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetSingleByGuid implements IReturn<PatientConsentSingleResponse>, IPatientConsentGetSingleByGuid
{
    [immerable]? = true;

    /** @description The guid of the patientconsent to retrieve. */
    // @DataMember(Order=1)
    public guid: string;

    public constructor(init?: Partial<PatientConsentGetSingleByGuid>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetSingleByGuid'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentSingleResponse(); }
}

// @Route("/opms/patientconsent/collection", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetCollection implements IReturn<PatientConsentCollectionResponse>, IPatientConsentGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PatientConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentCollectionResponse(); }
}

// @Route("/opms/patientconsent/collection/institution/{InstitutionCode}", "GET")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientConsentGetCollectionByInstitutionCode implements IReturn<PatientConsentCollectionResponse>, IPatientConsentGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The institution code of the patientconsent to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    public constructor(init?: Partial<PatientConsentGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientConsentCollectionResponse(); }
}

// @Route("/opms/patientconsent/save", "POST")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentSingleResponse)", StatusCode=500)
// @DataContract
export class PatientConsentPostSave implements IReturn<PatientConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The patientconsent to save. */
    // @DataMember(Order=1)
    public patientConsent: PatientConsent;

    /** @description The patientconsent to check. */
    // @DataMember(Order=1)
    public emailRequired: boolean;

    public constructor(init?: Partial<PatientConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientConsentSingleResponse(); }
}

// @Route("/opms/patientconsent/delete/{Id}", "DELETE")
// @Api(Description="PatientConsent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__EConsent.PatientConsent.PatientConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class PatientConsentDelete implements IReturn<PatientConsentDeleteResponse>, IPatientConsentDelete
{
    [immerable]? = true;

    /** @description The patientconsent ID to delete. */
    // @DataMember(Order=1)
    public id: number;

    public constructor(init?: Partial<PatientConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PatientConsentDeleteResponse(); }
}

// @Route("/opms/patient-consent/save-status", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSaveStatus implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;
    public statusId?: StatusTypeEnum;

    public constructor(init?: Partial<PatientConsentSaveStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSaveStatus'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/patient-consent/send-reminder", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSendReminder implements IReturn<ResponseStatus>, IPost
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<PatientConsentSendReminder>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSendReminder'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ResponseStatus(); }
}

// @Route("/opms/patient-consent/send-verification-code", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSendVerificationCode implements IReturn<PatientConsentSendVerificationCodeResponse>, IPost
{
    [immerable]? = true;

    public phoneNumber: string;

    public constructor(init?: Partial<PatientConsentSendVerificationCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSendVerificationCode'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientConsentSendVerificationCodeResponse(); }
}

// @Route("/opms/patient-consent/view-consent-file/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentViewConsentFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<PatientConsentViewConsentFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentViewConsentFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/patient-consent/information", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class PatientConsentSendInformationEmail implements IReturnVoid, IPost
{
    [immerable]? = true;

    public email: string;
    public instCode: string;

    public constructor(init?: Partial<PatientConsentSendInformationEmail>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientConsentSendInformationEmail'; }
    public getMethod() { return 'POST'; }
    public createResponse() {}
}

// @Route("/opms/sae/medicalreview/{PatientStudyNumber}/{SaeNumber}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeMedicalReviewSingleByPatientStudyNumber implements IReturn<SaeMedicalReviewSingleByPatientStudyNumberResponse>
{
    [immerable]? = true;

    /** @description The patient study number of the sae */
    // @DataMember(Order=1)
    // @ApiMember(Description="The patient study number of the sae", IsRequired=true, Name="PatientStudyNumber", ParameterType="string")
    public patientStudyNumber: string;

    /** @description The sae number */
    // @DataMember(Order=2)
    // @ApiMember(Description="The sae number", IsRequired=true, Name="SaeNumber", ParameterType="int")
    public saeNumber: number;

    public constructor(init?: Partial<SaeMedicalReviewSingleByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeMedicalReviewSingleByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeMedicalReviewSingleByPatientStudyNumberResponse(); }
}

// @Route("/opms/sae/medicalreview/save-narrative-summary", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeMedicalReviewNarrativeSummaryPostSave implements IReturn<SaeMedicalReviewNarrativeSummaryPostSaveResponse>
{
    [immerable]? = true;

    /** @description The medical review id of the narrative to save */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The medical review id of the narrative to save", IsRequired=true, Name="MedicalReviewId", ParameterType="body")
    public medicalReviewId: number;

    /** @description The narrative to save */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The narrative to save", IsRequired=true, Name="NarrativeSummary", ParameterType="body")
    public narrativeSummary: string;

    public constructor(init?: Partial<SaeMedicalReviewNarrativeSummaryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeMedicalReviewNarrativeSummaryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeMedicalReviewNarrativeSummaryPostSaveResponse(); }
}

// @Route("/opms/sae/medicalreview/save", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeMedicalReviewPostSave implements IReturn<SaeMedicalReviewPostSaveResponse>
{
    [immerable]? = true;

    /** @description The medical review to save */
    // @DataMember(Order=1)
    // @ApiMember(DataType="model", Description="The medical review to save", IsRequired=true, Name="PatientStudyNumber", ParameterType="body")
    public medicalReview: MedicalReview;

    public constructor(init?: Partial<SaeMedicalReviewPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeMedicalReviewPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeMedicalReviewPostSaveResponse(); }
}

// @Route("/opms/sae/medicalreview/validate", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeValidateMedicalReview implements IReturn<SaeValidateMedicalReviewResponse>
{
    [immerable]? = true;

    /** @description The medical review */
    // @DataMember(Order=1)
    // @ApiMember(DataType="MedicalReview", Description="The medical review", IsRequired=true, Name="MedicalReview", ParameterType="body")
    public medicalReview: MedicalReview;

    public constructor(init?: Partial<SaeValidateMedicalReview>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeValidateMedicalReview'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeValidateMedicalReviewResponse(); }
}

// @Route("/opms/sae/query/{PatientStudyNumber}/{SaeNumber}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeQueryCollectionByPatientSaeNumber implements IReturn<SaeQueryCollectionByPatientSaeNumberResponse>
{
    [immerable]? = true;

    /** @description The patient study number of the sae */
    // @DataMember(Order=1)
    // @ApiMember(Description="The patient study number of the sae", IsRequired=true, Name="PatientStudyNumber", ParameterType="string")
    public patientStudyNumber: string;

    /** @description The sae number */
    // @DataMember(Order=2)
    // @ApiMember(Description="The sae number", IsRequired=true, Name="SaeNumber", ParameterType="int")
    public saeNumber: number;

    public constructor(init?: Partial<SaeQueryCollectionByPatientSaeNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeQueryCollectionByPatientSaeNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeQueryCollectionByPatientSaeNumberResponse(); }
}

// @Route("/opms/sae/query/save", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeQueryPostSave implements IReturn<SaeQueryPostSaveResponse>
{
    [immerable]? = true;

    /** @description The queries to save */
    // @DataMember(Order=1)
    // @ApiMember(DataType="model", Description="The queries to save", IsRequired=true, Name="Queries", ParameterType="body")
    public queries: Query[];

    public constructor(init?: Partial<SaeQueryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeQueryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeQueryPostSaveResponse(); }
}

// @Route("/opms/sae/query/recipient/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeQueryRecipientSingleById implements IReturn<SaeQueryRecipientSingleByIdResponse>
{
    [immerable]? = true;

    /** @description The id of the query recipient */
    // @DataMember(Order=1)
    // @ApiMember(Description="The id of the query recipient", IsRequired=true, Name="Id", ParameterType="int")
    public id: number;

    public constructor(init?: Partial<SaeQueryRecipientSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeQueryRecipientSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeQueryRecipientSingleByIdResponse(); }
}

// @Route("/api/sae/collection", "GET")
// @Api(Description="Sae")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=500)
// @DataContract
export class SaeGetCollection implements IReturn<SaeCollectionResponse>, ISaeGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SaeGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeCollectionResponse(); }
}

// @Route("/api/sae/collection/institution/{InstitutionCode}", "GET")
// @Api(Description="Sae")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Sae.Sae.SaeCollectionResponse)", StatusCode=500)
// @DataContract
export class SaeGetCollectionByInstitutionCode implements IReturn<SaeCollectionResponse>, ISaeGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The code of the Institution associated with the sae to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    public constructor(init?: Partial<SaeGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeCollectionResponse(); }
}

// @Route("/api/sae/single/patient-study-number/{PatientStudyNumber}/sae-number/{SaeNumber}", "GET")
// @Api(Description="Sae")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Sae.Sae.SaeSingleResponse)", StatusCode=500)
// @DataContract
export class SaeGetSingleByPatientStudyNumber implements IReturn<SaeSingleResponse>, ISaeGetSingleByPatientStudyNumber
{
    [immerable]? = true;

    /** @description The study number of the Patient associated with the sae to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The sae number of the Sae associated with the sae to retrieve. */
    // @DataMember(Order=2)
    public saeNumber: number;

    public constructor(init?: Partial<SaeGetSingleByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeGetSingleByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeSingleResponse(); }
}

// @Route("/opms/sae/collection/status", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeGetCollectionByStatus implements IReturn<SaeGetCollectionByStatusResponse>
{
    [immerable]? = true;

    /** @description The status of the saes */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The status of the saes", IsRequired=true, Name="Status", ParameterType="body")
    public status: SaeStatus;

    public constructor(init?: Partial<SaeGetCollectionByStatus>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeGetCollectionByStatus'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeGetCollectionByStatusResponse(); }
}

// @Route("/opms/sae/incomplete/forms", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeGetIncompleteForms implements IReturn<SaeGetIncompleteFormsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<SaeGetIncompleteForms>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeGetIncompleteForms'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SaeGetIncompleteFormsResponse(); }
}

// @Route("/opms/sae/webaction", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeWebActionSave implements IReturn<SaeWebActionSaveResponse>
{
    [immerable]? = true;

    /** @description The sae web action */
    // @DataMember(Order=1)
    // @ApiMember(Description="The sae web action", IsRequired=true, Name="WebAction", ParameterType="model")
    public webAction: WebAction;

    public constructor(init?: Partial<SaeWebActionSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeWebActionSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeWebActionSaveResponse(); }
}

// @Route("/opms/sae/webaction/medicalreview", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeMedicalReviewWebActionSave implements IReturn<SaeMedicalReviewWebActionSaveResponse>
{
    [immerable]? = true;

    /** @description The patient study number of the sae */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The patient study number of the sae", IsRequired=true, Name="PatientStudyNumber", ParameterType="body")
    public patientStudyNumber: string;

    /** @description The sae number of the sae */
    // @DataMember(Order=2)
    // @ApiMember(DataType="integer", Description="The sae number of the sae", IsRequired=true, Name="SaeNumber", ParameterType="body")
    public saeNumber: number;

    /** @description The medical review form from which the sae web action will be based off */
    // @DataMember(Order=3)
    // @ApiMember(Description="The medical review form from which the sae web action will be based off", IsRequired=true, Name="SaeMedicalReviewForm", ParameterType="model")
    public medicalReview: SaeMedicalReviewForm;

    public constructor(init?: Partial<SaeMedicalReviewWebActionSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeMedicalReviewWebActionSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeMedicalReviewWebActionSaveResponse(); }
}

// @Route("/opms/sae/send-notification", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeSendNotification implements IReturn<SaeSendNotificationResponse>
{
    [immerable]? = true;

    /** @description The patient study number of the sae */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The patient study number of the sae", IsRequired=true, Name="PatientStudyNumber", ParameterType="body")
    public patientStudyNumber: string;

    /** @description The sae number of the sae */
    // @DataMember(Order=1)
    // @ApiMember(DataType="integer", Description="The sae number of the sae", IsRequired=true, Name="SaeNumber", ParameterType="body")
    public saeNumber: number;

    /** @description The notification form */
    // @DataMember(Order=1)
    // @ApiMember(DataType="SaeNotificationForm", Description="The notification form", IsRequired=true, Name="NotificationForm", ParameterType="body")
    public notificationForm: SaeNotificationForm;

    public constructor(init?: Partial<SaeSendNotification>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeSendNotification'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeSendNotificationResponse(); }
}

// @Route("/opms/sae/validate-notification", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeValidateNotificationForm implements IReturn<SaeValidateNotificationFormResponse>
{
    [immerable]? = true;

    /** @description The notification form */
    // @DataMember(Order=1)
    // @ApiMember(DataType="SaeNotificationForm", Description="The notification form", IsRequired=true, Name="NotificationForm", ParameterType="body")
    public form: SaeNotificationForm;

    public constructor(init?: Partial<SaeValidateNotificationForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeValidateNotificationForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeValidateNotificationFormResponse(); }
}

// @Route("/opms/sae/validate-rejection", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeValidateRejectionForm implements IReturn<SaeValidateRejectionFormResponse>
{
    [immerable]? = true;

    /** @description The rejection form */
    // @DataMember(Order=1)
    // @ApiMember(DataType="WebAction", Description="The rejection form", IsRequired=true, Name="RejectionForm", ParameterType="body")
    public form: WebAction;

    public constructor(init?: Partial<SaeValidateRejectionForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeValidateRejectionForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeValidateRejectionFormResponse(); }
}

// @Route("/opms/sae/open-clinica/document", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeGetOpenClinicaDocument implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    /** @description The file name of the document in openclinica */
    // @DataMember(Order=1)
    // @ApiMember(DataType="string", Description="The file name of the document in openclinica", IsRequired=true, Name="FileName", ParameterType="body")
    public fileName: string;

    public constructor(init?: Partial<SaeGetOpenClinicaDocument>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeGetOpenClinicaDocument'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/sae/file/download/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class DownloadInvalidSaeFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<DownloadInvalidSaeFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadInvalidSaeFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/sae/file/view/{Id}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetInvalidSaeFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<GetInvalidSaeFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInvalidSaeFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/sae/invalid-form/save", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeInvalidFormPostSave implements IReturn<SaeInvalidFormPostSaveResponse>
{
    [immerable]? = true;

    /** @description The invalid sae form to save */
    // @DataMember(Order=1)
    // @ApiMember(DataType="model", Description="The invalid sae form to save", IsRequired=true, Name="InvalidSaeForm", ParameterType="body")
    public invalidSaeForm: InvalidSaeForm;

    public constructor(init?: Partial<SaeInvalidFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeInvalidFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeInvalidFormPostSaveResponse(); }
}

// @Route("/opms/sae/invalid-form/validate", "POST")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
// @DataContract
export class SaeValidateInvalidForm implements IReturn<SaeValidateInvalidFormResponse>
{
    [immerable]? = true;

    /** @description The invalid sae form to validate */
    // @DataMember(Order=1)
    // @ApiMember(DataType="model", Description="The invalid sae form to validate", IsRequired=true, Name="InvalidSaeForm", ParameterType="body")
    public invalidSaeForm: InvalidSaeForm;

    public constructor(init?: Partial<SaeValidateInvalidForm>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SaeValidateInvalidForm'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SaeValidateInvalidFormResponse(); }
}

/** @description Sign In */
// @Route("/auth", "GET,POST")
// @Route("/auth/{provider}", "GET,POST")
// @Api(Description="Sign In")
// @DataContract
export class Authenticate implements IReturn<AuthenticateResponse>, IPost
{
    [immerable]? = true;

    /** @description AuthProvider, e.g. credentials */
    // @DataMember(Order=1)
    public provider: string;

    // @DataMember(Order=2)
    public userName: string;

    // @DataMember(Order=3)
    public password: string;

    // @DataMember(Order=4)
    public rememberMe?: boolean;

    // @DataMember(Order=5)
    public accessToken: string;

    // @DataMember(Order=6)
    public accessTokenSecret: string;

    // @DataMember(Order=7)
    public returnUrl: string;

    // @DataMember(Order=8)
    public errorView: string;

    // @DataMember(Order=9)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<Authenticate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'Authenticate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AuthenticateResponse(); }
}

// @Route("/assignroles", "POST")
// @DataContract
export class AssignRoles implements IReturn<AssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<AssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AssignRolesResponse(); }
}

// @Route("/unassignroles", "POST")
// @DataContract
export class UnAssignRoles implements IReturn<UnAssignRolesResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public userName: string;

    // @DataMember(Order=2)
    public permissions: string[];

    // @DataMember(Order=3)
    public roles: string[];

    // @DataMember(Order=4)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<UnAssignRoles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UnAssignRoles'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UnAssignRolesResponse(); }
}

// @Route("/apikeys")
// @Route("/apikeys/{Environment}")
// @DataContract
export class GetApiKeys implements IReturn<GetApiKeysResponse>, IGet
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<GetApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetApiKeys'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetApiKeysResponse(); }
}

// @Route("/apikeys/regenerate")
// @Route("/apikeys/regenerate/{Environment}")
// @DataContract
export class RegenerateApiKeys implements IReturn<RegenerateApiKeysResponse>, IPost
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public environment: string;

    // @DataMember(Order=2)
    public meta: { [index: string]: string; };

    public constructor(init?: Partial<RegenerateApiKeys>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegenerateApiKeys'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegenerateApiKeysResponse(); }
}

// @DataContract
export class FormValidationById implements IReturn<FormValidationByIdResponse>
{
    [immerable]? = true;

    // @DataMember(Order=1)
    public patientId?: number;

    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    // @DataMember(Order=3)
    public eventRepeat?: number;

    // @DataMember(Order=4)
    public formDefinitionId?: number;

    // @DataMember(Order=5)
    public formRepeat?: number;

    public constructor(init?: Partial<FormValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormValidationById'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FormValidationByIdResponse(); }
}

// @Route("/opms/file-upload", "POST")
export class PostUploadFile implements IReturn<UploadResponse>, IPost
{
    [immerable]? = true;


    public constructor(init?: Partial<PostUploadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostUploadFile'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/info/{Guid}", "GET")
export class GetUploadInfo implements IReturn<UploadResponse>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetUploadInfo>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUploadInfo'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/file-upload/{Guid}", "GET")
export class GetUpload implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<GetUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/download/{Guid}", "GET")
export class DownloadUpload implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<DownloadUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadUpload'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file-upload/{Guid}", "DELETE")
export class DeleteUpload implements IReturn<UploadResponse>, IDelete
{
    [immerable]? = true;

    public guid: string;

    public constructor(init?: Partial<DeleteUpload>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DeleteUpload'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UploadResponse(); }
}

// @Route("/opms/user")
export class GetUser implements IReturn<GetUserResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<GetUser>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUser'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetUserResponse(); }
}

// @Route("/opms/lookup/collection/form-definition/{FormDefinitionId}", "GET")
// @Api(Description="Lookup")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.LookupCollectionResponse)", StatusCode=500)
// @DataContract
export class LookupGetCollectionByFormDefinitionId implements IReturn<LookupCollectionResponse>, ILookupGetCollectionByFormDefinitionId
{
    [immerable]? = true;

    /** @description The ID of the Form Definition associated with the lookup to retrieve. */
    // @DataMember(Order=1)
    public formDefinitionId?: number;

    public constructor(init?: Partial<LookupGetCollectionByFormDefinitionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'LookupGetCollectionByFormDefinitionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new LookupCollectionResponse(); }
}

// @Route("/opms/form-names")
export class GetFormMetadata implements IReturn<GetFormMetadataResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetFormMetadata>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFormMetadata'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetFormMetadataResponse(); }
}

// @Route("/opms/event-definition/single/id/{Id}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleById implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/single/code/{Code}", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetSingleByCode implements IReturn<EventDefinitionSingleResponse>, IEventDefinitionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the event definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<EventDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionSingleResponse(); }
}

// @Route("/opms/event-definition/collection", "GET")
// @Api(Description="Event Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventDefinition.EventDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class EventDefinitionGetCollection implements IReturn<EventDefinitionCollectionResponse>, IEventDefinitionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EventDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventDefinitionCollectionResponse(); }
}

// @Route("/opms/form-definition/single/id/{Id}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleById implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FormDefinitionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/single/code/{Code}", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionSingleResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetSingleByCode implements IReturn<FormDefinitionSingleResponse>, IFormDefinitionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the form definition to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<FormDefinitionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionSingleResponse(); }
}

// @Route("/opms/form-definition/collection", "GET")
// @Api(Description="Form Definition")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.FormDefinition.FormDefinitionCollectionResponse)", StatusCode=500)
// @DataContract
export class FormDefinitionGetCollection implements IReturn<FormDefinitionCollectionResponse>, IFormDefinitionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<FormDefinitionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormDefinitionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormDefinitionCollectionResponse(); }
}

// @Route("/opms/patient-state/single/id/{Id}", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateSingleResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetSingleById implements IReturn<PatientStateSingleResponse>, IPatientStateGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient state to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientStateGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateSingleResponse(); }
}

// @Route("/opms/patient-state/collection", "GET")
// @Api(Description="Patient State")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.PatientState.PatientStateCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientStateGetCollection implements IReturn<PatientStateCollectionResponse>, IPatientStateGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PatientStateGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientStateGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientStateCollectionResponse(); }
}

// @Route("/opms/treatment/single/id/{Id}", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetSingleById implements IReturn<TreatmentSingleResponse>, ITreatmentGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the treatment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TreatmentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentSingleResponse(); }
}

// @Route("/opms/treatment/collection", "GET")
// @Api(Description="Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Treatment.TreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentGetCollection implements IReturn<TreatmentCollectionResponse>, ITreatmentGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TreatmentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentCollectionResponse(); }
}

// @Route("/opms/master-group/single/id/{Id}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleById implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MasterGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/single/code/{Code}", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupSingleResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetSingleByCode implements IReturn<MasterGroupSingleResponse>, IMasterGroupGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the master group to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<MasterGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupSingleResponse(); }
}

// @Route("/opms/master-group/collection", "GET")
// @Api(Description="Master Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.MasterGroup.MasterGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class MasterGroupGetCollection implements IReturn<MasterGroupCollectionResponse>, IMasterGroupGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MasterGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MasterGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MasterGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/single/id/{Id}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleById implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CollaboratingGroupGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/single/code/{Code}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupSingleResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetSingleByCode implements IReturn<CollaboratingGroupSingleResponse>, ICollaboratingGroupGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<CollaboratingGroupGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupSingleResponse(); }
}

// @Route("/opms/collaborating-group/collection", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollection implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CollaboratingGroupGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupId implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/collaborating-group/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Collaborating Group")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.CollaboratingGroup.CollaboratingGroupCollectionResponse)", StatusCode=500)
// @DataContract
export class CollaboratingGroupGetCollectionByMasterGroupCode implements IReturn<CollaboratingGroupCollectionResponse>, ICollaboratingGroupGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the collaborating group to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    public constructor(init?: Partial<CollaboratingGroupGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CollaboratingGroupGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CollaboratingGroupCollectionResponse(); }
}

// @Route("/opms/country/single/id/{Id}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleById implements IReturn<CountrySingleResponse>, ICountryGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CountryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/single/code/{Code}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountrySingleResponse)", StatusCode=500)
// @DataContract
export class CountryGetSingleByCode implements IReturn<CountrySingleResponse>, ICountryGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the country to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<CountryGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountrySingleResponse(); }
}

// @Route("/opms/country/collection", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollection implements IReturn<CountryCollectionResponse>, ICountryGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CountryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByMasterGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    public constructor(init?: Partial<CountryGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupId implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId?: number;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/country/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Country")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Country.CountryCollectionResponse)", StatusCode=500)
// @DataContract
export class CountryGetCollectionByCollaboratingGroupCode implements IReturn<CountryCollectionResponse>, ICountryGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the country to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    public constructor(init?: Partial<CountryGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CountryGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CountryCollectionResponse(); }
}

// @Route("/opms/institution/single/id/{Id}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleById implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InstitutionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/single/code/{Code}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionSingleResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetSingleByCode implements IReturn<InstitutionSingleResponse>, IInstitutionGetSingleByCode
{
    [immerable]? = true;

    /** @description The ID of the institution to retrieve. */
    // @DataMember(Order=1)
    public code: string;

    public constructor(init?: Partial<InstitutionGetSingleByCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetSingleByCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionSingleResponse(); }
}

// @Route("/opms/institution/collection", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollection implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<InstitutionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/id/{CountryId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryId
{
    [immerable]? = true;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupId implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCountryCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCountryCode
{
    [immerable]? = true;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByMasterGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/institution/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Institution")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Institution.InstitutionCollectionResponse)", StatusCode=500)
// @DataContract
export class InstitutionGetCollectionByCollaboratingGroupCode implements IReturn<InstitutionCollectionResponse>, IInstitutionGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the institution to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the institution to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    public constructor(init?: Partial<InstitutionGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InstitutionGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionCollectionResponse(); }
}

// @Route("/opms/patient/single/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleById implements IReturn<PatientSingleResponse>, IPatientGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/single/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientGetSingleByStudyNumber implements IReturn<PatientSingleResponse>, IPatientGetSingleByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<PatientGetSingleByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetSingleByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/validation/id/{Id}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationById implements IReturn<PatientValidationResponse>, IPatientGetValidationById
{
    [immerable]? = true;

    /** @description The ID of the patient to validate. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description Whether to only run the patient validator or to validate all events and forms as well. */
    // @DataMember(Order=2)
    public patientOnly?: boolean;

    public constructor(init?: Partial<PatientGetValidationById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/validation/study-number/{StudyNumber}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientValidationResponse)", StatusCode=500)
// @DataContract
export class PatientGetValidationByStudyNumber implements IReturn<PatientValidationResponse>, IPatientGetValidationByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to validate. */
    // @DataMember(Order=1)
    public studyNumber: string;

    /** @description Whether to only run the patient validator or to validate all events and forms as well. */
    // @DataMember(Order=2)
    public patientOnly?: boolean;

    public constructor(init?: Partial<PatientGetValidationByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetValidationByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientValidationResponse(); }
}

// @Route("/opms/patient/collection", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollection implements IReturn<PatientCollectionResponse>, IPatientGetCollection
{
    [immerable]? = true;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/id/{MasterGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupId
{
    [immerable]? = true;

    /** @description The ID of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/id/{CollaboratingGroupId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupId
{
    [immerable]? = true;

    /** @description The ID of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupId: number;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryId?: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/id/{CountryId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryId
{
    [immerable]? = true;

    /** @description The ID of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/id/{InstitutionId}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionId implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionId
{
    [immerable]? = true;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionId: number;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/master-group/code/{MasterGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByMasterGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByMasterGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Master Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public masterGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByMasterGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByMasterGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/collaborating-group/code/{CollaboratingGroupCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCollaboratingGroupCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCollaboratingGroupCode
{
    [immerable]? = true;

    /** @description The Code of the Collaborating Group associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public collaboratingGroupCode: string;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCollaboratingGroupCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCollaboratingGroupCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/country/code/{CountryCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByCountryCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByCountryCode
{
    [immerable]? = true;

    /** @description The Code of the Country associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public countryCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByCountryCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByCountryCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/collection/institution/code/{InstitutionCode}", "GET")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientCollectionResponse)", StatusCode=500)
// @DataContract
export class PatientGetCollectionByInstitutionCode implements IReturn<PatientCollectionResponse>, IPatientGetCollectionByInstitutionCode
{
    [immerable]? = true;

    /** @description The Code of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=1)
    public institutionCode: string;

    /** @description The IDs of the Patient States associated with the patient to retrieve. */
    // @DataMember(Order=3)
    public patientStateIds: number[];

    public constructor(init?: Partial<PatientGetCollectionByInstitutionCode>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientGetCollectionByInstitutionCode'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientCollectionResponse(); }
}

// @Route("/opms/patient/Save", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSave implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    public constructor(init?: Partial<PatientPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/ids", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithIds implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    public constructor(init?: Partial<PatientPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/patient/save/codes", "POST")
// @Api(Description="Patient")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Patient.PatientSingleResponse)", StatusCode=500)
// @DataContract
export class PatientPostSaveWithCodes implements IReturn<PatientSingleResponse>
{
    [immerable]? = true;

    /** @description The patient to save. */
    // @DataMember(Order=1)
    public patient: Patient;

    /** @description The ID of the Institution associated with the patient to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    public constructor(init?: Partial<PatientPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientSingleResponse(); }
}

// @Route("/opms/event/validation/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventValidationResponse)", StatusCode=500)
// @DataContract
export class EventGetValidationByIds implements IReturn<EventValidationResponse>, IEventGetValidationByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the event to validate. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to validate. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat of the event to validate. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description Whether to only run the event validator or to validate all forms as well. */
    // @DataMember(Order=4)
    public eventOnly?: boolean;

    public constructor(init?: Partial<EventGetValidationByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetValidationByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventValidationResponse(); }
}

// @Route("/opms/event/single/id/{Id}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleById implements IReturn<EventSingleResponse>, IEventGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the event to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/ids", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByIds implements IReturn<EventSingleResponse>, IEventGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Id of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/single/codes", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventGetSingleByCodes implements IReturn<EventSingleResponse>, IEventGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Code of the Institution associated to the event to retrieve. */
    // @DataMember(Order=4)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=5)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=6)
    public createEvent?: boolean;

    public constructor(init?: Partial<EventGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/collection", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollection implements IReturn<EventCollectionResponse>, IEventGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EventGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/id/{PatientId}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientId implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientId
{
    [immerable]? = true;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientId: number;

    public constructor(init?: Partial<EventGetCollectionByPatientId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientId'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/collection/patient/study-number/{PatientStudyNumber}", "GET")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventCollectionResponse)", StatusCode=500)
// @DataContract
export class EventGetCollectionByPatientStudyNumber implements IReturn<EventCollectionResponse>, IEventGetCollectionByPatientStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    public constructor(init?: Partial<EventGetCollectionByPatientStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventGetCollectionByPatientStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventCollectionResponse(); }
}

// @Route("/opms/event/Save", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSave implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    public constructor(init?: Partial<EventPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/ids", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithIds implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The ID of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/event/save/codes", "POST")
// @Api(Description="Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Event.EventSingleResponse)", StatusCode=500)
// @DataContract
export class EventPostSaveWithCodes implements IReturn<EventSingleResponse>
{
    [immerable]? = true;

    /** @description The event to save. */
    // @DataMember(Order=1)
    public event: Event;

    /** @description The Code of the Institution associated with the event to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the event to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Repeat number of the event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    public constructor(init?: Partial<EventPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EventSingleResponse(); }
}

// @Route("/opms/form/image-document/single/id/{Id}", "GET")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentGetSingleById implements IReturn<ImageDocumentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the image document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ImageDocumentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageDocumentSingleResponse(); }
}

// @Route("/opms/form/image-document/single/ids", "GET")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentGetSingleByIds implements IReturn<ImageDocumentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the image document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the image document to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new image document if no image document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ImageDocumentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageDocumentSingleResponse(); }
}

// @Route("/opms/form/image-document/single/codes", "GET")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentGetSingleByCodes implements IReturn<ImageDocumentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the image document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the image document to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new image document if no image document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ImageDocumentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageDocumentSingleResponse(); }
}

// @Route("/opms/form/image-document/collection", "GET")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentGetCollection implements IReturn<ImageDocumentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ImageDocumentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageDocumentCollectionResponse(); }
}

// @Route("/opms/form/image-document/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentGetCollectionByIds implements IReturn<ImageDocumentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the image document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageDocumentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageDocumentCollectionResponse(); }
}

// @Route("/opms/form/image-document/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentGetCollectionByCodes implements IReturn<ImageDocumentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the image document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageDocumentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageDocumentCollectionResponse(); }
}

// @Route("/opms/form/image-document/save", "POST")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentPostSave implements IReturn<ImageDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The image document to save. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    public constructor(init?: Partial<ImageDocumentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageDocumentSingleResponse(); }
}

// @Route("/opms/form/image-document/save/ids", "POST")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentPostSaveWithIds implements IReturn<ImageDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The image document to save. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    /** @description The ID of the Institution associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the image document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the image document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ImageDocumentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageDocumentSingleResponse(); }
}

// @Route("/opms/form/image-document/save/codes", "POST")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentPostSaveWithCodes implements IReturn<ImageDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The image document to save. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    /** @description The Code of the Institution associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the image document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the image document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ImageDocumentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageDocumentSingleResponse(); }
}

// @Route("/opms/form/image-document/delete", "DELETE")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentDelete implements IReturn<ImageDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The image document to delete. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    public constructor(init?: Partial<ImageDocumentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-document/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentDeleteWithId implements IReturn<ImageDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the image document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ImageDocumentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-document/delete/ids", "DELETE")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentDeleteWithIds implements IReturn<ImageDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the image document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ImageDocumentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-document/delete/codes", "DELETE")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentDeleteByCodes implements IReturn<ImageDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the image document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ImageDocumentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-document/validate", "POST")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentPostValidate implements IReturn<ImageDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The image document to validate. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    public constructor(init?: Partial<ImageDocumentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageDocumentValidationResponse(); }
}

// @Route("/opms/form/image-document/validate/ids", "POST")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentPostValidateWithIds implements IReturn<ImageDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The image document to validate. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    /** @description The ID of the Institution associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the image document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageDocumentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageDocumentValidationResponse(); }
}

// @Route("/opms/form/image-document/validate/codes", "POST")
// @Api(Description="Form - Image Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class ImageDocumentPostValidateWithCodes implements IReturn<ImageDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The image document to validate. */
    // @DataMember(Order=1)
    public form: ImageDocument;

    /** @description The Code of the Institution associated with the image document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the image document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the image document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageDocumentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageDocumentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageDocumentValidationResponse(); }
}

// @Route("/opms/form/mri-image-upload/single/id/{Id}", "GET")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadGetSingleById implements IReturn<MriImageUploadSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MriImageUploadGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriImageUploadSingleResponse(); }
}

// @Route("/opms/form/mri-image-upload/single/ids", "GET")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadGetSingleByIds implements IReturn<MriImageUploadSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the mri image upload to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new mri image upload if no mri image upload is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MriImageUploadGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriImageUploadSingleResponse(); }
}

// @Route("/opms/form/mri-image-upload/single/codes", "GET")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadGetSingleByCodes implements IReturn<MriImageUploadSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the mri image upload to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new mri image upload if no mri image upload is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MriImageUploadGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriImageUploadSingleResponse(); }
}

// @Route("/opms/form/mri-image-upload/collection", "GET")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadGetCollection implements IReturn<MriImageUploadCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MriImageUploadGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriImageUploadCollectionResponse(); }
}

// @Route("/opms/form/mri-image-upload/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadGetCollectionByIds implements IReturn<MriImageUploadCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriImageUploadGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriImageUploadCollectionResponse(); }
}

// @Route("/opms/form/mri-image-upload/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadCollectionResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadGetCollectionByCodes implements IReturn<MriImageUploadCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriImageUploadGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriImageUploadCollectionResponse(); }
}

// @Route("/opms/form/mri-image-upload/save", "POST")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadPostSave implements IReturn<MriImageUploadSingleResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to save. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    public constructor(init?: Partial<MriImageUploadPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriImageUploadSingleResponse(); }
}

// @Route("/opms/form/mri-image-upload/save/ids", "POST")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadPostSaveWithIds implements IReturn<MriImageUploadSingleResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to save. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    /** @description The ID of the Institution associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the mri image upload to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MriImageUploadPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriImageUploadSingleResponse(); }
}

// @Route("/opms/form/mri-image-upload/save/codes", "POST")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadSingleResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadPostSaveWithCodes implements IReturn<MriImageUploadSingleResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to save. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    /** @description The Code of the Institution associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the mri image upload to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MriImageUploadPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriImageUploadSingleResponse(); }
}

// @Route("/opms/form/mri-image-upload/delete", "DELETE")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadDelete implements IReturn<MriImageUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to delete. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    public constructor(init?: Partial<MriImageUploadDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriImageUploadDeleteResponse(); }
}

// @Route("/opms/form/mri-image-upload/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadDeleteWithId implements IReturn<MriImageUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MriImageUploadDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriImageUploadDeleteResponse(); }
}

// @Route("/opms/form/mri-image-upload/delete/ids", "DELETE")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadDeleteWithIds implements IReturn<MriImageUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MriImageUploadDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriImageUploadDeleteResponse(); }
}

// @Route("/opms/form/mri-image-upload/delete/codes", "DELETE")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadDeleteByCodes implements IReturn<MriImageUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the mri image upload to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MriImageUploadDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriImageUploadDeleteResponse(); }
}

// @Route("/opms/form/mri-image-upload/validate", "POST")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadPostValidate implements IReturn<MriImageUploadValidationResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to validate. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    public constructor(init?: Partial<MriImageUploadPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriImageUploadValidationResponse(); }
}

// @Route("/opms/form/mri-image-upload/validate/ids", "POST")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadPostValidateWithIds implements IReturn<MriImageUploadValidationResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to validate. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    /** @description The ID of the Institution associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriImageUploadPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriImageUploadValidationResponse(); }
}

// @Route("/opms/form/mri-image-upload/validate/codes", "POST")
// @Api(Description="Form - Mri Image Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriImageUploadValidationResponse)", StatusCode=500)
// @DataContract
export class MriImageUploadPostValidateWithCodes implements IReturn<MriImageUploadValidationResponse>
{
    [immerable]? = true;

    /** @description The mri image upload to validate. */
    // @DataMember(Order=1)
    public form: MriImageUpload;

    /** @description The Code of the Institution associated with the mri image upload to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the mri image upload to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the mri image upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri image upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriImageUploadPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriImageUploadPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriImageUploadValidationResponse(); }
}

// @Route("/opms/form/image-report-document/single/id/{Id}", "GET")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentGetSingleById implements IReturn<ImageReportDocumentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the image report document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ImageReportDocumentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportDocumentSingleResponse(); }
}

// @Route("/opms/form/image-report-document/single/ids", "GET")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentGetSingleByIds implements IReturn<ImageReportDocumentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the image report document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the image report document to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new image report document if no image report document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ImageReportDocumentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportDocumentSingleResponse(); }
}

// @Route("/opms/form/image-report-document/single/codes", "GET")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentGetSingleByCodes implements IReturn<ImageReportDocumentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the image report document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the image report document to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new image report document if no image report document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ImageReportDocumentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportDocumentSingleResponse(); }
}

// @Route("/opms/form/image-report-document/collection", "GET")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentGetCollection implements IReturn<ImageReportDocumentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ImageReportDocumentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportDocumentCollectionResponse(); }
}

// @Route("/opms/form/image-report-document/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentGetCollectionByIds implements IReturn<ImageReportDocumentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the image report document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportDocumentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportDocumentCollectionResponse(); }
}

// @Route("/opms/form/image-report-document/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentGetCollectionByCodes implements IReturn<ImageReportDocumentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the image report document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportDocumentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportDocumentCollectionResponse(); }
}

// @Route("/opms/form/image-report-document/save", "POST")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentPostSave implements IReturn<ImageReportDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The image report document to save. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    public constructor(init?: Partial<ImageReportDocumentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportDocumentSingleResponse(); }
}

// @Route("/opms/form/image-report-document/save/ids", "POST")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentPostSaveWithIds implements IReturn<ImageReportDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The image report document to save. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    /** @description The ID of the Institution associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the image report document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ImageReportDocumentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportDocumentSingleResponse(); }
}

// @Route("/opms/form/image-report-document/save/codes", "POST")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentPostSaveWithCodes implements IReturn<ImageReportDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The image report document to save. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    /** @description The Code of the Institution associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the image report document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the image report document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ImageReportDocumentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportDocumentSingleResponse(); }
}

// @Route("/opms/form/image-report-document/delete", "DELETE")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentDelete implements IReturn<ImageReportDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The image report document to delete. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    public constructor(init?: Partial<ImageReportDocumentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-report-document/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentDeleteWithId implements IReturn<ImageReportDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the image report document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ImageReportDocumentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-report-document/delete/ids", "DELETE")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentDeleteWithIds implements IReturn<ImageReportDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the image report document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ImageReportDocumentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-report-document/delete/codes", "DELETE")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentDeleteByCodes implements IReturn<ImageReportDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the image report document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ImageReportDocumentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportDocumentDeleteResponse(); }
}

// @Route("/opms/form/image-report-document/validate", "POST")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentPostValidate implements IReturn<ImageReportDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The image report document to validate. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    public constructor(init?: Partial<ImageReportDocumentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportDocumentValidationResponse(); }
}

// @Route("/opms/form/image-report-document/validate/ids", "POST")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentPostValidateWithIds implements IReturn<ImageReportDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The image report document to validate. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    /** @description The ID of the Institution associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportDocumentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportDocumentValidationResponse(); }
}

// @Route("/opms/form/image-report-document/validate/codes", "POST")
// @Api(Description="Form - Image Report Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class ImageReportDocumentPostValidateWithCodes implements IReturn<ImageReportDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The image report document to validate. */
    // @DataMember(Order=1)
    public form: ImageReportDocument;

    /** @description The Code of the Institution associated with the image report document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the image report document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the image report document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportDocumentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportDocumentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportDocumentValidationResponse(); }
}

// @Route("/opms/form/source-document/single/id/{Id}", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetSingleById implements IReturn<SourceDocumentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SourceDocumentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/single/ids", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetSingleByIds implements IReturn<SourceDocumentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the source document to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new source document if no source document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SourceDocumentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/single/codes", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetSingleByCodes implements IReturn<SourceDocumentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the source document to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new source document if no source document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SourceDocumentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/collection", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetCollection implements IReturn<SourceDocumentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SourceDocumentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/source-document/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetCollectionByIds implements IReturn<SourceDocumentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/source-document/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentGetCollectionByCodes implements IReturn<SourceDocumentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/source-document/save", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostSave implements IReturn<SourceDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The source document to save. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/save/ids", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostSaveWithIds implements IReturn<SourceDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The source document to save. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The ID of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the source document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SourceDocumentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/save/codes", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostSaveWithCodes implements IReturn<SourceDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The source document to save. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The Code of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the source document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SourceDocumentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentSingleResponse(); }
}

// @Route("/opms/form/source-document/delete", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDelete implements IReturn<SourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The source document to delete. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDeleteWithId implements IReturn<SourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SourceDocumentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/delete/ids", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDeleteWithIds implements IReturn<SourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SourceDocumentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/delete/codes", "DELETE")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentDeleteByCodes implements IReturn<SourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SourceDocumentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/source-document/validate", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostValidate implements IReturn<SourceDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The source document to validate. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    public constructor(init?: Partial<SourceDocumentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentValidationResponse(); }
}

// @Route("/opms/form/source-document/validate/ids", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostValidateWithIds implements IReturn<SourceDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The source document to validate. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The ID of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentValidationResponse(); }
}

// @Route("/opms/form/source-document/validate/codes", "POST")
// @Api(Description="Form - Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SourceDocumentPostValidateWithCodes implements IReturn<SourceDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The source document to validate. */
    // @DataMember(Order=1)
    public form: SourceDocument;

    /** @description The Code of the Institution associated with the source document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the source document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SourceDocumentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SourceDocumentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SourceDocumentValidationResponse(); }
}

// @Route("/opms/form/system-error-details/single/id/{Id}", "GET")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsGetSingleById implements IReturn<SystemErrorDetailsSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the system error details to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorDetailsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorDetailsSingleResponse(); }
}

// @Route("/opms/form/system-error-details/single/ids", "GET")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsGetSingleByIds implements IReturn<SystemErrorDetailsSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error details to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error details to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the system error details to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error details if no system error details is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorDetailsGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorDetailsSingleResponse(); }
}

// @Route("/opms/form/system-error-details/single/codes", "GET")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsGetSingleByCodes implements IReturn<SystemErrorDetailsSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error details to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error details to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the system error details to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error details if no system error details is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorDetailsGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorDetailsSingleResponse(); }
}

// @Route("/opms/form/system-error-details/collection", "GET")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsGetCollection implements IReturn<SystemErrorDetailsCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SystemErrorDetailsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorDetailsCollectionResponse(); }
}

// @Route("/opms/form/system-error-details/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsGetCollectionByIds implements IReturn<SystemErrorDetailsCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error details to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorDetailsGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorDetailsCollectionResponse(); }
}

// @Route("/opms/form/system-error-details/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsGetCollectionByCodes implements IReturn<SystemErrorDetailsCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the system error details to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorDetailsGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorDetailsCollectionResponse(); }
}

// @Route("/opms/form/system-error-details/save", "POST")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsPostSave implements IReturn<SystemErrorDetailsSingleResponse>
{
    [immerable]? = true;

    /** @description The system error details to save. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    public constructor(init?: Partial<SystemErrorDetailsPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorDetailsSingleResponse(); }
}

// @Route("/opms/form/system-error-details/save/ids", "POST")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsPostSaveWithIds implements IReturn<SystemErrorDetailsSingleResponse>
{
    [immerable]? = true;

    /** @description The system error details to save. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    /** @description The ID of the Institution associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error details to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorDetailsPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorDetailsSingleResponse(); }
}

// @Route("/opms/form/system-error-details/save/codes", "POST")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsPostSaveWithCodes implements IReturn<SystemErrorDetailsSingleResponse>
{
    [immerable]? = true;

    /** @description The system error details to save. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    /** @description The Code of the Institution associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error details to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error details to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorDetailsPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorDetailsSingleResponse(); }
}

// @Route("/opms/form/system-error-details/delete", "DELETE")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsDelete implements IReturn<SystemErrorDetailsDeleteResponse>
{
    [immerable]? = true;

    /** @description The system error details to delete. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    public constructor(init?: Partial<SystemErrorDetailsDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorDetailsDeleteResponse(); }
}

// @Route("/opms/form/system-error-details/delete/id/{Id}", "DELETE")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsDeleteWithId implements IReturn<SystemErrorDetailsDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the system error details to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorDetailsDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorDetailsDeleteResponse(); }
}

// @Route("/opms/form/system-error-details/delete/ids", "DELETE")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsDeleteWithIds implements IReturn<SystemErrorDetailsDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the system error details to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error details to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorDetailsDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorDetailsDeleteResponse(); }
}

// @Route("/opms/form/system-error-details/delete/codes", "DELETE")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsDeleteByCodes implements IReturn<SystemErrorDetailsDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error details to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error details to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorDetailsDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorDetailsDeleteResponse(); }
}

// @Route("/opms/form/system-error-details/validate", "POST")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsPostValidate implements IReturn<SystemErrorDetailsValidationResponse>
{
    [immerable]? = true;

    /** @description The system error details to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    public constructor(init?: Partial<SystemErrorDetailsPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorDetailsValidationResponse(); }
}

// @Route("/opms/form/system-error-details/validate/ids", "POST")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsPostValidateWithIds implements IReturn<SystemErrorDetailsValidationResponse>
{
    [immerable]? = true;

    /** @description The system error details to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    /** @description The ID of the Institution associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorDetailsPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorDetailsValidationResponse(); }
}

// @Route("/opms/form/system-error-details/validate/codes", "POST")
// @Api(Description="Form - System Error Details")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorDetailsValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorDetailsPostValidateWithCodes implements IReturn<SystemErrorDetailsValidationResponse>
{
    [immerable]? = true;

    /** @description The system error details to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorDetails;

    /** @description The Code of the Institution associated with the system error details to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error details to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error details to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error details to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorDetailsPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorDetailsPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorDetailsValidationResponse(); }
}

// @Route("/opms/form/system-error-form/single/id/{Id}", "GET")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormGetSingleById implements IReturn<SystemErrorFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the system error form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorFormSingleResponse(); }
}

// @Route("/opms/form/system-error-form/single/ids", "GET")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormGetSingleByIds implements IReturn<SystemErrorFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the system error form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error form if no system error form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorFormSingleResponse(); }
}

// @Route("/opms/form/system-error-form/single/codes", "GET")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormGetSingleByCodes implements IReturn<SystemErrorFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the system error form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error form if no system error form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorFormSingleResponse(); }
}

// @Route("/opms/form/system-error-form/collection", "GET")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormGetCollection implements IReturn<SystemErrorFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SystemErrorFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorFormCollectionResponse(); }
}

// @Route("/opms/form/system-error-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormGetCollectionByIds implements IReturn<SystemErrorFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorFormCollectionResponse(); }
}

// @Route("/opms/form/system-error-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormGetCollectionByCodes implements IReturn<SystemErrorFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the system error form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorFormCollectionResponse(); }
}

// @Route("/opms/form/system-error-form/save", "POST")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormPostSave implements IReturn<SystemErrorFormSingleResponse>
{
    [immerable]? = true;

    /** @description The system error form to save. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    public constructor(init?: Partial<SystemErrorFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorFormSingleResponse(); }
}

// @Route("/opms/form/system-error-form/save/ids", "POST")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormPostSaveWithIds implements IReturn<SystemErrorFormSingleResponse>
{
    [immerable]? = true;

    /** @description The system error form to save. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    /** @description The ID of the Institution associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorFormSingleResponse(); }
}

// @Route("/opms/form/system-error-form/save/codes", "POST")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormPostSaveWithCodes implements IReturn<SystemErrorFormSingleResponse>
{
    [immerable]? = true;

    /** @description The system error form to save. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    /** @description The Code of the Institution associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorFormSingleResponse(); }
}

// @Route("/opms/form/system-error-form/delete", "DELETE")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormDelete implements IReturn<SystemErrorFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The system error form to delete. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    public constructor(init?: Partial<SystemErrorFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorFormDeleteResponse(); }
}

// @Route("/opms/form/system-error-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormDeleteWithId implements IReturn<SystemErrorFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the system error form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorFormDeleteResponse(); }
}

// @Route("/opms/form/system-error-form/delete/ids", "DELETE")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormDeleteWithIds implements IReturn<SystemErrorFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the system error form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorFormDeleteResponse(); }
}

// @Route("/opms/form/system-error-form/delete/codes", "DELETE")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormDeleteByCodes implements IReturn<SystemErrorFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorFormDeleteResponse(); }
}

// @Route("/opms/form/system-error-form/validate", "POST")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormPostValidate implements IReturn<SystemErrorFormValidationResponse>
{
    [immerable]? = true;

    /** @description The system error form to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    public constructor(init?: Partial<SystemErrorFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorFormValidationResponse(); }
}

// @Route("/opms/form/system-error-form/validate/ids", "POST")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormPostValidateWithIds implements IReturn<SystemErrorFormValidationResponse>
{
    [immerable]? = true;

    /** @description The system error form to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    /** @description The ID of the Institution associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorFormValidationResponse(); }
}

// @Route("/opms/form/system-error-form/validate/codes", "POST")
// @Api(Description="Form - System Error Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorFormValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorFormPostValidateWithCodes implements IReturn<SystemErrorFormValidationResponse>
{
    [immerable]? = true;

    /** @description The system error form to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorForm;

    /** @description The Code of the Institution associated with the system error form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorFormValidationResponse(); }
}

// @Route("/opms/form/system-error-info/single/id/{Id}", "GET")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoGetSingleById implements IReturn<SystemErrorInfoSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the system error info to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorInfoGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorInfoSingleResponse(); }
}

// @Route("/opms/form/system-error-info/single/ids", "GET")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoGetSingleByIds implements IReturn<SystemErrorInfoSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error info to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error info to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the system error info to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error info if no system error info is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorInfoGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorInfoSingleResponse(); }
}

// @Route("/opms/form/system-error-info/single/codes", "GET")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoGetSingleByCodes implements IReturn<SystemErrorInfoSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error info to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error info to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the system error info to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error info if no system error info is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorInfoGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorInfoSingleResponse(); }
}

// @Route("/opms/form/system-error-info/collection", "GET")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoGetCollection implements IReturn<SystemErrorInfoCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SystemErrorInfoGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorInfoCollectionResponse(); }
}

// @Route("/opms/form/system-error-info/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoGetCollectionByIds implements IReturn<SystemErrorInfoCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error info to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorInfoGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorInfoCollectionResponse(); }
}

// @Route("/opms/form/system-error-info/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoGetCollectionByCodes implements IReturn<SystemErrorInfoCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the system error info to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorInfoGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorInfoCollectionResponse(); }
}

// @Route("/opms/form/system-error-info/save", "POST")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoPostSave implements IReturn<SystemErrorInfoSingleResponse>
{
    [immerable]? = true;

    /** @description The system error info to save. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    public constructor(init?: Partial<SystemErrorInfoPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorInfoSingleResponse(); }
}

// @Route("/opms/form/system-error-info/save/ids", "POST")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoPostSaveWithIds implements IReturn<SystemErrorInfoSingleResponse>
{
    [immerable]? = true;

    /** @description The system error info to save. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    /** @description The ID of the Institution associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error info to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorInfoPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorInfoSingleResponse(); }
}

// @Route("/opms/form/system-error-info/save/codes", "POST")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoPostSaveWithCodes implements IReturn<SystemErrorInfoSingleResponse>
{
    [immerable]? = true;

    /** @description The system error info to save. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    /** @description The Code of the Institution associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error info to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error info to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorInfoPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorInfoSingleResponse(); }
}

// @Route("/opms/form/system-error-info/delete", "DELETE")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoDelete implements IReturn<SystemErrorInfoDeleteResponse>
{
    [immerable]? = true;

    /** @description The system error info to delete. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    public constructor(init?: Partial<SystemErrorInfoDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorInfoDeleteResponse(); }
}

// @Route("/opms/form/system-error-info/delete/id/{Id}", "DELETE")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoDeleteWithId implements IReturn<SystemErrorInfoDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the system error info to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorInfoDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorInfoDeleteResponse(); }
}

// @Route("/opms/form/system-error-info/delete/ids", "DELETE")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoDeleteWithIds implements IReturn<SystemErrorInfoDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the system error info to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error info to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorInfoDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorInfoDeleteResponse(); }
}

// @Route("/opms/form/system-error-info/delete/codes", "DELETE")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoDeleteByCodes implements IReturn<SystemErrorInfoDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error info to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error info to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorInfoDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorInfoDeleteResponse(); }
}

// @Route("/opms/form/system-error-info/validate", "POST")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoPostValidate implements IReturn<SystemErrorInfoValidationResponse>
{
    [immerable]? = true;

    /** @description The system error info to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    public constructor(init?: Partial<SystemErrorInfoPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorInfoValidationResponse(); }
}

// @Route("/opms/form/system-error-info/validate/ids", "POST")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoPostValidateWithIds implements IReturn<SystemErrorInfoValidationResponse>
{
    [immerable]? = true;

    /** @description The system error info to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    /** @description The ID of the Institution associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorInfoPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorInfoValidationResponse(); }
}

// @Route("/opms/form/system-error-info/validate/codes", "POST")
// @Api(Description="Form - System Error Info")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorInfoValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorInfoPostValidateWithCodes implements IReturn<SystemErrorInfoValidationResponse>
{
    [immerable]? = true;

    /** @description The system error info to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorInfo;

    /** @description The Code of the Institution associated with the system error info to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error info to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error info to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error info to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorInfoPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorInfoPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorInfoValidationResponse(); }
}

// @Route("/opms/form/system-error-source-document/single/id/{Id}", "GET")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentGetSingleById implements IReturn<SystemErrorSourceDocumentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorSourceDocumentSingleResponse(); }
}

// @Route("/opms/form/system-error-source-document/single/ids", "GET")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentGetSingleByIds implements IReturn<SystemErrorSourceDocumentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the system error source document to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error source document if no system error source document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorSourceDocumentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorSourceDocumentSingleResponse(); }
}

// @Route("/opms/form/system-error-source-document/single/codes", "GET")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentGetSingleByCodes implements IReturn<SystemErrorSourceDocumentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the system error source document to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new system error source document if no system error source document is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SystemErrorSourceDocumentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorSourceDocumentSingleResponse(); }
}

// @Route("/opms/form/system-error-source-document/collection", "GET")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentGetCollection implements IReturn<SystemErrorSourceDocumentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SystemErrorSourceDocumentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorSourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/system-error-source-document/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentGetCollectionByIds implements IReturn<SystemErrorSourceDocumentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorSourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/system-error-source-document/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentCollectionResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentGetCollectionByCodes implements IReturn<SystemErrorSourceDocumentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the system error source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SystemErrorSourceDocumentCollectionResponse(); }
}

// @Route("/opms/form/system-error-source-document/save", "POST")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentPostSave implements IReturn<SystemErrorSourceDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The system error source document to save. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    public constructor(init?: Partial<SystemErrorSourceDocumentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorSourceDocumentSingleResponse(); }
}

// @Route("/opms/form/system-error-source-document/save/ids", "POST")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentPostSaveWithIds implements IReturn<SystemErrorSourceDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The system error source document to save. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    /** @description The ID of the Institution associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error source document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorSourceDocumentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorSourceDocumentSingleResponse(); }
}

// @Route("/opms/form/system-error-source-document/save/codes", "POST")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentSingleResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentPostSaveWithCodes implements IReturn<SystemErrorSourceDocumentSingleResponse>
{
    [immerable]? = true;

    /** @description The system error source document to save. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    /** @description The Code of the Institution associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the system error source document to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SystemErrorSourceDocumentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorSourceDocumentSingleResponse(); }
}

// @Route("/opms/form/system-error-source-document/delete", "DELETE")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentDelete implements IReturn<SystemErrorSourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The system error source document to delete. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    public constructor(init?: Partial<SystemErrorSourceDocumentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorSourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/system-error-source-document/delete/id/{Id}", "DELETE")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentDeleteWithId implements IReturn<SystemErrorSourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorSourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/system-error-source-document/delete/ids", "DELETE")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentDeleteWithIds implements IReturn<SystemErrorSourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorSourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/system-error-source-document/delete/codes", "DELETE")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentDeleteResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentDeleteByCodes implements IReturn<SystemErrorSourceDocumentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the system error source document to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the system error source document to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SystemErrorSourceDocumentDeleteResponse(); }
}

// @Route("/opms/form/system-error-source-document/validate", "POST")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentPostValidate implements IReturn<SystemErrorSourceDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The system error source document to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    public constructor(init?: Partial<SystemErrorSourceDocumentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorSourceDocumentValidationResponse(); }
}

// @Route("/opms/form/system-error-source-document/validate/ids", "POST")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentPostValidateWithIds implements IReturn<SystemErrorSourceDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The system error source document to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    /** @description The ID of the Institution associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorSourceDocumentValidationResponse(); }
}

// @Route("/opms/form/system-error-source-document/validate/codes", "POST")
// @Api(Description="Form - System Error Source Document")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SystemErrorSourceDocumentValidationResponse)", StatusCode=500)
// @DataContract
export class SystemErrorSourceDocumentPostValidateWithCodes implements IReturn<SystemErrorSourceDocumentValidationResponse>
{
    [immerable]? = true;

    /** @description The system error source document to validate. */
    // @DataMember(Order=1)
    public form: SystemErrorSourceDocument;

    /** @description The Code of the Institution associated with the system error source document to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the system error source document to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the system error source document to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the system error source document to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SystemErrorSourceDocumentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SystemErrorSourceDocumentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SystemErrorSourceDocumentValidationResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/single/id/{Id}", "GET")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleGetSingleById implements IReturn<BreastCancerTreatmentOutcomesScaleSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleSingleResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/single/ids", "GET")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleGetSingleByIds implements IReturn<BreastCancerTreatmentOutcomesScaleSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new breast cancer treatment outcomes scale if no breast cancer treatment outcomes scale is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleSingleResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/single/codes", "GET")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleGetSingleByCodes implements IReturn<BreastCancerTreatmentOutcomesScaleSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new breast cancer treatment outcomes scale if no breast cancer treatment outcomes scale is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleSingleResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/collection", "GET")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleGetCollection implements IReturn<BreastCancerTreatmentOutcomesScaleCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleCollectionResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleGetCollectionByIds implements IReturn<BreastCancerTreatmentOutcomesScaleCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleCollectionResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleGetCollectionByCodes implements IReturn<BreastCancerTreatmentOutcomesScaleCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleCollectionResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/save", "POST")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScalePostSave implements IReturn<BreastCancerTreatmentOutcomesScaleSingleResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to save. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScalePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScalePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleSingleResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/save/ids", "POST")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScalePostSaveWithIds implements IReturn<BreastCancerTreatmentOutcomesScaleSingleResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to save. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    /** @description The ID of the Institution associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScalePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScalePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleSingleResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/save/codes", "POST")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleSingleResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScalePostSaveWithCodes implements IReturn<BreastCancerTreatmentOutcomesScaleSingleResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to save. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    /** @description The Code of the Institution associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScalePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScalePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleSingleResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/delete", "DELETE")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleDelete implements IReturn<BreastCancerTreatmentOutcomesScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to delete. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleDeleteResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleDeleteWithId implements IReturn<BreastCancerTreatmentOutcomesScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleDeleteResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/delete/ids", "DELETE")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleDeleteWithIds implements IReturn<BreastCancerTreatmentOutcomesScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleDeleteResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/delete/codes", "DELETE")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScaleDeleteByCodes implements IReturn<BreastCancerTreatmentOutcomesScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScaleDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScaleDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleDeleteResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/validate", "POST")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScalePostValidate implements IReturn<BreastCancerTreatmentOutcomesScaleValidationResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to validate. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScalePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScalePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleValidationResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/validate/ids", "POST")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScalePostValidateWithIds implements IReturn<BreastCancerTreatmentOutcomesScaleValidationResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to validate. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    /** @description The ID of the Institution associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScalePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScalePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleValidationResponse(); }
}

// @Route("/opms/form/breast-cancer-treatment-outcomes-scale/validate/codes", "POST")
// @Api(Description="Form - Breast Cancer Treatment Outcomes Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastCancerTreatmentOutcomesScaleValidationResponse)", StatusCode=500)
// @DataContract
export class BreastCancerTreatmentOutcomesScalePostValidateWithCodes implements IReturn<BreastCancerTreatmentOutcomesScaleValidationResponse>
{
    [immerable]? = true;

    /** @description The breast cancer treatment outcomes scale to validate. */
    // @DataMember(Order=1)
    public form: BreastCancerTreatmentOutcomesScale;

    /** @description The Code of the Institution associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast cancer treatment outcomes scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastCancerTreatmentOutcomesScalePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastCancerTreatmentOutcomesScalePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastCancerTreatmentOutcomesScaleValidationResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/single/id/{Id}", "GET")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireGetSingleById implements IReturn<BriefIllnessPerceptionQuestionnaireSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireSingleResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/single/ids", "GET")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireGetSingleByIds implements IReturn<BriefIllnessPerceptionQuestionnaireSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new brief illness perception questionnaire if no brief illness perception questionnaire is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireSingleResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/single/codes", "GET")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireGetSingleByCodes implements IReturn<BriefIllnessPerceptionQuestionnaireSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new brief illness perception questionnaire if no brief illness perception questionnaire is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireSingleResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/collection", "GET")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireGetCollection implements IReturn<BriefIllnessPerceptionQuestionnaireCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireCollectionResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireGetCollectionByIds implements IReturn<BriefIllnessPerceptionQuestionnaireCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireCollectionResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireCollectionResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireGetCollectionByCodes implements IReturn<BriefIllnessPerceptionQuestionnaireCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireCollectionResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/save", "POST")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnairePostSave implements IReturn<BriefIllnessPerceptionQuestionnaireSingleResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to save. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnairePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnairePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireSingleResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/save/ids", "POST")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnairePostSaveWithIds implements IReturn<BriefIllnessPerceptionQuestionnaireSingleResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to save. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    /** @description The ID of the Institution associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnairePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnairePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireSingleResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/save/codes", "POST")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireSingleResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnairePostSaveWithCodes implements IReturn<BriefIllnessPerceptionQuestionnaireSingleResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to save. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    /** @description The Code of the Institution associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnairePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnairePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireSingleResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/delete", "DELETE")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireDelete implements IReturn<BriefIllnessPerceptionQuestionnaireDeleteResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to delete. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireDeleteResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireDeleteWithId implements IReturn<BriefIllnessPerceptionQuestionnaireDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireDeleteResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/delete/ids", "DELETE")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireDeleteWithIds implements IReturn<BriefIllnessPerceptionQuestionnaireDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireDeleteResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/delete/codes", "DELETE")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireDeleteResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnaireDeleteByCodes implements IReturn<BriefIllnessPerceptionQuestionnaireDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnaireDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnaireDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireDeleteResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/validate", "POST")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnairePostValidate implements IReturn<BriefIllnessPerceptionQuestionnaireValidationResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to validate. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnairePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnairePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireValidationResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/validate/ids", "POST")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnairePostValidateWithIds implements IReturn<BriefIllnessPerceptionQuestionnaireValidationResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to validate. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    /** @description The ID of the Institution associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnairePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnairePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireValidationResponse(); }
}

// @Route("/opms/form/brief-illness-perception-questionnaire/validate/codes", "POST")
// @Api(Description="Form - Brief Illness Perception Questionnaire")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BriefIllnessPerceptionQuestionnaireValidationResponse)", StatusCode=500)
// @DataContract
export class BriefIllnessPerceptionQuestionnairePostValidateWithCodes implements IReturn<BriefIllnessPerceptionQuestionnaireValidationResponse>
{
    [immerable]? = true;

    /** @description The brief illness perception questionnaire to validate. */
    // @DataMember(Order=1)
    public form: BriefIllnessPerceptionQuestionnaire;

    /** @description The Code of the Institution associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the brief illness perception questionnaire to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BriefIllnessPerceptionQuestionnairePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BriefIllnessPerceptionQuestionnairePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BriefIllnessPerceptionQuestionnaireValidationResponse(); }
}

// @Route("/opms/form/decision-regret-scale/single/id/{Id}", "GET")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleGetSingleById implements IReturn<DecisionRegretScaleSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<DecisionRegretScaleGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DecisionRegretScaleSingleResponse(); }
}

// @Route("/opms/form/decision-regret-scale/single/ids", "GET")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleGetSingleByIds implements IReturn<DecisionRegretScaleSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the decision regret scale to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new decision regret scale if no decision regret scale is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<DecisionRegretScaleGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DecisionRegretScaleSingleResponse(); }
}

// @Route("/opms/form/decision-regret-scale/single/codes", "GET")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleGetSingleByCodes implements IReturn<DecisionRegretScaleSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the decision regret scale to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new decision regret scale if no decision regret scale is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<DecisionRegretScaleGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DecisionRegretScaleSingleResponse(); }
}

// @Route("/opms/form/decision-regret-scale/collection", "GET")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleGetCollection implements IReturn<DecisionRegretScaleCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<DecisionRegretScaleGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DecisionRegretScaleCollectionResponse(); }
}

// @Route("/opms/form/decision-regret-scale/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleGetCollectionByIds implements IReturn<DecisionRegretScaleCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<DecisionRegretScaleGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DecisionRegretScaleCollectionResponse(); }
}

// @Route("/opms/form/decision-regret-scale/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleCollectionResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleGetCollectionByCodes implements IReturn<DecisionRegretScaleCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<DecisionRegretScaleGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DecisionRegretScaleCollectionResponse(); }
}

// @Route("/opms/form/decision-regret-scale/save", "POST")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScalePostSave implements IReturn<DecisionRegretScaleSingleResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to save. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    public constructor(init?: Partial<DecisionRegretScalePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScalePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DecisionRegretScaleSingleResponse(); }
}

// @Route("/opms/form/decision-regret-scale/save/ids", "POST")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScalePostSaveWithIds implements IReturn<DecisionRegretScaleSingleResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to save. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    /** @description The ID of the Institution associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the decision regret scale to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<DecisionRegretScalePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScalePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DecisionRegretScaleSingleResponse(); }
}

// @Route("/opms/form/decision-regret-scale/save/codes", "POST")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleSingleResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScalePostSaveWithCodes implements IReturn<DecisionRegretScaleSingleResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to save. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    /** @description The Code of the Institution associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the decision regret scale to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<DecisionRegretScalePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScalePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DecisionRegretScaleSingleResponse(); }
}

// @Route("/opms/form/decision-regret-scale/delete", "DELETE")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleDelete implements IReturn<DecisionRegretScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to delete. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    public constructor(init?: Partial<DecisionRegretScaleDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DecisionRegretScaleDeleteResponse(); }
}

// @Route("/opms/form/decision-regret-scale/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleDeleteWithId implements IReturn<DecisionRegretScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<DecisionRegretScaleDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DecisionRegretScaleDeleteResponse(); }
}

// @Route("/opms/form/decision-regret-scale/delete/ids", "DELETE")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleDeleteWithIds implements IReturn<DecisionRegretScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<DecisionRegretScaleDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DecisionRegretScaleDeleteResponse(); }
}

// @Route("/opms/form/decision-regret-scale/delete/codes", "DELETE")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleDeleteResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScaleDeleteByCodes implements IReturn<DecisionRegretScaleDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the decision regret scale to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<DecisionRegretScaleDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScaleDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DecisionRegretScaleDeleteResponse(); }
}

// @Route("/opms/form/decision-regret-scale/validate", "POST")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScalePostValidate implements IReturn<DecisionRegretScaleValidationResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to validate. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    public constructor(init?: Partial<DecisionRegretScalePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScalePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DecisionRegretScaleValidationResponse(); }
}

// @Route("/opms/form/decision-regret-scale/validate/ids", "POST")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScalePostValidateWithIds implements IReturn<DecisionRegretScaleValidationResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to validate. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    /** @description The ID of the Institution associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<DecisionRegretScalePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScalePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DecisionRegretScaleValidationResponse(); }
}

// @Route("/opms/form/decision-regret-scale/validate/codes", "POST")
// @Api(Description="Form - Decision Regret Scale")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DecisionRegretScaleValidationResponse)", StatusCode=500)
// @DataContract
export class DecisionRegretScalePostValidateWithCodes implements IReturn<DecisionRegretScaleValidationResponse>
{
    [immerable]? = true;

    /** @description The decision regret scale to validate. */
    // @DataMember(Order=1)
    public form: DecisionRegretScale;

    /** @description The Code of the Institution associated with the decision regret scale to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the decision regret scale to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the decision regret scale to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the decision regret scale to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<DecisionRegretScalePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DecisionRegretScalePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DecisionRegretScaleValidationResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/single/id/{Id}", "GET")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceGetSingleById implements IReturn<EndocrineTherapyAdherenceSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherenceGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndocrineTherapyAdherenceSingleResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/single/ids", "GET")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceGetSingleByIds implements IReturn<EndocrineTherapyAdherenceSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new endocrine therapy adherence if no endocrine therapy adherence is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EndocrineTherapyAdherenceGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndocrineTherapyAdherenceSingleResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/single/codes", "GET")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceGetSingleByCodes implements IReturn<EndocrineTherapyAdherenceSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new endocrine therapy adherence if no endocrine therapy adherence is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EndocrineTherapyAdherenceGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndocrineTherapyAdherenceSingleResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/collection", "GET")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceGetCollection implements IReturn<EndocrineTherapyAdherenceCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EndocrineTherapyAdherenceGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndocrineTherapyAdherenceCollectionResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceGetCollectionByIds implements IReturn<EndocrineTherapyAdherenceCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherenceGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndocrineTherapyAdherenceCollectionResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceCollectionResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceGetCollectionByCodes implements IReturn<EndocrineTherapyAdherenceCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherenceGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EndocrineTherapyAdherenceCollectionResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/save", "POST")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherencePostSave implements IReturn<EndocrineTherapyAdherenceSingleResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to save. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    public constructor(init?: Partial<EndocrineTherapyAdherencePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherencePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndocrineTherapyAdherenceSingleResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/save/ids", "POST")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherencePostSaveWithIds implements IReturn<EndocrineTherapyAdherenceSingleResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to save. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    /** @description The ID of the Institution associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EndocrineTherapyAdherencePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherencePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndocrineTherapyAdherenceSingleResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/save/codes", "POST")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceSingleResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherencePostSaveWithCodes implements IReturn<EndocrineTherapyAdherenceSingleResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to save. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    /** @description The Code of the Institution associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EndocrineTherapyAdherencePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherencePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndocrineTherapyAdherenceSingleResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/delete", "DELETE")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceDelete implements IReturn<EndocrineTherapyAdherenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to delete. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    public constructor(init?: Partial<EndocrineTherapyAdherenceDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndocrineTherapyAdherenceDeleteResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceDeleteWithId implements IReturn<EndocrineTherapyAdherenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherenceDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndocrineTherapyAdherenceDeleteResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/delete/ids", "DELETE")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceDeleteWithIds implements IReturn<EndocrineTherapyAdherenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherenceDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndocrineTherapyAdherenceDeleteResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/delete/codes", "DELETE")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceDeleteResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherenceDeleteByCodes implements IReturn<EndocrineTherapyAdherenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherenceDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherenceDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EndocrineTherapyAdherenceDeleteResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/validate", "POST")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherencePostValidate implements IReturn<EndocrineTherapyAdherenceValidationResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to validate. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    public constructor(init?: Partial<EndocrineTherapyAdherencePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherencePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndocrineTherapyAdherenceValidationResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/validate/ids", "POST")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherencePostValidateWithIds implements IReturn<EndocrineTherapyAdherenceValidationResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to validate. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    /** @description The ID of the Institution associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherencePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherencePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndocrineTherapyAdherenceValidationResponse(); }
}

// @Route("/opms/form/endocrine-therapy-adherence/validate/codes", "POST")
// @Api(Description="Form - Endocrine Therapy Adherence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EndocrineTherapyAdherenceValidationResponse)", StatusCode=500)
// @DataContract
export class EndocrineTherapyAdherencePostValidateWithCodes implements IReturn<EndocrineTherapyAdherenceValidationResponse>
{
    [immerable]? = true;

    /** @description The endocrine therapy adherence to validate. */
    // @DataMember(Order=1)
    public form: EndocrineTherapyAdherence;

    /** @description The Code of the Institution associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the endocrine therapy adherence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EndocrineTherapyAdherencePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EndocrineTherapyAdherencePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EndocrineTherapyAdherenceValidationResponse(); }
}

// @Route("/opms/form/eortc-i-l353/single/id/{Id}", "GET")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=500)
// @DataContract
export class EortcIL353GetSingleById implements IReturn<EortcIL353SingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EortcIL353GetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353GetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EortcIL353SingleResponse(); }
}

// @Route("/opms/form/eortc-i-l353/single/ids", "GET")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=500)
// @DataContract
export class EortcIL353GetSingleByIds implements IReturn<EortcIL353SingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the eortc i l353 to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new eortc i l353 if no eortc i l353 is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EortcIL353GetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353GetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EortcIL353SingleResponse(); }
}

// @Route("/opms/form/eortc-i-l353/single/codes", "GET")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=500)
// @DataContract
export class EortcIL353GetSingleByCodes implements IReturn<EortcIL353SingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the eortc i l353 to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new eortc i l353 if no eortc i l353 is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EortcIL353GetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353GetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EortcIL353SingleResponse(); }
}

// @Route("/opms/form/eortc-i-l353/collection", "GET")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=500)
// @DataContract
export class EortcIL353GetCollection implements IReturn<EortcIL353CollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EortcIL353GetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353GetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EortcIL353CollectionResponse(); }
}

// @Route("/opms/form/eortc-i-l353/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=500)
// @DataContract
export class EortcIL353GetCollectionByIds implements IReturn<EortcIL353CollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EortcIL353GetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353GetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EortcIL353CollectionResponse(); }
}

// @Route("/opms/form/eortc-i-l353/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353CollectionResponse)", StatusCode=500)
// @DataContract
export class EortcIL353GetCollectionByCodes implements IReturn<EortcIL353CollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EortcIL353GetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353GetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EortcIL353CollectionResponse(); }
}

// @Route("/opms/form/eortc-i-l353/save", "POST")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=500)
// @DataContract
export class EortcIL353PostSave implements IReturn<EortcIL353SingleResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to save. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    public constructor(init?: Partial<EortcIL353PostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353PostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EortcIL353SingleResponse(); }
}

// @Route("/opms/form/eortc-i-l353/save/ids", "POST")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=500)
// @DataContract
export class EortcIL353PostSaveWithIds implements IReturn<EortcIL353SingleResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to save. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    /** @description The ID of the Institution associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the eortc i l353 to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EortcIL353PostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353PostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EortcIL353SingleResponse(); }
}

// @Route("/opms/form/eortc-i-l353/save/codes", "POST")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353SingleResponse)", StatusCode=500)
// @DataContract
export class EortcIL353PostSaveWithCodes implements IReturn<EortcIL353SingleResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to save. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    /** @description The Code of the Institution associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the eortc i l353 to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EortcIL353PostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353PostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EortcIL353SingleResponse(); }
}

// @Route("/opms/form/eortc-i-l353/delete", "DELETE")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=500)
// @DataContract
export class EortcIL353Delete implements IReturn<EortcIL353DeleteResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to delete. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    public constructor(init?: Partial<EortcIL353Delete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353Delete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EortcIL353DeleteResponse(); }
}

// @Route("/opms/form/eortc-i-l353/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=500)
// @DataContract
export class EortcIL353DeleteWithId implements IReturn<EortcIL353DeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EortcIL353DeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353DeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EortcIL353DeleteResponse(); }
}

// @Route("/opms/form/eortc-i-l353/delete/ids", "DELETE")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=500)
// @DataContract
export class EortcIL353DeleteWithIds implements IReturn<EortcIL353DeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EortcIL353DeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353DeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EortcIL353DeleteResponse(); }
}

// @Route("/opms/form/eortc-i-l353/delete/codes", "DELETE")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353DeleteResponse)", StatusCode=500)
// @DataContract
export class EortcIL353DeleteByCodes implements IReturn<EortcIL353DeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the eortc i l353 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EortcIL353DeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353DeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EortcIL353DeleteResponse(); }
}

// @Route("/opms/form/eortc-i-l353/validate", "POST")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=500)
// @DataContract
export class EortcIL353PostValidate implements IReturn<EortcIL353ValidationResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to validate. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    public constructor(init?: Partial<EortcIL353PostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353PostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EortcIL353ValidationResponse(); }
}

// @Route("/opms/form/eortc-i-l353/validate/ids", "POST")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=500)
// @DataContract
export class EortcIL353PostValidateWithIds implements IReturn<EortcIL353ValidationResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to validate. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    /** @description The ID of the Institution associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EortcIL353PostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353PostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EortcIL353ValidationResponse(); }
}

// @Route("/opms/form/eortc-i-l353/validate/codes", "POST")
// @Api(Description="Form - Eortc I L353")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EortcIL353ValidationResponse)", StatusCode=500)
// @DataContract
export class EortcIL353PostValidateWithCodes implements IReturn<EortcIL353ValidationResponse>
{
    [immerable]? = true;

    /** @description The eortc i l353 to validate. */
    // @DataMember(Order=1)
    public form: EortcIL353;

    /** @description The Code of the Institution associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the eortc i l353 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EortcIL353PostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EortcIL353PostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EortcIL353ValidationResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/single/id/{Id}", "GET")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LGetSingleById implements IReturn<EQ5D5LSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EQ5D5LGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EQ5D5LSingleResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/single/ids", "GET")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LGetSingleByIds implements IReturn<EQ5D5LSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the e q5 d5 l to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new e q5 d5 l if no e q5 d5 l is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EQ5D5LGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EQ5D5LSingleResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/single/codes", "GET")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LGetSingleByCodes implements IReturn<EQ5D5LSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the e q5 d5 l to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new e q5 d5 l if no e q5 d5 l is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<EQ5D5LGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EQ5D5LSingleResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/collection", "GET")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LGetCollection implements IReturn<EQ5D5LCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<EQ5D5LGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EQ5D5LCollectionResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LGetCollectionByIds implements IReturn<EQ5D5LCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EQ5D5LGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EQ5D5LCollectionResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LCollectionResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LGetCollectionByCodes implements IReturn<EQ5D5LCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<EQ5D5LGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EQ5D5LCollectionResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/save", "POST")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LPostSave implements IReturn<EQ5D5LSingleResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to save. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    public constructor(init?: Partial<EQ5D5LPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EQ5D5LSingleResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/save/ids", "POST")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LPostSaveWithIds implements IReturn<EQ5D5LSingleResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to save. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    /** @description The ID of the Institution associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EQ5D5LPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EQ5D5LSingleResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/save/codes", "POST")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LSingleResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LPostSaveWithCodes implements IReturn<EQ5D5LSingleResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to save. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    /** @description The Code of the Institution associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<EQ5D5LPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EQ5D5LSingleResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/delete", "DELETE")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LDelete implements IReturn<EQ5D5LDeleteResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to delete. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    public constructor(init?: Partial<EQ5D5LDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EQ5D5LDeleteResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/delete/id/{Id}", "DELETE")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LDeleteWithId implements IReturn<EQ5D5LDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EQ5D5LDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EQ5D5LDeleteResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/delete/ids", "DELETE")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LDeleteWithIds implements IReturn<EQ5D5LDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EQ5D5LDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EQ5D5LDeleteResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/delete/codes", "DELETE")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LDeleteResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LDeleteByCodes implements IReturn<EQ5D5LDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<EQ5D5LDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new EQ5D5LDeleteResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/validate", "POST")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LPostValidate implements IReturn<EQ5D5LValidationResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to validate. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    public constructor(init?: Partial<EQ5D5LPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EQ5D5LValidationResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/validate/ids", "POST")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LPostValidateWithIds implements IReturn<EQ5D5LValidationResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to validate. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    /** @description The ID of the Institution associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EQ5D5LPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EQ5D5LValidationResponse(); }
}

// @Route("/opms/form/e-q5-d5-l/validate/codes", "POST")
// @Api(Description="Form - E Q5 D5 L")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.EQ5D5LValidationResponse)", StatusCode=500)
// @DataContract
export class EQ5D5LPostValidateWithCodes implements IReturn<EQ5D5LValidationResponse>
{
    [immerable]? = true;

    /** @description The e q5 d5 l to validate. */
    // @DataMember(Order=1)
    public form: EQ5D5L;

    /** @description The Code of the Institution associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the e q5 d5 l to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<EQ5D5LPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EQ5D5LPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new EQ5D5LValidationResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/single/id/{Id}", "GET")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentGetSingleById implements IReturn<ExperienceAndImpactOfTreatmentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentSingleResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/single/ids", "GET")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentGetSingleByIds implements IReturn<ExperienceAndImpactOfTreatmentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the experience and impact of treatment to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new experience and impact of treatment if no experience and impact of treatment is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentSingleResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/single/codes", "GET")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentGetSingleByCodes implements IReturn<ExperienceAndImpactOfTreatmentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the experience and impact of treatment to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new experience and impact of treatment if no experience and impact of treatment is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentSingleResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/collection", "GET")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentGetCollection implements IReturn<ExperienceAndImpactOfTreatmentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentCollectionResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentGetCollectionByIds implements IReturn<ExperienceAndImpactOfTreatmentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentCollectionResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentCollectionResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentGetCollectionByCodes implements IReturn<ExperienceAndImpactOfTreatmentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentCollectionResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/save", "POST")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentPostSave implements IReturn<ExperienceAndImpactOfTreatmentSingleResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to save. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentSingleResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/save/ids", "POST")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentPostSaveWithIds implements IReturn<ExperienceAndImpactOfTreatmentSingleResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to save. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    /** @description The ID of the Institution associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentSingleResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/save/codes", "POST")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentSingleResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentPostSaveWithCodes implements IReturn<ExperienceAndImpactOfTreatmentSingleResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to save. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    /** @description The Code of the Institution associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentSingleResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/delete", "DELETE")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentDelete implements IReturn<ExperienceAndImpactOfTreatmentDeleteResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to delete. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentDeleteResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentDeleteWithId implements IReturn<ExperienceAndImpactOfTreatmentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentDeleteResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/delete/ids", "DELETE")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentDeleteWithIds implements IReturn<ExperienceAndImpactOfTreatmentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentDeleteResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/delete/codes", "DELETE")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentDeleteResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentDeleteByCodes implements IReturn<ExperienceAndImpactOfTreatmentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentDeleteResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/validate", "POST")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentPostValidate implements IReturn<ExperienceAndImpactOfTreatmentValidationResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to validate. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentValidationResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/validate/ids", "POST")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentPostValidateWithIds implements IReturn<ExperienceAndImpactOfTreatmentValidationResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to validate. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    /** @description The ID of the Institution associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentValidationResponse(); }
}

// @Route("/opms/form/experience-and-impact-of-treatment/validate/codes", "POST")
// @Api(Description="Form - Experience And Impact Of Treatment")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ExperienceAndImpactOfTreatmentValidationResponse)", StatusCode=500)
// @DataContract
export class ExperienceAndImpactOfTreatmentPostValidateWithCodes implements IReturn<ExperienceAndImpactOfTreatmentValidationResponse>
{
    [immerable]? = true;

    /** @description The experience and impact of treatment to validate. */
    // @DataMember(Order=1)
    public form: ExperienceAndImpactOfTreatment;

    /** @description The Code of the Institution associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the experience and impact of treatment to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ExperienceAndImpactOfTreatmentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ExperienceAndImpactOfTreatmentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ExperienceAndImpactOfTreatmentValidationResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/single/id/{Id}", "GET")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceGetSingleById implements IReturn<FearOfCancerRecurrenceSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FearOfCancerRecurrenceGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FearOfCancerRecurrenceSingleResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/single/ids", "GET")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceGetSingleByIds implements IReturn<FearOfCancerRecurrenceSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new fear of cancer recurrence if no fear of cancer recurrence is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<FearOfCancerRecurrenceGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FearOfCancerRecurrenceSingleResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/single/codes", "GET")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceGetSingleByCodes implements IReturn<FearOfCancerRecurrenceSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new fear of cancer recurrence if no fear of cancer recurrence is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<FearOfCancerRecurrenceGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FearOfCancerRecurrenceSingleResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/collection", "GET")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceGetCollection implements IReturn<FearOfCancerRecurrenceCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<FearOfCancerRecurrenceGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FearOfCancerRecurrenceCollectionResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceGetCollectionByIds implements IReturn<FearOfCancerRecurrenceCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<FearOfCancerRecurrenceGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FearOfCancerRecurrenceCollectionResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceCollectionResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceGetCollectionByCodes implements IReturn<FearOfCancerRecurrenceCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<FearOfCancerRecurrenceGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FearOfCancerRecurrenceCollectionResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/save", "POST")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrencePostSave implements IReturn<FearOfCancerRecurrenceSingleResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to save. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    public constructor(init?: Partial<FearOfCancerRecurrencePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrencePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FearOfCancerRecurrenceSingleResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/save/ids", "POST")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrencePostSaveWithIds implements IReturn<FearOfCancerRecurrenceSingleResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to save. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    /** @description The ID of the Institution associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<FearOfCancerRecurrencePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrencePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FearOfCancerRecurrenceSingleResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/save/codes", "POST")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceSingleResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrencePostSaveWithCodes implements IReturn<FearOfCancerRecurrenceSingleResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to save. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    /** @description The Code of the Institution associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<FearOfCancerRecurrencePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrencePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FearOfCancerRecurrenceSingleResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/delete", "DELETE")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceDelete implements IReturn<FearOfCancerRecurrenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to delete. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    public constructor(init?: Partial<FearOfCancerRecurrenceDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FearOfCancerRecurrenceDeleteResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceDeleteWithId implements IReturn<FearOfCancerRecurrenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<FearOfCancerRecurrenceDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FearOfCancerRecurrenceDeleteResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/delete/ids", "DELETE")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceDeleteWithIds implements IReturn<FearOfCancerRecurrenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<FearOfCancerRecurrenceDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FearOfCancerRecurrenceDeleteResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/delete/codes", "DELETE")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceDeleteResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrenceDeleteByCodes implements IReturn<FearOfCancerRecurrenceDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<FearOfCancerRecurrenceDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrenceDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new FearOfCancerRecurrenceDeleteResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/validate", "POST")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrencePostValidate implements IReturn<FearOfCancerRecurrenceValidationResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to validate. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    public constructor(init?: Partial<FearOfCancerRecurrencePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrencePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FearOfCancerRecurrenceValidationResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/validate/ids", "POST")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrencePostValidateWithIds implements IReturn<FearOfCancerRecurrenceValidationResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to validate. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    /** @description The ID of the Institution associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<FearOfCancerRecurrencePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrencePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FearOfCancerRecurrenceValidationResponse(); }
}

// @Route("/opms/form/fear-of-cancer-recurrence/validate/codes", "POST")
// @Api(Description="Form - Fear Of Cancer Recurrence")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.FearOfCancerRecurrenceValidationResponse)", StatusCode=500)
// @DataContract
export class FearOfCancerRecurrencePostValidateWithCodes implements IReturn<FearOfCancerRecurrenceValidationResponse>
{
    [immerable]? = true;

    /** @description The fear of cancer recurrence to validate. */
    // @DataMember(Order=1)
    public form: FearOfCancerRecurrence;

    /** @description The Code of the Institution associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the fear of cancer recurrence to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<FearOfCancerRecurrencePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FearOfCancerRecurrencePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new FearOfCancerRecurrenceValidationResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/single/id/{Id}", "GET")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2GetSingleById implements IReturn<GeneralizedAnxietyDisorder2SingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2GetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2GetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2SingleResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/single/ids", "GET")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2GetSingleByIds implements IReturn<GeneralizedAnxietyDisorder2SingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new generalized anxiety disorder2 if no generalized anxiety disorder2 is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2GetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2GetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2SingleResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/single/codes", "GET")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2GetSingleByCodes implements IReturn<GeneralizedAnxietyDisorder2SingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new generalized anxiety disorder2 if no generalized anxiety disorder2 is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2GetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2GetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2SingleResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/collection", "GET")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2GetCollection implements IReturn<GeneralizedAnxietyDisorder2CollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<GeneralizedAnxietyDisorder2GetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2GetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2CollectionResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2GetCollectionByIds implements IReturn<GeneralizedAnxietyDisorder2CollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2GetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2GetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2CollectionResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2CollectionResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2GetCollectionByCodes implements IReturn<GeneralizedAnxietyDisorder2CollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2GetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2GetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2CollectionResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/save", "POST")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2PostSave implements IReturn<GeneralizedAnxietyDisorder2SingleResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to save. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2PostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2PostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2SingleResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/save/ids", "POST")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2PostSaveWithIds implements IReturn<GeneralizedAnxietyDisorder2SingleResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to save. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    /** @description The ID of the Institution associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2PostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2PostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2SingleResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/save/codes", "POST")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2SingleResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2PostSaveWithCodes implements IReturn<GeneralizedAnxietyDisorder2SingleResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to save. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    /** @description The Code of the Institution associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2PostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2PostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2SingleResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/delete", "DELETE")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2Delete implements IReturn<GeneralizedAnxietyDisorder2DeleteResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to delete. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2Delete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2Delete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2DeleteResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2DeleteWithId implements IReturn<GeneralizedAnxietyDisorder2DeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2DeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2DeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2DeleteResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/delete/ids", "DELETE")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2DeleteWithIds implements IReturn<GeneralizedAnxietyDisorder2DeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2DeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2DeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2DeleteResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/delete/codes", "DELETE")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2DeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2DeleteByCodes implements IReturn<GeneralizedAnxietyDisorder2DeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2DeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2DeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2DeleteResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/validate", "POST")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2PostValidate implements IReturn<GeneralizedAnxietyDisorder2ValidationResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to validate. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2PostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2PostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2ValidationResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/validate/ids", "POST")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2PostValidateWithIds implements IReturn<GeneralizedAnxietyDisorder2ValidationResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to validate. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    /** @description The ID of the Institution associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2PostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2PostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2ValidationResponse(); }
}

// @Route("/opms/form/generalized-anxiety-disorder2/validate/codes", "POST")
// @Api(Description="Form - Generalized Anxiety Disorder2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralizedAnxietyDisorder2ValidationResponse)", StatusCode=500)
// @DataContract
export class GeneralizedAnxietyDisorder2PostValidateWithCodes implements IReturn<GeneralizedAnxietyDisorder2ValidationResponse>
{
    [immerable]? = true;

    /** @description The generalized anxiety disorder2 to validate. */
    // @DataMember(Order=1)
    public form: GeneralizedAnxietyDisorder2;

    /** @description The Code of the Institution associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the generalized anxiety disorder2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralizedAnxietyDisorder2PostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralizedAnxietyDisorder2PostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralizedAnxietyDisorder2ValidationResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/single/id/{Id}", "GET")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolGetSingleById implements IReturn<InternationalPersonalityItemPoolSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InternationalPersonalityItemPoolSingleResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/single/ids", "GET")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolGetSingleByIds implements IReturn<InternationalPersonalityItemPoolSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the international personality item pool to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new international personality item pool if no international personality item pool is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<InternationalPersonalityItemPoolGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InternationalPersonalityItemPoolSingleResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/single/codes", "GET")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolGetSingleByCodes implements IReturn<InternationalPersonalityItemPoolSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the international personality item pool to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new international personality item pool if no international personality item pool is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<InternationalPersonalityItemPoolGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InternationalPersonalityItemPoolSingleResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/collection", "GET")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolGetCollection implements IReturn<InternationalPersonalityItemPoolCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<InternationalPersonalityItemPoolGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InternationalPersonalityItemPoolCollectionResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolGetCollectionByIds implements IReturn<InternationalPersonalityItemPoolCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InternationalPersonalityItemPoolCollectionResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolCollectionResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolGetCollectionByCodes implements IReturn<InternationalPersonalityItemPoolCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InternationalPersonalityItemPoolCollectionResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/save", "POST")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolPostSave implements IReturn<InternationalPersonalityItemPoolSingleResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to save. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    public constructor(init?: Partial<InternationalPersonalityItemPoolPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InternationalPersonalityItemPoolSingleResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/save/ids", "POST")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolPostSaveWithIds implements IReturn<InternationalPersonalityItemPoolSingleResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to save. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    /** @description The ID of the Institution associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the international personality item pool to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<InternationalPersonalityItemPoolPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InternationalPersonalityItemPoolSingleResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/save/codes", "POST")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolSingleResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolPostSaveWithCodes implements IReturn<InternationalPersonalityItemPoolSingleResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to save. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    /** @description The Code of the Institution associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the international personality item pool to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<InternationalPersonalityItemPoolPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InternationalPersonalityItemPoolSingleResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/delete", "DELETE")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolDelete implements IReturn<InternationalPersonalityItemPoolDeleteResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to delete. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    public constructor(init?: Partial<InternationalPersonalityItemPoolDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new InternationalPersonalityItemPoolDeleteResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/delete/id/{Id}", "DELETE")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolDeleteWithId implements IReturn<InternationalPersonalityItemPoolDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new InternationalPersonalityItemPoolDeleteResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/delete/ids", "DELETE")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolDeleteWithIds implements IReturn<InternationalPersonalityItemPoolDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new InternationalPersonalityItemPoolDeleteResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/delete/codes", "DELETE")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolDeleteResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolDeleteByCodes implements IReturn<InternationalPersonalityItemPoolDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the international personality item pool to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new InternationalPersonalityItemPoolDeleteResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/validate", "POST")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolPostValidate implements IReturn<InternationalPersonalityItemPoolValidationResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to validate. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    public constructor(init?: Partial<InternationalPersonalityItemPoolPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InternationalPersonalityItemPoolValidationResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/validate/ids", "POST")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolPostValidateWithIds implements IReturn<InternationalPersonalityItemPoolValidationResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to validate. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    /** @description The ID of the Institution associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InternationalPersonalityItemPoolValidationResponse(); }
}

// @Route("/opms/form/international-personality-item-pool/validate/codes", "POST")
// @Api(Description="Form - International Personality Item Pool")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.InternationalPersonalityItemPoolValidationResponse)", StatusCode=500)
// @DataContract
export class InternationalPersonalityItemPoolPostValidateWithCodes implements IReturn<InternationalPersonalityItemPoolValidationResponse>
{
    [immerable]? = true;

    /** @description The international personality item pool to validate. */
    // @DataMember(Order=1)
    public form: InternationalPersonalityItemPool;

    /** @description The Code of the Institution associated with the international personality item pool to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the international personality item pool to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the international personality item pool to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the international personality item pool to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<InternationalPersonalityItemPoolPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'InternationalPersonalityItemPoolPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new InternationalPersonalityItemPoolValidationResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/single/id/{Id}", "GET")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2GetSingleById implements IReturn<PatientHealthQuestionnaire2SingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2GetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2GetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientHealthQuestionnaire2SingleResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/single/ids", "GET")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2GetSingleByIds implements IReturn<PatientHealthQuestionnaire2SingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new patient health questionnaire2 if no patient health questionnaire2 is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PatientHealthQuestionnaire2GetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2GetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientHealthQuestionnaire2SingleResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/single/codes", "GET")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2GetSingleByCodes implements IReturn<PatientHealthQuestionnaire2SingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new patient health questionnaire2 if no patient health questionnaire2 is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PatientHealthQuestionnaire2GetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2GetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientHealthQuestionnaire2SingleResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/collection", "GET")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2GetCollection implements IReturn<PatientHealthQuestionnaire2CollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PatientHealthQuestionnaire2GetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2GetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientHealthQuestionnaire2CollectionResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2GetCollectionByIds implements IReturn<PatientHealthQuestionnaire2CollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2GetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2GetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientHealthQuestionnaire2CollectionResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2CollectionResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2GetCollectionByCodes implements IReturn<PatientHealthQuestionnaire2CollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2GetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2GetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PatientHealthQuestionnaire2CollectionResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/save", "POST")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2PostSave implements IReturn<PatientHealthQuestionnaire2SingleResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to save. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    public constructor(init?: Partial<PatientHealthQuestionnaire2PostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2PostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientHealthQuestionnaire2SingleResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/save/ids", "POST")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2PostSaveWithIds implements IReturn<PatientHealthQuestionnaire2SingleResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to save. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    /** @description The ID of the Institution associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PatientHealthQuestionnaire2PostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2PostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientHealthQuestionnaire2SingleResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/save/codes", "POST")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2SingleResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2PostSaveWithCodes implements IReturn<PatientHealthQuestionnaire2SingleResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to save. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    /** @description The Code of the Institution associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PatientHealthQuestionnaire2PostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2PostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientHealthQuestionnaire2SingleResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/delete", "DELETE")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2Delete implements IReturn<PatientHealthQuestionnaire2DeleteResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to delete. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    public constructor(init?: Partial<PatientHealthQuestionnaire2Delete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2Delete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PatientHealthQuestionnaire2DeleteResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2DeleteWithId implements IReturn<PatientHealthQuestionnaire2DeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2DeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2DeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PatientHealthQuestionnaire2DeleteResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/delete/ids", "DELETE")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2DeleteWithIds implements IReturn<PatientHealthQuestionnaire2DeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2DeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2DeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PatientHealthQuestionnaire2DeleteResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/delete/codes", "DELETE")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2DeleteResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2DeleteByCodes implements IReturn<PatientHealthQuestionnaire2DeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2DeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2DeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PatientHealthQuestionnaire2DeleteResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/validate", "POST")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2PostValidate implements IReturn<PatientHealthQuestionnaire2ValidationResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to validate. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    public constructor(init?: Partial<PatientHealthQuestionnaire2PostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2PostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientHealthQuestionnaire2ValidationResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/validate/ids", "POST")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2PostValidateWithIds implements IReturn<PatientHealthQuestionnaire2ValidationResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to validate. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    /** @description The ID of the Institution associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2PostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2PostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientHealthQuestionnaire2ValidationResponse(); }
}

// @Route("/opms/form/patient-health-questionnaire2/validate/codes", "POST")
// @Api(Description="Form - Patient Health Questionnaire2")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PatientHealthQuestionnaire2ValidationResponse)", StatusCode=500)
// @DataContract
export class PatientHealthQuestionnaire2PostValidateWithCodes implements IReturn<PatientHealthQuestionnaire2ValidationResponse>
{
    [immerable]? = true;

    /** @description The patient health questionnaire2 to validate. */
    // @DataMember(Order=1)
    public form: PatientHealthQuestionnaire2;

    /** @description The Code of the Institution associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the patient health questionnaire2 to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PatientHealthQuestionnaire2PostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PatientHealthQuestionnaire2PostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PatientHealthQuestionnaire2ValidationResponse(); }
}

// @Route("/opms/form/risk-appraisal/single/id/{Id}", "GET")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalGetSingleById implements IReturn<RiskAppraisalSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RiskAppraisalGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RiskAppraisalSingleResponse(); }
}

// @Route("/opms/form/risk-appraisal/single/ids", "GET")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalGetSingleByIds implements IReturn<RiskAppraisalSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the risk appraisal to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new risk appraisal if no risk appraisal is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RiskAppraisalGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RiskAppraisalSingleResponse(); }
}

// @Route("/opms/form/risk-appraisal/single/codes", "GET")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalGetSingleByCodes implements IReturn<RiskAppraisalSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the risk appraisal to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new risk appraisal if no risk appraisal is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RiskAppraisalGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RiskAppraisalSingleResponse(); }
}

// @Route("/opms/form/risk-appraisal/collection", "GET")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalGetCollection implements IReturn<RiskAppraisalCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<RiskAppraisalGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RiskAppraisalCollectionResponse(); }
}

// @Route("/opms/form/risk-appraisal/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalGetCollectionByIds implements IReturn<RiskAppraisalCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RiskAppraisalGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RiskAppraisalCollectionResponse(); }
}

// @Route("/opms/form/risk-appraisal/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalCollectionResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalGetCollectionByCodes implements IReturn<RiskAppraisalCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RiskAppraisalGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RiskAppraisalCollectionResponse(); }
}

// @Route("/opms/form/risk-appraisal/save", "POST")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalPostSave implements IReturn<RiskAppraisalSingleResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to save. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    public constructor(init?: Partial<RiskAppraisalPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RiskAppraisalSingleResponse(); }
}

// @Route("/opms/form/risk-appraisal/save/ids", "POST")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalPostSaveWithIds implements IReturn<RiskAppraisalSingleResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to save. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    /** @description The ID of the Institution associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the risk appraisal to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RiskAppraisalPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RiskAppraisalSingleResponse(); }
}

// @Route("/opms/form/risk-appraisal/save/codes", "POST")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalSingleResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalPostSaveWithCodes implements IReturn<RiskAppraisalSingleResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to save. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    /** @description The Code of the Institution associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the risk appraisal to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RiskAppraisalPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RiskAppraisalSingleResponse(); }
}

// @Route("/opms/form/risk-appraisal/delete", "DELETE")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalDelete implements IReturn<RiskAppraisalDeleteResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to delete. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    public constructor(init?: Partial<RiskAppraisalDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RiskAppraisalDeleteResponse(); }
}

// @Route("/opms/form/risk-appraisal/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalDeleteWithId implements IReturn<RiskAppraisalDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RiskAppraisalDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RiskAppraisalDeleteResponse(); }
}

// @Route("/opms/form/risk-appraisal/delete/ids", "DELETE")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalDeleteWithIds implements IReturn<RiskAppraisalDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RiskAppraisalDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RiskAppraisalDeleteResponse(); }
}

// @Route("/opms/form/risk-appraisal/delete/codes", "DELETE")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalDeleteResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalDeleteByCodes implements IReturn<RiskAppraisalDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the risk appraisal to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RiskAppraisalDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RiskAppraisalDeleteResponse(); }
}

// @Route("/opms/form/risk-appraisal/validate", "POST")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalPostValidate implements IReturn<RiskAppraisalValidationResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to validate. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    public constructor(init?: Partial<RiskAppraisalPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RiskAppraisalValidationResponse(); }
}

// @Route("/opms/form/risk-appraisal/validate/ids", "POST")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalPostValidateWithIds implements IReturn<RiskAppraisalValidationResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to validate. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    /** @description The ID of the Institution associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RiskAppraisalPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RiskAppraisalValidationResponse(); }
}

// @Route("/opms/form/risk-appraisal/validate/codes", "POST")
// @Api(Description="Form - Risk Appraisal")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RiskAppraisalValidationResponse)", StatusCode=500)
// @DataContract
export class RiskAppraisalPostValidateWithCodes implements IReturn<RiskAppraisalValidationResponse>
{
    [immerable]? = true;

    /** @description The risk appraisal to validate. */
    // @DataMember(Order=1)
    public form: RiskAppraisal;

    /** @description The Code of the Institution associated with the risk appraisal to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the risk appraisal to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the risk appraisal to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the risk appraisal to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RiskAppraisalPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RiskAppraisalPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RiskAppraisalValidationResponse(); }
}

// @Route("/opms/form/procomida/single/id/{Id}", "GET")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaGetSingleById implements IReturn<ProcomidaSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the procomida to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProcomidaGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaSingleResponse(); }
}

// @Route("/opms/form/procomida/single/ids", "GET")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaGetSingleByIds implements IReturn<ProcomidaSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the procomida to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new procomida if no procomida is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ProcomidaGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaSingleResponse(); }
}

// @Route("/opms/form/procomida/single/codes", "GET")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaGetSingleByCodes implements IReturn<ProcomidaSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the procomida to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the procomida to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new procomida if no procomida is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ProcomidaGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaSingleResponse(); }
}

// @Route("/opms/form/procomida/collection", "GET")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaGetCollection implements IReturn<ProcomidaCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ProcomidaGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaCollectionResponse(); }
}

// @Route("/opms/form/procomida/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaGetCollectionByIds implements IReturn<ProcomidaCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaCollectionResponse(); }
}

// @Route("/opms/form/procomida/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaGetCollectionByCodes implements IReturn<ProcomidaCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the procomida to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaCollectionResponse(); }
}

// @Route("/opms/form/procomida/save", "POST")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaPostSave implements IReturn<ProcomidaSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida to save. */
    // @DataMember(Order=1)
    public form: Procomida;

    public constructor(init?: Partial<ProcomidaPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaSingleResponse(); }
}

// @Route("/opms/form/procomida/save/ids", "POST")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaPostSaveWithIds implements IReturn<ProcomidaSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida to save. */
    // @DataMember(Order=1)
    public form: Procomida;

    /** @description The ID of the Institution associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the procomida to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ProcomidaPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaSingleResponse(); }
}

// @Route("/opms/form/procomida/save/codes", "POST")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaPostSaveWithCodes implements IReturn<ProcomidaSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida to save. */
    // @DataMember(Order=1)
    public form: Procomida;

    /** @description The Code of the Institution associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the procomida to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the procomida to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ProcomidaPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaSingleResponse(); }
}

// @Route("/opms/form/procomida/delete", "DELETE")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaDelete implements IReturn<ProcomidaDeleteResponse>
{
    [immerable]? = true;

    /** @description The procomida to delete. */
    // @DataMember(Order=1)
    public form: Procomida;

    public constructor(init?: Partial<ProcomidaDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaDeleteResponse(); }
}

// @Route("/opms/form/procomida/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaDeleteWithId implements IReturn<ProcomidaDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the procomida to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProcomidaDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaDeleteResponse(); }
}

// @Route("/opms/form/procomida/delete/ids", "DELETE")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaDeleteWithIds implements IReturn<ProcomidaDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ProcomidaDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaDeleteResponse(); }
}

// @Route("/opms/form/procomida/delete/codes", "DELETE")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaDeleteByCodes implements IReturn<ProcomidaDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the procomida to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ProcomidaDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaDeleteResponse(); }
}

// @Route("/opms/form/procomida/validate", "POST")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaPostValidate implements IReturn<ProcomidaValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida to validate. */
    // @DataMember(Order=1)
    public form: Procomida;

    public constructor(init?: Partial<ProcomidaPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaValidationResponse(); }
}

// @Route("/opms/form/procomida/validate/ids", "POST")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaPostValidateWithIds implements IReturn<ProcomidaValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida to validate. */
    // @DataMember(Order=1)
    public form: Procomida;

    /** @description The ID of the Institution associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaValidationResponse(); }
}

// @Route("/opms/form/procomida/validate/codes", "POST")
// @Api(Description="Form - Procomida")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaPostValidateWithCodes implements IReturn<ProcomidaValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida to validate. */
    // @DataMember(Order=1)
    public form: Procomida;

    /** @description The Code of the Institution associated with the procomida to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the procomida to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the procomida to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaValidationResponse(); }
}

// @Route("/opms/form/procomida-assistance/single/id/{Id}", "GET")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceGetSingleById implements IReturn<ProcomidaAssistanceSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProcomidaAssistanceGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaAssistanceSingleResponse(); }
}

// @Route("/opms/form/procomida-assistance/single/ids", "GET")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceGetSingleByIds implements IReturn<ProcomidaAssistanceSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the procomida assistance to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new procomida assistance if no procomida assistance is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ProcomidaAssistanceGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaAssistanceSingleResponse(); }
}

// @Route("/opms/form/procomida-assistance/single/codes", "GET")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceGetSingleByCodes implements IReturn<ProcomidaAssistanceSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the procomida assistance to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new procomida assistance if no procomida assistance is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ProcomidaAssistanceGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaAssistanceSingleResponse(); }
}

// @Route("/opms/form/procomida-assistance/collection", "GET")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceGetCollection implements IReturn<ProcomidaAssistanceCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ProcomidaAssistanceGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaAssistanceCollectionResponse(); }
}

// @Route("/opms/form/procomida-assistance/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceGetCollectionByIds implements IReturn<ProcomidaAssistanceCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaAssistanceGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaAssistanceCollectionResponse(); }
}

// @Route("/opms/form/procomida-assistance/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceGetCollectionByCodes implements IReturn<ProcomidaAssistanceCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaAssistanceGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaAssistanceCollectionResponse(); }
}

// @Route("/opms/form/procomida-assistance/save", "POST")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistancePostSave implements IReturn<ProcomidaAssistanceSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to save. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    public constructor(init?: Partial<ProcomidaAssistancePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistancePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaAssistanceSingleResponse(); }
}

// @Route("/opms/form/procomida-assistance/save/ids", "POST")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistancePostSaveWithIds implements IReturn<ProcomidaAssistanceSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to save. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    /** @description The ID of the Institution associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the procomida assistance to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ProcomidaAssistancePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistancePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaAssistanceSingleResponse(); }
}

// @Route("/opms/form/procomida-assistance/save/codes", "POST")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistancePostSaveWithCodes implements IReturn<ProcomidaAssistanceSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to save. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    /** @description The Code of the Institution associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the procomida assistance to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ProcomidaAssistancePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistancePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaAssistanceSingleResponse(); }
}

// @Route("/opms/form/procomida-assistance/delete", "DELETE")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceDelete implements IReturn<ProcomidaAssistanceDeleteResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to delete. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    public constructor(init?: Partial<ProcomidaAssistanceDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaAssistanceDeleteResponse(); }
}

// @Route("/opms/form/procomida-assistance/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceDeleteWithId implements IReturn<ProcomidaAssistanceDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProcomidaAssistanceDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaAssistanceDeleteResponse(); }
}

// @Route("/opms/form/procomida-assistance/delete/ids", "DELETE")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceDeleteWithIds implements IReturn<ProcomidaAssistanceDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ProcomidaAssistanceDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaAssistanceDeleteResponse(); }
}

// @Route("/opms/form/procomida-assistance/delete/codes", "DELETE")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistanceDeleteByCodes implements IReturn<ProcomidaAssistanceDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the procomida assistance to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ProcomidaAssistanceDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistanceDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaAssistanceDeleteResponse(); }
}

// @Route("/opms/form/procomida-assistance/validate", "POST")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistancePostValidate implements IReturn<ProcomidaAssistanceValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to validate. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    public constructor(init?: Partial<ProcomidaAssistancePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistancePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaAssistanceValidationResponse(); }
}

// @Route("/opms/form/procomida-assistance/validate/ids", "POST")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistancePostValidateWithIds implements IReturn<ProcomidaAssistanceValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to validate. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    /** @description The ID of the Institution associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaAssistancePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistancePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaAssistanceValidationResponse(); }
}

// @Route("/opms/form/procomida-assistance/validate/codes", "POST")
// @Api(Description="Form - Procomida Assistance")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaAssistanceValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaAssistancePostValidateWithCodes implements IReturn<ProcomidaAssistanceValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida assistance to validate. */
    // @DataMember(Order=1)
    public form: ProcomidaAssistance;

    /** @description The Code of the Institution associated with the procomida assistance to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the procomida assistance to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the procomida assistance to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida assistance to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaAssistancePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaAssistancePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaAssistanceValidationResponse(); }
}

// @Route("/opms/form/procomida-incomplete/single/id/{Id}", "GET")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteGetSingleById implements IReturn<ProcomidaIncompleteSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProcomidaIncompleteGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaIncompleteSingleResponse(); }
}

// @Route("/opms/form/procomida-incomplete/single/ids", "GET")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteGetSingleByIds implements IReturn<ProcomidaIncompleteSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the procomida incomplete to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new procomida incomplete if no procomida incomplete is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ProcomidaIncompleteGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaIncompleteSingleResponse(); }
}

// @Route("/opms/form/procomida-incomplete/single/codes", "GET")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteGetSingleByCodes implements IReturn<ProcomidaIncompleteSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the procomida incomplete to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new procomida incomplete if no procomida incomplete is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ProcomidaIncompleteGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaIncompleteSingleResponse(); }
}

// @Route("/opms/form/procomida-incomplete/collection", "GET")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteGetCollection implements IReturn<ProcomidaIncompleteCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ProcomidaIncompleteGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaIncompleteCollectionResponse(); }
}

// @Route("/opms/form/procomida-incomplete/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteGetCollectionByIds implements IReturn<ProcomidaIncompleteCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaIncompleteGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaIncompleteCollectionResponse(); }
}

// @Route("/opms/form/procomida-incomplete/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteCollectionResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteGetCollectionByCodes implements IReturn<ProcomidaIncompleteCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaIncompleteGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ProcomidaIncompleteCollectionResponse(); }
}

// @Route("/opms/form/procomida-incomplete/save", "POST")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompletePostSave implements IReturn<ProcomidaIncompleteSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to save. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    public constructor(init?: Partial<ProcomidaIncompletePostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompletePostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaIncompleteSingleResponse(); }
}

// @Route("/opms/form/procomida-incomplete/save/ids", "POST")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompletePostSaveWithIds implements IReturn<ProcomidaIncompleteSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to save. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    /** @description The ID of the Institution associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the procomida incomplete to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ProcomidaIncompletePostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompletePostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaIncompleteSingleResponse(); }
}

// @Route("/opms/form/procomida-incomplete/save/codes", "POST")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteSingleResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompletePostSaveWithCodes implements IReturn<ProcomidaIncompleteSingleResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to save. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    /** @description The Code of the Institution associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the procomida incomplete to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ProcomidaIncompletePostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompletePostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaIncompleteSingleResponse(); }
}

// @Route("/opms/form/procomida-incomplete/delete", "DELETE")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteDelete implements IReturn<ProcomidaIncompleteDeleteResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to delete. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    public constructor(init?: Partial<ProcomidaIncompleteDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaIncompleteDeleteResponse(); }
}

// @Route("/opms/form/procomida-incomplete/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteDeleteWithId implements IReturn<ProcomidaIncompleteDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ProcomidaIncompleteDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaIncompleteDeleteResponse(); }
}

// @Route("/opms/form/procomida-incomplete/delete/ids", "DELETE")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteDeleteWithIds implements IReturn<ProcomidaIncompleteDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ProcomidaIncompleteDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaIncompleteDeleteResponse(); }
}

// @Route("/opms/form/procomida-incomplete/delete/codes", "DELETE")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteDeleteResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompleteDeleteByCodes implements IReturn<ProcomidaIncompleteDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the procomida incomplete to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ProcomidaIncompleteDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompleteDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ProcomidaIncompleteDeleteResponse(); }
}

// @Route("/opms/form/procomida-incomplete/validate", "POST")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompletePostValidate implements IReturn<ProcomidaIncompleteValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to validate. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    public constructor(init?: Partial<ProcomidaIncompletePostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompletePostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaIncompleteValidationResponse(); }
}

// @Route("/opms/form/procomida-incomplete/validate/ids", "POST")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompletePostValidateWithIds implements IReturn<ProcomidaIncompleteValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to validate. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    /** @description The ID of the Institution associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaIncompletePostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompletePostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaIncompleteValidationResponse(); }
}

// @Route("/opms/form/procomida-incomplete/validate/codes", "POST")
// @Api(Description="Form - Procomida Incomplete")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ProcomidaIncompleteValidationResponse)", StatusCode=500)
// @DataContract
export class ProcomidaIncompletePostValidateWithCodes implements IReturn<ProcomidaIncompleteValidationResponse>
{
    [immerable]? = true;

    /** @description The procomida incomplete to validate. */
    // @DataMember(Order=1)
    public form: ProcomidaIncomplete;

    /** @description The Code of the Institution associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the procomida incomplete to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ProcomidaIncompletePostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ProcomidaIncompletePostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ProcomidaIncompleteValidationResponse(); }
}

// @Route("/opms/form/screening-form/single/id/{Id}", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetSingleById implements IReturn<ScreeningFormSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ScreeningFormGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/single/ids", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetSingleByIds implements IReturn<ScreeningFormSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the screening form to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new screening form if no screening form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ScreeningFormGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/single/codes", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetSingleByCodes implements IReturn<ScreeningFormSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the screening form to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new screening form if no screening form is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ScreeningFormGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/collection", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetCollection implements IReturn<ScreeningFormCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ScreeningFormGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormCollectionResponse(); }
}

// @Route("/opms/form/screening-form/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetCollectionByIds implements IReturn<ScreeningFormCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormCollectionResponse(); }
}

// @Route("/opms/form/screening-form/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormCollectionResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormGetCollectionByCodes implements IReturn<ScreeningFormCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ScreeningFormCollectionResponse(); }
}

// @Route("/opms/form/screening-form/save", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostSave implements IReturn<ScreeningFormSingleResponse>
{
    [immerable]? = true;

    /** @description The screening form to save. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    public constructor(init?: Partial<ScreeningFormPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/save/ids", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostSaveWithIds implements IReturn<ScreeningFormSingleResponse>
{
    [immerable]? = true;

    /** @description The screening form to save. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The ID of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the screening form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ScreeningFormPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/save/codes", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormSingleResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostSaveWithCodes implements IReturn<ScreeningFormSingleResponse>
{
    [immerable]? = true;

    /** @description The screening form to save. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The Code of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the screening form to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ScreeningFormPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormSingleResponse(); }
}

// @Route("/opms/form/screening-form/delete", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDelete implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The screening form to delete. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    public constructor(init?: Partial<ScreeningFormDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDeleteWithId implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ScreeningFormDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/delete/ids", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDeleteWithIds implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ScreeningFormDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/delete/codes", "DELETE")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormDeleteResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormDeleteByCodes implements IReturn<ScreeningFormDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the screening form to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the screening form to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ScreeningFormDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ScreeningFormDeleteResponse(); }
}

// @Route("/opms/form/screening-form/validate", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostValidate implements IReturn<ScreeningFormValidationResponse>
{
    [immerable]? = true;

    /** @description The screening form to validate. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    public constructor(init?: Partial<ScreeningFormPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormValidationResponse(); }
}

// @Route("/opms/form/screening-form/validate/ids", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostValidateWithIds implements IReturn<ScreeningFormValidationResponse>
{
    [immerable]? = true;

    /** @description The screening form to validate. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The ID of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormValidationResponse(); }
}

// @Route("/opms/form/screening-form/validate/codes", "POST")
// @Api(Description="Form - Screening Form")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ScreeningFormValidationResponse)", StatusCode=500)
// @DataContract
export class ScreeningFormPostValidateWithCodes implements IReturn<ScreeningFormValidationResponse>
{
    [immerable]? = true;

    /** @description The screening form to validate. */
    // @DataMember(Order=1)
    public form: ScreeningForm;

    /** @description The Code of the Institution associated with the screening form to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the screening form to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the screening form to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the screening form to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ScreeningFormPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ScreeningFormPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ScreeningFormValidationResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/single/id/{Id}", "GET")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentGetSingleById implements IReturn<WithdrawalOfConsentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<WithdrawalOfConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalOfConsentSingleResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/single/ids", "GET")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentGetSingleByIds implements IReturn<WithdrawalOfConsentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the withdrawal of consent to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new withdrawal of consent if no withdrawal of consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<WithdrawalOfConsentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalOfConsentSingleResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/single/codes", "GET")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentGetSingleByCodes implements IReturn<WithdrawalOfConsentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the withdrawal of consent to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new withdrawal of consent if no withdrawal of consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<WithdrawalOfConsentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalOfConsentSingleResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/collection", "GET")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentGetCollection implements IReturn<WithdrawalOfConsentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<WithdrawalOfConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalOfConsentCollectionResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentGetCollectionByIds implements IReturn<WithdrawalOfConsentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalOfConsentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalOfConsentCollectionResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentGetCollectionByCodes implements IReturn<WithdrawalOfConsentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalOfConsentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new WithdrawalOfConsentCollectionResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/save", "POST")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentPostSave implements IReturn<WithdrawalOfConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to save. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    public constructor(init?: Partial<WithdrawalOfConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalOfConsentSingleResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/save/ids", "POST")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentPostSaveWithIds implements IReturn<WithdrawalOfConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to save. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    /** @description The ID of the Institution associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<WithdrawalOfConsentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalOfConsentSingleResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/save/codes", "POST")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentSingleResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentPostSaveWithCodes implements IReturn<WithdrawalOfConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to save. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    /** @description The Code of the Institution associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<WithdrawalOfConsentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalOfConsentSingleResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/delete", "DELETE")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentDelete implements IReturn<WithdrawalOfConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to delete. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    public constructor(init?: Partial<WithdrawalOfConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalOfConsentDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentDeleteWithId implements IReturn<WithdrawalOfConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<WithdrawalOfConsentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalOfConsentDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/delete/ids", "DELETE")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentDeleteWithIds implements IReturn<WithdrawalOfConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<WithdrawalOfConsentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalOfConsentDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/delete/codes", "DELETE")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentDeleteByCodes implements IReturn<WithdrawalOfConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<WithdrawalOfConsentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new WithdrawalOfConsentDeleteResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/validate", "POST")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentPostValidate implements IReturn<WithdrawalOfConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to validate. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    public constructor(init?: Partial<WithdrawalOfConsentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalOfConsentValidationResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/validate/ids", "POST")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentPostValidateWithIds implements IReturn<WithdrawalOfConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to validate. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    /** @description The ID of the Institution associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalOfConsentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalOfConsentValidationResponse(); }
}

// @Route("/opms/form/withdrawal-of-consent/validate/codes", "POST")
// @Api(Description="Form - Withdrawal Of Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.WithdrawalOfConsentValidationResponse)", StatusCode=500)
// @DataContract
export class WithdrawalOfConsentPostValidateWithCodes implements IReturn<WithdrawalOfConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The withdrawal of consent to validate. */
    // @DataMember(Order=1)
    public form: WithdrawalOfConsent;

    /** @description The Code of the Institution associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the withdrawal of consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<WithdrawalOfConsentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'WithdrawalOfConsentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new WithdrawalOfConsentValidationResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/single/id/{Id}", "GET")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingGetSingleById implements IReturn<DiagnosticImagingSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<DiagnosticImagingGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DiagnosticImagingSingleResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/single/ids", "GET")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingGetSingleByIds implements IReturn<DiagnosticImagingSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the diagnostic imaging to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new diagnostic imaging if no diagnostic imaging is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<DiagnosticImagingGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DiagnosticImagingSingleResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/single/codes", "GET")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingGetSingleByCodes implements IReturn<DiagnosticImagingSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the diagnostic imaging to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new diagnostic imaging if no diagnostic imaging is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<DiagnosticImagingGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DiagnosticImagingSingleResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/collection", "GET")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingGetCollection implements IReturn<DiagnosticImagingCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<DiagnosticImagingGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DiagnosticImagingCollectionResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingGetCollectionByIds implements IReturn<DiagnosticImagingCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DiagnosticImagingCollectionResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingCollectionResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingGetCollectionByCodes implements IReturn<DiagnosticImagingCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new DiagnosticImagingCollectionResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/save", "POST")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingPostSave implements IReturn<DiagnosticImagingSingleResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to save. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    public constructor(init?: Partial<DiagnosticImagingPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosticImagingSingleResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/save/ids", "POST")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingPostSaveWithIds implements IReturn<DiagnosticImagingSingleResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to save. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    /** @description The ID of the Institution associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<DiagnosticImagingPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosticImagingSingleResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/save/codes", "POST")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingSingleResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingPostSaveWithCodes implements IReturn<DiagnosticImagingSingleResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to save. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    /** @description The Code of the Institution associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<DiagnosticImagingPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosticImagingSingleResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/delete", "DELETE")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingDelete implements IReturn<DiagnosticImagingDeleteResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to delete. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    public constructor(init?: Partial<DiagnosticImagingDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DiagnosticImagingDeleteResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingDeleteWithId implements IReturn<DiagnosticImagingDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<DiagnosticImagingDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DiagnosticImagingDeleteResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/delete/ids", "DELETE")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingDeleteWithIds implements IReturn<DiagnosticImagingDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DiagnosticImagingDeleteResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/delete/codes", "DELETE")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingDeleteResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingDeleteByCodes implements IReturn<DiagnosticImagingDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new DiagnosticImagingDeleteResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/validate", "POST")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingPostValidate implements IReturn<DiagnosticImagingValidationResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to validate. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    public constructor(init?: Partial<DiagnosticImagingPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosticImagingValidationResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/validate/ids", "POST")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingPostValidateWithIds implements IReturn<DiagnosticImagingValidationResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to validate. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    /** @description The ID of the Institution associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosticImagingValidationResponse(); }
}

// @Route("/opms/form/diagnostic-imaging/validate/codes", "POST")
// @Api(Description="Form - Diagnostic Imaging")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.DiagnosticImagingValidationResponse)", StatusCode=500)
// @DataContract
export class DiagnosticImagingPostValidateWithCodes implements IReturn<DiagnosticImagingValidationResponse>
{
    [immerable]? = true;

    /** @description The diagnostic imaging to validate. */
    // @DataMember(Order=1)
    public form: DiagnosticImaging;

    /** @description The Code of the Institution associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the diagnostic imaging to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<DiagnosticImagingPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DiagnosticImagingPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new DiagnosticImagingValidationResponse(); }
}

// @Route("/opms/form/general-and-consent/single/id/{Id}", "GET")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentGetSingleById implements IReturn<GeneralAndConsentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<GeneralAndConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralAndConsentSingleResponse(); }
}

// @Route("/opms/form/general-and-consent/single/ids", "GET")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentGetSingleByIds implements IReturn<GeneralAndConsentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the general and consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the general and consent to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new general and consent if no general and consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<GeneralAndConsentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralAndConsentSingleResponse(); }
}

// @Route("/opms/form/general-and-consent/single/codes", "GET")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentGetSingleByCodes implements IReturn<GeneralAndConsentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the general and consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the general and consent to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new general and consent if no general and consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<GeneralAndConsentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralAndConsentSingleResponse(); }
}

// @Route("/opms/form/general-and-consent/collection", "GET")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentGetCollection implements IReturn<GeneralAndConsentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<GeneralAndConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralAndConsentCollectionResponse(); }
}

// @Route("/opms/form/general-and-consent/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentGetCollectionByIds implements IReturn<GeneralAndConsentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralAndConsentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralAndConsentCollectionResponse(); }
}

// @Route("/opms/form/general-and-consent/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentGetCollectionByCodes implements IReturn<GeneralAndConsentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the general and consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralAndConsentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GeneralAndConsentCollectionResponse(); }
}

// @Route("/opms/form/general-and-consent/save", "POST")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentPostSave implements IReturn<GeneralAndConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The general and consent to save. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    public constructor(init?: Partial<GeneralAndConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralAndConsentSingleResponse(); }
}

// @Route("/opms/form/general-and-consent/save/ids", "POST")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentPostSaveWithIds implements IReturn<GeneralAndConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The general and consent to save. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    /** @description The ID of the Institution associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the general and consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<GeneralAndConsentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralAndConsentSingleResponse(); }
}

// @Route("/opms/form/general-and-consent/save/codes", "POST")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentSingleResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentPostSaveWithCodes implements IReturn<GeneralAndConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The general and consent to save. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    /** @description The Code of the Institution associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the general and consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the general and consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<GeneralAndConsentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralAndConsentSingleResponse(); }
}

// @Route("/opms/form/general-and-consent/delete", "DELETE")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentDelete implements IReturn<GeneralAndConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The general and consent to delete. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    public constructor(init?: Partial<GeneralAndConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralAndConsentDeleteResponse(); }
}

// @Route("/opms/form/general-and-consent/delete/id/{Id}", "DELETE")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentDeleteWithId implements IReturn<GeneralAndConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<GeneralAndConsentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralAndConsentDeleteResponse(); }
}

// @Route("/opms/form/general-and-consent/delete/ids", "DELETE")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentDeleteWithIds implements IReturn<GeneralAndConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the general and consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralAndConsentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralAndConsentDeleteResponse(); }
}

// @Route("/opms/form/general-and-consent/delete/codes", "DELETE")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentDeleteByCodes implements IReturn<GeneralAndConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the general and consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the general and consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<GeneralAndConsentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new GeneralAndConsentDeleteResponse(); }
}

// @Route("/opms/form/general-and-consent/validate", "POST")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentPostValidate implements IReturn<GeneralAndConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The general and consent to validate. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    public constructor(init?: Partial<GeneralAndConsentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralAndConsentValidationResponse(); }
}

// @Route("/opms/form/general-and-consent/validate/ids", "POST")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentPostValidateWithIds implements IReturn<GeneralAndConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The general and consent to validate. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    /** @description The ID of the Institution associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralAndConsentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralAndConsentValidationResponse(); }
}

// @Route("/opms/form/general-and-consent/validate/codes", "POST")
// @Api(Description="Form - General And Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.GeneralAndConsentValidationResponse)", StatusCode=500)
// @DataContract
export class GeneralAndConsentPostValidateWithCodes implements IReturn<GeneralAndConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The general and consent to validate. */
    // @DataMember(Order=1)
    public form: GeneralAndConsent;

    /** @description The Code of the Institution associated with the general and consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the general and consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the general and consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the general and consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<GeneralAndConsentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GeneralAndConsentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new GeneralAndConsentValidationResponse(); }
}

// @Route("/opms/form/image-report-upload/single/id/{Id}", "GET")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadGetSingleById implements IReturn<ImageReportUploadSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ImageReportUploadGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportUploadSingleResponse(); }
}

// @Route("/opms/form/image-report-upload/single/ids", "GET")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadGetSingleByIds implements IReturn<ImageReportUploadSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the image report upload to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new image report upload if no image report upload is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ImageReportUploadGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportUploadSingleResponse(); }
}

// @Route("/opms/form/image-report-upload/single/codes", "GET")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadGetSingleByCodes implements IReturn<ImageReportUploadSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the image report upload to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new image report upload if no image report upload is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ImageReportUploadGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportUploadSingleResponse(); }
}

// @Route("/opms/form/image-report-upload/collection", "GET")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadGetCollection implements IReturn<ImageReportUploadCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ImageReportUploadGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportUploadCollectionResponse(); }
}

// @Route("/opms/form/image-report-upload/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadGetCollectionByIds implements IReturn<ImageReportUploadCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportUploadGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportUploadCollectionResponse(); }
}

// @Route("/opms/form/image-report-upload/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadCollectionResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadGetCollectionByCodes implements IReturn<ImageReportUploadCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the image report upload to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportUploadGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ImageReportUploadCollectionResponse(); }
}

// @Route("/opms/form/image-report-upload/save", "POST")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadPostSave implements IReturn<ImageReportUploadSingleResponse>
{
    [immerable]? = true;

    /** @description The image report upload to save. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    public constructor(init?: Partial<ImageReportUploadPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportUploadSingleResponse(); }
}

// @Route("/opms/form/image-report-upload/save/ids", "POST")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadPostSaveWithIds implements IReturn<ImageReportUploadSingleResponse>
{
    [immerable]? = true;

    /** @description The image report upload to save. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    /** @description The ID of the Institution associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the image report upload to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ImageReportUploadPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportUploadSingleResponse(); }
}

// @Route("/opms/form/image-report-upload/save/codes", "POST")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadSingleResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadPostSaveWithCodes implements IReturn<ImageReportUploadSingleResponse>
{
    [immerable]? = true;

    /** @description The image report upload to save. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    /** @description The Code of the Institution associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the image report upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the image report upload to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ImageReportUploadPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportUploadSingleResponse(); }
}

// @Route("/opms/form/image-report-upload/delete", "DELETE")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadDelete implements IReturn<ImageReportUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The image report upload to delete. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    public constructor(init?: Partial<ImageReportUploadDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportUploadDeleteResponse(); }
}

// @Route("/opms/form/image-report-upload/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadDeleteWithId implements IReturn<ImageReportUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ImageReportUploadDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportUploadDeleteResponse(); }
}

// @Route("/opms/form/image-report-upload/delete/ids", "DELETE")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadDeleteWithIds implements IReturn<ImageReportUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ImageReportUploadDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportUploadDeleteResponse(); }
}

// @Route("/opms/form/image-report-upload/delete/codes", "DELETE")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadDeleteResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadDeleteByCodes implements IReturn<ImageReportUploadDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the image report upload to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the image report upload to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ImageReportUploadDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ImageReportUploadDeleteResponse(); }
}

// @Route("/opms/form/image-report-upload/validate", "POST")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadPostValidate implements IReturn<ImageReportUploadValidationResponse>
{
    [immerable]? = true;

    /** @description The image report upload to validate. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    public constructor(init?: Partial<ImageReportUploadPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportUploadValidationResponse(); }
}

// @Route("/opms/form/image-report-upload/validate/ids", "POST")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadPostValidateWithIds implements IReturn<ImageReportUploadValidationResponse>
{
    [immerable]? = true;

    /** @description The image report upload to validate. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    /** @description The ID of the Institution associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportUploadPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportUploadValidationResponse(); }
}

// @Route("/opms/form/image-report-upload/validate/codes", "POST")
// @Api(Description="Form - Image Report Upload")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ImageReportUploadValidationResponse)", StatusCode=500)
// @DataContract
export class ImageReportUploadPostValidateWithCodes implements IReturn<ImageReportUploadValidationResponse>
{
    [immerable]? = true;

    /** @description The image report upload to validate. */
    // @DataMember(Order=1)
    public form: ImageReportUpload;

    /** @description The Code of the Institution associated with the image report upload to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the image report upload to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the image report upload to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the image report upload to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ImageReportUploadPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ImageReportUploadPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ImageReportUploadValidationResponse(); }
}

// @Route("/opms/form/medical-history/single/id/{Id}", "GET")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryGetSingleById implements IReturn<MedicalHistorySingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the medical history to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MedicalHistoryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalHistorySingleResponse(); }
}

// @Route("/opms/form/medical-history/single/ids", "GET")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryGetSingleByIds implements IReturn<MedicalHistorySingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the medical history to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the medical history to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the medical history to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new medical history if no medical history is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MedicalHistoryGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalHistorySingleResponse(); }
}

// @Route("/opms/form/medical-history/single/codes", "GET")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryGetSingleByCodes implements IReturn<MedicalHistorySingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the medical history to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the medical history to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the medical history to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new medical history if no medical history is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MedicalHistoryGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalHistorySingleResponse(); }
}

// @Route("/opms/form/medical-history/collection", "GET")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryGetCollection implements IReturn<MedicalHistoryCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MedicalHistoryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalHistoryCollectionResponse(); }
}

// @Route("/opms/form/medical-history/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryGetCollectionByIds implements IReturn<MedicalHistoryCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the medical history to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalHistoryCollectionResponse(); }
}

// @Route("/opms/form/medical-history/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryCollectionResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryGetCollectionByCodes implements IReturn<MedicalHistoryCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the medical history to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MedicalHistoryCollectionResponse(); }
}

// @Route("/opms/form/medical-history/save", "POST")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryPostSave implements IReturn<MedicalHistorySingleResponse>
{
    [immerable]? = true;

    /** @description The medical history to save. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    public constructor(init?: Partial<MedicalHistoryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalHistorySingleResponse(); }
}

// @Route("/opms/form/medical-history/save/ids", "POST")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryPostSaveWithIds implements IReturn<MedicalHistorySingleResponse>
{
    [immerable]? = true;

    /** @description The medical history to save. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    /** @description The ID of the Institution associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the medical history to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MedicalHistoryPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalHistorySingleResponse(); }
}

// @Route("/opms/form/medical-history/save/codes", "POST")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistorySingleResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryPostSaveWithCodes implements IReturn<MedicalHistorySingleResponse>
{
    [immerable]? = true;

    /** @description The medical history to save. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    /** @description The Code of the Institution associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the medical history to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the medical history to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MedicalHistoryPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalHistorySingleResponse(); }
}

// @Route("/opms/form/medical-history/delete", "DELETE")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryDelete implements IReturn<MedicalHistoryDeleteResponse>
{
    [immerable]? = true;

    /** @description The medical history to delete. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    public constructor(init?: Partial<MedicalHistoryDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MedicalHistoryDeleteResponse(); }
}

// @Route("/opms/form/medical-history/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryDeleteWithId implements IReturn<MedicalHistoryDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the medical history to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MedicalHistoryDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MedicalHistoryDeleteResponse(); }
}

// @Route("/opms/form/medical-history/delete/ids", "DELETE")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryDeleteWithIds implements IReturn<MedicalHistoryDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the medical history to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the medical history to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MedicalHistoryDeleteResponse(); }
}

// @Route("/opms/form/medical-history/delete/codes", "DELETE")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryDeleteResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryDeleteByCodes implements IReturn<MedicalHistoryDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the medical history to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the medical history to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MedicalHistoryDeleteResponse(); }
}

// @Route("/opms/form/medical-history/validate", "POST")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryPostValidate implements IReturn<MedicalHistoryValidationResponse>
{
    [immerable]? = true;

    /** @description The medical history to validate. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    public constructor(init?: Partial<MedicalHistoryPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalHistoryValidationResponse(); }
}

// @Route("/opms/form/medical-history/validate/ids", "POST")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryPostValidateWithIds implements IReturn<MedicalHistoryValidationResponse>
{
    [immerable]? = true;

    /** @description The medical history to validate. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    /** @description The ID of the Institution associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalHistoryValidationResponse(); }
}

// @Route("/opms/form/medical-history/validate/codes", "POST")
// @Api(Description="Form - Medical History")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MedicalHistoryValidationResponse)", StatusCode=500)
// @DataContract
export class MedicalHistoryPostValidateWithCodes implements IReturn<MedicalHistoryValidationResponse>
{
    [immerable]? = true;

    /** @description The medical history to validate. */
    // @DataMember(Order=1)
    public form: MedicalHistory;

    /** @description The Code of the Institution associated with the medical history to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the medical history to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the medical history to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the medical history to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MedicalHistoryPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MedicalHistoryPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MedicalHistoryValidationResponse(); }
}

// @Route("/opms/form/proms/single/id/{Id}", "GET")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=500)
// @DataContract
export class PromsGetSingleById implements IReturn<PromsSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the proms to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PromsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PromsSingleResponse(); }
}

// @Route("/opms/form/proms/single/ids", "GET")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=500)
// @DataContract
export class PromsGetSingleByIds implements IReturn<PromsSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the proms to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the proms to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the proms to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new proms if no proms is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PromsGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PromsSingleResponse(); }
}

// @Route("/opms/form/proms/single/codes", "GET")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=500)
// @DataContract
export class PromsGetSingleByCodes implements IReturn<PromsSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the proms to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the proms to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the proms to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new proms if no proms is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<PromsGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PromsSingleResponse(); }
}

// @Route("/opms/form/proms/collection", "GET")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=500)
// @DataContract
export class PromsGetCollection implements IReturn<PromsCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<PromsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PromsCollectionResponse(); }
}

// @Route("/opms/form/proms/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=500)
// @DataContract
export class PromsGetCollectionByIds implements IReturn<PromsCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the proms to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PromsGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PromsCollectionResponse(); }
}

// @Route("/opms/form/proms/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsCollectionResponse)", StatusCode=500)
// @DataContract
export class PromsGetCollectionByCodes implements IReturn<PromsCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the proms to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<PromsGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new PromsCollectionResponse(); }
}

// @Route("/opms/form/proms/save", "POST")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=500)
// @DataContract
export class PromsPostSave implements IReturn<PromsSingleResponse>
{
    [immerable]? = true;

    /** @description The proms to save. */
    // @DataMember(Order=1)
    public form: Proms;

    public constructor(init?: Partial<PromsPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PromsSingleResponse(); }
}

// @Route("/opms/form/proms/save/ids", "POST")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=500)
// @DataContract
export class PromsPostSaveWithIds implements IReturn<PromsSingleResponse>
{
    [immerable]? = true;

    /** @description The proms to save. */
    // @DataMember(Order=1)
    public form: Proms;

    /** @description The ID of the Institution associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the proms to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the proms to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PromsPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PromsSingleResponse(); }
}

// @Route("/opms/form/proms/save/codes", "POST")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsSingleResponse)", StatusCode=500)
// @DataContract
export class PromsPostSaveWithCodes implements IReturn<PromsSingleResponse>
{
    [immerable]? = true;

    /** @description The proms to save. */
    // @DataMember(Order=1)
    public form: Proms;

    /** @description The Code of the Institution associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the proms to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the proms to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<PromsPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PromsSingleResponse(); }
}

// @Route("/opms/form/proms/delete", "DELETE")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=500)
// @DataContract
export class PromsDelete implements IReturn<PromsDeleteResponse>
{
    [immerable]? = true;

    /** @description The proms to delete. */
    // @DataMember(Order=1)
    public form: Proms;

    public constructor(init?: Partial<PromsDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PromsDeleteResponse(); }
}

// @Route("/opms/form/proms/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=500)
// @DataContract
export class PromsDeleteWithId implements IReturn<PromsDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the proms to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<PromsDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PromsDeleteResponse(); }
}

// @Route("/opms/form/proms/delete/ids", "DELETE")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=500)
// @DataContract
export class PromsDeleteWithIds implements IReturn<PromsDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the proms to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the proms to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PromsDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PromsDeleteResponse(); }
}

// @Route("/opms/form/proms/delete/codes", "DELETE")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsDeleteResponse)", StatusCode=500)
// @DataContract
export class PromsDeleteByCodes implements IReturn<PromsDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the proms to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the proms to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<PromsDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new PromsDeleteResponse(); }
}

// @Route("/opms/form/proms/validate", "POST")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=500)
// @DataContract
export class PromsPostValidate implements IReturn<PromsValidationResponse>
{
    [immerable]? = true;

    /** @description The proms to validate. */
    // @DataMember(Order=1)
    public form: Proms;

    public constructor(init?: Partial<PromsPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PromsValidationResponse(); }
}

// @Route("/opms/form/proms/validate/ids", "POST")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=500)
// @DataContract
export class PromsPostValidateWithIds implements IReturn<PromsValidationResponse>
{
    [immerable]? = true;

    /** @description The proms to validate. */
    // @DataMember(Order=1)
    public form: Proms;

    /** @description The ID of the Institution associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the proms to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PromsPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PromsValidationResponse(); }
}

// @Route("/opms/form/proms/validate/codes", "POST")
// @Api(Description="Form - Proms")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.PromsValidationResponse)", StatusCode=500)
// @DataContract
export class PromsPostValidateWithCodes implements IReturn<PromsValidationResponse>
{
    [immerable]? = true;

    /** @description The proms to validate. */
    // @DataMember(Order=1)
    public form: Proms;

    /** @description The Code of the Institution associated with the proms to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the proms to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the proms to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the proms to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<PromsPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PromsPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new PromsValidationResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/single/id/{Id}", "GET")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistGetSingleById implements IReturn<RegistrationEligibilityChecklistSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationEligibilityChecklistSingleResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/single/ids", "GET")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistGetSingleByIds implements IReturn<RegistrationEligibilityChecklistSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the registration eligibility checklist to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new registration eligibility checklist if no registration eligibility checklist is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RegistrationEligibilityChecklistGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationEligibilityChecklistSingleResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/single/codes", "GET")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistGetSingleByCodes implements IReturn<RegistrationEligibilityChecklistSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the registration eligibility checklist to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new registration eligibility checklist if no registration eligibility checklist is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RegistrationEligibilityChecklistGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationEligibilityChecklistSingleResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/collection", "GET")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistGetCollection implements IReturn<RegistrationEligibilityChecklistCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<RegistrationEligibilityChecklistGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationEligibilityChecklistCollectionResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistGetCollectionByIds implements IReturn<RegistrationEligibilityChecklistCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationEligibilityChecklistCollectionResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistCollectionResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistGetCollectionByCodes implements IReturn<RegistrationEligibilityChecklistCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RegistrationEligibilityChecklistCollectionResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/save", "POST")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistPostSave implements IReturn<RegistrationEligibilityChecklistSingleResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to save. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    public constructor(init?: Partial<RegistrationEligibilityChecklistPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationEligibilityChecklistSingleResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/save/ids", "POST")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistPostSaveWithIds implements IReturn<RegistrationEligibilityChecklistSingleResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to save. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    /** @description The ID of the Institution associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RegistrationEligibilityChecklistPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationEligibilityChecklistSingleResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/save/codes", "POST")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistSingleResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistPostSaveWithCodes implements IReturn<RegistrationEligibilityChecklistSingleResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to save. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    /** @description The Code of the Institution associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RegistrationEligibilityChecklistPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationEligibilityChecklistSingleResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/delete", "DELETE")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistDelete implements IReturn<RegistrationEligibilityChecklistDeleteResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to delete. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    public constructor(init?: Partial<RegistrationEligibilityChecklistDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationEligibilityChecklistDeleteResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistDeleteWithId implements IReturn<RegistrationEligibilityChecklistDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationEligibilityChecklistDeleteResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/delete/ids", "DELETE")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistDeleteWithIds implements IReturn<RegistrationEligibilityChecklistDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationEligibilityChecklistDeleteResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/delete/codes", "DELETE")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistDeleteResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistDeleteByCodes implements IReturn<RegistrationEligibilityChecklistDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RegistrationEligibilityChecklistDeleteResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/validate", "POST")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistPostValidate implements IReturn<RegistrationEligibilityChecklistValidationResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to validate. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    public constructor(init?: Partial<RegistrationEligibilityChecklistPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationEligibilityChecklistValidationResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/validate/ids", "POST")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistPostValidateWithIds implements IReturn<RegistrationEligibilityChecklistValidationResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to validate. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    /** @description The ID of the Institution associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationEligibilityChecklistValidationResponse(); }
}

// @Route("/opms/form/registration-eligibility-checklist/validate/codes", "POST")
// @Api(Description="Form - Registration Eligibility Checklist")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RegistrationEligibilityChecklistValidationResponse)", StatusCode=500)
// @DataContract
export class RegistrationEligibilityChecklistPostValidateWithCodes implements IReturn<RegistrationEligibilityChecklistValidationResponse>
{
    [immerable]? = true;

    /** @description The registration eligibility checklist to validate. */
    // @DataMember(Order=1)
    public form: RegistrationEligibilityChecklist;

    /** @description The Code of the Institution associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the registration eligibility checklist to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RegistrationEligibilityChecklistPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RegistrationEligibilityChecklistPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RegistrationEligibilityChecklistValidationResponse(); }
}

// @Route("/opms/form/cem-report-lesion/single/id/{Id}", "GET")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionGetSingleById implements IReturn<CemReportLesionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CemReportLesionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CemReportLesionSingleResponse(); }
}

// @Route("/opms/form/cem-report-lesion/single/ids", "GET")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionGetSingleByIds implements IReturn<CemReportLesionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the cem report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new cem report lesion if no cem report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<CemReportLesionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CemReportLesionSingleResponse(); }
}

// @Route("/opms/form/cem-report-lesion/single/codes", "GET")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionGetSingleByCodes implements IReturn<CemReportLesionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the cem report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new cem report lesion if no cem report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<CemReportLesionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CemReportLesionSingleResponse(); }
}

// @Route("/opms/form/cem-report-lesion/collection", "GET")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionGetCollection implements IReturn<CemReportLesionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<CemReportLesionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CemReportLesionCollectionResponse(); }
}

// @Route("/opms/form/cem-report-lesion/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionGetCollectionByIds implements IReturn<CemReportLesionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<CemReportLesionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CemReportLesionCollectionResponse(); }
}

// @Route("/opms/form/cem-report-lesion/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionGetCollectionByCodes implements IReturn<CemReportLesionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<CemReportLesionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CemReportLesionCollectionResponse(); }
}

// @Route("/opms/form/cem-report-lesion/save", "POST")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionPostSave implements IReturn<CemReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to save. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    public constructor(init?: Partial<CemReportLesionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CemReportLesionSingleResponse(); }
}

// @Route("/opms/form/cem-report-lesion/save/ids", "POST")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionPostSaveWithIds implements IReturn<CemReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to save. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    /** @description The ID of the Institution associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the cem report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<CemReportLesionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CemReportLesionSingleResponse(); }
}

// @Route("/opms/form/cem-report-lesion/save/codes", "POST")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionPostSaveWithCodes implements IReturn<CemReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to save. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    /** @description The Code of the Institution associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the cem report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<CemReportLesionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CemReportLesionSingleResponse(); }
}

// @Route("/opms/form/cem-report-lesion/delete", "DELETE")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionDelete implements IReturn<CemReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to delete. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    public constructor(init?: Partial<CemReportLesionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CemReportLesionDeleteResponse(); }
}

// @Route("/opms/form/cem-report-lesion/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionDeleteWithId implements IReturn<CemReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<CemReportLesionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CemReportLesionDeleteResponse(); }
}

// @Route("/opms/form/cem-report-lesion/delete/ids", "DELETE")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionDeleteWithIds implements IReturn<CemReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<CemReportLesionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CemReportLesionDeleteResponse(); }
}

// @Route("/opms/form/cem-report-lesion/delete/codes", "DELETE")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionDeleteByCodes implements IReturn<CemReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the cem report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<CemReportLesionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new CemReportLesionDeleteResponse(); }
}

// @Route("/opms/form/cem-report-lesion/validate", "POST")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionPostValidate implements IReturn<CemReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to validate. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    public constructor(init?: Partial<CemReportLesionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CemReportLesionValidationResponse(); }
}

// @Route("/opms/form/cem-report-lesion/validate/ids", "POST")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionPostValidateWithIds implements IReturn<CemReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to validate. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    /** @description The ID of the Institution associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<CemReportLesionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CemReportLesionValidationResponse(); }
}

// @Route("/opms/form/cem-report-lesion/validate/codes", "POST")
// @Api(Description="Form - Cem Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.CemReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class CemReportLesionPostValidateWithCodes implements IReturn<CemReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The cem report lesion to validate. */
    // @DataMember(Order=1)
    public form: CEMReportLesion;

    /** @description The Code of the Institution associated with the cem report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the cem report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the cem report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the cem report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<CemReportLesionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CemReportLesionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new CemReportLesionValidationResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/single/id/{Id}", "GET")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionGetSingleById implements IReturn<MammographyReportLesionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MammographyReportLesionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MammographyReportLesionSingleResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/single/ids", "GET")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionGetSingleByIds implements IReturn<MammographyReportLesionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the mammography report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new mammography report lesion if no mammography report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MammographyReportLesionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MammographyReportLesionSingleResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/single/codes", "GET")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionGetSingleByCodes implements IReturn<MammographyReportLesionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the mammography report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new mammography report lesion if no mammography report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MammographyReportLesionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MammographyReportLesionSingleResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/collection", "GET")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionGetCollection implements IReturn<MammographyReportLesionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MammographyReportLesionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MammographyReportLesionCollectionResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionGetCollectionByIds implements IReturn<MammographyReportLesionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MammographyReportLesionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MammographyReportLesionCollectionResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionGetCollectionByCodes implements IReturn<MammographyReportLesionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MammographyReportLesionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MammographyReportLesionCollectionResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/save", "POST")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionPostSave implements IReturn<MammographyReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to save. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    public constructor(init?: Partial<MammographyReportLesionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MammographyReportLesionSingleResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/save/ids", "POST")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionPostSaveWithIds implements IReturn<MammographyReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to save. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    /** @description The ID of the Institution associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the mammography report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MammographyReportLesionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MammographyReportLesionSingleResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/save/codes", "POST")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionPostSaveWithCodes implements IReturn<MammographyReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to save. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    /** @description The Code of the Institution associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the mammography report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MammographyReportLesionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MammographyReportLesionSingleResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/delete", "DELETE")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionDelete implements IReturn<MammographyReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to delete. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    public constructor(init?: Partial<MammographyReportLesionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MammographyReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionDeleteWithId implements IReturn<MammographyReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MammographyReportLesionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MammographyReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/delete/ids", "DELETE")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionDeleteWithIds implements IReturn<MammographyReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MammographyReportLesionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MammographyReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/delete/codes", "DELETE")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionDeleteByCodes implements IReturn<MammographyReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the mammography report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MammographyReportLesionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MammographyReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/validate", "POST")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionPostValidate implements IReturn<MammographyReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to validate. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    public constructor(init?: Partial<MammographyReportLesionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MammographyReportLesionValidationResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/validate/ids", "POST")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionPostValidateWithIds implements IReturn<MammographyReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to validate. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    /** @description The ID of the Institution associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MammographyReportLesionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MammographyReportLesionValidationResponse(); }
}

// @Route("/opms/form/mammography-report-lesion/validate/codes", "POST")
// @Api(Description="Form - Mammography Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MammographyReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class MammographyReportLesionPostValidateWithCodes implements IReturn<MammographyReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The mammography report lesion to validate. */
    // @DataMember(Order=1)
    public form: MammographyReportLesion;

    /** @description The Code of the Institution associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mammography report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MammographyReportLesionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MammographyReportLesionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MammographyReportLesionValidationResponse(); }
}

// @Route("/opms/form/mri-report-lesion/single/id/{Id}", "GET")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionGetSingleById implements IReturn<MriReportLesionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MriReportLesionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriReportLesionSingleResponse(); }
}

// @Route("/opms/form/mri-report-lesion/single/ids", "GET")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionGetSingleByIds implements IReturn<MriReportLesionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the mri report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new mri report lesion if no mri report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MriReportLesionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriReportLesionSingleResponse(); }
}

// @Route("/opms/form/mri-report-lesion/single/codes", "GET")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionGetSingleByCodes implements IReturn<MriReportLesionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the mri report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new mri report lesion if no mri report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MriReportLesionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriReportLesionSingleResponse(); }
}

// @Route("/opms/form/mri-report-lesion/collection", "GET")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionGetCollection implements IReturn<MriReportLesionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MriReportLesionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriReportLesionCollectionResponse(); }
}

// @Route("/opms/form/mri-report-lesion/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionGetCollectionByIds implements IReturn<MriReportLesionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriReportLesionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriReportLesionCollectionResponse(); }
}

// @Route("/opms/form/mri-report-lesion/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionGetCollectionByCodes implements IReturn<MriReportLesionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriReportLesionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MriReportLesionCollectionResponse(); }
}

// @Route("/opms/form/mri-report-lesion/save", "POST")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionPostSave implements IReturn<MriReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to save. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    public constructor(init?: Partial<MriReportLesionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriReportLesionSingleResponse(); }
}

// @Route("/opms/form/mri-report-lesion/save/ids", "POST")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionPostSaveWithIds implements IReturn<MriReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to save. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    /** @description The ID of the Institution associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the mri report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MriReportLesionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriReportLesionSingleResponse(); }
}

// @Route("/opms/form/mri-report-lesion/save/codes", "POST")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionPostSaveWithCodes implements IReturn<MriReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to save. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    /** @description The Code of the Institution associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the mri report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MriReportLesionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriReportLesionSingleResponse(); }
}

// @Route("/opms/form/mri-report-lesion/delete", "DELETE")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionDelete implements IReturn<MriReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to delete. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    public constructor(init?: Partial<MriReportLesionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mri-report-lesion/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionDeleteWithId implements IReturn<MriReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MriReportLesionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mri-report-lesion/delete/ids", "DELETE")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionDeleteWithIds implements IReturn<MriReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MriReportLesionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mri-report-lesion/delete/codes", "DELETE")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionDeleteByCodes implements IReturn<MriReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the mri report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MriReportLesionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MriReportLesionDeleteResponse(); }
}

// @Route("/opms/form/mri-report-lesion/validate", "POST")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionPostValidate implements IReturn<MriReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to validate. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    public constructor(init?: Partial<MriReportLesionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriReportLesionValidationResponse(); }
}

// @Route("/opms/form/mri-report-lesion/validate/ids", "POST")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionPostValidateWithIds implements IReturn<MriReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to validate. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    /** @description The ID of the Institution associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriReportLesionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriReportLesionValidationResponse(); }
}

// @Route("/opms/form/mri-report-lesion/validate/codes", "POST")
// @Api(Description="Form - Mri Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MriReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class MriReportLesionPostValidateWithCodes implements IReturn<MriReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The mri report lesion to validate. */
    // @DataMember(Order=1)
    public form: MRIReportLesion;

    /** @description The Code of the Institution associated with the mri report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the mri report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the mri report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the mri report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MriReportLesionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MriReportLesionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MriReportLesionValidationResponse(); }
}

// @Route("/opms/form/radiology-report/single/id/{Id}", "GET")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportGetSingleById implements IReturn<RadiologyReportSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RadiologyReportGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RadiologyReportSingleResponse(); }
}

// @Route("/opms/form/radiology-report/single/ids", "GET")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportGetSingleByIds implements IReturn<RadiologyReportSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the radiology report to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the radiology report to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new radiology report if no radiology report is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RadiologyReportGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RadiologyReportSingleResponse(); }
}

// @Route("/opms/form/radiology-report/single/codes", "GET")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportGetSingleByCodes implements IReturn<RadiologyReportSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the radiology report to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the radiology report to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new radiology report if no radiology report is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<RadiologyReportGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RadiologyReportSingleResponse(); }
}

// @Route("/opms/form/radiology-report/collection", "GET")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportGetCollection implements IReturn<RadiologyReportCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<RadiologyReportGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RadiologyReportCollectionResponse(); }
}

// @Route("/opms/form/radiology-report/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportGetCollectionByIds implements IReturn<RadiologyReportCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RadiologyReportGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RadiologyReportCollectionResponse(); }
}

// @Route("/opms/form/radiology-report/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportCollectionResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportGetCollectionByCodes implements IReturn<RadiologyReportCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the radiology report to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<RadiologyReportGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new RadiologyReportCollectionResponse(); }
}

// @Route("/opms/form/radiology-report/save", "POST")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportPostSave implements IReturn<RadiologyReportSingleResponse>
{
    [immerable]? = true;

    /** @description The radiology report to save. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    public constructor(init?: Partial<RadiologyReportPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RadiologyReportSingleResponse(); }
}

// @Route("/opms/form/radiology-report/save/ids", "POST")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportPostSaveWithIds implements IReturn<RadiologyReportSingleResponse>
{
    [immerable]? = true;

    /** @description The radiology report to save. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    /** @description The ID of the Institution associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the radiology report to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RadiologyReportPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RadiologyReportSingleResponse(); }
}

// @Route("/opms/form/radiology-report/save/codes", "POST")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportSingleResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportPostSaveWithCodes implements IReturn<RadiologyReportSingleResponse>
{
    [immerable]? = true;

    /** @description The radiology report to save. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    /** @description The Code of the Institution associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the radiology report to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the radiology report to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<RadiologyReportPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RadiologyReportSingleResponse(); }
}

// @Route("/opms/form/radiology-report/delete", "DELETE")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportDelete implements IReturn<RadiologyReportDeleteResponse>
{
    [immerable]? = true;

    /** @description The radiology report to delete. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    public constructor(init?: Partial<RadiologyReportDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RadiologyReportDeleteResponse(); }
}

// @Route("/opms/form/radiology-report/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportDeleteWithId implements IReturn<RadiologyReportDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<RadiologyReportDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RadiologyReportDeleteResponse(); }
}

// @Route("/opms/form/radiology-report/delete/ids", "DELETE")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportDeleteWithIds implements IReturn<RadiologyReportDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the radiology report to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RadiologyReportDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RadiologyReportDeleteResponse(); }
}

// @Route("/opms/form/radiology-report/delete/codes", "DELETE")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportDeleteResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportDeleteByCodes implements IReturn<RadiologyReportDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the radiology report to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the radiology report to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<RadiologyReportDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new RadiologyReportDeleteResponse(); }
}

// @Route("/opms/form/radiology-report/validate", "POST")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportPostValidate implements IReturn<RadiologyReportValidationResponse>
{
    [immerable]? = true;

    /** @description The radiology report to validate. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    public constructor(init?: Partial<RadiologyReportPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RadiologyReportValidationResponse(); }
}

// @Route("/opms/form/radiology-report/validate/ids", "POST")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportPostValidateWithIds implements IReturn<RadiologyReportValidationResponse>
{
    [immerable]? = true;

    /** @description The radiology report to validate. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    /** @description The ID of the Institution associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RadiologyReportPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RadiologyReportValidationResponse(); }
}

// @Route("/opms/form/radiology-report/validate/codes", "POST")
// @Api(Description="Form - Radiology Report")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.RadiologyReportValidationResponse)", StatusCode=500)
// @DataContract
export class RadiologyReportPostValidateWithCodes implements IReturn<RadiologyReportValidationResponse>
{
    [immerable]? = true;

    /** @description The radiology report to validate. */
    // @DataMember(Order=1)
    public form: RadiologyReport;

    /** @description The Code of the Institution associated with the radiology report to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the radiology report to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the radiology report to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the radiology report to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<RadiologyReportPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'RadiologyReportPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new RadiologyReportValidationResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/single/id/{Id}", "GET")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionGetSingleById implements IReturn<UltrasoundReportLesionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<UltrasoundReportLesionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UltrasoundReportLesionSingleResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/single/ids", "GET")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionGetSingleByIds implements IReturn<UltrasoundReportLesionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the ultrasound report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new ultrasound report lesion if no ultrasound report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<UltrasoundReportLesionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UltrasoundReportLesionSingleResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/single/codes", "GET")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionGetSingleByCodes implements IReturn<UltrasoundReportLesionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the ultrasound report lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new ultrasound report lesion if no ultrasound report lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<UltrasoundReportLesionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UltrasoundReportLesionSingleResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/collection", "GET")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionGetCollection implements IReturn<UltrasoundReportLesionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<UltrasoundReportLesionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UltrasoundReportLesionCollectionResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionGetCollectionByIds implements IReturn<UltrasoundReportLesionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<UltrasoundReportLesionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UltrasoundReportLesionCollectionResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionGetCollectionByCodes implements IReturn<UltrasoundReportLesionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<UltrasoundReportLesionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new UltrasoundReportLesionCollectionResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/save", "POST")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionPostSave implements IReturn<UltrasoundReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to save. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    public constructor(init?: Partial<UltrasoundReportLesionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UltrasoundReportLesionSingleResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/save/ids", "POST")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionPostSaveWithIds implements IReturn<UltrasoundReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to save. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    /** @description The ID of the Institution associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<UltrasoundReportLesionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UltrasoundReportLesionSingleResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/save/codes", "POST")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionSingleResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionPostSaveWithCodes implements IReturn<UltrasoundReportLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to save. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    /** @description The Code of the Institution associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<UltrasoundReportLesionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UltrasoundReportLesionSingleResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/delete", "DELETE")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionDelete implements IReturn<UltrasoundReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to delete. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    public constructor(init?: Partial<UltrasoundReportLesionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UltrasoundReportLesionDeleteResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionDeleteWithId implements IReturn<UltrasoundReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<UltrasoundReportLesionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UltrasoundReportLesionDeleteResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/delete/ids", "DELETE")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionDeleteWithIds implements IReturn<UltrasoundReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<UltrasoundReportLesionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UltrasoundReportLesionDeleteResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/delete/codes", "DELETE")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionDeleteByCodes implements IReturn<UltrasoundReportLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<UltrasoundReportLesionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new UltrasoundReportLesionDeleteResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/validate", "POST")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionPostValidate implements IReturn<UltrasoundReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to validate. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    public constructor(init?: Partial<UltrasoundReportLesionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UltrasoundReportLesionValidationResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/validate/ids", "POST")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionPostValidateWithIds implements IReturn<UltrasoundReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to validate. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    /** @description The ID of the Institution associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<UltrasoundReportLesionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UltrasoundReportLesionValidationResponse(); }
}

// @Route("/opms/form/ultrasound-report-lesion/validate/codes", "POST")
// @Api(Description="Form - Ultrasound Report Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.UltrasoundReportLesionValidationResponse)", StatusCode=500)
// @DataContract
export class UltrasoundReportLesionPostValidateWithCodes implements IReturn<UltrasoundReportLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The ultrasound report lesion to validate. */
    // @DataMember(Order=1)
    public form: UltrasoundReportLesion;

    /** @description The Code of the Institution associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the ultrasound report lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<UltrasoundReportLesionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'UltrasoundReportLesionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UltrasoundReportLesionValidationResponse(); }
}

// @Route("/opms/form/main-consent/single/id/{Id}", "GET")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentGetSingleById implements IReturn<MainConsentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the main consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MainConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentSingleResponse(); }
}

// @Route("/opms/form/main-consent/single/ids", "GET")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentGetSingleByIds implements IReturn<MainConsentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the main consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the main consent to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new main consent if no main consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MainConsentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentSingleResponse(); }
}

// @Route("/opms/form/main-consent/single/codes", "GET")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentGetSingleByCodes implements IReturn<MainConsentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the main consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the main consent to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new main consent if no main consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<MainConsentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentSingleResponse(); }
}

// @Route("/opms/form/main-consent/collection", "GET")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class MainConsentGetCollection implements IReturn<MainConsentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<MainConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentCollectionResponse(); }
}

// @Route("/opms/form/main-consent/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class MainConsentGetCollectionByIds implements IReturn<MainConsentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the main consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentCollectionResponse(); }
}

// @Route("/opms/form/main-consent/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class MainConsentGetCollectionByCodes implements IReturn<MainConsentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the main consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new MainConsentCollectionResponse(); }
}

// @Route("/opms/form/main-consent/save", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentPostSave implements IReturn<MainConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The main consent to save. */
    // @DataMember(Order=1)
    public form: MainConsent;

    public constructor(init?: Partial<MainConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentSingleResponse(); }
}

// @Route("/opms/form/main-consent/save/ids", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentPostSaveWithIds implements IReturn<MainConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The main consent to save. */
    // @DataMember(Order=1)
    public form: MainConsent;

    /** @description The ID of the Institution associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the main consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MainConsentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentSingleResponse(); }
}

// @Route("/opms/form/main-consent/save/codes", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentSingleResponse)", StatusCode=500)
// @DataContract
export class MainConsentPostSaveWithCodes implements IReturn<MainConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The main consent to save. */
    // @DataMember(Order=1)
    public form: MainConsent;

    /** @description The Code of the Institution associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the main consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the main consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<MainConsentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentSingleResponse(); }
}

// @Route("/opms/form/main-consent/delete", "DELETE")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentDelete implements IReturn<MainConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The main consent to delete. */
    // @DataMember(Order=1)
    public form: MainConsent;

    public constructor(init?: Partial<MainConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentDeleteResponse(); }
}

// @Route("/opms/form/main-consent/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentDeleteWithId implements IReturn<MainConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the main consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<MainConsentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentDeleteResponse(); }
}

// @Route("/opms/form/main-consent/delete/ids", "DELETE")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentDeleteWithIds implements IReturn<MainConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the main consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MainConsentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentDeleteResponse(); }
}

// @Route("/opms/form/main-consent/delete/codes", "DELETE")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class MainConsentDeleteByCodes implements IReturn<MainConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the main consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the main consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<MainConsentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new MainConsentDeleteResponse(); }
}

// @Route("/opms/form/main-consent/validate", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentPostValidate implements IReturn<MainConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The main consent to validate. */
    // @DataMember(Order=1)
    public form: MainConsent;

    public constructor(init?: Partial<MainConsentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentValidationResponse(); }
}

// @Route("/opms/form/main-consent/validate/ids", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentPostValidateWithIds implements IReturn<MainConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The main consent to validate. */
    // @DataMember(Order=1)
    public form: MainConsent;

    /** @description The ID of the Institution associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentValidationResponse(); }
}

// @Route("/opms/form/main-consent/validate/codes", "POST")
// @Api(Description="Form - Main Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.MainConsentValidationResponse)", StatusCode=500)
// @DataContract
export class MainConsentPostValidateWithCodes implements IReturn<MainConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The main consent to validate. */
    // @DataMember(Order=1)
    public form: MainConsent;

    /** @description The Code of the Institution associated with the main consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the main consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the main consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the main consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<MainConsentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'MainConsentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new MainConsentValidationResponse(); }
}

// @Route("/opms/form/services-australia-consent/single/id/{Id}", "GET")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentGetSingleById implements IReturn<ServicesAustraliaConsentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent/single/ids", "GET")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentGetSingleByIds implements IReturn<ServicesAustraliaConsentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the services australia consent to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new services australia consent if no services australia consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent/single/codes", "GET")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentGetSingleByCodes implements IReturn<ServicesAustraliaConsentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the services australia consent to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new services australia consent if no services australia consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent/collection", "GET")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentGetCollection implements IReturn<ServicesAustraliaConsentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ServicesAustraliaConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentCollectionResponse(); }
}

// @Route("/opms/form/services-australia-consent/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentGetCollectionByIds implements IReturn<ServicesAustraliaConsentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentCollectionResponse(); }
}

// @Route("/opms/form/services-australia-consent/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentGetCollectionByCodes implements IReturn<ServicesAustraliaConsentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ServicesAustraliaConsentCollectionResponse(); }
}

// @Route("/opms/form/services-australia-consent/save", "POST")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentPostSave implements IReturn<ServicesAustraliaConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to save. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    public constructor(init?: Partial<ServicesAustraliaConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent/save/ids", "POST")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentPostSaveWithIds implements IReturn<ServicesAustraliaConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to save. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    /** @description The ID of the Institution associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the services australia consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent/save/codes", "POST")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentSingleResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentPostSaveWithCodes implements IReturn<ServicesAustraliaConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to save. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    /** @description The Code of the Institution associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the services australia consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ServicesAustraliaConsentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentSingleResponse(); }
}

// @Route("/opms/form/services-australia-consent/delete", "DELETE")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentDelete implements IReturn<ServicesAustraliaConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to delete. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    public constructor(init?: Partial<ServicesAustraliaConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentDeleteWithId implements IReturn<ServicesAustraliaConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent/delete/ids", "DELETE")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentDeleteWithIds implements IReturn<ServicesAustraliaConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent/delete/codes", "DELETE")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentDeleteByCodes implements IReturn<ServicesAustraliaConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the services australia consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ServicesAustraliaConsentDeleteResponse(); }
}

// @Route("/opms/form/services-australia-consent/validate", "POST")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentPostValidate implements IReturn<ServicesAustraliaConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to validate. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    public constructor(init?: Partial<ServicesAustraliaConsentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentValidationResponse(); }
}

// @Route("/opms/form/services-australia-consent/validate/ids", "POST")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentPostValidateWithIds implements IReturn<ServicesAustraliaConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to validate. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    /** @description The ID of the Institution associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentValidationResponse(); }
}

// @Route("/opms/form/services-australia-consent/validate/codes", "POST")
// @Api(Description="Form - Services Australia Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ServicesAustraliaConsentValidationResponse)", StatusCode=500)
// @DataContract
export class ServicesAustraliaConsentPostValidateWithCodes implements IReturn<ServicesAustraliaConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The services australia consent to validate. */
    // @DataMember(Order=1)
    public form: ServicesAustraliaConsent;

    /** @description The Code of the Institution associated with the services australia consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the services australia consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the services australia consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the services australia consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ServicesAustraliaConsentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ServicesAustraliaConsentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ServicesAustraliaConsentValidationResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/single/id/{Id}", "GET")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentGetSingleById implements IReturn<TissueBankingConsentSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TissueBankingConsentGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueBankingConsentSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/single/ids", "GET")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentGetSingleByIds implements IReturn<TissueBankingConsentSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the tissue banking consent to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new tissue banking consent if no tissue banking consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TissueBankingConsentGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueBankingConsentSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/single/codes", "GET")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentGetSingleByCodes implements IReturn<TissueBankingConsentSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the tissue banking consent to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new tissue banking consent if no tissue banking consent is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TissueBankingConsentGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueBankingConsentSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/collection", "GET")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentGetCollection implements IReturn<TissueBankingConsentCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TissueBankingConsentGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueBankingConsentCollectionResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentGetCollectionByIds implements IReturn<TissueBankingConsentCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueBankingConsentGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueBankingConsentCollectionResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentCollectionResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentGetCollectionByCodes implements IReturn<TissueBankingConsentCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueBankingConsentGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueBankingConsentCollectionResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/save", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentPostSave implements IReturn<TissueBankingConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to save. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    public constructor(init?: Partial<TissueBankingConsentPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/save/ids", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentPostSaveWithIds implements IReturn<TissueBankingConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to save. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    /** @description The ID of the Institution associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the tissue banking consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TissueBankingConsentPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/save/codes", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentSingleResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentPostSaveWithCodes implements IReturn<TissueBankingConsentSingleResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to save. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    /** @description The Code of the Institution associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the tissue banking consent to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TissueBankingConsentPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentSingleResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/delete", "DELETE")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentDelete implements IReturn<TissueBankingConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to delete. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    public constructor(init?: Partial<TissueBankingConsentDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueBankingConsentDeleteResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentDeleteWithId implements IReturn<TissueBankingConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TissueBankingConsentDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueBankingConsentDeleteResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/delete/ids", "DELETE")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentDeleteWithIds implements IReturn<TissueBankingConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TissueBankingConsentDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueBankingConsentDeleteResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/delete/codes", "DELETE")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentDeleteByCodes implements IReturn<TissueBankingConsentDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the tissue banking consent to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TissueBankingConsentDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueBankingConsentDeleteResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/validate", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentPostValidate implements IReturn<TissueBankingConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to validate. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    public constructor(init?: Partial<TissueBankingConsentPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentValidationResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/validate/ids", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentPostValidateWithIds implements IReturn<TissueBankingConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to validate. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    /** @description The ID of the Institution associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueBankingConsentPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentValidationResponse(); }
}

// @Route("/opms/form/tissue-banking-consent/validate/codes", "POST")
// @Api(Description="Form - Tissue Banking Consent")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueBankingConsentValidationResponse)", StatusCode=500)
// @DataContract
export class TissueBankingConsentPostValidateWithCodes implements IReturn<TissueBankingConsentValidationResponse>
{
    [immerable]? = true;

    /** @description The tissue banking consent to validate. */
    // @DataMember(Order=1)
    public form: TissueBankingConsent;

    /** @description The Code of the Institution associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue banking consent to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueBankingConsentPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueBankingConsentPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueBankingConsentValidationResponse(); }
}

// @Route("/opms/form/additional-cancer/single/id/{Id}", "GET")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerGetSingleById implements IReturn<AdditionalCancerSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdditionalCancerGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerSingleResponse(); }
}

// @Route("/opms/form/additional-cancer/single/ids", "GET")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerGetSingleByIds implements IReturn<AdditionalCancerSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the additional cancer to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new additional cancer if no additional cancer is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdditionalCancerGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerSingleResponse(); }
}

// @Route("/opms/form/additional-cancer/single/codes", "GET")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerGetSingleByCodes implements IReturn<AdditionalCancerSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the additional cancer to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new additional cancer if no additional cancer is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdditionalCancerGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerSingleResponse(); }
}

// @Route("/opms/form/additional-cancer/collection", "GET")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerGetCollection implements IReturn<AdditionalCancerCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<AdditionalCancerGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerCollectionResponse(); }
}

// @Route("/opms/form/additional-cancer/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerGetCollectionByIds implements IReturn<AdditionalCancerCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerCollectionResponse(); }
}

// @Route("/opms/form/additional-cancer/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerCollectionResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerGetCollectionByCodes implements IReturn<AdditionalCancerCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerCollectionResponse(); }
}

// @Route("/opms/form/additional-cancer/save", "POST")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerPostSave implements IReturn<AdditionalCancerSingleResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to save. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    public constructor(init?: Partial<AdditionalCancerPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerSingleResponse(); }
}

// @Route("/opms/form/additional-cancer/save/ids", "POST")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerPostSaveWithIds implements IReturn<AdditionalCancerSingleResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to save. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    /** @description The ID of the Institution associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the additional cancer to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdditionalCancerPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerSingleResponse(); }
}

// @Route("/opms/form/additional-cancer/save/codes", "POST")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerPostSaveWithCodes implements IReturn<AdditionalCancerSingleResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to save. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    /** @description The Code of the Institution associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the additional cancer to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdditionalCancerPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerSingleResponse(); }
}

// @Route("/opms/form/additional-cancer/delete", "DELETE")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDelete implements IReturn<AdditionalCancerDeleteResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to delete. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    public constructor(init?: Partial<AdditionalCancerDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDeleteWithId implements IReturn<AdditionalCancerDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdditionalCancerDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer/delete/ids", "DELETE")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDeleteWithIds implements IReturn<AdditionalCancerDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer/delete/codes", "DELETE")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDeleteByCodes implements IReturn<AdditionalCancerDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the additional cancer to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer/validate", "POST")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerPostValidate implements IReturn<AdditionalCancerValidationResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to validate. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    public constructor(init?: Partial<AdditionalCancerPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerValidationResponse(); }
}

// @Route("/opms/form/additional-cancer/validate/ids", "POST")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerPostValidateWithIds implements IReturn<AdditionalCancerValidationResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to validate. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    /** @description The ID of the Institution associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerValidationResponse(); }
}

// @Route("/opms/form/additional-cancer/validate/codes", "POST")
// @Api(Description="Form - Additional Cancer")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerValidationResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerPostValidateWithCodes implements IReturn<AdditionalCancerValidationResponse>
{
    [immerable]? = true;

    /** @description The additional cancer to validate. */
    // @DataMember(Order=1)
    public form: AdditionalCancer;

    /** @description The Code of the Institution associated with the additional cancer to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the additional cancer to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the additional cancer to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerValidationResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/single/id/{Id}", "GET")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailGetSingleById implements IReturn<AdditionalCancerDetailSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdditionalCancerDetailGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerDetailSingleResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/single/ids", "GET")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailGetSingleByIds implements IReturn<AdditionalCancerDetailSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the additional cancer detail to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new additional cancer detail if no additional cancer detail is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdditionalCancerDetailGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerDetailSingleResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/single/codes", "GET")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailGetSingleByCodes implements IReturn<AdditionalCancerDetailSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the additional cancer detail to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new additional cancer detail if no additional cancer detail is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdditionalCancerDetailGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerDetailSingleResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/collection", "GET")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailGetCollection implements IReturn<AdditionalCancerDetailCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<AdditionalCancerDetailGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerDetailCollectionResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailGetCollectionByIds implements IReturn<AdditionalCancerDetailCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDetailGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerDetailCollectionResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailCollectionResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailGetCollectionByCodes implements IReturn<AdditionalCancerDetailCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDetailGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdditionalCancerDetailCollectionResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/save", "POST")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailPostSave implements IReturn<AdditionalCancerDetailSingleResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to save. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    public constructor(init?: Partial<AdditionalCancerDetailPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerDetailSingleResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/save/ids", "POST")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailPostSaveWithIds implements IReturn<AdditionalCancerDetailSingleResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to save. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    /** @description The ID of the Institution associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the additional cancer detail to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdditionalCancerDetailPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerDetailSingleResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/save/codes", "POST")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailSingleResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailPostSaveWithCodes implements IReturn<AdditionalCancerDetailSingleResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to save. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    /** @description The Code of the Institution associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the additional cancer detail to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdditionalCancerDetailPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerDetailSingleResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/delete", "DELETE")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailDelete implements IReturn<AdditionalCancerDetailDeleteResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to delete. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    public constructor(init?: Partial<AdditionalCancerDetailDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDetailDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailDeleteWithId implements IReturn<AdditionalCancerDetailDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdditionalCancerDetailDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDetailDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/delete/ids", "DELETE")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailDeleteWithIds implements IReturn<AdditionalCancerDetailDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDetailDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDetailDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/delete/codes", "DELETE")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailDeleteResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailDeleteByCodes implements IReturn<AdditionalCancerDetailDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the additional cancer detail to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDetailDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdditionalCancerDetailDeleteResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/validate", "POST")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailPostValidate implements IReturn<AdditionalCancerDetailValidationResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to validate. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    public constructor(init?: Partial<AdditionalCancerDetailPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerDetailValidationResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/validate/ids", "POST")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailPostValidateWithIds implements IReturn<AdditionalCancerDetailValidationResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to validate. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    /** @description The ID of the Institution associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDetailPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerDetailValidationResponse(); }
}

// @Route("/opms/form/additional-cancer-detail/validate/codes", "POST")
// @Api(Description="Form - Additional Cancer Detail")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdditionalCancerDetailValidationResponse)", StatusCode=500)
// @DataContract
export class AdditionalCancerDetailPostValidateWithCodes implements IReturn<AdditionalCancerDetailValidationResponse>
{
    [immerable]? = true;

    /** @description The additional cancer detail to validate. */
    // @DataMember(Order=1)
    public form: AdditionalCancerDetail;

    /** @description The Code of the Institution associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the additional cancer detail to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdditionalCancerDetailPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdditionalCancerDetailPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdditionalCancerDetailValidationResponse(); }
}

// @Route("/opms/form/adverse-event/single/id/{Id}", "GET")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventGetSingleById implements IReturn<AdverseEventSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdverseEventGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventSingleResponse(); }
}

// @Route("/opms/form/adverse-event/single/ids", "GET")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventGetSingleByIds implements IReturn<AdverseEventSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the adverse event to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new adverse event if no adverse event is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdverseEventGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventSingleResponse(); }
}

// @Route("/opms/form/adverse-event/single/codes", "GET")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventGetSingleByCodes implements IReturn<AdverseEventSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the adverse event to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new adverse event if no adverse event is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<AdverseEventGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventSingleResponse(); }
}

// @Route("/opms/form/adverse-event/collection", "GET")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventGetCollection implements IReturn<AdverseEventCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<AdverseEventGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventCollectionResponse(); }
}

// @Route("/opms/form/adverse-event/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventGetCollectionByIds implements IReturn<AdverseEventCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventCollectionResponse(); }
}

// @Route("/opms/form/adverse-event/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventCollectionResponse)", StatusCode=500)
// @DataContract
export class AdverseEventGetCollectionByCodes implements IReturn<AdverseEventCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the adverse event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new AdverseEventCollectionResponse(); }
}

// @Route("/opms/form/adverse-event/save", "POST")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventPostSave implements IReturn<AdverseEventSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse event to save. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    public constructor(init?: Partial<AdverseEventPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventSingleResponse(); }
}

// @Route("/opms/form/adverse-event/save/ids", "POST")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventPostSaveWithIds implements IReturn<AdverseEventSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse event to save. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    /** @description The ID of the Institution associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the adverse event to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdverseEventPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventSingleResponse(); }
}

// @Route("/opms/form/adverse-event/save/codes", "POST")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventSingleResponse)", StatusCode=500)
// @DataContract
export class AdverseEventPostSaveWithCodes implements IReturn<AdverseEventSingleResponse>
{
    [immerable]? = true;

    /** @description The adverse event to save. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    /** @description The Code of the Institution associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the adverse event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the adverse event to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<AdverseEventPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventSingleResponse(); }
}

// @Route("/opms/form/adverse-event/delete", "DELETE")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventDelete implements IReturn<AdverseEventDeleteResponse>
{
    [immerable]? = true;

    /** @description The adverse event to delete. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    public constructor(init?: Partial<AdverseEventDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventDeleteResponse(); }
}

// @Route("/opms/form/adverse-event/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventDeleteWithId implements IReturn<AdverseEventDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<AdverseEventDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventDeleteResponse(); }
}

// @Route("/opms/form/adverse-event/delete/ids", "DELETE")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventDeleteWithIds implements IReturn<AdverseEventDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdverseEventDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventDeleteResponse(); }
}

// @Route("/opms/form/adverse-event/delete/codes", "DELETE")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventDeleteResponse)", StatusCode=500)
// @DataContract
export class AdverseEventDeleteByCodes implements IReturn<AdverseEventDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the adverse event to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the adverse event to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<AdverseEventDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new AdverseEventDeleteResponse(); }
}

// @Route("/opms/form/adverse-event/validate", "POST")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventPostValidate implements IReturn<AdverseEventValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse event to validate. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    public constructor(init?: Partial<AdverseEventPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventValidationResponse(); }
}

// @Route("/opms/form/adverse-event/validate/ids", "POST")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventPostValidateWithIds implements IReturn<AdverseEventValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse event to validate. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    /** @description The ID of the Institution associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventValidationResponse(); }
}

// @Route("/opms/form/adverse-event/validate/codes", "POST")
// @Api(Description="Form - Adverse Event")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.AdverseEventValidationResponse)", StatusCode=500)
// @DataContract
export class AdverseEventPostValidateWithCodes implements IReturn<AdverseEventValidationResponse>
{
    [immerable]? = true;

    /** @description The adverse event to validate. */
    // @DataMember(Order=1)
    public form: AdverseEvent;

    /** @description The Code of the Institution associated with the adverse event to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the adverse event to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the adverse event to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the adverse event to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<AdverseEventPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'AdverseEventPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new AdverseEventValidationResponse(); }
}

// @Route("/opms/form/breast-mri/single/id/{Id}", "GET")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriGetSingleById implements IReturn<BreastMriSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BreastMriGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriSingleResponse(); }
}

// @Route("/opms/form/breast-mri/single/ids", "GET")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriGetSingleByIds implements IReturn<BreastMriSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the breast mri to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new breast mri if no breast mri is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BreastMriGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriSingleResponse(); }
}

// @Route("/opms/form/breast-mri/single/codes", "GET")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriGetSingleByCodes implements IReturn<BreastMriSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the breast mri to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new breast mri if no breast mri is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BreastMriGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriSingleResponse(); }
}

// @Route("/opms/form/breast-mri/collection", "GET")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastMriGetCollection implements IReturn<BreastMriCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<BreastMriGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriCollectionResponse(); }
}

// @Route("/opms/form/breast-mri/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastMriGetCollectionByIds implements IReturn<BreastMriCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriCollectionResponse(); }
}

// @Route("/opms/form/breast-mri/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastMriGetCollectionByCodes implements IReturn<BreastMriCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the breast mri to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriCollectionResponse(); }
}

// @Route("/opms/form/breast-mri/save", "POST")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriPostSave implements IReturn<BreastMriSingleResponse>
{
    [immerable]? = true;

    /** @description The breast mri to save. */
    // @DataMember(Order=1)
    public form: BreastMri;

    public constructor(init?: Partial<BreastMriPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriSingleResponse(); }
}

// @Route("/opms/form/breast-mri/save/ids", "POST")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriPostSaveWithIds implements IReturn<BreastMriSingleResponse>
{
    [immerable]? = true;

    /** @description The breast mri to save. */
    // @DataMember(Order=1)
    public form: BreastMri;

    /** @description The ID of the Institution associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the breast mri to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BreastMriPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriSingleResponse(); }
}

// @Route("/opms/form/breast-mri/save/codes", "POST")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriPostSaveWithCodes implements IReturn<BreastMriSingleResponse>
{
    [immerable]? = true;

    /** @description The breast mri to save. */
    // @DataMember(Order=1)
    public form: BreastMri;

    /** @description The Code of the Institution associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the breast mri to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the breast mri to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BreastMriPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriSingleResponse(); }
}

// @Route("/opms/form/breast-mri/delete", "DELETE")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriDelete implements IReturn<BreastMriDeleteResponse>
{
    [immerable]? = true;

    /** @description The breast mri to delete. */
    // @DataMember(Order=1)
    public form: BreastMri;

    public constructor(init?: Partial<BreastMriDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriDeleteResponse(); }
}

// @Route("/opms/form/breast-mri/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriDeleteWithId implements IReturn<BreastMriDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BreastMriDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriDeleteResponse(); }
}

// @Route("/opms/form/breast-mri/delete/ids", "DELETE")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriDeleteWithIds implements IReturn<BreastMriDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BreastMriDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriDeleteResponse(); }
}

// @Route("/opms/form/breast-mri/delete/codes", "DELETE")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriDeleteByCodes implements IReturn<BreastMriDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the breast mri to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BreastMriDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriDeleteResponse(); }
}

// @Route("/opms/form/breast-mri/validate", "POST")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=500)
// @DataContract
export class BreastMriPostValidate implements IReturn<BreastMriValidationResponse>
{
    [immerable]? = true;

    /** @description The breast mri to validate. */
    // @DataMember(Order=1)
    public form: BreastMri;

    public constructor(init?: Partial<BreastMriPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriValidationResponse(); }
}

// @Route("/opms/form/breast-mri/validate/ids", "POST")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=500)
// @DataContract
export class BreastMriPostValidateWithIds implements IReturn<BreastMriValidationResponse>
{
    [immerable]? = true;

    /** @description The breast mri to validate. */
    // @DataMember(Order=1)
    public form: BreastMri;

    /** @description The ID of the Institution associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriValidationResponse(); }
}

// @Route("/opms/form/breast-mri/validate/codes", "POST")
// @Api(Description="Form - Breast Mri")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriValidationResponse)", StatusCode=500)
// @DataContract
export class BreastMriPostValidateWithCodes implements IReturn<BreastMriValidationResponse>
{
    [immerable]? = true;

    /** @description The breast mri to validate. */
    // @DataMember(Order=1)
    public form: BreastMri;

    /** @description The Code of the Institution associated with the breast mri to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the breast mri to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the breast mri to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriValidationResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/single/id/{Id}", "GET")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionGetSingleById implements IReturn<BreastMriAdditionalLesionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriAdditionalLesionSingleResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/single/ids", "GET")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionGetSingleByIds implements IReturn<BreastMriAdditionalLesionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the breast mri additional lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new breast mri additional lesion if no breast mri additional lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BreastMriAdditionalLesionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriAdditionalLesionSingleResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/single/codes", "GET")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionGetSingleByCodes implements IReturn<BreastMriAdditionalLesionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the breast mri additional lesion to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new breast mri additional lesion if no breast mri additional lesion is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<BreastMriAdditionalLesionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriAdditionalLesionSingleResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/collection", "GET")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionGetCollection implements IReturn<BreastMriAdditionalLesionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<BreastMriAdditionalLesionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriAdditionalLesionCollectionResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionGetCollectionByIds implements IReturn<BreastMriAdditionalLesionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriAdditionalLesionCollectionResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionCollectionResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionGetCollectionByCodes implements IReturn<BreastMriAdditionalLesionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new BreastMriAdditionalLesionCollectionResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/save", "POST")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionPostSave implements IReturn<BreastMriAdditionalLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to save. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    public constructor(init?: Partial<BreastMriAdditionalLesionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriAdditionalLesionSingleResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/save/ids", "POST")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionPostSaveWithIds implements IReturn<BreastMriAdditionalLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to save. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    /** @description The ID of the Institution associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BreastMriAdditionalLesionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriAdditionalLesionSingleResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/save/codes", "POST")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionSingleResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionPostSaveWithCodes implements IReturn<BreastMriAdditionalLesionSingleResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to save. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    /** @description The Code of the Institution associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<BreastMriAdditionalLesionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriAdditionalLesionSingleResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/delete", "DELETE")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionDelete implements IReturn<BreastMriAdditionalLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to delete. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    public constructor(init?: Partial<BreastMriAdditionalLesionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriAdditionalLesionDeleteResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionDeleteWithId implements IReturn<BreastMriAdditionalLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriAdditionalLesionDeleteResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/delete/ids", "DELETE")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionDeleteWithIds implements IReturn<BreastMriAdditionalLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriAdditionalLesionDeleteResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/delete/codes", "DELETE")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionDeleteResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionDeleteByCodes implements IReturn<BreastMriAdditionalLesionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new BreastMriAdditionalLesionDeleteResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/validate", "POST")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionPostValidate implements IReturn<BreastMriAdditionalLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to validate. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    public constructor(init?: Partial<BreastMriAdditionalLesionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriAdditionalLesionValidationResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/validate/ids", "POST")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionPostValidateWithIds implements IReturn<BreastMriAdditionalLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to validate. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    /** @description The ID of the Institution associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriAdditionalLesionValidationResponse(); }
}

// @Route("/opms/form/breast-mri-additional-lesion/validate/codes", "POST")
// @Api(Description="Form - Breast Mri Additional Lesion")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.BreastMriAdditionalLesionValidationResponse)", StatusCode=500)
// @DataContract
export class BreastMriAdditionalLesionPostValidateWithCodes implements IReturn<BreastMriAdditionalLesionValidationResponse>
{
    [immerable]? = true;

    /** @description The breast mri additional lesion to validate. */
    // @DataMember(Order=1)
    public form: BreastMriAdditionalLesion;

    /** @description The Code of the Institution associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the breast mri additional lesion to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<BreastMriAdditionalLesionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'BreastMriAdditionalLesionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new BreastMriAdditionalLesionValidationResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/single/id/{Id}", "GET")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramGetSingleById implements IReturn<ContrastEnhancedMammogramSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContrastEnhancedMammogramSingleResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/single/ids", "GET")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramGetSingleByIds implements IReturn<ContrastEnhancedMammogramSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new contrast enhanced mammogram if no contrast enhanced mammogram is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ContrastEnhancedMammogramGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContrastEnhancedMammogramSingleResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/single/codes", "GET")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramGetSingleByCodes implements IReturn<ContrastEnhancedMammogramSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new contrast enhanced mammogram if no contrast enhanced mammogram is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<ContrastEnhancedMammogramGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContrastEnhancedMammogramSingleResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/collection", "GET")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramGetCollection implements IReturn<ContrastEnhancedMammogramCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<ContrastEnhancedMammogramGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContrastEnhancedMammogramCollectionResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramGetCollectionByIds implements IReturn<ContrastEnhancedMammogramCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContrastEnhancedMammogramCollectionResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramCollectionResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramGetCollectionByCodes implements IReturn<ContrastEnhancedMammogramCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new ContrastEnhancedMammogramCollectionResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/save", "POST")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramPostSave implements IReturn<ContrastEnhancedMammogramSingleResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to save. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    public constructor(init?: Partial<ContrastEnhancedMammogramPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContrastEnhancedMammogramSingleResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/save/ids", "POST")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramPostSaveWithIds implements IReturn<ContrastEnhancedMammogramSingleResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to save. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    /** @description The ID of the Institution associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ContrastEnhancedMammogramPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContrastEnhancedMammogramSingleResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/save/codes", "POST")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramSingleResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramPostSaveWithCodes implements IReturn<ContrastEnhancedMammogramSingleResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to save. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    /** @description The Code of the Institution associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<ContrastEnhancedMammogramPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContrastEnhancedMammogramSingleResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/delete", "DELETE")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramDelete implements IReturn<ContrastEnhancedMammogramDeleteResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to delete. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    public constructor(init?: Partial<ContrastEnhancedMammogramDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ContrastEnhancedMammogramDeleteResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramDeleteWithId implements IReturn<ContrastEnhancedMammogramDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ContrastEnhancedMammogramDeleteResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/delete/ids", "DELETE")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramDeleteWithIds implements IReturn<ContrastEnhancedMammogramDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ContrastEnhancedMammogramDeleteResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/delete/codes", "DELETE")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramDeleteResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramDeleteByCodes implements IReturn<ContrastEnhancedMammogramDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new ContrastEnhancedMammogramDeleteResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/validate", "POST")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramPostValidate implements IReturn<ContrastEnhancedMammogramValidationResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to validate. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    public constructor(init?: Partial<ContrastEnhancedMammogramPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContrastEnhancedMammogramValidationResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/validate/ids", "POST")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramPostValidateWithIds implements IReturn<ContrastEnhancedMammogramValidationResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to validate. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    /** @description The ID of the Institution associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContrastEnhancedMammogramValidationResponse(); }
}

// @Route("/opms/form/contrast-enhanced-mammogram/validate/codes", "POST")
// @Api(Description="Form - Contrast Enhanced Mammogram")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.ContrastEnhancedMammogramValidationResponse)", StatusCode=500)
// @DataContract
export class ContrastEnhancedMammogramPostValidateWithCodes implements IReturn<ContrastEnhancedMammogramValidationResponse>
{
    [immerable]? = true;

    /** @description The contrast enhanced mammogram to validate. */
    // @DataMember(Order=1)
    public form: ContrastEnhancedMammogram;

    /** @description The Code of the Institution associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the contrast enhanced mammogram to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<ContrastEnhancedMammogramPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'ContrastEnhancedMammogramPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new ContrastEnhancedMammogramValidationResponse(); }
}

// @Route("/opms/form/histopathology/single/id/{Id}", "GET")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=500)
// @DataContract
export class HistopathologyGetSingleById implements IReturn<HistopathologySingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<HistopathologyGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HistopathologySingleResponse(); }
}

// @Route("/opms/form/histopathology/single/ids", "GET")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=500)
// @DataContract
export class HistopathologyGetSingleByIds implements IReturn<HistopathologySingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the histopathology to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the histopathology to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new histopathology if no histopathology is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<HistopathologyGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HistopathologySingleResponse(); }
}

// @Route("/opms/form/histopathology/single/codes", "GET")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=500)
// @DataContract
export class HistopathologyGetSingleByCodes implements IReturn<HistopathologySingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the histopathology to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the histopathology to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new histopathology if no histopathology is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<HistopathologyGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HistopathologySingleResponse(); }
}

// @Route("/opms/form/histopathology/collection", "GET")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=500)
// @DataContract
export class HistopathologyGetCollection implements IReturn<HistopathologyCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<HistopathologyGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HistopathologyCollectionResponse(); }
}

// @Route("/opms/form/histopathology/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=500)
// @DataContract
export class HistopathologyGetCollectionByIds implements IReturn<HistopathologyCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<HistopathologyGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HistopathologyCollectionResponse(); }
}

// @Route("/opms/form/histopathology/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyCollectionResponse)", StatusCode=500)
// @DataContract
export class HistopathologyGetCollectionByCodes implements IReturn<HistopathologyCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the histopathology to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<HistopathologyGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new HistopathologyCollectionResponse(); }
}

// @Route("/opms/form/histopathology/save", "POST")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=500)
// @DataContract
export class HistopathologyPostSave implements IReturn<HistopathologySingleResponse>
{
    [immerable]? = true;

    /** @description The histopathology to save. */
    // @DataMember(Order=1)
    public form: Histopathology;

    public constructor(init?: Partial<HistopathologyPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HistopathologySingleResponse(); }
}

// @Route("/opms/form/histopathology/save/ids", "POST")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=500)
// @DataContract
export class HistopathologyPostSaveWithIds implements IReturn<HistopathologySingleResponse>
{
    [immerable]? = true;

    /** @description The histopathology to save. */
    // @DataMember(Order=1)
    public form: Histopathology;

    /** @description The ID of the Institution associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the histopathology to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<HistopathologyPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HistopathologySingleResponse(); }
}

// @Route("/opms/form/histopathology/save/codes", "POST")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologySingleResponse)", StatusCode=500)
// @DataContract
export class HistopathologyPostSaveWithCodes implements IReturn<HistopathologySingleResponse>
{
    [immerable]? = true;

    /** @description The histopathology to save. */
    // @DataMember(Order=1)
    public form: Histopathology;

    /** @description The Code of the Institution associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the histopathology to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the histopathology to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<HistopathologyPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HistopathologySingleResponse(); }
}

// @Route("/opms/form/histopathology/delete", "DELETE")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=500)
// @DataContract
export class HistopathologyDelete implements IReturn<HistopathologyDeleteResponse>
{
    [immerable]? = true;

    /** @description The histopathology to delete. */
    // @DataMember(Order=1)
    public form: Histopathology;

    public constructor(init?: Partial<HistopathologyDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new HistopathologyDeleteResponse(); }
}

// @Route("/opms/form/histopathology/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=500)
// @DataContract
export class HistopathologyDeleteWithId implements IReturn<HistopathologyDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<HistopathologyDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new HistopathologyDeleteResponse(); }
}

// @Route("/opms/form/histopathology/delete/ids", "DELETE")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=500)
// @DataContract
export class HistopathologyDeleteWithIds implements IReturn<HistopathologyDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the histopathology to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<HistopathologyDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new HistopathologyDeleteResponse(); }
}

// @Route("/opms/form/histopathology/delete/codes", "DELETE")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyDeleteResponse)", StatusCode=500)
// @DataContract
export class HistopathologyDeleteByCodes implements IReturn<HistopathologyDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the histopathology to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the histopathology to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<HistopathologyDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new HistopathologyDeleteResponse(); }
}

// @Route("/opms/form/histopathology/validate", "POST")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=500)
// @DataContract
export class HistopathologyPostValidate implements IReturn<HistopathologyValidationResponse>
{
    [immerable]? = true;

    /** @description The histopathology to validate. */
    // @DataMember(Order=1)
    public form: Histopathology;

    public constructor(init?: Partial<HistopathologyPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HistopathologyValidationResponse(); }
}

// @Route("/opms/form/histopathology/validate/ids", "POST")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=500)
// @DataContract
export class HistopathologyPostValidateWithIds implements IReturn<HistopathologyValidationResponse>
{
    [immerable]? = true;

    /** @description The histopathology to validate. */
    // @DataMember(Order=1)
    public form: Histopathology;

    /** @description The ID of the Institution associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<HistopathologyPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HistopathologyValidationResponse(); }
}

// @Route("/opms/form/histopathology/validate/codes", "POST")
// @Api(Description="Form - Histopathology")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.HistopathologyValidationResponse)", StatusCode=500)
// @DataContract
export class HistopathologyPostValidateWithCodes implements IReturn<HistopathologyValidationResponse>
{
    [immerable]? = true;

    /** @description The histopathology to validate. */
    // @DataMember(Order=1)
    public form: Histopathology;

    /** @description The Code of the Institution associated with the histopathology to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the histopathology to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the histopathology to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the histopathology to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<HistopathologyPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'HistopathologyPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HistopathologyValidationResponse(); }
}

// @Route("/opms/form/surgery/single/id/{Id}", "GET")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=500)
// @DataContract
export class SurgeryGetSingleById implements IReturn<SurgerySingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the surgery to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SurgeryGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SurgerySingleResponse(); }
}

// @Route("/opms/form/surgery/single/ids", "GET")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=500)
// @DataContract
export class SurgeryGetSingleByIds implements IReturn<SurgerySingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the surgery to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the surgery to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the surgery to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new surgery if no surgery is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SurgeryGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SurgerySingleResponse(); }
}

// @Route("/opms/form/surgery/single/codes", "GET")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=500)
// @DataContract
export class SurgeryGetSingleByCodes implements IReturn<SurgerySingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the surgery to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the surgery to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the surgery to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new surgery if no surgery is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<SurgeryGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SurgerySingleResponse(); }
}

// @Route("/opms/form/surgery/collection", "GET")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=500)
// @DataContract
export class SurgeryGetCollection implements IReturn<SurgeryCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<SurgeryGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SurgeryCollectionResponse(); }
}

// @Route("/opms/form/surgery/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=500)
// @DataContract
export class SurgeryGetCollectionByIds implements IReturn<SurgeryCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the surgery to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SurgeryGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SurgeryCollectionResponse(); }
}

// @Route("/opms/form/surgery/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryCollectionResponse)", StatusCode=500)
// @DataContract
export class SurgeryGetCollectionByCodes implements IReturn<SurgeryCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the surgery to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<SurgeryGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new SurgeryCollectionResponse(); }
}

// @Route("/opms/form/surgery/save", "POST")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=500)
// @DataContract
export class SurgeryPostSave implements IReturn<SurgerySingleResponse>
{
    [immerable]? = true;

    /** @description The surgery to save. */
    // @DataMember(Order=1)
    public form: Surgery;

    public constructor(init?: Partial<SurgeryPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SurgerySingleResponse(); }
}

// @Route("/opms/form/surgery/save/ids", "POST")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=500)
// @DataContract
export class SurgeryPostSaveWithIds implements IReturn<SurgerySingleResponse>
{
    [immerable]? = true;

    /** @description The surgery to save. */
    // @DataMember(Order=1)
    public form: Surgery;

    /** @description The ID of the Institution associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the surgery to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SurgeryPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SurgerySingleResponse(); }
}

// @Route("/opms/form/surgery/save/codes", "POST")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgerySingleResponse)", StatusCode=500)
// @DataContract
export class SurgeryPostSaveWithCodes implements IReturn<SurgerySingleResponse>
{
    [immerable]? = true;

    /** @description The surgery to save. */
    // @DataMember(Order=1)
    public form: Surgery;

    /** @description The Code of the Institution associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the surgery to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the surgery to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<SurgeryPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SurgerySingleResponse(); }
}

// @Route("/opms/form/surgery/delete", "DELETE")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=500)
// @DataContract
export class SurgeryDelete implements IReturn<SurgeryDeleteResponse>
{
    [immerable]? = true;

    /** @description The surgery to delete. */
    // @DataMember(Order=1)
    public form: Surgery;

    public constructor(init?: Partial<SurgeryDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SurgeryDeleteResponse(); }
}

// @Route("/opms/form/surgery/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=500)
// @DataContract
export class SurgeryDeleteWithId implements IReturn<SurgeryDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the surgery to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<SurgeryDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SurgeryDeleteResponse(); }
}

// @Route("/opms/form/surgery/delete/ids", "DELETE")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=500)
// @DataContract
export class SurgeryDeleteWithIds implements IReturn<SurgeryDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the surgery to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the surgery to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SurgeryDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SurgeryDeleteResponse(); }
}

// @Route("/opms/form/surgery/delete/codes", "DELETE")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryDeleteResponse)", StatusCode=500)
// @DataContract
export class SurgeryDeleteByCodes implements IReturn<SurgeryDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the surgery to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the surgery to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<SurgeryDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new SurgeryDeleteResponse(); }
}

// @Route("/opms/form/surgery/validate", "POST")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=500)
// @DataContract
export class SurgeryPostValidate implements IReturn<SurgeryValidationResponse>
{
    [immerable]? = true;

    /** @description The surgery to validate. */
    // @DataMember(Order=1)
    public form: Surgery;

    public constructor(init?: Partial<SurgeryPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SurgeryValidationResponse(); }
}

// @Route("/opms/form/surgery/validate/ids", "POST")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=500)
// @DataContract
export class SurgeryPostValidateWithIds implements IReturn<SurgeryValidationResponse>
{
    [immerable]? = true;

    /** @description The surgery to validate. */
    // @DataMember(Order=1)
    public form: Surgery;

    /** @description The ID of the Institution associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SurgeryPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SurgeryValidationResponse(); }
}

// @Route("/opms/form/surgery/validate/codes", "POST")
// @Api(Description="Form - Surgery")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.SurgeryValidationResponse)", StatusCode=500)
// @DataContract
export class SurgeryPostValidateWithCodes implements IReturn<SurgeryValidationResponse>
{
    [immerable]? = true;

    /** @description The surgery to validate. */
    // @DataMember(Order=1)
    public form: Surgery;

    /** @description The Code of the Institution associated with the surgery to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the surgery to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the surgery to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the surgery to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<SurgeryPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'SurgeryPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new SurgeryValidationResponse(); }
}

// @Route("/opms/form/tissue-collection/single/id/{Id}", "GET")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionGetSingleById implements IReturn<TissueCollectionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TissueCollectionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueCollectionSingleResponse(); }
}

// @Route("/opms/form/tissue-collection/single/ids", "GET")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionGetSingleByIds implements IReturn<TissueCollectionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the tissue collection to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new tissue collection if no tissue collection is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TissueCollectionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueCollectionSingleResponse(); }
}

// @Route("/opms/form/tissue-collection/single/codes", "GET")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionGetSingleByCodes implements IReturn<TissueCollectionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the tissue collection to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new tissue collection if no tissue collection is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TissueCollectionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueCollectionSingleResponse(); }
}

// @Route("/opms/form/tissue-collection/collection", "GET")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionGetCollection implements IReturn<TissueCollectionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TissueCollectionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueCollectionCollectionResponse(); }
}

// @Route("/opms/form/tissue-collection/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionGetCollectionByIds implements IReturn<TissueCollectionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueCollectionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueCollectionCollectionResponse(); }
}

// @Route("/opms/form/tissue-collection/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionCollectionResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionGetCollectionByCodes implements IReturn<TissueCollectionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueCollectionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TissueCollectionCollectionResponse(); }
}

// @Route("/opms/form/tissue-collection/save", "POST")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionPostSave implements IReturn<TissueCollectionSingleResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to save. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    public constructor(init?: Partial<TissueCollectionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueCollectionSingleResponse(); }
}

// @Route("/opms/form/tissue-collection/save/ids", "POST")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionPostSaveWithIds implements IReturn<TissueCollectionSingleResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to save. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    /** @description The ID of the Institution associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the tissue collection to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TissueCollectionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueCollectionSingleResponse(); }
}

// @Route("/opms/form/tissue-collection/save/codes", "POST")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionPostSaveWithCodes implements IReturn<TissueCollectionSingleResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to save. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    /** @description The Code of the Institution associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the tissue collection to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TissueCollectionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueCollectionSingleResponse(); }
}

// @Route("/opms/form/tissue-collection/delete", "DELETE")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionDelete implements IReturn<TissueCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to delete. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    public constructor(init?: Partial<TissueCollectionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueCollectionDeleteResponse(); }
}

// @Route("/opms/form/tissue-collection/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionDeleteWithId implements IReturn<TissueCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TissueCollectionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueCollectionDeleteResponse(); }
}

// @Route("/opms/form/tissue-collection/delete/ids", "DELETE")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionDeleteWithIds implements IReturn<TissueCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TissueCollectionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueCollectionDeleteResponse(); }
}

// @Route("/opms/form/tissue-collection/delete/codes", "DELETE")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionDeleteByCodes implements IReturn<TissueCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the tissue collection to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TissueCollectionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TissueCollectionDeleteResponse(); }
}

// @Route("/opms/form/tissue-collection/validate", "POST")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionPostValidate implements IReturn<TissueCollectionValidationResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to validate. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    public constructor(init?: Partial<TissueCollectionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueCollectionValidationResponse(); }
}

// @Route("/opms/form/tissue-collection/validate/ids", "POST")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionPostValidateWithIds implements IReturn<TissueCollectionValidationResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to validate. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    /** @description The ID of the Institution associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueCollectionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueCollectionValidationResponse(); }
}

// @Route("/opms/form/tissue-collection/validate/codes", "POST")
// @Api(Description="Form - Tissue Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TissueCollectionValidationResponse)", StatusCode=500)
// @DataContract
export class TissueCollectionPostValidateWithCodes implements IReturn<TissueCollectionValidationResponse>
{
    [immerable]? = true;

    /** @description The tissue collection to validate. */
    // @DataMember(Order=1)
    public form: TissueCollection;

    /** @description The Code of the Institution associated with the tissue collection to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the tissue collection to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the tissue collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the tissue collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TissueCollectionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TissueCollectionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TissueCollectionValidationResponse(); }
}

// @Route("/opms/form/translational-blood-collection/single/id/{Id}", "GET")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionGetSingleById implements IReturn<TranslationalBloodCollectionSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TranslationalBloodCollectionSingleResponse(); }
}

// @Route("/opms/form/translational-blood-collection/single/ids", "GET")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionGetSingleByIds implements IReturn<TranslationalBloodCollectionSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the translational blood collection to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new translational blood collection if no translational blood collection is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TranslationalBloodCollectionGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TranslationalBloodCollectionSingleResponse(); }
}

// @Route("/opms/form/translational-blood-collection/single/codes", "GET")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionGetSingleByCodes implements IReturn<TranslationalBloodCollectionSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the translational blood collection to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new translational blood collection if no translational blood collection is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TranslationalBloodCollectionGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TranslationalBloodCollectionSingleResponse(); }
}

// @Route("/opms/form/translational-blood-collection/collection", "GET")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionGetCollection implements IReturn<TranslationalBloodCollectionCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TranslationalBloodCollectionGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TranslationalBloodCollectionCollectionResponse(); }
}

// @Route("/opms/form/translational-blood-collection/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionGetCollectionByIds implements IReturn<TranslationalBloodCollectionCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TranslationalBloodCollectionCollectionResponse(); }
}

// @Route("/opms/form/translational-blood-collection/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionCollectionResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionGetCollectionByCodes implements IReturn<TranslationalBloodCollectionCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TranslationalBloodCollectionCollectionResponse(); }
}

// @Route("/opms/form/translational-blood-collection/save", "POST")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionPostSave implements IReturn<TranslationalBloodCollectionSingleResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to save. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    public constructor(init?: Partial<TranslationalBloodCollectionPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TranslationalBloodCollectionSingleResponse(); }
}

// @Route("/opms/form/translational-blood-collection/save/ids", "POST")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionPostSaveWithIds implements IReturn<TranslationalBloodCollectionSingleResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to save. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    /** @description The ID of the Institution associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the translational blood collection to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TranslationalBloodCollectionPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TranslationalBloodCollectionSingleResponse(); }
}

// @Route("/opms/form/translational-blood-collection/save/codes", "POST")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionSingleResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionPostSaveWithCodes implements IReturn<TranslationalBloodCollectionSingleResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to save. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    /** @description The Code of the Institution associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the translational blood collection to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TranslationalBloodCollectionPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TranslationalBloodCollectionSingleResponse(); }
}

// @Route("/opms/form/translational-blood-collection/delete", "DELETE")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionDelete implements IReturn<TranslationalBloodCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to delete. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    public constructor(init?: Partial<TranslationalBloodCollectionDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TranslationalBloodCollectionDeleteResponse(); }
}

// @Route("/opms/form/translational-blood-collection/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionDeleteWithId implements IReturn<TranslationalBloodCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TranslationalBloodCollectionDeleteResponse(); }
}

// @Route("/opms/form/translational-blood-collection/delete/ids", "DELETE")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionDeleteWithIds implements IReturn<TranslationalBloodCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TranslationalBloodCollectionDeleteResponse(); }
}

// @Route("/opms/form/translational-blood-collection/delete/codes", "DELETE")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionDeleteResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionDeleteByCodes implements IReturn<TranslationalBloodCollectionDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the translational blood collection to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TranslationalBloodCollectionDeleteResponse(); }
}

// @Route("/opms/form/translational-blood-collection/validate", "POST")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionPostValidate implements IReturn<TranslationalBloodCollectionValidationResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to validate. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    public constructor(init?: Partial<TranslationalBloodCollectionPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TranslationalBloodCollectionValidationResponse(); }
}

// @Route("/opms/form/translational-blood-collection/validate/ids", "POST")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionPostValidateWithIds implements IReturn<TranslationalBloodCollectionValidationResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to validate. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    /** @description The ID of the Institution associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TranslationalBloodCollectionValidationResponse(); }
}

// @Route("/opms/form/translational-blood-collection/validate/codes", "POST")
// @Api(Description="Form - Translational Blood Collection")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TranslationalBloodCollectionValidationResponse)", StatusCode=500)
// @DataContract
export class TranslationalBloodCollectionPostValidateWithCodes implements IReturn<TranslationalBloodCollectionValidationResponse>
{
    [immerable]? = true;

    /** @description The translational blood collection to validate. */
    // @DataMember(Order=1)
    public form: TranslationalBloodCollection;

    /** @description The Code of the Institution associated with the translational blood collection to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the translational blood collection to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the translational blood collection to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the translational blood collection to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TranslationalBloodCollectionPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TranslationalBloodCollectionPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TranslationalBloodCollectionValidationResponse(); }
}

// @Route("/opms/form/treatment-decisions/single/id/{Id}", "GET")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsGetSingleById implements IReturn<TreatmentDecisionsSingleResponse>, IFormGetSingleById
{
    [immerable]? = true;

    /** @description The ID of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TreatmentDecisionsGetSingleById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsGetSingleById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentDecisionsSingleResponse(); }
}

// @Route("/opms/form/treatment-decisions/single/ids", "GET")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsGetSingleByIds implements IReturn<TreatmentDecisionsSingleResponse>, IFormGetSingleByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The ID of the Institution associated to the treatment decisions to retrieve. */
    // @DataMember(Order=5)
    public institutionId?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new treatment decisions if no treatment decisions is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TreatmentDecisionsGetSingleByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsGetSingleByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentDecisionsSingleResponse(); }
}

// @Route("/opms/form/treatment-decisions/single/codes", "GET")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsGetSingleByCodes implements IReturn<TreatmentDecisionsSingleResponse>, IFormGetSingleByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    /** @description The Code of the Institution associated to the treatment decisions to retrieve. */
    // @DataMember(Order=5)
    public institutionCode: string;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=6)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no event is found. */
    // @DataMember(Order=7)
    public createEvent?: boolean;

    /** @description Whether or not to create a new treatment decisions if no treatment decisions is found. */
    // @DataMember(Order=8)
    public createForm?: boolean;

    public constructor(init?: Partial<TreatmentDecisionsGetSingleByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsGetSingleByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentDecisionsSingleResponse(); }
}

// @Route("/opms/form/treatment-decisions/collection", "GET")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsGetCollection implements IReturn<TreatmentDecisionsCollectionResponse>, IFormGetCollection
{
    [immerable]? = true;


    public constructor(init?: Partial<TreatmentDecisionsGetCollection>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsGetCollection'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentDecisionsCollectionResponse(); }
}

// @Route("/opms/form/treatment-decisions/collection/ids/{PatientId}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsGetCollectionByIds implements IReturn<TreatmentDecisionsCollectionResponse>, IFormGetCollectionByIds
{
    [immerable]? = true;

    /** @description The Patient ID of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TreatmentDecisionsGetCollectionByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsGetCollectionByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentDecisionsCollectionResponse(); }
}

// @Route("/opms/form/treatment-decisions/collection/ids/{PatientStudyNumber}/{EventDefinitionCode}/{EventRepeat}", "GET")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=403)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsCollectionResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsGetCollectionByCodes implements IReturn<TreatmentDecisionsCollectionResponse>, IFormGetCollectionByCodes
{
    [immerable]? = true;

    /** @description The Patient Study Number of the patient associated with the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    public constructor(init?: Partial<TreatmentDecisionsGetCollectionByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsGetCollectionByCodes'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TreatmentDecisionsCollectionResponse(); }
}

// @Route("/opms/form/treatment-decisions/save", "POST")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsPostSave implements IReturn<TreatmentDecisionsSingleResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to save. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    public constructor(init?: Partial<TreatmentDecisionsPostSave>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsPostSave'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentDecisionsSingleResponse(); }
}

// @Route("/opms/form/treatment-decisions/save/ids", "POST")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsPostSaveWithIds implements IReturn<TreatmentDecisionsSingleResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to save. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    /** @description The ID of the Institution associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the treatment decisions to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TreatmentDecisionsPostSaveWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsPostSaveWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentDecisionsSingleResponse(); }
}

// @Route("/opms/form/treatment-decisions/save/codes", "POST")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsSingleResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsPostSaveWithCodes implements IReturn<TreatmentDecisionsSingleResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to save. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    /** @description The Code of the Institution associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    /** @description The Repeat number of the treatment decisions to retrieve. */
    // @DataMember(Order=6)
    public formRepeat?: number;

    /** @description Whether or not to create a new patient if no Patient ID is provided. */
    // @DataMember(Order=7)
    public createPatient?: boolean;

    /** @description Whether or not to create a new event if no Event Repeat is provided. */
    // @DataMember(Order=8)
    public createEvent?: boolean;

    public constructor(init?: Partial<TreatmentDecisionsPostSaveWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsPostSaveWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentDecisionsSingleResponse(); }
}

// @Route("/opms/form/treatment-decisions/delete", "DELETE")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsDelete implements IReturn<TreatmentDecisionsDeleteResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to delete. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    public constructor(init?: Partial<TreatmentDecisionsDelete>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsDelete'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TreatmentDecisionsDeleteResponse(); }
}

// @Route("/opms/form/treatment-decisions/delete/id/{Id}", "DELETE")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsDeleteWithId implements IReturn<TreatmentDecisionsDeleteResponse>
{
    [immerable]? = true;

    /** @description The ID of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<TreatmentDecisionsDeleteWithId>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsDeleteWithId'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TreatmentDecisionsDeleteResponse(); }
}

// @Route("/opms/form/treatment-decisions/delete/ids", "DELETE")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsDeleteWithIds implements IReturn<TreatmentDecisionsDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient ID of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public patientId?: number;

    /** @description The Event Definition ID of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionId?: number;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TreatmentDecisionsDeleteWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsDeleteWithIds'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TreatmentDecisionsDeleteResponse(); }
}

// @Route("/opms/form/treatment-decisions/delete/codes", "DELETE")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsDeleteResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsDeleteByCodes implements IReturn<TreatmentDecisionsDeleteResponse>
{
    [immerable]? = true;

    /** @description The Patient Study Number of the treatment decisions to retrieve. */
    // @DataMember(Order=1)
    public patientStudyNumber: string;

    /** @description The Event Definition Code of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public eventRepeat?: number;

    /** @description The Form Repeat number of the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public formRepeat?: number;

    public constructor(init?: Partial<TreatmentDecisionsDeleteByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsDeleteByCodes'; }
    public getMethod() { return 'DELETE'; }
    public createResponse() { return new TreatmentDecisionsDeleteResponse(); }
}

// @Route("/opms/form/treatment-decisions/validate", "POST")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsPostValidate implements IReturn<TreatmentDecisionsValidationResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to validate. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    public constructor(init?: Partial<TreatmentDecisionsPostValidate>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsPostValidate'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentDecisionsValidationResponse(); }
}

// @Route("/opms/form/treatment-decisions/validate/ids", "POST")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsPostValidateWithIds implements IReturn<TreatmentDecisionsValidationResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to validate. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    /** @description The ID of the Institution associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public institutionId: number;

    /** @description The ID of the Patient associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public patientId?: number;

    /** @description The ID of the Event Definition of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionId: number;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TreatmentDecisionsPostValidateWithIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsPostValidateWithIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentDecisionsValidationResponse(); }
}

// @Route("/opms/form/treatment-decisions/validate/codes", "POST")
// @Api(Description="Form - Treatment Decisions")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.Form.TreatmentDecisionsValidationResponse)", StatusCode=500)
// @DataContract
export class TreatmentDecisionsPostValidateWithCodes implements IReturn<TreatmentDecisionsValidationResponse>
{
    [immerable]? = true;

    /** @description The treatment decisions to validate. */
    // @DataMember(Order=1)
    public form: TreatmentDecisions;

    /** @description The Code of the Institution associated with the treatment decisions to retrieve. */
    // @DataMember(Order=2)
    public institutionCode: string;

    /** @description The Study Number of the Patient associated with the treatment decisions to retrieve. */
    // @DataMember(Order=3)
    public patientStudyNumber: string;

    /** @description The Code of the Event Definition associated with the treatment decisions to retrieve. */
    // @DataMember(Order=4)
    public eventDefinitionCode: string;

    /** @description The Event Repeat number of the Event associated with the treatment decisions to retrieve. */
    // @DataMember(Order=5)
    public eventRepeat?: number;

    public constructor(init?: Partial<TreatmentDecisionsPostValidateWithCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'TreatmentDecisionsPostValidateWithCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new TreatmentDecisionsValidationResponse(); }
}

// @Route("/opms/file/view/{Id}", "GET")
export class GetFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<GetFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download/{Id}", "GET")
export class DownloadFile implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public id?: number;

    public constructor(init?: Partial<DownloadFile>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadFile'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/file/download-all/{PatientId}/{FormDefinitionId}/{FormId}", "GET")
export class DownloadAllFiles implements IReturn<Blob>, IGet
{
    [immerable]? = true;

    public patientId?: number;
    public formDefinitionId?: number;
    public formId?: number;

    public constructor(init?: Partial<DownloadAllFiles>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'DownloadAllFiles'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new Blob(); }
}

// @Route("/opms/event-state/id/{Id}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesById implements IReturn<EventStateResponse>, IPatientGetEventStatesById
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    public constructor(init?: Partial<EventStatesById>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesById'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/event-state/study-number/{StudyNumber}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.EventStateResponse)", StatusCode=500)
// @DataContract
export class EventStatesByStudyNumber implements IReturn<EventStateResponse>, IPatientGetEventStatesByStudyNumber
{
    [immerable]? = true;

    /** @description The Study Number of the patient to retrieve. */
    // @DataMember(Order=1)
    public studyNumber: string;

    public constructor(init?: Partial<EventStatesByStudyNumber>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'EventStatesByStudyNumber'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new EventStateResponse(); }
}

// @Route("/opms/form-state/ids/{Id}/{EventDefinitionId}/{EventRepeat}", "GET")
// @Api(Description="")
// @ApiResponse(Description="Unauthorized.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=401)
// @ApiResponse(Description="Forbidden.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=403)
// @ApiResponse(Description="Not Found.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=404)
// @ApiResponse(Description="Bad Request.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", ResponseType="typeof(__Opms.EventState.FormStateResponse)", StatusCode=500)
// @DataContract
export class FormStatesByIds implements IReturn<FormStateResponse>, IPatientGetFormStatesByIds
{
    [immerable]? = true;

    /** @description The ID of the patient to retrieve. */
    // @DataMember(Order=1)
    public id?: number;

    /** @description The event definition ID of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventDefinitionId?: number;

    /** @description The event repeat of the patient event to retrieve. */
    // @DataMember(Order=1)
    public eventRepeat?: number;

    public constructor(init?: Partial<FormStatesByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'FormStatesByIds'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new FormStateResponse(); }
}

export class GetUserPermissions implements IReturn<UserPermissionsResponse>
{
    [immerable]? = true;


    public constructor(init?: Partial<GetUserPermissions>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetUserPermissions'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new UserPermissionsResponse(); }
}

export class PostHasOpmsPermissionsByIds implements IReturn<HasOpmsPermissionCollectionResponse>
{
    [immerable]? = true;

    public masterGroupId?: number;
    public coordinatingGroupId?: number;
    public institutionId?: number;
    public patientId?: number;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByIds>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByIds'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class PostHasOpmsPermissionsByCodes implements IReturn<HasOpmsPermissionCollectionResponse>
{
    [immerable]? = true;

    public masterGroupCode: string;
    public coordinatingGroupCode: string;
    public institutionCode: string;
    public patientStudyNumber: string;
    public permissions: Permission[];

    public constructor(init?: Partial<PostHasOpmsPermissionsByCodes>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'PostHasOpmsPermissionsByCodes'; }
    public getMethod() { return 'POST'; }
    public createResponse() { return new HasOpmsPermissionCollectionResponse(); }
}

export class GetInstitutionPersonnel implements IReturn<InstitutionPersonnelResponse>, IGet
{
    [immerable]? = true;

    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnel>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnel'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelResponse(); }
}

export class GetInstitutionPersonnelNames implements IReturn<InstitutionPersonnelNamesResponse>, IGet
{
    [immerable]? = true;

    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetInstitutionPersonnelNames>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetInstitutionPersonnelNames'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new InstitutionPersonnelNamesResponse(); }
}

export class GetTrialPersonnelHasActiveRole implements IReturn<TrialPersonnelActiveRoleResponse>, IGet
{
    [immerable]? = true;

    public personId: number;
    public institutionCode: string;
    public roles: number[];

    public constructor(init?: Partial<GetTrialPersonnelHasActiveRole>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetTrialPersonnelHasActiveRole'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new TrialPersonnelActiveRoleResponse(); }
}

// @Route("/opms/protocol/{InstCode}", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class GetSiteProtocol implements IReturn<GetSiteProtocolResponse>, IGet
{
    [immerable]? = true;

    public instCode: string;

    public constructor(init?: Partial<GetSiteProtocol>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'GetSiteProtocol'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new GetSiteProtocolResponse(); }
}

// @Route("/opms/protocol/new-protocol-check", "GET")
// @ApiResponse(Description="Unauthorized.", StatusCode=401)
// @ApiResponse(Description="Forbidden.", StatusCode=403)
// @ApiResponse(Description="Bad Request.", StatusCode=400)
// @ApiResponse(Description="Internal Server Error.", StatusCode=500)
export class CheckAnyOpmsInstitutionOnNewProtocol implements IReturn<CheckAnyOpmsInstitutionOnNewProtocolResponse>, IGet
{
    [immerable]? = true;


    public constructor(init?: Partial<CheckAnyOpmsInstitutionOnNewProtocol>) { (Object as any).assign(this, init); }
    public getTypeName() { return 'CheckAnyOpmsInstitutionOnNewProtocol'; }
    public getMethod() { return 'GET'; }
    public createResponse() { return new CheckAnyOpmsInstitutionOnNewProtocolResponse(); }
}

